
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec720"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec720"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);

var $beeSh = parcelRequire("beeSh");

var $hGJaZ = parcelRequire("hGJaZ");
const $84d1df06ca739753$var$__default__ = {};
var $84d1df06ca739753$export$2e2bcd8739ae039 = /*@__PURE__*/ Object.assign($84d1df06ca739753$var$__default__, {
    __name: 'App',
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get banner () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($beeSh));
            },
            get footer () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($hGJaZ));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("beeSh", function(module, exports) {
module.exports = import.meta.resolve("iZJUP");

});

parcelRegister("hGJaZ", function(module, exports) {
module.exports = import.meta.resolve("5qnuI");

});


parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
const $2c4cb1eb429dee56$var$_hoisted_1 = [
    "src"
];
const $2c4cb1eb429dee56$var$_hoisted_2 = [
    "src"
];
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("header", null, [
            (0, $TusQn.createElementVNode)("img", {
                src: $setup.banner,
                alt: "N\xe1pis Rus\xednsky preklada\u010D s tradi\u010Dn\xfdm folk\xf3rnym vzorom"
            }, null, 8, $2c4cb1eb429dee56$var$_hoisted_1),
            (0, $TusQn.createElementVNode)("nav", null, [
                (0, $TusQn.createVNode)(_component_router_link, {
                    class: "link px-2 py-2 mx-5",
                    to: "/"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            ..._cache[0] || (_cache[0] = [
                                (0, $TusQn.createTextVNode)("Domov", -1)
                            ])
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)(_component_router_link, {
                    class: "link px-2 py-2 mx-5",
                    to: "/info"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            ..._cache[1] || (_cache[1] = [
                                (0, $TusQn.createTextVNode)("Info", -1)
                            ])
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)(_component_router_link, {
                    class: "link px-2 py-2 mx-5",
                    to: "/preklad"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            ..._cache[2] || (_cache[2] = [
                                (0, $TusQn.createTextVNode)("Preklad", -1)
                            ])
                        ]),
                    _: 1
                })
            ])
        ]),
        (0, $TusQn.createElementVNode)("main", null, [
            (0, $TusQn.createVNode)(_component_router_view)
        ]),
        (0, $TusQn.createElementVNode)("footer", null, [
            (0, $TusQn.createElementVNode)("img", {
                src: $setup.footer,
                alt: "Tradi\u010Dn\xfd folkl\xf3rny vzor",
                type: "image/bmp"
            }, null, 8, $2c4cb1eb429dee56$var$_hoisted_2)
        ])
    ], 64);
}

});
parcelRegister("dk7qG", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("TusQn")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
/**
* vue v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("8POXm");parcelRequire("01W3b");

var $3HHJ3 = parcelRequire("3HHJ3");

var $8POXm = parcelRequire("8POXm");
function $9b32e7f566245c4e$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $9b32e7f566245c4e$var$compileCache = /* @__PURE__ */ Object.create(null);
function $9b32e7f566245c4e$export$ef7acd7185315e22(template, options) {
    if (!(0, $8POXm.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, $8POXm.NOOP;
    }
    const key = (0, $8POXm.genCacheKey)(template, options);
    const cached = $9b32e7f566245c4e$var$compileCache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, $8POXm.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, $8POXm.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code: code } = (0, $3HHJ3.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, $8POXm.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, $TusQn.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)($9b32e7f566245c4e$import$4f81359071792c76);
    render._rc = true;
    return $9b32e7f566245c4e$var$compileCache[key] = render;
}
(0, $TusQn.registerRuntimeCompiler)($9b32e7f566245c4e$export$ef7acd7185315e22);

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$setHmrUpdating = (v1)=>{
    try {
        return $0a6cc4ba868319ae$var$isHmrUpdating;
    } finally{
        $0a6cc4ba868319ae$var$isHmrUpdating = v1;
    }
};
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0a6cc4ba868319ae$var$isHmrUpdating = true;
                instance.parent.update();
                $0a6cc4ba868319ae$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if ($0a6cc4ba868319ae$var$currentInstance) {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0a6cc4ba868319ae$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $0a6cc4ba868319ae$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($0a6cc4ba868319ae$var$pendingMounts.get(vnode) !== mountJob) return;
                $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
                if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                    mount(vnode, container, vnode.anchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $0a6cc4ba868319ae$var$pendingMounts.set(vnode, mountJob);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $0a6cc4ba868319ae$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        let shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
        const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
            shouldRemove = false;
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(oldInnerChild, innerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$0a6cc4ba868319ae$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            const done = el[$0a6cc4ba868319ae$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0a6cc4ba868319ae$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? (0, $8POXm.NO) : (key)=>{
        if ($0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0a6cc4ba868319ae$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0a6cc4ba868319ae$var$pendingSetRefMap.set(rawRef, job);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0a6cc4ba868319ae$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $8POXm.isReservedProp)(key)) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8POXm.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        const hasProps = Object.keys(props).length > 0;
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $8POXm.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && key[0] !== "$" && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (0, $8POXm.hasOwn)(props, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const inSSRSetup = $0a6cc4ba868319ae$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    const restore = ()=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($0a6cc4ba868319ae$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    };
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, emittedValue) && (0, $8POXm.hasChanged)(value, prevSetValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0a6cc4ba868319ae$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $8POXm.isObject)(nextProp) && (0, $8POXm.isObject)(prevProp)) return !(0, $8POXm.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(measureName, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMeasures(measureName);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    if (el._isLeaving) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $0a6cc4ba868319ae$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $8POXm.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])\w/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
                if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.32";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.__v_skip = true;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
function $005d1fb7704e278c$var$toWrapped(target, item) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return $005d1fb7704e278c$export$352205f445242f02(target) ? $005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item)) : $005d1fb7704e278c$export$4a78e7a2a4fb689f(item);
    return $005d1fb7704e278c$export$45c769cf449a508c(item);
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$005d1fb7704e278c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $005d1fb7704e278c$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $005d1fb7704e278c$var$toWrapped(self, result) : result;
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return (0, $8POXm.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const rawValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $8POXm.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $8POXm.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $8POXm.isSymbol)(key) ? key : String(key);
        this._raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $8POXm.isArray)(_object) || (0, $8POXm.isSymbol)(this._key) || !(0, $8POXm.isIntegerKey)(this._key)) do shallow = !$005d1fb7704e278c$export$5f3ca29d057519b3(obj) || $005d1fb7704e278c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $005d1fb7704e278c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    return new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "genCacheKey", () => $66ea9d0aaa418c4d$export$abc5374c10a73a04);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "generateCodeFrame", () => $66ea9d0aaa418c4d$export$f9c0d8b6684a279b);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "parseStringStyle", () => $66ea9d0aaa418c4d$export$76a205ce979d066a);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isVoidTag", () => $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("TusQn")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
/**
* @vue/runtime-dom v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow(el);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow(el);
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $8POXm.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(?:^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue)))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $8POXm.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $8POXm.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $8POXm.camelize)(prop) === camelKey);
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) Comp = (0, $8POXm.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $8POXm.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, $a5d55dc64ccb07cf$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, $a5d55dc64ccb07cf$var$getPosition(c.el));
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = /* @__PURE__ */ Symbol("_assign");
function $a5d55dc64ccb07cf$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $8POXm.looseToNumber)(value);
    return value;
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = $a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$export$cd4aa0842d13df8b
}, $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});

parcelRegister("3HHJ3", function(module, exports) {

$parcel$export(module.exports, "compile", () => $2b274e48783ce38c$export$ef7acd7185315e22);
/**
* @vue/compiler-dom v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $6rMDr = parcelRequire("6rMDr");

var $8POXm = parcelRequire("8POXm");
const $2b274e48783ce38c$export$840cf4d687fa64bf = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$228d0b64761291c1 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$9f97e65b6f78b584 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$19eac69b46d09cfc = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$334590174a9e57a1 = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$5c621dc1b9e655a = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$94febfb27c95c3cd = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$be7d85494bd6f37b = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$f2127cf693ff3edc = /* @__PURE__ */ Symbol(``);
const $2b274e48783ce38c$export$bb9790ed494aa172 = /* @__PURE__ */ Symbol(``);
(0, $6rMDr.registerRuntimeHelpers)({
    [$2b274e48783ce38c$export$840cf4d687fa64bf]: `vModelRadio`,
    [$2b274e48783ce38c$export$228d0b64761291c1]: `vModelCheckbox`,
    [$2b274e48783ce38c$export$9f97e65b6f78b584]: `vModelText`,
    [$2b274e48783ce38c$export$19eac69b46d09cfc]: `vModelSelect`,
    [$2b274e48783ce38c$export$334590174a9e57a1]: `vModelDynamic`,
    [$2b274e48783ce38c$export$5c621dc1b9e655a]: `withModifiers`,
    [$2b274e48783ce38c$export$94febfb27c95c3cd]: `withKeys`,
    [$2b274e48783ce38c$export$be7d85494bd6f37b]: `vShow`,
    [$2b274e48783ce38c$export$f2127cf693ff3edc]: `Transition`,
    [$2b274e48783ce38c$export$bb9790ed494aa172]: `TransitionGroup`
});
let $2b274e48783ce38c$var$decoder;
function $2b274e48783ce38c$var$decodeHtmlBrowser(raw, asAttr = false) {
    if (!$2b274e48783ce38c$var$decoder) $2b274e48783ce38c$var$decoder = document.createElement("div");
    if (asAttr) {
        $2b274e48783ce38c$var$decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return $2b274e48783ce38c$var$decoder.children[0].getAttribute("foo");
    } else {
        $2b274e48783ce38c$var$decoder.innerHTML = raw;
        return $2b274e48783ce38c$var$decoder.textContent;
    }
}
const $2b274e48783ce38c$export$f3377f1c03a3aebd = {
    parseMode: "html",
    isVoidTag: $8POXm.isVoidTag,
    isNativeTag: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    isIgnoreNewlineTag: (tag)=>tag === "pre" || tag === "textarea",
    decodeEntities: $2b274e48783ce38c$var$decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return $2b274e48783ce38c$export$f2127cf693ff3edc;
        else if (tag === "TransitionGroup" || tag === "transition-group") return $2b274e48783ce38c$export$bb9790ed494aa172;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const $2b274e48783ce38c$export$8dfeb887a12dd97a = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, $6rMDr.createSimpleExpression)(`style`, true, p.loc),
            exp: $2b274e48783ce38c$var$parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const $2b274e48783ce38c$var$parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, $8POXm.parseStringStyle)(cssText);
    return (0, $6rMDr.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function $2b274e48783ce38c$export$c2fa14fc707a7d94(code, loc) {
    return (0, $6rMDr.createCompilerError)(code, loc, void 0);
}
const $2b274e48783ce38c$export$3f0f75fff33734b3 = {
    "X_V_HTML_NO_EXPRESSION": 54,
    "54": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 55,
    "55": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 56,
    "56": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 57,
    "57": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 58,
    "58": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 59,
    "59": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 60,
    "60": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 61,
    "61": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 62,
    "62": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 63,
    "63": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 64,
    "64": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 65,
    "65": "__EXTEND_POINT__"
};
const $2b274e48783ce38c$export$b1db1c803eda55f9 = {
    [54]: `v-html is missing expression.`,
    [55]: `v-html will override element children.`,
    [56]: `v-text is missing expression.`,
    [57]: `v-text will override element children.`,
    [58]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [59]: `v-model argument is not supported on plain elements.`,
    [60]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [61]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [62]: `v-show is missing expression.`,
    [63]: `<Transition> expects exactly one child element or component.`,
    [64]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const $2b274e48783ce38c$var$transformVHtml = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(54, loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(55, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, $6rMDr.createSimpleExpression)("", true))
        ]
    };
};
const $2b274e48783ce38c$var$transformVText = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(56, loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(57, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`textContent`, true), exp ? (0, $6rMDr.getConstantType)(exp, context) > 0 ? exp : (0, $6rMDr.createCallExpression)(context.helperString((0, $6rMDr.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, $6rMDr.createSimpleExpression)("", true))
        ]
    };
};
const $2b274e48783ce38c$var$transformModel = (dir, node, context)=>{
    const baseResult = (0, $6rMDr.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(59, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, $6rMDr.findDir)(node, "bind");
        if (value && (0, $6rMDr.isStaticArgOf)(value.arg, "value")) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(61, value.loc));
    }
    const { tag: tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = $2b274e48783ce38c$export$9f97e65b6f78b584;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, $6rMDr.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = $2b274e48783ce38c$export$840cf4d687fa64bf;
                        break;
                    case "checkbox":
                        directiveToUse = $2b274e48783ce38c$export$228d0b64761291c1;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(60, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, $6rMDr.hasDynamicKeyVBind)(node)) directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
        } else if (tag === "select") directiveToUse = $2b274e48783ce38c$export$19eac69b46d09cfc;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(58, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const $2b274e48783ce38c$var$isEventOptionModifier = /* @__PURE__ */ (0, $8POXm.makeMap)(`passive,once,capture`);
const $2b274e48783ce38c$var$isNonKeyModifier = /* @__PURE__ */ (0, $8POXm.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const $2b274e48783ce38c$var$maybeKeyModifier = /* @__PURE__ */ (0, $8POXm.makeMap)("left,right");
const $2b274e48783ce38c$var$isKeyboardEvent = /* @__PURE__ */ (0, $8POXm.makeMap)(`onkeyup,onkeydown,onkeypress`);
const $2b274e48783ce38c$var$resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i].content;
        if (modifier === "native" && (0, $6rMDr.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if ($2b274e48783ce38c$var$isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if ($2b274e48783ce38c$var$maybeKeyModifier(modifier)) {
                if ((0, $6rMDr.isStaticExp)(key)) {
                    if ($2b274e48783ce38c$var$isKeyboardEvent(key.content.toLowerCase())) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if ($2b274e48783ce38c$var$isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers: keyModifiers,
        nonKeyModifiers: nonKeyModifiers,
        eventOptionModifiers: eventOptionModifiers
    };
};
const $2b274e48783ce38c$var$transformClick = (key, event)=>{
    const isStaticClick = (0, $6rMDr.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, $6rMDr.createSimpleExpression)(event, true) : key.type !== 4 ? (0, $6rMDr.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const $2b274e48783ce38c$var$transformOn = (dir, node, context)=>{
    return (0, $6rMDr.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers: modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key: key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers: keyModifiers, nonKeyModifiers: nonKeyModifiers, eventOptionModifiers: eventOptionModifiers } = $2b274e48783ce38c$var$resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = $2b274e48783ce38c$var$transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = $2b274e48783ce38c$var$transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$5c621dc1b9e655a), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, $6rMDr.isStaticExp)(key) || $2b274e48783ce38c$var$isKeyboardEvent(key.content.toLowerCase()))) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$94febfb27c95c3cd), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, $8POXm.capitalize)).join("");
            key = (0, $6rMDr.isStaticExp)(key) ? (0, $6rMDr.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, $6rMDr.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, $6rMDr.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const $2b274e48783ce38c$var$transformShow = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(62, loc));
    return {
        props: [],
        needRuntime: context.helper($2b274e48783ce38c$export$be7d85494bd6f37b)
    };
};
const $2b274e48783ce38c$var$transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === $2b274e48783ce38c$export$f2127cf693ff3edc) return ()=>{
            if (!node.children.length) return;
            if ($2b274e48783ce38c$var$hasMultipleChildren(node)) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(63, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function $2b274e48783ce38c$var$hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>!(0, $6rMDr.isCommentOrWhitespace)(c));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some($2b274e48783ce38c$var$hasMultipleChildren);
}
const $2b274e48783ce38c$var$ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
function $2b274e48783ce38c$var$isValidHTMLNesting(parent, child) {
    if (parent === "template") return true;
    if (parent in $2b274e48783ce38c$var$onlyValidChildren) return $2b274e48783ce38c$var$onlyValidChildren[parent].has(child);
    if (child in $2b274e48783ce38c$var$onlyValidParents) return $2b274e48783ce38c$var$onlyValidParents[child].has(parent);
    if (parent in $2b274e48783ce38c$var$knownInvalidChildren) {
        if ($2b274e48783ce38c$var$knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in $2b274e48783ce38c$var$knownInvalidParents) {
        if ($2b274e48783ce38c$var$knownInvalidParents[child].has(parent)) return false;
    }
    return true;
}
const $2b274e48783ce38c$var$headings = /* @__PURE__ */ new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const $2b274e48783ce38c$var$emptySet = /* @__PURE__ */ new Set([]);
const $2b274e48783ce38c$var$onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
        "base",
        "basefront",
        "bgsound",
        "link",
        "meta",
        "title",
        "noscript",
        "noframes",
        "style",
        "script",
        "template"
    ]),
    optgroup: /* @__PURE__ */ new Set([
        "option"
    ]),
    select: /* @__PURE__ */ new Set([
        "optgroup",
        "option",
        "hr"
    ]),
    // table
    table: /* @__PURE__ */ new Set([
        "caption",
        "colgroup",
        "tbody",
        "tfoot",
        "thead"
    ]),
    tr: /* @__PURE__ */ new Set([
        "td",
        "th"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "col"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "tr"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "tr"
    ]),
    // these elements can not have any children elements
    script: $2b274e48783ce38c$var$emptySet,
    iframe: $2b274e48783ce38c$var$emptySet,
    option: $2b274e48783ce38c$var$emptySet,
    textarea: $2b274e48783ce38c$var$emptySet,
    style: $2b274e48783ce38c$var$emptySet,
    title: $2b274e48783ce38c$var$emptySet
};
const $2b274e48783ce38c$var$onlyValidParents = {
    // sections
    html: $2b274e48783ce38c$var$emptySet,
    body: /* @__PURE__ */ new Set([
        "html"
    ]),
    head: /* @__PURE__ */ new Set([
        "html"
    ]),
    // table
    td: /* @__PURE__ */ new Set([
        "tr"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "table"
    ]),
    caption: /* @__PURE__ */ new Set([
        "table"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "table"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "table"
    ]),
    col: /* @__PURE__ */ new Set([
        "colgroup"
    ]),
    th: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "table"
    ]),
    tr: /* @__PURE__ */ new Set([
        "tbody",
        "thead",
        "tfoot"
    ]),
    // data list
    dd: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    // other
    figcaption: /* @__PURE__ */ new Set([
        "figure"
    ]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set([
        "details"
    ]),
    area: /* @__PURE__ */ new Set([
        "map"
    ])
};
const $2b274e48783ce38c$var$knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
        "address",
        "article",
        "aside",
        "blockquote",
        "center",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "fieldset",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "menu",
        "ol",
        "p",
        "pre",
        "section",
        "table",
        "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "li",
        "menu",
        "meta",
        "ol",
        "p",
        "pre",
        "ruby",
        "s",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "u",
        "ul",
        "var"
    ])
};
const $2b274e48783ce38c$var$knownInvalidParents = {
    a: /* @__PURE__ */ new Set([
        "a"
    ]),
    button: /* @__PURE__ */ new Set([
        "button"
    ]),
    dd: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    form: /* @__PURE__ */ new Set([
        "form"
    ]),
    li: /* @__PURE__ */ new Set([
        "li"
    ]),
    h1: $2b274e48783ce38c$var$headings,
    h2: $2b274e48783ce38c$var$headings,
    h3: $2b274e48783ce38c$var$headings,
    h4: $2b274e48783ce38c$var$headings,
    h5: $2b274e48783ce38c$var$headings,
    h6: $2b274e48783ce38c$var$headings
};
const $2b274e48783ce38c$var$validateHtmlNesting = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !$2b274e48783ce38c$var$isValidHTMLNesting(context.parent.tag, node.tag)) {
        const error = new SyntaxError(`<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`);
        error.loc = node.loc;
        context.onWarn(error);
    }
};
const $2b274e48783ce38c$export$e801dc6012e0c348 = [
    $2b274e48783ce38c$export$8dfeb887a12dd97a
];
const $2b274e48783ce38c$export$2257f60ebb1a11be = {
    cloak: (0, $6rMDr.noopDirectiveTransform),
    html: $2b274e48783ce38c$var$transformVHtml,
    text: $2b274e48783ce38c$var$transformVText,
    model: $2b274e48783ce38c$var$transformModel,
    // override compiler-core
    on: $2b274e48783ce38c$var$transformOn,
    // override compiler-core
    show: $2b274e48783ce38c$var$transformShow
};
function $2b274e48783ce38c$export$ef7acd7185315e22(src, options = {}) {
    return (0, $6rMDr.baseCompile)(src, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            $2b274e48783ce38c$var$ignoreSideEffectTags,
            ...$2b274e48783ce38c$export$e801dc6012e0c348,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $8POXm.extend)({}, $2b274e48783ce38c$export$2257f60ebb1a11be, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function $2b274e48783ce38c$export$98e6a39c04603d36(template, options = {}) {
    return (0, $6rMDr.baseParse)(template, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options));
}

});
parcelRegister("6rMDr", function(module, exports) {

$parcel$export(module.exports, "TO_DISPLAY_STRING", () => $4b1afda415637ecc$export$68f5914cce0a5680);
$parcel$export(module.exports, "registerRuntimeHelpers", () => $4b1afda415637ecc$export$8c4e724519c87f31);
$parcel$export(module.exports, "createObjectProperty", () => $4b1afda415637ecc$export$45231d90c148ea74);
$parcel$export(module.exports, "createSimpleExpression", () => $4b1afda415637ecc$export$ac2aa689b44cdd23);
$parcel$export(module.exports, "createCompoundExpression", () => $4b1afda415637ecc$export$60ad01cd5cde5e50);
$parcel$export(module.exports, "createCallExpression", () => $4b1afda415637ecc$export$2cdf8617f9d8e39d);
$parcel$export(module.exports, "checkCompatEnabled", () => $4b1afda415637ecc$export$1b1c14b93fcc0fe4);
$parcel$export(module.exports, "createCompilerError", () => $4b1afda415637ecc$export$57c5a5dc5aa19bdf);
$parcel$export(module.exports, "isStaticExp", () => $4b1afda415637ecc$export$43d387e2d68b51dc);
$parcel$export(module.exports, "findDir", () => $4b1afda415637ecc$export$1199bc2a2b648c8c);
$parcel$export(module.exports, "findProp", () => $4b1afda415637ecc$export$4ae65475e3513615);
$parcel$export(module.exports, "isStaticArgOf", () => $4b1afda415637ecc$export$45cac5109adb5e55);
$parcel$export(module.exports, "hasDynamicKeyVBind", () => $4b1afda415637ecc$export$4e1f112c75b8dafc);
$parcel$export(module.exports, "isCommentOrWhitespace", () => $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0);
$parcel$export(module.exports, "baseParse", () => $4b1afda415637ecc$export$f5f219d5f09c81b5);
$parcel$export(module.exports, "getConstantType", () => $4b1afda415637ecc$export$7967f5197c38d72a);
$parcel$export(module.exports, "transformOn", () => $4b1afda415637ecc$export$ff060d152244ee7b);
$parcel$export(module.exports, "transformModel", () => $4b1afda415637ecc$export$567db1f69abf4dcb);
$parcel$export(module.exports, "baseCompile", () => $4b1afda415637ecc$export$3243579822c486a0);
$parcel$export(module.exports, "noopDirectiveTransform", () => $4b1afda415637ecc$export$eb34aa2b2065da17);
/**
* @vue/compiler-core v3.5.32
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
const $4b1afda415637ecc$export$4bebefc40c8513e8 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e74e82bc14ac4f98 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$2237d737f4a10705 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e9ff5bb5c39478ed = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b357ae9fe0a3685a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$59578e14f90a15eb = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$37ddf5a12480514c = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$f87906340c78a650 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6db5bf2474139178 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b22e7e78da20c982 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b2aae42fb0a19db3 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$8890896270dfc293 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$1a493e4b98fdcf3 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$28c52e95383d270 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$582a2287b73d3265 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7f3ccc2ef793ecce = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$2c190751e09c3969 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a5e4c1729e50ed6d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$3da0e5cd78c1870 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a91e32c6b04aa348 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6a6b6a5c860c238d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$68f5914cce0a5680 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$825e32c0f842262a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$6382e3ed89de4e2a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$b9d3780a9ab822b4 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$78c34c869683dd86 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7046bb8d3c918928 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$4bdbf33367525856 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$3ebbf6981763e181 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e3e7f5f6c22384b5 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$8687eaac3cd39ddd = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$37cf1f9ab937c10d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$d8e039410dcfa57d = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$4266498fbffc3354 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$141e17a2b5200090 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$e0f3ad8c273cc513 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$cf2c1c7bc34dc87e = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$a0fd71f0f7cd2781 = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$ae18cf0dc81df35a = /* @__PURE__ */ Symbol(``);
const $4b1afda415637ecc$export$7dc1fc5a07bc9b35 = {
    [$4b1afda415637ecc$export$4bebefc40c8513e8]: `Fragment`,
    [$4b1afda415637ecc$export$e74e82bc14ac4f98]: `Teleport`,
    [$4b1afda415637ecc$export$2237d737f4a10705]: `Suspense`,
    [$4b1afda415637ecc$export$e9ff5bb5c39478ed]: `KeepAlive`,
    [$4b1afda415637ecc$export$b357ae9fe0a3685a]: `BaseTransition`,
    [$4b1afda415637ecc$export$59578e14f90a15eb]: `openBlock`,
    [$4b1afda415637ecc$export$37ddf5a12480514c]: `createBlock`,
    [$4b1afda415637ecc$export$f87906340c78a650]: `createElementBlock`,
    [$4b1afda415637ecc$export$6db5bf2474139178]: `createVNode`,
    [$4b1afda415637ecc$export$b22e7e78da20c982]: `createElementVNode`,
    [$4b1afda415637ecc$export$b2aae42fb0a19db3]: `createCommentVNode`,
    [$4b1afda415637ecc$export$8890896270dfc293]: `createTextVNode`,
    [$4b1afda415637ecc$export$1a493e4b98fdcf3]: `createStaticVNode`,
    [$4b1afda415637ecc$export$28c52e95383d270]: `resolveComponent`,
    [$4b1afda415637ecc$export$582a2287b73d3265]: `resolveDynamicComponent`,
    [$4b1afda415637ecc$export$7f3ccc2ef793ecce]: `resolveDirective`,
    [$4b1afda415637ecc$export$2c190751e09c3969]: `resolveFilter`,
    [$4b1afda415637ecc$export$a5e4c1729e50ed6d]: `withDirectives`,
    [$4b1afda415637ecc$export$3da0e5cd78c1870]: `renderList`,
    [$4b1afda415637ecc$export$a91e32c6b04aa348]: `renderSlot`,
    [$4b1afda415637ecc$export$6a6b6a5c860c238d]: `createSlots`,
    [$4b1afda415637ecc$export$68f5914cce0a5680]: `toDisplayString`,
    [$4b1afda415637ecc$export$825e32c0f842262a]: `mergeProps`,
    [$4b1afda415637ecc$export$6382e3ed89de4e2a]: `normalizeClass`,
    [$4b1afda415637ecc$export$b9d3780a9ab822b4]: `normalizeStyle`,
    [$4b1afda415637ecc$export$78c34c869683dd86]: `normalizeProps`,
    [$4b1afda415637ecc$export$7046bb8d3c918928]: `guardReactiveProps`,
    [$4b1afda415637ecc$export$4bdbf33367525856]: `toHandlers`,
    [$4b1afda415637ecc$export$3ebbf6981763e181]: `camelize`,
    [$4b1afda415637ecc$export$e3e7f5f6c22384b5]: `capitalize`,
    [$4b1afda415637ecc$export$8687eaac3cd39ddd]: `toHandlerKey`,
    [$4b1afda415637ecc$export$37cf1f9ab937c10d]: `setBlockTracking`,
    [$4b1afda415637ecc$export$d8e039410dcfa57d]: `pushScopeId`,
    [$4b1afda415637ecc$export$4266498fbffc3354]: `popScopeId`,
    [$4b1afda415637ecc$export$141e17a2b5200090]: `withCtx`,
    [$4b1afda415637ecc$export$e0f3ad8c273cc513]: `unref`,
    [$4b1afda415637ecc$export$cf2c1c7bc34dc87e]: `isRef`,
    [$4b1afda415637ecc$export$a0fd71f0f7cd2781]: `withMemo`,
    [$4b1afda415637ecc$export$ae18cf0dc81df35a]: `isMemoSame`
};
function $4b1afda415637ecc$export$8c4e724519c87f31(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        $4b1afda415637ecc$export$7dc1fc5a07bc9b35[s] = helpers[s];
    });
}
const $4b1afda415637ecc$export$2f21297dc8e7cb72 = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const $4b1afda415637ecc$export$2ed9472effad1b70 = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const $4b1afda415637ecc$export$6d501ccfb21c5e10 = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const $4b1afda415637ecc$export$537bd56c9a924c51 = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_CACHE": 2,
    "2": "CAN_CACHE",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const $4b1afda415637ecc$export$6c4f24c93c3e8659 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function $4b1afda415637ecc$export$882461b6382ed46c(children, source = "") {
    return {
        type: 0,
        source: source,
        children: children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: [],
        temps: 0,
        codegenNode: void 0,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$d1cb722ac2a8b632(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    if (context) {
        if (isBlock) {
            context.helper($4b1afda415637ecc$export$59578e14f90a15eb);
            context.helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent));
        } else context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent));
        if (directives) context.helper($4b1afda415637ecc$export$a5e4c1729e50ed6d);
    }
    return {
        type: 13,
        tag: tag,
        props: props,
        children: children,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        directives: directives,
        isBlock: isBlock,
        disableTracking: disableTracking,
        isComponent: isComponent,
        loc: loc
    };
}
function $4b1afda415637ecc$export$c887713da9895dbb(elements, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 17,
        loc: loc,
        elements: elements
    };
}
function $4b1afda415637ecc$export$ccb2e514379853a7(properties, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 15,
        loc: loc,
        properties: properties
    };
}
function $4b1afda415637ecc$export$45231d90c148ea74(key, value) {
    return {
        type: 16,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659,
        key: (0, $8POXm.isString)(key) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(key, true) : key,
        value: value
    };
}
function $4b1afda415637ecc$export$ac2aa689b44cdd23(content, isStatic = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659, constType = 0) {
    return {
        type: 4,
        loc: loc,
        content: content,
        isStatic: isStatic,
        constType: isStatic ? 3 : constType
    };
}
function $4b1afda415637ecc$export$96ca1dcf947302d0(content, loc) {
    return {
        type: 5,
        loc: loc,
        content: (0, $8POXm.isString)(content) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(content, false, loc) : content
    };
}
function $4b1afda415637ecc$export$60ad01cd5cde5e50(children, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 8,
        loc: loc,
        children: children
    };
}
function $4b1afda415637ecc$export$2cdf8617f9d8e39d(callee, args = [], loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 14,
        loc: loc,
        callee: callee,
        arguments: args
    };
}
function $4b1afda415637ecc$export$253e05bfd5b6c4c6(params, returns, newline = false, isSlot = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 18,
        params: params,
        returns: returns,
        newline: newline,
        isSlot: isSlot,
        loc: loc
    };
}
function $4b1afda415637ecc$export$374e02fb5bd90a4e(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test: test,
        consequent: consequent,
        alternate: alternate,
        newline: newline,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$4abd162ddf919697(index, value, needPauseTracking = false, inVOnce = false) {
    return {
        type: 20,
        index: index,
        value: value,
        needPauseTracking: needPauseTracking,
        inVOnce: inVOnce,
        needArraySpread: false,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$c3ad9e28586f1d07(body) {
    return {
        type: 21,
        body: body,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$242433d85418a087(elements) {
    return {
        type: 22,
        elements: elements,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$71ff4dcc047b6a4e(test, consequent, alternate) {
    return {
        type: 23,
        test: test,
        consequent: consequent,
        alternate: alternate,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$f6cfc415b0df5d79(left, right) {
    return {
        type: 24,
        left: left,
        right: right,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$42d3d4c35b19948b(expressions) {
    return {
        type: 25,
        expressions: expressions,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$746323a443188826(returns) {
    return {
        type: 26,
        returns: returns,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$3b9fc44425f495a6(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$6db5bf2474139178 : $4b1afda415637ecc$export$b22e7e78da20c982;
}
function $4b1afda415637ecc$export$74fb204a6eba800d(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$37ddf5a12480514c : $4b1afda415637ecc$export$f87906340c78a650;
}
function $4b1afda415637ecc$export$dc00c05f515bd739(node, { helper: helper, removeHelper: removeHelper, inSSR: inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(inSSR, node.isComponent));
        helper($4b1afda415637ecc$export$59578e14f90a15eb);
        helper($4b1afda415637ecc$export$74fb204a6eba800d(inSSR, node.isComponent));
    }
}
const $4b1afda415637ecc$var$defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const $4b1afda415637ecc$var$defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function $4b1afda415637ecc$var$isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function $4b1afda415637ecc$var$isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function $4b1afda415637ecc$var$isEndOfTagSection(c) {
    return c === 47 || c === 62 || $4b1afda415637ecc$var$isWhitespace(c);
}
function $4b1afda415637ecc$var$toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const $4b1afda415637ecc$var$Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class $4b1afda415637ecc$var$Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = $4b1afda415637ecc$var$defaultDelimitersOpen;
        this.delimiterClose = $4b1afda415637ecc$var$defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = $4b1afda415637ecc$var$defaultDelimitersOpen;
        this.delimiterClose = $4b1afda415637ecc$var$defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        const length = this.newlines.length;
        let j = -1;
        if (length > 100) {
            let l = -1;
            let r = length;
            while(l + 1 < r){
                const m = l + r >>> 1;
                this.newlines[m] < index ? l = m : r = m;
            }
            j = l;
        } else {
            for(let i = length - 1; i >= 0; i--)if (index > this.newlines[i]) {
                j = i;
                break;
            }
        }
        if (j >= 0) {
            line = j + 2;
            column = index - this.newlines[j];
        }
        return {
            column: column,
            line: line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        $4b1afda415637ecc$var$isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || $4b1afda415637ecc$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $4b1afda415637ecc$var$Sequences.TitleEnd || this.currentSequence === $4b1afda415637ecc$var$Sequences.TextareaEnd && !this.inSFCRoot) {
                if (!this.inVPre && c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === $4b1afda415637ecc$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $4b1afda415637ecc$var$Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = $4b1afda415637ecc$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $4b1afda415637ecc$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if ($4b1afda415637ecc$var$isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($4b1afda415637ecc$var$isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if ($4b1afda415637ecc$var$isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA($4b1afda415637ecc$var$toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if ($4b1afda415637ecc$var$isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = $4b1afda415637ecc$var$isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || $4b1afda415637ecc$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || $4b1afda415637ecc$var$isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!$4b1afda415637ecc$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if ($4b1afda415637ecc$var$isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = $4b1afda415637ecc$var$Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === $4b1afda415637ecc$var$Sequences.ScriptEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.ScriptEnd, 4);
        else if (c === $4b1afda415637ecc$var$Sequences.StyleEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === $4b1afda415637ecc$var$Sequences.TitleEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.TitleEnd, 4);
        else if (c === $4b1afda415637ecc$var$Sequences.TextareaEnd[3]) this.startSpecial($4b1afda415637ecc$var$Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10 && this.state !== 33) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === $4b1afda415637ecc$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const $4b1afda415637ecc$export$9354a9698ba2ae26 = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const $4b1afda415637ecc$var$deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function $4b1afda415637ecc$var$getCompatValue(key, { compatConfig: compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function $4b1afda415637ecc$var$isCompatEnabled(key, context) {
    const mode = $4b1afda415637ecc$var$getCompatValue("MODE", context);
    const value = $4b1afda415637ecc$var$getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function $4b1afda415637ecc$export$1b1c14b93fcc0fe4(key, context, loc, ...args) {
    const enabled = $4b1afda415637ecc$var$isCompatEnabled(key, context);
    return enabled;
}
function $4b1afda415637ecc$export$1c4d39b152e0f791(key, context, loc, ...args) {
    const val = $4b1afda415637ecc$var$getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message: message, link: link } = $4b1afda415637ecc$var$deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function $4b1afda415637ecc$var$defaultOnError(error) {
    throw error;
}
function $4b1afda415637ecc$var$defaultOnWarn(msg) {}
function $4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const $4b1afda415637ecc$export$10e8e1cf990558d7 = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_V_MODEL_ON_CONST": 45,
    "45": "X_V_MODEL_ON_CONST",
    "X_INVALID_EXPRESSION": 46,
    "46": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 47,
    "47": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 48,
    "48": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 49,
    "49": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 50,
    "50": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 51,
    "51": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 52,
    "52": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 53,
    "53": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 54,
    "54": "__EXTEND_POINT__"
};
const $4b1afda415637ecc$export$d8bd0967cb58683 = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [53]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `v-model cannot be used on a const binding because it is not writable.`,
    [46]: `Error parsing JavaScript expression: `,
    [47]: `<KeepAlive> expects exactly one child component.`,
    [52]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [48]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [49]: `ES module mode is not supported in this build of compiler.`,
    [50]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [51]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [54]: ``
};
function $4b1afda415637ecc$export$1f18e145724205f0(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function $4b1afda415637ecc$export$a351a8c8c66104d7(id, parent, parentStack) {
    return false;
}
function $4b1afda415637ecc$export$b1c677096ee1f9ce(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function $4b1afda415637ecc$export$6fdc7720591bc1f7(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function $4b1afda415637ecc$export$d41514e9f2f5bb4d(node, onIdent) {
    for (const p of node.params)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(p))onIdent(id);
}
function $4b1afda415637ecc$export$3e47780ecfa08385(block, onIdent) {
    const body = block.type === "SwitchCase" ? block.consequent : block.body;
    for (const stmt of body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if ($4b1afda415637ecc$var$isForStatement(stmt)) $4b1afda415637ecc$var$walkForStatement(stmt, true, onIdent);
        else if (stmt.type === "SwitchStatement") $4b1afda415637ecc$var$walkSwitchStatement(stmt, true, onIdent);
    }
}
function $4b1afda415637ecc$var$isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function $4b1afda415637ecc$var$walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
    }
}
function $4b1afda415637ecc$var$walkSwitchStatement(stmt, isVar, onIdent) {
    for (const cs of stmt.cases){
        for (const stmt2 of cs.consequent)if (stmt2.type === "VariableDeclaration" && (stmt2.kind === "var" ? isVar : !isVar)) {
            for (const decl of stmt2.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
        }
        $4b1afda415637ecc$export$3e47780ecfa08385(cs, onIdent);
    }
}
function $4b1afda415637ecc$export$31e5048ec55fc20d(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") $4b1afda415637ecc$export$31e5048ec55fc20d(prop.argument, nodes);
            else $4b1afda415637ecc$export$31e5048ec55fc20d(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) $4b1afda415637ecc$export$31e5048ec55fc20d(element, nodes);
            });
            break;
        case "RestElement":
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.argument, nodes);
            break;
        case "AssignmentPattern":
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.left, nodes);
            break;
    }
    return nodes;
}
const $4b1afda415637ecc$export$8af909612acebc9b = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const $4b1afda415637ecc$export$f6ddf7e7b08e8e00 = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const $4b1afda415637ecc$export$644dbfd5b3d2f87f = (node, parent)=>$4b1afda415637ecc$export$f6ddf7e7b08e8e00(parent) && parent.key === node;
const $4b1afda415637ecc$export$d40f31ccee2489f = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function $4b1afda415637ecc$export$4bc65b30e69d96a9(node) {
    if ($4b1afda415637ecc$export$d40f31ccee2489f.includes(node.type)) return $4b1afda415637ecc$export$4bc65b30e69d96a9(node.expression);
    else return node;
}
const $4b1afda415637ecc$export$43d387e2d68b51dc = (p)=>p.type === 4 && p.isStatic;
function $4b1afda415637ecc$export$69768c9b514a01e9(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return $4b1afda415637ecc$export$e74e82bc14ac4f98;
        case "Suspense":
        case "suspense":
            return $4b1afda415637ecc$export$2237d737f4a10705;
        case "KeepAlive":
        case "keep-alive":
            return $4b1afda415637ecc$export$e9ff5bb5c39478ed;
        case "BaseTransition":
        case "base-transition":
            return $4b1afda415637ecc$export$b357ae9fe0a3685a;
    }
}
const $4b1afda415637ecc$var$nonIdentifierRE = /^$|^\d|[^\$\w\xA0-\uFFFF]/;
const $4b1afda415637ecc$export$3cb8486ad206c65 = (name)=>!$4b1afda415637ecc$var$nonIdentifierRE.test(name);
const $4b1afda415637ecc$export$187a93453b63d7b5 = /[A-Za-z_$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const $4b1afda415637ecc$var$getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const $4b1afda415637ecc$export$fc15bf43a5359adf = (exp)=>{
    const path = $4b1afda415637ecc$var$getExpSource(exp).trim().replace($4b1afda415637ecc$var$whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? $4b1afda415637ecc$export$187a93453b63d7b5 : $4b1afda415637ecc$var$validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const $4b1afda415637ecc$export$380d727799fbcdda = (0, $8POXm.NOOP);
const $4b1afda415637ecc$export$9c8bdf9fab617ce4 = $4b1afda415637ecc$export$fc15bf43a5359adf;
const $4b1afda415637ecc$var$fnExpRE = /^\s*(?:async\s*)?(?:\([^)]*?\)|[\w$_]+)\s*(?::[^=]+)?=>|^\s*(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const $4b1afda415637ecc$export$aaa41f84da434bf1 = (exp)=>$4b1afda415637ecc$var$fnExpRE.test($4b1afda415637ecc$var$getExpSource(exp));
const $4b1afda415637ecc$export$d64efa2398fbfc9d = (0, $8POXm.NOOP);
const $4b1afda415637ecc$export$482164e6e5517986 = $4b1afda415637ecc$export$aaa41f84da434bf1;
function $4b1afda415637ecc$export$1cdf554524c0924f(pos, source, numberOfCharacters = source.length) {
    return $4b1afda415637ecc$export$c57ab60b0c6308ea({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function $4b1afda415637ecc$export$c57ab60b0c6308ea(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function $4b1afda415637ecc$export$a7a9523472993e97(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function $4b1afda415637ecc$export$1199bc2a2b648c8c(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, $8POXm.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function $4b1afda415637ecc$export$4ae65475e3513615(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, name)) return p;
    }
}
function $4b1afda415637ecc$export$45cac5109adb5e55(arg, name) {
    return !!(arg && $4b1afda415637ecc$export$43d387e2d68b51dc(arg) && arg.content === name);
}
function $4b1afda415637ecc$export$4e1f112c75b8dafc(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function $4b1afda415637ecc$export$1879817ac5c922b7(node) {
    return node.type === 5 || node.type === 2;
}
function $4b1afda415637ecc$export$bd191120df7729f2(p) {
    return p.type === 7 && p.name === "pre";
}
function $4b1afda415637ecc$export$eaf8991bb8af8cbb(p) {
    return p.type === 7 && p.name === "slot";
}
function $4b1afda415637ecc$export$f125a8a2b402ed89(node) {
    return node.type === 1 && node.tagType === 3;
}
function $4b1afda415637ecc$export$45f38ad7fffc9b53(node) {
    return node.type === 1 && node.tagType === 2;
}
const $4b1afda415637ecc$var$propsHelperSet = /* @__PURE__ */ new Set([
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, $8POXm.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, $8POXm.isString)(callee) && $4b1afda415637ecc$var$propsHelperSet.has(callee)) return $4b1afda415637ecc$var$getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function $4b1afda415637ecc$export$ec34add3fb2185f8(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, $8POXm.isString)(props) && props.type === 14) {
        const ret = $4b1afda415637ecc$var$getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, $8POXm.isString)(props)) propsWithInjection = $4b1afda415637ecc$export$ccb2e514379853a7([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, $8POXm.isString)(first) && first.type === 15) {
            if (!$4b1afda415637ecc$var$hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === $4b1afda415637ecc$export$4bdbf33367525856) propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift($4b1afda415637ecc$export$ccb2e514379853a7([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!$4b1afda415637ecc$var$hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === $4b1afda415637ecc$export$7046bb8d3c918928) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function $4b1afda415637ecc$var$hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function $4b1afda415637ecc$export$80505c1072df544f(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function $4b1afda415637ecc$export$587b5ad66ebfa843(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && ($4b1afda415637ecc$export$587b5ad66ebfa843(p.arg, ids) || $4b1afda415637ecc$export$587b5ad66ebfa843(p.exp, ids))) return true;
            }
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 11:
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.source, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 9:
            return node.branches.some((b)=>$4b1afda415637ecc$export$587b5ad66ebfa843(b, ids));
        case 10:
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.condition, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 4:
            return !node.isStatic && $4b1afda415637ecc$export$3cb8486ad206c65(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, $8POXm.isObject)(c) && $4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 5:
        case 12:
            return $4b1afda415637ecc$export$587b5ad66ebfa843(node.content, ids);
        case 2:
        case 3:
        case 20:
            return false;
        default:
            return false;
    }
}
function $4b1afda415637ecc$export$39e241985cd3e673(node) {
    if (node.type === 14 && node.callee === $4b1afda415637ecc$export$a0fd71f0f7cd2781) return node.arguments[1].returns;
    else return node;
}
const $4b1afda415637ecc$export$a81a10be31983be5 = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
function $4b1afda415637ecc$export$bf5a08668a401ef9(str) {
    for(let i = 0; i < str.length; i++){
        if (!$4b1afda415637ecc$var$isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function $4b1afda415637ecc$export$e27743005f03840(node) {
    return node.type === 2 && $4b1afda415637ecc$export$bf5a08668a401ef9(node.content) || node.type === 12 && $4b1afda415637ecc$export$e27743005f03840(node.content);
}
function $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(node) {
    return node.type === 3 || $4b1afda415637ecc$export$e27743005f03840(node);
}
const $4b1afda415637ecc$var$defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, $8POXm.NO),
    isPreTag: (0, $8POXm.NO),
    isIgnoreNewlineTag: (0, $8POXm.NO),
    isCustomElement: (0, $8POXm.NO),
    onError: $4b1afda415637ecc$var$defaultOnError,
    onWarn: $4b1afda415637ecc$var$defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let $4b1afda415637ecc$var$currentOptions = $4b1afda415637ecc$var$defaultParserOptions;
let $4b1afda415637ecc$var$currentRoot = null;
let $4b1afda415637ecc$var$currentInput = "";
let $4b1afda415637ecc$var$currentOpenTag = null;
let $4b1afda415637ecc$var$currentProp = null;
let $4b1afda415637ecc$var$currentAttrValue = "";
let $4b1afda415637ecc$var$currentAttrStartIndex = -1;
let $4b1afda415637ecc$var$currentAttrEndIndex = -1;
let $4b1afda415637ecc$var$inPre = 0;
let $4b1afda415637ecc$var$inVPre = false;
let $4b1afda415637ecc$var$currentVPreBoundary = null;
const $4b1afda415637ecc$var$stack = [];
const $4b1afda415637ecc$var$tokenizer = new $4b1afda415637ecc$var$Tokenizer($4b1afda415637ecc$var$stack, {
    onerr: $4b1afda415637ecc$var$emitError,
    ontext (start, end) {
        $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        $4b1afda415637ecc$var$onText(char, start, end);
    },
    oninterpolation (start, end) {
        if ($4b1afda415637ecc$var$inVPre) return $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
        let innerStart = start + $4b1afda415637ecc$var$tokenizer.delimiterOpen.length;
        let innerEnd = end - $4b1afda415637ecc$var$tokenizer.delimiterClose.length;
        while($4b1afda415637ecc$var$isWhitespace($4b1afda415637ecc$var$currentInput.charCodeAt(innerStart)))innerStart++;
        while($4b1afda415637ecc$var$isWhitespace($4b1afda415637ecc$var$currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = $4b1afda415637ecc$var$getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = $4b1afda415637ecc$var$currentOptions.decodeEntities(exp, false);
        $4b1afda415637ecc$var$addNode({
            type: 5,
            content: $4b1afda415637ecc$var$createExp(exp, false, $4b1afda415637ecc$var$getLoc(innerStart, innerEnd)),
            loc: $4b1afda415637ecc$var$getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        $4b1afda415637ecc$var$currentOpenTag = {
            type: 1,
            tag: name,
            ns: $4b1afda415637ecc$var$currentOptions.getNamespace(name, $4b1afda415637ecc$var$stack[0], $4b1afda415637ecc$var$currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: $4b1afda415637ecc$var$getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        $4b1afda415637ecc$var$endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        if (!$4b1afda415637ecc$var$currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < $4b1afda415637ecc$var$stack.length; i++){
                const e = $4b1afda415637ecc$var$stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) $4b1afda415637ecc$var$emitError(24, $4b1afda415637ecc$var$stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = $4b1afda415637ecc$var$stack.shift();
                        $4b1afda415637ecc$var$onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) $4b1afda415637ecc$var$emitError(23, $4b1afda415637ecc$var$backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = $4b1afda415637ecc$var$currentOpenTag.tag;
        $4b1afda415637ecc$var$currentOpenTag.isSelfClosing = true;
        $4b1afda415637ecc$var$endOpenTag(end);
        if ($4b1afda415637ecc$var$stack[0] && $4b1afda415637ecc$var$stack[0].tag === name) $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$stack.shift(), end);
    },
    onattribname (start, end) {
        $4b1afda415637ecc$var$currentProp = {
            type: 6,
            name: $4b1afda415637ecc$var$getSlice(start, end),
            nameLoc: $4b1afda415637ecc$var$getLoc(start, end),
            value: void 0,
            loc: $4b1afda415637ecc$var$getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = $4b1afda415637ecc$var$getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!$4b1afda415637ecc$var$inVPre && name === "") $4b1afda415637ecc$var$emitError(26, start);
        if ($4b1afda415637ecc$var$inVPre || name === "") $4b1afda415637ecc$var$currentProp = {
            type: 6,
            name: raw,
            nameLoc: $4b1afda415637ecc$var$getLoc(start, end),
            value: void 0,
            loc: $4b1afda415637ecc$var$getLoc(start)
        };
        else {
            $4b1afda415637ecc$var$currentProp = {
                type: 7,
                name: name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    $4b1afda415637ecc$export$ac2aa689b44cdd23("prop")
                ] : [],
                loc: $4b1afda415637ecc$var$getLoc(start)
            };
            if (name === "pre") {
                $4b1afda415637ecc$var$inVPre = $4b1afda415637ecc$var$tokenizer.inVPre = true;
                $4b1afda415637ecc$var$currentVPreBoundary = $4b1afda415637ecc$var$currentOpenTag;
                const props = $4b1afda415637ecc$var$currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = $4b1afda415637ecc$var$dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$inVPre && !$4b1afda415637ecc$export$bd191120df7729f2($4b1afda415637ecc$var$currentProp)) {
            $4b1afda415637ecc$var$currentProp.name += arg;
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            $4b1afda415637ecc$var$currentProp.arg = $4b1afda415637ecc$var$createExp(isStatic ? arg : arg.slice(1, -1), isStatic, $4b1afda415637ecc$var$getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$inVPre && !$4b1afda415637ecc$export$bd191120df7729f2($4b1afda415637ecc$var$currentProp)) {
            $4b1afda415637ecc$var$currentProp.name += "." + mod;
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.nameLoc, end);
        } else if ($4b1afda415637ecc$var$currentProp.name === "slot") {
            const arg = $4b1afda415637ecc$var$currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                $4b1afda415637ecc$var$setLocEnd(arg.loc, end);
            }
        } else {
            const exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(mod, true, $4b1afda415637ecc$var$getLoc(start, end));
            $4b1afda415637ecc$var$currentProp.modifiers.push(exp);
        }
    },
    onattribdata (start, end) {
        $4b1afda415637ecc$var$currentAttrValue += $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$currentAttrStartIndex < 0) $4b1afda415637ecc$var$currentAttrStartIndex = start;
        $4b1afda415637ecc$var$currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        $4b1afda415637ecc$var$currentAttrValue += char;
        if ($4b1afda415637ecc$var$currentAttrStartIndex < 0) $4b1afda415637ecc$var$currentAttrStartIndex = start;
        $4b1afda415637ecc$var$currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = $4b1afda415637ecc$var$currentProp.loc.start.offset;
        const name = $4b1afda415637ecc$var$getSlice(start, end);
        if ($4b1afda415637ecc$var$currentProp.type === 7) $4b1afda415637ecc$var$currentProp.rawName = name;
        if ($4b1afda415637ecc$var$currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) $4b1afda415637ecc$var$emitError(2, start);
    },
    onattribend (quote, end) {
        if ($4b1afda415637ecc$var$currentOpenTag && $4b1afda415637ecc$var$currentProp) {
            $4b1afda415637ecc$var$setLocEnd($4b1afda415637ecc$var$currentProp.loc, end);
            if (quote !== 0) {
                if ($4b1afda415637ecc$var$currentAttrValue.includes("&")) $4b1afda415637ecc$var$currentAttrValue = $4b1afda415637ecc$var$currentOptions.decodeEntities($4b1afda415637ecc$var$currentAttrValue, true);
                if ($4b1afda415637ecc$var$currentProp.type === 6) {
                    if ($4b1afda415637ecc$var$currentProp.name === "class") $4b1afda415637ecc$var$currentAttrValue = $4b1afda415637ecc$var$condense($4b1afda415637ecc$var$currentAttrValue).trim();
                    if (quote === 1 && !$4b1afda415637ecc$var$currentAttrValue) $4b1afda415637ecc$var$emitError(13, end);
                    $4b1afda415637ecc$var$currentProp.value = {
                        type: 2,
                        content: $4b1afda415637ecc$var$currentAttrValue,
                        loc: quote === 1 ? $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex, $4b1afda415637ecc$var$currentAttrEndIndex) : $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex - 1, $4b1afda415637ecc$var$currentAttrEndIndex + 1)
                    };
                    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot && $4b1afda415637ecc$var$currentOpenTag.tag === "template" && $4b1afda415637ecc$var$currentProp.name === "lang" && $4b1afda415637ecc$var$currentAttrValue && $4b1afda415637ecc$var$currentAttrValue !== "html") $4b1afda415637ecc$var$tokenizer.enterRCDATA($4b1afda415637ecc$var$toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    $4b1afda415637ecc$var$currentProp.exp = $4b1afda415637ecc$var$createExp($4b1afda415637ecc$var$currentAttrValue, false, $4b1afda415637ecc$var$getLoc($4b1afda415637ecc$var$currentAttrStartIndex, $4b1afda415637ecc$var$currentAttrEndIndex), 0, expParseMode);
                    if ($4b1afda415637ecc$var$currentProp.name === "for") $4b1afda415637ecc$var$currentProp.forParseResult = $4b1afda415637ecc$var$parseForExpression($4b1afda415637ecc$var$currentProp.exp);
                    let syncIndex = -1;
                    if ($4b1afda415637ecc$var$currentProp.name === "bind" && (syncIndex = $4b1afda415637ecc$var$currentProp.modifiers.findIndex((mod)=>mod.content === "sync")) > -1 && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_V_BIND_SYNC", $4b1afda415637ecc$var$currentOptions, $4b1afda415637ecc$var$currentProp.loc, $4b1afda415637ecc$var$currentProp.arg.loc.source)) {
                        $4b1afda415637ecc$var$currentProp.name = "model";
                        $4b1afda415637ecc$var$currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if ($4b1afda415637ecc$var$currentProp.type !== 7 || $4b1afda415637ecc$var$currentProp.name !== "pre") $4b1afda415637ecc$var$currentOpenTag.props.push($4b1afda415637ecc$var$currentProp);
        }
        $4b1afda415637ecc$var$currentAttrValue = "";
        $4b1afda415637ecc$var$currentAttrStartIndex = $4b1afda415637ecc$var$currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if ($4b1afda415637ecc$var$currentOptions.comments) $4b1afda415637ecc$var$addNode({
            type: 3,
            content: $4b1afda415637ecc$var$getSlice(start, end),
            loc: $4b1afda415637ecc$var$getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = $4b1afda415637ecc$var$currentInput.length;
        for(let index = 0; index < $4b1afda415637ecc$var$stack.length; index++){
            $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$stack[index], end - 1);
            $4b1afda415637ecc$var$emitError(24, $4b1afda415637ecc$var$stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if ($4b1afda415637ecc$var$stack[0].ns !== 0) $4b1afda415637ecc$var$onText($4b1afda415637ecc$var$getSlice(start, end), start, end);
        else $4b1afda415637ecc$var$emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if (($4b1afda415637ecc$var$stack[0] ? $4b1afda415637ecc$var$stack[0].ns : $4b1afda415637ecc$var$currentOptions.ns) === 0) $4b1afda415637ecc$var$emitError(21, start - 1);
    }
});
const $4b1afda415637ecc$var$forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const $4b1afda415637ecc$var$stripParensRE = /^\(|\)$/g;
function $4b1afda415637ecc$var$parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match($4b1afda415637ecc$export$a81a10be31983be5);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return $4b1afda415637ecc$var$createExp(content, false, $4b1afda415637ecc$var$getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace($4b1afda415637ecc$var$stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match($4b1afda415637ecc$var$forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace($4b1afda415637ecc$var$forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function $4b1afda415637ecc$var$getSlice(start, end) {
    return $4b1afda415637ecc$var$currentInput.slice(start, end);
}
function $4b1afda415637ecc$var$endOpenTag(end) {
    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot) $4b1afda415637ecc$var$currentOpenTag.innerLoc = $4b1afda415637ecc$var$getLoc(end + 1, end + 1);
    $4b1afda415637ecc$var$addNode($4b1afda415637ecc$var$currentOpenTag);
    const { tag: tag, ns: ns } = $4b1afda415637ecc$var$currentOpenTag;
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isPreTag(tag)) $4b1afda415637ecc$var$inPre++;
    if ($4b1afda415637ecc$var$currentOptions.isVoidTag(tag)) $4b1afda415637ecc$var$onCloseTag($4b1afda415637ecc$var$currentOpenTag, end);
    else {
        $4b1afda415637ecc$var$stack.unshift($4b1afda415637ecc$var$currentOpenTag);
        if (ns === 1 || ns === 2) $4b1afda415637ecc$var$tokenizer.inXML = true;
    }
    $4b1afda415637ecc$var$currentOpenTag = null;
}
function $4b1afda415637ecc$var$onText(content, start, end) {
    {
        const tag = $4b1afda415637ecc$var$stack[0] && $4b1afda415637ecc$var$stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = $4b1afda415637ecc$var$currentOptions.decodeEntities(content, false);
    }
    const parent = $4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        $4b1afda415637ecc$var$setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content: content,
        loc: $4b1afda415637ecc$var$getLoc(start, end)
    });
}
function $4b1afda415637ecc$var$onCloseTag(el, end, isImplied = false) {
    if (isImplied) $4b1afda415637ecc$var$setLocEnd(el.loc, $4b1afda415637ecc$var$backTrack(end, 60));
    else $4b1afda415637ecc$var$setLocEnd(el.loc, $4b1afda415637ecc$var$lookAhead(end, 62) + 1);
    if ($4b1afda415637ecc$var$tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, $8POXm.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, $8POXm.extend)({}, el.innerLoc.start);
        el.innerLoc.source = $4b1afda415637ecc$var$getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag: tag, ns: ns, children: children } = el;
    if (!$4b1afda415637ecc$var$inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if ($4b1afda415637ecc$var$isFragmentTemplate(el)) el.tagType = 3;
        else if ($4b1afda415637ecc$var$isComponent(el)) el.tagType = 1;
    }
    if (!$4b1afda415637ecc$var$tokenizer.inRCDATA) el.children = $4b1afda415637ecc$var$condenseWhitespace(children);
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isIgnoreNewlineTag(tag)) {
        const first = children[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    if (ns === 0 && $4b1afda415637ecc$var$currentOptions.isPreTag(tag)) $4b1afda415637ecc$var$inPre--;
    if ($4b1afda415637ecc$var$currentVPreBoundary === el) {
        $4b1afda415637ecc$var$inVPre = $4b1afda415637ecc$var$tokenizer.inVPre = false;
        $4b1afda415637ecc$var$currentVPreBoundary = null;
    }
    if ($4b1afda415637ecc$var$tokenizer.inXML && ($4b1afda415637ecc$var$stack[0] ? $4b1afda415637ecc$var$stack[0].ns : $4b1afda415637ecc$var$currentOptions.ns) === 0) $4b1afda415637ecc$var$tokenizer.inXML = false;
    {
        const props = el.props;
        if (!$4b1afda415637ecc$var$tokenizer.inSFCRoot && $4b1afda415637ecc$var$isCompatEnabled("COMPILER_NATIVE_TEMPLATE", $4b1afda415637ecc$var$currentOptions) && el.tag === "template" && !$4b1afda415637ecc$var$isFragmentTemplate(el)) {
            const parent = $4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_INLINE_TEMPLATE", $4b1afda415637ecc$var$currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: $4b1afda415637ecc$var$getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function $4b1afda415637ecc$var$lookAhead(index, c) {
    let i = index;
    while($4b1afda415637ecc$var$currentInput.charCodeAt(i) !== c && i < $4b1afda415637ecc$var$currentInput.length - 1)i++;
    return i;
}
function $4b1afda415637ecc$var$backTrack(index, c) {
    let i = index;
    while($4b1afda415637ecc$var$currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const $4b1afda415637ecc$var$specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function $4b1afda415637ecc$var$isFragmentTemplate({ tag: tag, props: props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && $4b1afda415637ecc$var$specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$isComponent({ tag: tag, props: props }) {
    if ($4b1afda415637ecc$var$currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || $4b1afda415637ecc$var$isUpperCase(tag.charCodeAt(0)) || $4b1afda415637ecc$export$69768c9b514a01e9(tag) || $4b1afda415637ecc$var$currentOptions.isBuiltInComponent && $4b1afda415637ecc$var$currentOptions.isBuiltInComponent(tag) || $4b1afda415637ecc$var$currentOptions.isNativeTag && !$4b1afda415637ecc$var$currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if ($4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $4b1afda415637ecc$var$currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, "is") && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $4b1afda415637ecc$var$currentOptions, p.loc)) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$isUpperCase(c) {
    return c > 64 && c < 91;
}
const $4b1afda415637ecc$var$windowsNewlineRE = /\r\n/g;
function $4b1afda415637ecc$var$condenseWhitespace(nodes) {
    const shouldCondense = $4b1afda415637ecc$var$currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!$4b1afda415637ecc$var$inPre) {
                if ($4b1afda415637ecc$export$bf5a08668a401ef9(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && $4b1afda415637ecc$var$hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = $4b1afda415637ecc$var$condense(node.content);
            } else node.content = node.content.replace($4b1afda415637ecc$var$windowsNewlineRE, "\n");
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function $4b1afda415637ecc$var$hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function $4b1afda415637ecc$var$condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if ($4b1afda415637ecc$var$isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function $4b1afda415637ecc$var$addNode(node) {
    ($4b1afda415637ecc$var$stack[0] || $4b1afda415637ecc$var$currentRoot).children.push(node);
}
function $4b1afda415637ecc$var$getLoc(start, end) {
    return {
        start: $4b1afda415637ecc$var$tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : $4b1afda415637ecc$var$tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : $4b1afda415637ecc$var$getSlice(start, end)
    };
}
function $4b1afda415637ecc$var$cloneLoc(loc) {
    return $4b1afda415637ecc$var$getLoc(loc.start.offset, loc.end.offset);
}
function $4b1afda415637ecc$var$setLocEnd(loc, end) {
    loc.end = $4b1afda415637ecc$var$tokenizer.getPos(end);
    loc.source = $4b1afda415637ecc$var$getSlice(loc.start.offset, end);
}
function $4b1afda415637ecc$var$dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: $4b1afda415637ecc$var$getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc: loc
        };
    }
    return attr;
}
function $4b1afda415637ecc$var$createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(content, isStatic, loc, constType);
    return exp;
}
function $4b1afda415637ecc$var$emitError(code, index, message) {
    $4b1afda415637ecc$var$currentOptions.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, $4b1afda415637ecc$var$getLoc(index, index), void 0, message));
}
function $4b1afda415637ecc$var$reset() {
    $4b1afda415637ecc$var$tokenizer.reset();
    $4b1afda415637ecc$var$currentOpenTag = null;
    $4b1afda415637ecc$var$currentProp = null;
    $4b1afda415637ecc$var$currentAttrValue = "";
    $4b1afda415637ecc$var$currentAttrStartIndex = -1;
    $4b1afda415637ecc$var$currentAttrEndIndex = -1;
    $4b1afda415637ecc$var$stack.length = 0;
}
function $4b1afda415637ecc$export$f5f219d5f09c81b5(input, options) {
    $4b1afda415637ecc$var$reset();
    $4b1afda415637ecc$var$currentInput = input;
    $4b1afda415637ecc$var$currentOptions = (0, $8POXm.extend)({}, $4b1afda415637ecc$var$defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) $4b1afda415637ecc$var$currentOptions[key] = options[key];
    }
    $4b1afda415637ecc$var$tokenizer.mode = $4b1afda415637ecc$var$currentOptions.parseMode === "html" ? 1 : $4b1afda415637ecc$var$currentOptions.parseMode === "sfc" ? 2 : 0;
    $4b1afda415637ecc$var$tokenizer.inXML = $4b1afda415637ecc$var$currentOptions.ns === 1 || $4b1afda415637ecc$var$currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        $4b1afda415637ecc$var$tokenizer.delimiterOpen = $4b1afda415637ecc$var$toCharCodes(delimiters[0]);
        $4b1afda415637ecc$var$tokenizer.delimiterClose = $4b1afda415637ecc$var$toCharCodes(delimiters[1]);
    }
    const root = $4b1afda415637ecc$var$currentRoot = $4b1afda415637ecc$export$882461b6382ed46c([], input);
    $4b1afda415637ecc$var$tokenizer.parse($4b1afda415637ecc$var$currentInput);
    root.loc = $4b1afda415637ecc$var$getLoc(0, input.length);
    root.children = $4b1afda415637ecc$var$condenseWhitespace(root.children);
    $4b1afda415637ecc$var$currentRoot = null;
    return root;
}
function $4b1afda415637ecc$var$cacheStatic(root, context) {
    $4b1afda415637ecc$var$walk(root, void 0, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    !!$4b1afda415637ecc$var$getSingleElementRoot(root));
}
function $4b1afda415637ecc$var$getSingleElementRoot(root) {
    const children = root.children.filter((x)=>x.type !== 3);
    return children.length === 1 && children[0].type === 1 && !$4b1afda415637ecc$export$45f38ad7fffc9b53(children[0]) ? children[0] : null;
}
function $4b1afda415637ecc$var$walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children: children } = node;
    const toCache = [];
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    toCache.push(child);
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && $4b1afda415637ecc$var$getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = $4b1afda415637ecc$var$getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12) {
            const constantType = doNotHoistNode ? 0 : $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
            if (constantType >= 2) {
                if (child.codegenNode.type === 14 && child.codegenNode.arguments.length > 0) child.codegenNode.arguments.push(-1 + ``);
                toCache.push(child);
                continue;
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            $4b1afda415637ecc$var$walk(child, node, context, false, inFor);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) $4b1afda415637ecc$var$walk(child, node, context, child.children.length === 1, true);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)$4b1afda415637ecc$var$walk(child.branches[i2], node, context, child.branches[i2].children.length === 1, inFor);
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
        if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, $8POXm.isArray)(node.codegenNode.children)) {
            node.codegenNode.children = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(node.codegenNode.children));
            cachedAsArray = true;
        } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !(0, $8POXm.isArray)(node.codegenNode.children) && node.codegenNode.children.type === 15) {
            const slot = getSlotNode(node.codegenNode, "default");
            if (slot) {
                slot.returns = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !(0, $8POXm.isArray)(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
            const slotName = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot", true);
            const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
            if (slot) {
                slot.returns = getCacheExpression($4b1afda415637ecc$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        }
    }
    if (!cachedAsArray) for (const child of toCache)child.codegenNode = context.cache(child.codegenNode);
    function getCacheExpression(value) {
        const exp = context.cache(value);
        exp.needArraySpread = true;
        return exp;
    }
    function getSlotNode(node2, name) {
        if (node2.children && !(0, $8POXm.isArray)(node2.children) && node2.children.type === 15) {
            const slot = node2.children.properties.find((p)=>p.key === name || p.key.content === name);
            return slot && slot.value;
        }
    }
    if (toCache.length && context.transformHoist) context.transformHoist(children, context, node);
}
function $4b1afda415637ecc$export$7967f5197c38d72a(node, context) {
    const { constantCache: constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = $4b1afda415637ecc$export$7967f5197c38d72a(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = $4b1afda415637ecc$export$7967f5197c38d72a(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                    context.removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return $4b1afda415637ecc$export$7967f5197c38d72a(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, $8POXm.isString)(child) || (0, $8POXm.isSymbol)(child)) continue;
                const childType = $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        case 20:
            return 2;
        default:
            return 0;
    }
}
const $4b1afda415637ecc$var$allowHoistedHelperSet = /* @__PURE__ */ new Set([
    $4b1afda415637ecc$export$6382e3ed89de4e2a,
    $4b1afda415637ecc$export$b9d3780a9ab822b4,
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, $8POXm.isString)(value.callee) && $4b1afda415637ecc$var$allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return $4b1afda415637ecc$export$7967f5197c38d72a(arg, context);
        else if (arg.type === 14) return $4b1afda415637ecc$var$getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = $4b1afda415637ecc$var$getNodeProps(node);
    if (props && props.type === 15) {
        const { properties: properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key: key, value: value } = properties[i];
            const keyType = $4b1afda415637ecc$export$7967f5197c38d72a(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = $4b1afda415637ecc$export$7967f5197c38d72a(value, context);
            else if (value.type === 14) valueType = $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function $4b1afda415637ecc$var$getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function $4b1afda415637ecc$export$7438cb739e972616(root, { filename: filename = "", prefixIdentifiers: prefixIdentifiers = false, hoistStatic: hoistStatic = false, hmr: hmr = false, cacheHandlers: cacheHandlers = false, nodeTransforms: nodeTransforms = [], directiveTransforms: directiveTransforms = {}, transformHoist: transformHoist = null, isBuiltInComponent: isBuiltInComponent = (0, $8POXm.NOOP), isCustomElement: isCustomElement = (0, $8POXm.NOOP), expressionPlugins: expressionPlugins = [], scopeId: scopeId = null, slotted: slotted = true, ssr: ssr = false, inSSR: inSSR = false, ssrCssVars: ssrCssVars = ``, bindingMetadata: bindingMetadata = (0, $8POXm.EMPTY_OBJ), inline: inline = false, isTS: isTS = false, onError: onError = $4b1afda415637ecc$var$defaultOnError, onWarn: onWarn = $4b1afda415637ecc$var$defaultOnWarn, compatConfig: compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        filename: // options
        filename,
        selfName: nameMatch && (0, $8POXm.capitalize)((0, $8POXm.camelize)(nameMatch[1])),
        prefixIdentifiers: prefixIdentifiers,
        hoistStatic: hoistStatic,
        hmr: hmr,
        cacheHandlers: cacheHandlers,
        nodeTransforms: nodeTransforms,
        directiveTransforms: directiveTransforms,
        transformHoist: transformHoist,
        isBuiltInComponent: isBuiltInComponent,
        isCustomElement: isCustomElement,
        expressionPlugins: expressionPlugins,
        scopeId: scopeId,
        slotted: slotted,
        ssr: ssr,
        inSSR: inSSR,
        ssrCssVars: ssrCssVars,
        bindingMetadata: bindingMetadata,
        inline: inline,
        isTS: isTS,
        onError: onError,
        onWarn: onWarn,
        compatConfig: compatConfig,
        root: // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        cached: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        temps: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, $8POXm.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, $8POXm.isString)(exp)) exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(exp);
            context.hoists.push(exp);
            const identifier = $4b1afda415637ecc$export$ac2aa689b44cdd23(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false, inVOnce = false) {
            const cacheExp = $4b1afda415637ecc$export$4abd162ddf919697(context.cached.length, exp, isVNode, inVOnce);
            context.cached.push(cacheExp);
            return cacheExp;
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function $4b1afda415637ecc$export$51186ad6e864892a(root, options) {
    const context = $4b1afda415637ecc$export$7438cb739e972616(root, options);
    $4b1afda415637ecc$export$c9d429747c1011af(root, context);
    if (options.hoistStatic) $4b1afda415637ecc$var$cacheStatic(root, context);
    if (!options.ssr) $4b1afda415637ecc$var$createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function $4b1afda415637ecc$var$createRootCodegen(root, context) {
    const { helper: helper } = context;
    const { children: children } = root;
    if (children.length === 1) {
        const singleElementRootChild = $4b1afda415637ecc$var$getSingleElementRoot(root);
        if (singleElementRootChild && singleElementRootChild.codegenNode) {
            const codegenNode = singleElementRootChild.codegenNode;
            if (codegenNode.type === 13) $4b1afda415637ecc$export$dc00c05f515bd739(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = children[0];
    } else if (children.length > 1) {
        let patchFlag = 64;
        root.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function $4b1afda415637ecc$var$traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, $8POXm.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        $4b1afda415637ecc$export$c9d429747c1011af(child, context);
    }
}
function $4b1afda415637ecc$export$c9d429747c1011af(node, context) {
    context.currentNode = node;
    const { nodeTransforms: nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, $8POXm.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3);
            break;
        case 5:
            if (!context.ssr) context.helper($4b1afda415637ecc$export$68f5914cce0a5680);
            break;
        // for container types, further traverse downwards
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)$4b1afda415637ecc$export$c9d429747c1011af(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            $4b1afda415637ecc$var$traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function $4b1afda415637ecc$export$aee0887cf96094d7(name, fn) {
    const matches = (0, $8POXm.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props: props } = node;
            if (node.tagType === 3 && props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const $4b1afda415637ecc$var$PURE_ANNOTATION = `/*@__PURE__*/`;
const $4b1afda415637ecc$var$aliasHelper = (s)=>`${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}: _${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}`;
function $4b1afda415637ecc$var$createCodegenContext(ast, { mode: mode = "function", prefixIdentifiers: prefixIdentifiers = mode === "module", sourceMap: sourceMap = false, filename: filename = `template.vue.html`, scopeId: scopeId = null, optimizeImports: optimizeImports = false, runtimeGlobalName: runtimeGlobalName = `Vue`, runtimeModuleName: runtimeModuleName = `vue`, ssrRuntimeModuleName: ssrRuntimeModuleName = "vue/server-renderer", ssr: ssr = false, isTS: isTS = false, inSSR: inSSR = false }) {
    const context = {
        mode: mode,
        prefixIdentifiers: prefixIdentifiers,
        sourceMap: sourceMap,
        filename: filename,
        scopeId: scopeId,
        optimizeImports: optimizeImports,
        runtimeGlobalName: runtimeGlobalName,
        runtimeModuleName: runtimeModuleName,
        ssrRuntimeModuleName: ssrRuntimeModuleName,
        ssr: ssr,
        isTS: isTS,
        inSSR: inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function $4b1afda415637ecc$export$80d376111cc09ad7(ast, options = {}) {
    const context = $4b1afda415637ecc$var$createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode: mode, push: push, prefixIdentifiers: prefixIdentifiers, indent: indent, deindent: deindent, newline: newline, scopeId: scopeId, ssr: ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    $4b1afda415637ecc$var$genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map($4b1afda415637ecc$var$aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        $4b1afda415637ecc$var$genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        $4b1afda415637ecc$var$genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        $4b1afda415637ecc$var$genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) $4b1afda415637ecc$var$genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast: ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function $4b1afda415637ecc$var$genFunctionPreamble(ast, context) {
    const { ssr: ssr, prefixIdentifiers: prefixIdentifiers, push: push, newline: newline, runtimeModuleName: runtimeModuleName, runtimeGlobalName: runtimeGlobalName, ssrRuntimeModuleName: ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                $4b1afda415637ecc$export$6db5bf2474139178,
                $4b1afda415637ecc$export$b22e7e78da20c982,
                $4b1afda415637ecc$export$b2aae42fb0a19db3,
                $4b1afda415637ecc$export$8890896270dfc293,
                $4b1afda415637ecc$export$1a493e4b98fdcf3
            ].filter((helper)=>helpers.includes(helper)).map($4b1afda415637ecc$var$aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    $4b1afda415637ecc$var$genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function $4b1afda415637ecc$var$genAssets(assets, type, { helper: helper, push: push, newline: newline, isTS: isTS }) {
    const resolver = helper(type === "filter" ? $4b1afda415637ecc$export$2c190751e09c3969 : type === "component" ? $4b1afda415637ecc$export$28c52e95383d270 : $4b1afda415637ecc$export$7f3ccc2ef793ecce);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${$4b1afda415637ecc$export$80505c1072df544f(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function $4b1afda415637ecc$var$genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push: push, newline: newline } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = `);
            $4b1afda415637ecc$var$genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function $4b1afda415637ecc$var$isText(n) {
    return (0, $8POXm.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function $4b1afda415637ecc$var$genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    $4b1afda415637ecc$var$genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function $4b1afda415637ecc$var$genNodeList(nodes, context, multilines = false, comma = true) {
    const { push: push, newline: newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, $8POXm.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, $8POXm.isArray)(node)) $4b1afda415637ecc$var$genNodeListAsArray(node, context);
        else $4b1afda415637ecc$var$genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function $4b1afda415637ecc$var$genNode(node, context) {
    if ((0, $8POXm.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, $8POXm.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 2:
            $4b1afda415637ecc$var$genText(node, context);
            break;
        case 4:
            $4b1afda415637ecc$var$genExpression(node, context);
            break;
        case 5:
            $4b1afda415637ecc$var$genInterpolation(node, context);
            break;
        case 12:
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 8:
            $4b1afda415637ecc$var$genCompoundExpression(node, context);
            break;
        case 3:
            $4b1afda415637ecc$var$genComment(node, context);
            break;
        case 13:
            $4b1afda415637ecc$var$genVNodeCall(node, context);
            break;
        case 14:
            $4b1afda415637ecc$var$genCallExpression(node, context);
            break;
        case 15:
            $4b1afda415637ecc$var$genObjectExpression(node, context);
            break;
        case 17:
            $4b1afda415637ecc$var$genArrayExpression(node, context);
            break;
        case 18:
            $4b1afda415637ecc$var$genFunctionExpression(node, context);
            break;
        case 19:
            $4b1afda415637ecc$var$genConditionalExpression(node, context);
            break;
        case 20:
            $4b1afda415637ecc$var$genCacheExpression(node, context);
            break;
        case 21:
            $4b1afda415637ecc$var$genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        /* v8 ignore start */ case 10:
            break;
        default:
    }
}
function $4b1afda415637ecc$var$genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genExpression(node, context) {
    const { content: content, isStatic: isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genInterpolation(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$68f5914cce0a5680)}(`);
    $4b1afda415637ecc$var$genNode(node.content, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, $8POXm.isString)(child)) context.push(child, -3 /* Unknown */ );
        else $4b1afda415637ecc$var$genNode(child, context);
    }
}
function $4b1afda415637ecc$var$genExpressionAsPropertyKey(node, context) {
    const { push: push } = context;
    if (node.type === 8) {
        push(`[`);
        $4b1afda415637ecc$var$genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = $4b1afda415637ecc$export$3cb8486ad206c65(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genComment(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$b2aae42fb0a19db3)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function $4b1afda415637ecc$var$genVNodeCall(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const { tag: tag, props: props, children: children, patchFlag: patchFlag, dynamicProps: dynamicProps, directives: directives, isBlock: isBlock, disableTracking: disableTracking, isComponent: isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper($4b1afda415637ecc$export$a5e4c1729e50ed6d) + `(`);
    if (isBlock) push(`(${helper($4b1afda415637ecc$export$59578e14f90a15eb)}(${disableTracking ? `true` : ``}), `);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    const callHelper = isBlock ? $4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent) : $4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    $4b1afda415637ecc$var$genNodeList($4b1afda415637ecc$var$genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        $4b1afda415637ecc$var$genNode(directives, context);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function $4b1afda415637ecc$var$genCallExpression(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const callee = (0, $8POXm.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    $4b1afda415637ecc$var$genNodeList(node.arguments, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genObjectExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    const { properties: properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key: key, value: value } = properties[i];
        $4b1afda415637ecc$var$genExpressionAsPropertyKey(key, context);
        push(`: `);
        $4b1afda415637ecc$var$genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function $4b1afda415637ecc$var$genArrayExpression(node, context) {
    $4b1afda415637ecc$var$genNodeListAsArray(node.elements, context);
}
function $4b1afda415637ecc$var$genFunctionExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent } = context;
    const { params: params, returns: returns, body: body, newline: newline, isSlot: isSlot } = node;
    if (isSlot) push(`_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[$4b1afda415637ecc$export$141e17a2b5200090]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, $8POXm.isArray)(params)) $4b1afda415637ecc$var$genNodeList(params, context);
    else if (params) $4b1afda415637ecc$var$genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, $8POXm.isArray)(returns)) $4b1afda415637ecc$var$genNodeListAsArray(returns, context);
        else $4b1afda415637ecc$var$genNode(returns, context);
    } else if (body) $4b1afda415637ecc$var$genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genConditionalExpression(node, context) {
    const { test: test, consequent: consequent, alternate: alternate, newline: needNewline } = node;
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    if (test.type === 4) {
        const needsParens = !$4b1afda415637ecc$export$3cb8486ad206c65(test.content);
        needsParens && push(`(`);
        $4b1afda415637ecc$var$genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        $4b1afda415637ecc$var$genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    $4b1afda415637ecc$var$genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    $4b1afda415637ecc$var$genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function $4b1afda415637ecc$var$genCacheExpression(node, context) {
    const { push: push, helper: helper, indent: indent, deindent: deindent, newline: newline } = context;
    const { needPauseTracking: needPauseTracking, needArraySpread: needArraySpread } = node;
    if (needArraySpread) push(`[...(`);
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
        indent();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(-1`);
        if (node.inVOnce) push(`, true`);
        push(`),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    $4b1afda415637ecc$var$genNode(node.value, context);
    if (needPauseTracking) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
    if (needArraySpread) push(`)]`);
}
const $4b1afda415637ecc$var$prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const $4b1afda415637ecc$var$stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function $4b1afda415637ecc$var$validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace($4b1afda415637ecc$var$stripStringRE, "").match($4b1afda415637ecc$var$prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(46, node.loc, void 0, message));
    }
}
const $4b1afda415637ecc$export$7e9f01d2df839553 = (node, context)=>{
    if (node.type === 5) node.content = $4b1afda415637ecc$export$997045dce990ec35(node.content, context);
    else if (node.type === 1) {
        const memo = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        for(let i = 0; i < node.props.length; i++){
            const dir = node.props[i];
            if (dir.type === 7 && dir.name !== "for") {
                const exp = dir.exp;
                const arg = dir.arg;
                if (exp && exp.type === 4 && !(dir.name === "on" && arg) && // key has been processed in transformFor(vMemo + vFor)
                !(memo && arg && arg.type === 4 && arg.content === "key")) dir.exp = $4b1afda415637ecc$export$997045dce990ec35(exp, context, // slot args must be processed as function params
                dir.name === "slot");
                if (arg && arg.type === 4 && !arg.isStatic) dir.arg = $4b1afda415637ecc$export$997045dce990ec35(arg, context);
            }
        }
    }
};
function $4b1afda415637ecc$export$997045dce990ec35(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function $4b1afda415637ecc$export$123a9f8105e820ce(exp) {
    if ((0, $8POXm.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map($4b1afda415637ecc$export$123a9f8105e820ce).join("");
}
const $4b1afda415637ecc$var$transformIf = $4b1afda415637ecc$export$aee0887cf96094d7(/^(?:if|else|else-if)$/, (node, dir, context)=>{
    return $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = $4b1afda415637ecc$var$getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(28, dir.loc));
        dir.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: $4b1afda415637ecc$var$cloneLoc(node.loc),
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && $4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(sibling)) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if ((dir.name === "else-if" || dir.name === "else") && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, node.loc));
                context.removeNode();
                const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                $4b1afda415637ecc$export$c9d429747c1011af(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, node.loc));
            break;
        }
    }
}
function $4b1afda415637ecc$var$createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !$4b1afda415637ecc$export$1199bc2a2b648c8c(node, "for") ? node.children : [
            node
        ],
        userKey: $4b1afda415637ecc$export$4ae65475e3513615(node, `key`),
        isTemplateIf: isTemplateIf
    };
}
function $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return $4b1afda415637ecc$export$374e02fb5bd90a4e(branch.condition, $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3), [
        '""',
        "true"
    ]));
    else return $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context);
}
function $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper: helper } = context;
    const keyProperty = $4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(`${keyIndex}`, false, $4b1afda415637ecc$export$6c4f24c93c3e8659, 2));
    const { children: children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            return $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = $4b1afda415637ecc$export$39e241985cd3e673(ret);
        if (vnodeCall.type === 13) $4b1afda415637ecc$export$dc00c05f515bd739(vnodeCall, context);
        $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
        return ret;
    }
}
function $4b1afda415637ecc$var$isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function $4b1afda415637ecc$var$getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const $4b1afda415637ecc$var$transformFor = $4b1afda415637ecc$export$aee0887cf96094d7("for", (node, dir, context)=>{
    const { helper: helper, removeHelper: removeHelper } = context;
    return $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, (forNode)=>{
        const renderExp = $4b1afda415637ecc$export$2cdf8617f9d8e39d(helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
            forNode.source
        ]);
        const isTemplate = $4b1afda415637ecc$export$f125a8a2b402ed89(node);
        const memo = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        const keyProp = $4b1afda415637ecc$export$4ae65475e3513615(node, `key`, false, true);
        keyProp && keyProp.type;
        let keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? $4b1afda415637ecc$export$ac2aa689b44cdd23(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? $4b1afda415637ecc$export$45231d90c148ea74(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            let childBlock;
            const { children: children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = $4b1afda415637ecc$export$45f38ad7fffc9b53(node) ? node : isTemplate && node.children.length === 1 && $4b1afda415637ecc$export$45f38ad7fffc9b53(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), keyProperty ? $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                        removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                    } else removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper($4b1afda415637ecc$export$59578e14f90a15eb);
                    helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                } else helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult, [
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cached`)
                ]));
                loop.body = $4b1afda415637ecc$export$c3ad9e28586f1d07([
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `if (_cached && _cached.el`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString($4b1afda415637ecc$export$ae18cf0dc81df35a)}(_cached, _memo)) return _cached`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _item = `,
                        childBlock
                    ]),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_item.memo = _memo`),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`return _item`)
                ]);
                renderExp.arguments.push(loop, $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cache`), $4b1afda415637ecc$export$ac2aa689b44cdd23(String(context.cached.length)));
                context.cached.push(null);
            } else renderExp.arguments.push($4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult), childBlock, true));
        };
    });
});
function $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32, dir.loc));
        return;
    }
    $4b1afda415637ecc$var$finalizeForParseResult(parseResult, context);
    const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers, scopes: scopes } = context;
    const { source: source, value: value, key: key, index: index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source: source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult: parseResult,
        children: $4b1afda415637ecc$export$f125a8a2b402ed89(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function $4b1afda415637ecc$var$finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function $4b1afda415637ecc$export$5796ae82f3e98f88({ value: value, key: key, index: index }, memoArgs = []) {
    return $4b1afda415637ecc$var$createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function $4b1afda415637ecc$var$createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || $4b1afda415637ecc$export$ac2aa689b44cdd23(`_`.repeat(i2 + 1), false));
}
const $4b1afda415637ecc$var$defaultFallback = $4b1afda415637ecc$export$ac2aa689b44cdd23(`undefined`, false);
const $4b1afda415637ecc$export$f0a2c7894e526c50 = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const $4b1afda415637ecc$export$38b9212074cad7c2 = (node, context)=>{
    let vFor;
    if ($4b1afda415637ecc$export$f125a8a2b402ed89(node) && node.props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb) && (vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            $4b1afda415637ecc$var$finalizeForParseResult(result, context);
            const { value: value, key: key, index: index } = result;
            const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const $4b1afda415637ecc$var$buildClientSlotFn = (props, _vForExp, children, loc)=>$4b1afda415637ecc$export$253e05bfd5b6c4c6(props, children, false, true, children.length ? children[0].loc : loc);
function $4b1afda415637ecc$export$8083554712300565(node, context, buildSlotFn = $4b1afda415637ecc$var$buildClientSlotFn) {
    context.helper($4b1afda415637ecc$export$141e17a2b5200090);
    const { children: children, loc: loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "slot", true);
    if (onComponentSlot) {
        const { arg: arg, exp: exp } = onComponentSlot;
        if (arg && !$4b1afda415637ecc$export$43d387e2d68b51dc(arg)) hasDynamicSlots = true;
        slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(arg || $4b1afda415637ecc$export$ac2aa689b44cdd23("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!$4b1afda415637ecc$export$f125a8a2b402ed89(slotElement) || !(slotDir = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = $4b1afda415637ecc$export$ac2aa689b44cdd23(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push($4b1afda415637ecc$export$374e02fb5bd90a4e(vIf.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback));
        } else if (vElse = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, /^else(?:-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (!$4b1afda415637ecc$export$6d8f8b0d7fdfb5b0(prev)) break;
            }
            if (prev && $4b1afda415637ecc$export$f125a8a2b402ed89(prev) && $4b1afda415637ecc$export$1199bc2a2b648c8c(prev, /^(?:else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? $4b1afda415637ecc$export$374e02fb5bd90a4e(vElse.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback) : $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                $4b1afda415637ecc$var$finalizeForParseResult(parseResult, context);
                dynamicSlots.push($4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
                    parseResult.source,
                    $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(parseResult), $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return $4b1afda415637ecc$export$45231d90c148ea74(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        !implicitDefaultChildren.every($4b1afda415637ecc$export$e27743005f03840)) {
            if (hasNamedDefaultSlot) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : $4b1afda415637ecc$var$hasForwardedSlots(node.children) ? 3 : 1;
    let slots = $4b1afda415637ecc$export$ccb2e514379853a7(slotsProperties.concat($4b1afda415637ecc$export$45231d90c148ea74(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    $4b1afda415637ecc$export$ac2aa689b44cdd23(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6a6b6a5c860c238d), [
        slots,
        $4b1afda415637ecc$export$c887713da9895dbb(dynamicSlots)
    ]);
    return {
        slots: slots,
        hasDynamicSlots: hasDynamicSlots
    };
}
function $4b1afda415637ecc$var$buildDynamicSlot(name, fn, index) {
    const props = [
        $4b1afda415637ecc$export$45231d90c148ea74(`name`, name),
        $4b1afda415637ecc$export$45231d90c148ea74(`fn`, fn)
    ];
    if (index != null) props.push($4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(String(index), true)));
    return $4b1afda415637ecc$export$ccb2e514379853a7(props);
}
function $4b1afda415637ecc$var$hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || $4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
const $4b1afda415637ecc$var$directiveImportMap = /* @__PURE__ */ new WeakMap();
const $4b1afda415637ecc$export$5d90dc62c1c9e431 = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag: tag, props: props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, $8POXm.isObject)(vnodeTag) && vnodeTag.callee === $4b1afda415637ecc$export$582a2287b73d3265;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === $4b1afda415637ecc$export$e74e82bc14ac4f98 || vnodeTag === $4b1afda415637ecc$export$2237d737f4a10705 || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? $4b1afda415637ecc$export$c887713da9895dbb(directives.map((dir)=>$4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === $4b1afda415637ecc$export$e9ff5bb5c39478ed) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98 && // explained above.
            vnodeTag !== $4b1afda415637ecc$export$e9ff5bb5c39478ed;
            if (shouldBuildAsSlots) {
                const { slots: slots, hasDynamicSlots: hasDynamicSlots } = $4b1afda415637ecc$export$8083554712300565(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = $4b1afda415637ecc$var$stringifyDynamicPropNames(dynamicPropNames);
        node.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context, ssr = false) {
    let { tag: tag } = node;
    const isExplicitDynamic = $4b1afda415637ecc$var$isComponentTag(tag);
    const isProp = $4b1afda415637ecc$export$4ae65475e3513615(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && $4b1afda415637ecc$export$ac2aa689b44cdd23(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(`is`, false, isProp.arg.loc);
            }
            if (exp) return $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$582a2287b73d3265), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = $4b1afda415637ecc$export$69768c9b514a01e9(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper($4b1afda415637ecc$export$28c52e95383d270);
    context.components.add(tag);
    return $4b1afda415637ecc$export$80505c1072df544f(tag, `component`);
}
function $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag: tag, loc: elementLoc, children: children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push($4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23("ref_for", true), $4b1afda415637ecc$export$ac2aa689b44cdd23("true")));
    };
    const analyzePatchFlag = ({ key: key, value: value })=>{
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
            const name = key.content;
            const isEventHandler = (0, $8POXm.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, $8POXm.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, $8POXm.isReservedProp)(name)) hasVnodeHook = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && $4b1afda415637ecc$export$7967f5197c38d72a(value, context) > 0) return;
            if (name === "ref") hasRef = true;
            else if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc: loc, name: name, nameLoc: nameLoc, value: value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && ($4b1afda415637ecc$var$isComponentTag(tag) || value && value.content.startsWith("vue:") || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23(name, true, nameLoc), $4b1afda415637ecc$export$ac2aa689b44cdd23(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name: name, arg: arg, exp: exp, loc: loc, modifiers: modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "is") && ($4b1afda415637ecc$var$isComponentTag(tag) || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "key") || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "vue:before-update")) shouldUseBlock = true;
            if (isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushMergeArg();
                        if ($4b1afda415637ecc$var$isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        pushRefVForMarker();
                        pushMergeArg();
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc: loc,
                        callee: context.helper($4b1afda415637ecc$export$4bdbf33367525856),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.some((mod)=>mod.content === "prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime: needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !$4b1afda415637ecc$export$43d387e2d68b51dc(arg)) pushMergeArg($4b1afda415637ecc$export$ccb2e514379853a7(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, $8POXm.isSymbol)(needRuntime)) $4b1afda415637ecc$var$directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, $8POXm.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = $4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !$4b1afda415637ecc$export$43d387e2d68b51dc(classProp.value)) classProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6382e3ed89de4e2a), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b9d3780a9ab822b4), [
                    styleProp.value
                ]);
            } else propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$7046bb8d3c918928), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag: patchFlag,
        dynamicPropNames: dynamicPropNames,
        shouldUseBlock: shouldUseBlock
    };
}
function $4b1afda415637ecc$var$dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, $8POXm.isOn)(name)) $4b1afda415637ecc$var$mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function $4b1afda415637ecc$var$mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = $4b1afda415637ecc$export$c887713da9895dbb([
        existing.value,
        incoming.value
    ], existing.loc);
}
function $4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context) {
    const dirArgs = [];
    const runtime = $4b1afda415637ecc$var$directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper($4b1afda415637ecc$export$7f3ccc2ef793ecce);
        context.directives.add(dir.name);
        dirArgs.push($4b1afda415637ecc$export$80505c1072df544f(dir.name, `directive`));
    }
    const { loc: loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
        dirArgs.push($4b1afda415637ecc$export$ccb2e514379853a7(dir.modifiers.map((modifier)=>$4b1afda415637ecc$export$45231d90c148ea74(modifier, trueExpression)), loc));
    }
    return $4b1afda415637ecc$export$c887713da9895dbb(dirArgs, dir.loc);
}
function $4b1afda415637ecc$var$stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function $4b1afda415637ecc$var$isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const $4b1afda415637ecc$var$transformSlotOutlet = (node, context)=>{
    if ($4b1afda415637ecc$export$45f38ad7fffc9b53(node)) {
        const { children: children, loc: loc } = node;
        const { slotName: slotName, slotProps: slotProps } = $4b1afda415637ecc$export$cab34cff437fc757(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = $4b1afda415637ecc$export$253e05bfd5b6c4c6([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a91e32c6b04aa348), slotArgs, loc);
    }
};
function $4b1afda415637ecc$export$cab34cff437fc757(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, $8POXm.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, $8POXm.camelize)(p.arg.content);
                slotName = p.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && $4b1afda415637ecc$export$43d387e2d68b51dc(p.arg)) p.arg.content = (0, $8POXm.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props: props, directives: directives } = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(36, directives[0].loc));
    }
    return {
        slotName: slotName,
        slotProps: slotProps
    };
}
const $4b1afda415637ecc$export$ff060d152244ee7b = (dir, node, context, augmentor)=>{
    const { loc: loc, modifiers: modifiers, arg: arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = $4b1afda415637ecc$export$ac2aa689b44cdd23(eventString, true, arg.loc);
        } else eventName = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = $4b1afda415637ecc$export$9c8bdf9fab617ce4(exp);
        const isInlineStatement = !(isMemberExp || $4b1afda415637ecc$export$482164e6e5517986(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(eventName, exp || $4b1afda415637ecc$export$ac2aa689b44cdd23(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const $4b1afda415637ecc$export$2fa367e7c04d4515 = (dir, _node, context)=>{
    const { modifiers: modifiers, loc: loc } = dir;
    const arg = dir.arg;
    let { exp: exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = arg.content ? `${arg.content} || ""` : `""`;
    if (modifiers.some((mod)=>mod.content === "camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, $8POXm.camelize)(arg.content);
            else arg.content = `${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.some((mod)=>mod.content === "prop")) $4b1afda415637ecc$var$injectPrefix(arg, ".");
        if (modifiers.some((mod)=>mod.content === "attr")) $4b1afda415637ecc$var$injectPrefix(arg, "^");
    }
    return {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(arg, exp)
        ]
    };
};
const $4b1afda415637ecc$var$injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const $4b1afda415637ecc$var$transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if ($4b1afda415637ecc$export$1879817ac5c922b7(next)) {
                        if (!currentContainer) currentContainer = children[i] = $4b1afda415637ecc$export$60ad01cd5cde5e50([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$8890896270dfc293), callArgs)
                };
            }
        }
    };
};
const $4b1afda415637ecc$var$seen$1 = /* @__PURE__ */ new WeakSet();
const $4b1afda415637ecc$var$transformOnce = (node, context)=>{
    if (node.type === 1 && $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "once", true)) {
        if ($4b1afda415637ecc$var$seen$1.has(node) || context.inVOnce || context.inSSR) return;
        $4b1afda415637ecc$var$seen$1.add(node);
        context.inVOnce = true;
        context.helper($4b1afda415637ecc$export$37cf1f9ab937c10d);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true, true);
        };
    }
};
const $4b1afda415637ecc$export$567db1f69abf4dcb = (dir, node, context)=>{
    const { exp: exp, arg: arg } = dir;
    if (!exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(41, dir.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const rawExp = exp.loc.source.trim();
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(44, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    if (bindingType === "literal-const" || bindingType === "setup-const") {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(45, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    if (!expString.trim() || !$4b1afda415637ecc$export$9c8bdf9fab617ce4(exp) && true) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(42, exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const propName = arg ? arg : $4b1afda415637ecc$export$ac2aa689b44cdd23("modelValue", true);
    const eventName = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `onUpdate:${(0, $8POXm.camelize)(arg.content)}` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        $4b1afda415637ecc$export$45231d90c148ea74(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        $4b1afda415637ecc$export$45231d90c148ea74(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>m.content).map((m)=>($4b1afda415637ecc$export$3cb8486ad206c65(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `${arg.content}Modifiers` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push($4b1afda415637ecc$export$45231d90c148ea74(modifiersKey, $4b1afda415637ecc$export$ac2aa689b44cdd23(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return $4b1afda415637ecc$var$createTransformProps(props);
};
function $4b1afda415637ecc$var$createTransformProps(props = []) {
    return {
        props: props
    };
}
const $4b1afda415637ecc$var$validDivisionCharRE = /[\w).+\-_$\]]/;
const $4b1afda415637ecc$var$transformFilter = (node, context)=>{
    if (!$4b1afda415637ecc$var$isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) $4b1afda415637ecc$var$rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) $4b1afda415637ecc$var$rewriteFilter(prop.exp, context);
    });
};
function $4b1afda415637ecc$var$rewriteFilter(node, context) {
    if (node.type === 4) $4b1afda415637ecc$var$parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) $4b1afda415637ecc$var$parseFilter(child, context);
        else if (child.type === 8) $4b1afda415637ecc$var$rewriteFilter(node, context);
        else if (child.type === 5) $4b1afda415637ecc$var$rewriteFilter(child.content, context);
    }
}
function $4b1afda415637ecc$var$parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                // "
                case 39:
                    inSingle = true;
                    break;
                // '
                case 96:
                    inTemplateString = true;
                    break;
                // `
                case 40:
                    paren++;
                    break;
                // (
                case 41:
                    paren--;
                    break;
                // )
                case 91:
                    square++;
                    break;
                // [
                case 93:
                    square--;
                    break;
                // ]
                case 123:
                    curly++;
                    break;
                // {
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !$4b1afda415637ecc$var$validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = $4b1afda415637ecc$var$wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function $4b1afda415637ecc$var$wrapFilter(exp, filter, context) {
    context.helper($4b1afda415637ecc$export$2c190751e09c3969);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${$4b1afda415637ecc$export$80505c1072df544f(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${$4b1afda415637ecc$export$80505c1072df544f(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const $4b1afda415637ecc$var$seen = /* @__PURE__ */ new WeakSet();
const $4b1afda415637ecc$var$transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, "memo");
        if (!dir || $4b1afda415637ecc$var$seen.has(node) || context.inSSR) return;
        $4b1afda415637ecc$var$seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) $4b1afda415637ecc$export$dc00c05f515bd739(codegenNode, context);
                node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a0fd71f0f7cd2781), [
                    dir.exp,
                    $4b1afda415637ecc$export$253e05bfd5b6c4c6(void 0, codegenNode),
                    `_cache`,
                    String(context.cached.length)
                ]);
                context.cached.push(null);
            }
        };
    }
};
const $4b1afda415637ecc$export$4df7de08397f97e2 = (node, context)=>{
    if (node.type === 1) {
        for (const prop of node.props)if (prop.type === 7 && prop.name === "bind" && (!prop.exp || // #13930 :foo in in-DOM templates will be parsed into :foo="" by browser
        prop.exp.type === 4 && !prop.exp.content.trim()) && prop.arg) {
            const arg = prop.arg;
            if (arg.type !== 4 || !arg.isStatic) {
                context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(53, arg.loc));
                prop.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23("", true, arg.loc);
            } else {
                const propName = (0, $8POXm.camelize)(arg.content);
                if ($4b1afda415637ecc$export$187a93453b63d7b5.test(propName[0]) || // allow hyphen first char for https://github.com/vuejs/language-tools/pull/3424
                propName[0] === "-") prop.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(propName, false, arg.loc);
            }
        }
    }
};
function $4b1afda415637ecc$export$20c96dae9bab51d8(prefixIdentifiers) {
    return [
        [
            $4b1afda415637ecc$export$4df7de08397f97e2,
            $4b1afda415637ecc$var$transformOnce,
            $4b1afda415637ecc$var$transformIf,
            $4b1afda415637ecc$var$transformMemo,
            $4b1afda415637ecc$var$transformFor,
            $4b1afda415637ecc$var$transformFilter,
            $4b1afda415637ecc$var$transformSlotOutlet,
            $4b1afda415637ecc$export$5d90dc62c1c9e431,
            $4b1afda415637ecc$export$f0a2c7894e526c50,
            $4b1afda415637ecc$var$transformText
        ],
        {
            on: $4b1afda415637ecc$export$ff060d152244ee7b,
            bind: $4b1afda415637ecc$export$2fa367e7c04d4515,
            model: $4b1afda415637ecc$export$567db1f69abf4dcb
        }
    ];
}
function $4b1afda415637ecc$export$3243579822c486a0(source, options = {}) {
    const onError = options.onError || $4b1afda415637ecc$var$defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(48));
    else if (isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(49));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(50));
    if (options.scopeId && !isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(51));
    const resolvedOptions = (0, $8POXm.extend)({}, options, {
        prefixIdentifiers: prefixIdentifiers
    });
    const ast = (0, $8POXm.isString)(source) ? $4b1afda415637ecc$export$f5f219d5f09c81b5(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = $4b1afda415637ecc$export$20c96dae9bab51d8();
    $4b1afda415637ecc$export$51186ad6e864892a(ast, (0, $8POXm.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $8POXm.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return $4b1afda415637ecc$export$80d376111cc09ad7(ast, resolvedOptions);
}
const $4b1afda415637ecc$export$54871af2607057e6 = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const $4b1afda415637ecc$export$eb34aa2b2065da17 = ()=>({
        props: []
    });

});




parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1EVTs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $13566f5161335ae3$export$2e2bcd8739ae039);
parcelRequire("dk7qG");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $13566f5161335ae3$export$2e2bcd8739ae039 = {
    __name: 'Domov',
    setup (__props, { expose: __expose }) {
        __expose();
        const icon = new URL((parcelRequire("9ZY69"))).href;
        const router = (0, $73mM4.useRouter)();
        const text = (0, $01W3b.ref)('');
        function goToTranslate() {
            router.push({
                path: '/preklad',
                query: {
                    text: text.value
                }
            });
        }
        const __returned__ = {
            icon: icon,
            router: router,
            text: text,
            goToTranslate: goToTranslate,
            ref: $01W3b.ref,
            get useRouter () {
                return 0, $73mM4.useRouter;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", () => $a809ac530d32f081$export$7b4942f78e7b8a49);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
$parcel$export(module.exports, "useRoute", () => $a809ac530d32f081$export$3f79f0b98112cf57);
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ 
var $hbbek = parcelRequire("hbbek");
parcelRequire("dk7qG");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region src/history/html5.ts
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $a809ac530d32f081$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $hbbek.V)(pathFromHash, "");
    }
    return (0, $hbbek.V)(pathname, base) + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $hbbek.k).pop,
                direction: delta ? delta > 0 ? (0, $hbbek.O).forward : (0, $hbbek.O).back : (0, $hbbek.O).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $hbbek.J)({}, history$1.state, {
                scroll: (0, $hbbek.C)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $hbbek.C)() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $hbbek.J)({}, history$1.state, $a809ac530d32f081$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $hbbek.J)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $hbbek.C)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $hbbek.J)({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = (0, $hbbek.M)(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $hbbek.J)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $hbbek.j).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $hbbek.A),
            {}
        ]
    ];
    let position = 0;
    base = (0, $hbbek.M)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $hbbek.k).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $hbbek.A),
        state: {},
        base: base,
        createHref: (0, $hbbek.j).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $hbbek.A),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $hbbek.O).back : (0, $hbbek.O).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $a809ac530d32f081$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $a809ac530d32f081$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($a809ac530d32f081$var$TokenizerState || {});
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: $a809ac530d32f081$var$TokenType.Static,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $a809ac530d32f081$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $a809ac530d32f081$var$TokenizerState.Static) segment.push({
            type: $a809ac530d32f081$var$TokenType.Static,
            value: buffer
        });
        else if (state === $a809ac530d32f081$var$TokenizerState.Param || state === $a809ac530d32f081$var$TokenizerState.ParamRegExp || state === $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $a809ac530d32f081$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $a809ac530d32f081$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $a809ac530d32f081$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $a809ac530d32f081$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $a809ac530d32f081$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $a809ac530d32f081$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $a809ac530d32f081$var$TokenizerState.Param:
                if (char === "(") state = $a809ac530d32f081$var$TokenizerState.ParamRegExp;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $a809ac530d32f081$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $a809ac530d32f081$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $a809ac530d32f081$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $a809ac530d32f081$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $a809ac530d32f081$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($a809ac530d32f081$var$PathScore || {});
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = (0, $hbbek.J)({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $a809ac530d32f081$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $a809ac530d32f081$var$PathScore.Segment + (options.sensitive ? $a809ac530d32f081$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $a809ac530d32f081$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $a809ac530d32f081$var$PathScore.Static;
            } else if (token.type === $a809ac530d32f081$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                if (re$1 !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $a809ac530d32f081$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $a809ac530d32f081$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $a809ac530d32f081$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $a809ac530d32f081$var$TokenType.Static) path += token.value;
            else if (token.type === $a809ac530d32f081$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $hbbek.X)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $hbbek.X)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $a809ac530d32f081$var$PathScore.Static + $a809ac530d32f081$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $a809ac530d32f081$var$PathScore.Static + $a809ac530d32f081$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = (0, $hbbek.J)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $hbbek.Z)($a809ac530d32f081$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $hbbek.Z)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$normalizeRouteRecord((0, $hbbek.J)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($a809ac530d32f081$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $hbbek.Q);
    }
    function removeRoute(matcherRef) {
        if ((0, $hbbek.S)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $a809ac530d32f081$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $hbbek.y)((0, $hbbek._).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $hbbek.J)($a809ac530d32f081$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $a809ac530d32f081$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $hbbek.y)((0, $hbbek._).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $hbbek.J)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $a809ac530d32f081$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $hbbek.J)(meta, record.meta), {});
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $hbbek.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $hbbek.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $hbbek.K)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $hbbek.K)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $a809ac530d32f081$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($a809ac530d32f081$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $a809ac530d32f081$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $a809ac530d32f081$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($a809ac530d32f081$var$isMatchable(ancestor) && $a809ac530d32f081$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $a809ac530d32f081$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)((0, $hbbek.d));
    const currentRoute = (0, $TusQn.inject)((0, $hbbek.u));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $hbbek.L).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $hbbek.L).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $hbbek.I)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) {
            const p = router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch((0, $hbbek.Q));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $hbbek.$)) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $hbbek.x)((0, $01W3b.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $a809ac530d32f081$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $a809ac530d32f081$var$RouterLinkImpl = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)((0, $hbbek.d));
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $a809ac530d32f081$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $hbbek.X)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $a809ac530d32f081$var$RouterViewImpl = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)((0, $hbbek.f));
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)((0, $hbbek.p), 0);
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)((0, $hbbek.p), (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)((0, $hbbek.l), matchedRouteRef);
        (0, $TusQn.provide)((0, $hbbek.f), routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        (0, $01W3b.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $hbbek.L)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, (0, $hbbek.J)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $hbbek.$) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $hbbek.X)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $hbbek.K)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $hbbek.h);
    const stringifyQuery$1 = options.stringifyQuery || (0, $hbbek.g);
    const routerHistory = options.history;
    const beforeGuards = (0, $hbbek.c)();
    const beforeResolveGuards = (0, $hbbek.c)();
    const afterGuards = (0, $hbbek.c)();
    const currentRoute = (0, $01W3b.shallowRef)((0, $hbbek.P));
    let pendingLocation = (0, $hbbek.P);
    if ((0, $hbbek.$) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $hbbek.q).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $hbbek.q).bind(null, (0, $hbbek.W));
    const decodeParams = (0, $hbbek.q).bind(null, (0, $hbbek.H));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $hbbek.S)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $hbbek.J)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $hbbek.R)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $hbbek.J)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $hbbek.H)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $hbbek.J)({}, rawLocation, {
            path: (0, $hbbek.R)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $hbbek.J)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $hbbek.J)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $hbbek.B)(stringifyQuery$1, (0, $hbbek.J)({}, rawLocation, {
            hash: (0, $hbbek.U)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $hbbek.J)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $hbbek.g) ? (0, $hbbek.m)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $hbbek.R)(parseQuery$1, to, currentRoute.value.path) : (0, $hbbek.J)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $hbbek.y)((0, $hbbek._).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $hbbek.J)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $hbbek.J)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $hbbek.J)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $hbbek.J)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $hbbek.F)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $hbbek.y)((0, $hbbek._).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $hbbek.b)(error) ? (0, $hbbek.b)(error, (0, $hbbek._).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $hbbek.b)(failure$1, (0, $hbbek._).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $hbbek.J)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $hbbek.J)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $hbbek.n)(to, from);
        guards = (0, $hbbek.r)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $hbbek.i)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $hbbek.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $hbbek.r)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $hbbek.i)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $hbbek.X)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $hbbek.i)(beforeEnter, to, from));
                else guards.push((0, $hbbek.i)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $hbbek.r)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $hbbek.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $hbbek.b)(err, (0, $hbbek._).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $hbbek.P);
        const state = !(0, $hbbek.$) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $hbbek.J)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $hbbek.J)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $hbbek.Q));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $hbbek.$) (0, $hbbek.E)((0, $hbbek.T)(from.fullPath, info.delta), (0, $hbbek.C)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $hbbek.b)(error, (0, $hbbek._).NAVIGATION_ABORTED | (0, $hbbek._).NAVIGATION_CANCELLED)) return error;
                if ((0, $hbbek.b)(error, (0, $hbbek._).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $hbbek.J)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $hbbek.b)(failure, (0, $hbbek._).NAVIGATION_ABORTED | (0, $hbbek._).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $hbbek.k).pop) routerHistory.go(-1, false);
                    }).catch((0, $hbbek.Q));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $hbbek.b)(failure, (0, $hbbek._).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $hbbek.k).pop && (0, $hbbek.b)(failure, (0, $hbbek._).NAVIGATION_ABORTED | (0, $hbbek._).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $hbbek.Q));
        });
    }
    let readyHandlers = (0, $hbbek.c)();
    let errorListeners = (0, $hbbek.c)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $hbbek.P)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $hbbek.$) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $hbbek.w)((0, $hbbek.T)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $hbbek.D)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            if ((0, $hbbek.$) && !started && currentRoute.value === (0, $hbbek.P)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $hbbek.P)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $hbbek.d), router);
            app.provide((0, $hbbek.u), (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide((0, $hbbek.f), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $hbbek.P);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $hbbek.P);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $hbbek.$)) (0, $hbbek.t)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)((0, $hbbek.d));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $a809ac530d32f081$export$3f79f0b98112cf57(_name) {
    return (0, $TusQn.inject)((0, $hbbek.u));
}

});
parcelRegister("hbbek", function(module, exports) {

$parcel$export(module.exports, "$", () => $e75a6c24923c03f0$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "J", () => $e75a6c24923c03f0$export$b4171a6734a65d42);
$parcel$export(module.exports, "q", () => $e75a6c24923c03f0$export$9e5f44173e64f162);
$parcel$export(module.exports, "X", () => $e75a6c24923c03f0$export$78acf4525d8a74c4);
$parcel$export(module.exports, "Q", () => $e75a6c24923c03f0$export$3722cfe417b6ed86);
$parcel$export(module.exports, "Z", () => $e75a6c24923c03f0$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "K", () => $e75a6c24923c03f0$export$3466f893ebf79586);
$parcel$export(module.exports, "U", () => $e75a6c24923c03f0$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "W", () => $e75a6c24923c03f0$export$71cec2538cb2c617);
$parcel$export(module.exports, "H", () => $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "R", () => $e75a6c24923c03f0$export$db202ddc8be9136);
$parcel$export(module.exports, "B", () => $e75a6c24923c03f0$export$ef35774e6d314e91);
$parcel$export(module.exports, "V", () => $e75a6c24923c03f0$export$e7c866399fa523f5);
$parcel$export(module.exports, "F", () => $e75a6c24923c03f0$export$d66501df72047452);
$parcel$export(module.exports, "L", () => $e75a6c24923c03f0$export$61196ced6d74a310);
$parcel$export(module.exports, "I", () => $e75a6c24923c03f0$export$9bb611d729802a56);
$parcel$export(module.exports, "P", () => $e75a6c24923c03f0$export$56c0d5a1e737357d);
$parcel$export(module.exports, "k", () => $e75a6c24923c03f0$export$342063e11d6c3cad);
$parcel$export(module.exports, "O", () => $e75a6c24923c03f0$export$c4ce752e73470fba);
$parcel$export(module.exports, "A", () => $e75a6c24923c03f0$export$ebd11618f299a286);
$parcel$export(module.exports, "M", () => $e75a6c24923c03f0$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "j", () => $e75a6c24923c03f0$export$35e795649ee09318);
$parcel$export(module.exports, "C", () => $e75a6c24923c03f0$export$e7094788287c5e9b);
$parcel$export(module.exports, "D", () => $e75a6c24923c03f0$export$96f57966bedc81b4);
$parcel$export(module.exports, "T", () => $e75a6c24923c03f0$export$971d5caa766a69d7);
$parcel$export(module.exports, "E", () => $e75a6c24923c03f0$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "w", () => $e75a6c24923c03f0$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e75a6c24923c03f0$export$d141bba7fdc215a3);
$parcel$export(module.exports, "S", () => $e75a6c24923c03f0$export$25ce5a424b770e84);
$parcel$export(module.exports, "_", () => $e75a6c24923c03f0$export$71511d61b312f219);
$parcel$export(module.exports, "y", () => $e75a6c24923c03f0$export$4a5767248b18ef41);
$parcel$export(module.exports, "b", () => $e75a6c24923c03f0$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $e75a6c24923c03f0$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "g", () => $e75a6c24923c03f0$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $e75a6c24923c03f0$export$953cecd6e717a553);
$parcel$export(module.exports, "l", () => $e75a6c24923c03f0$export$882b5998b3b9117c);
$parcel$export(module.exports, "p", () => $e75a6c24923c03f0$export$ffb5f4729a158638);
$parcel$export(module.exports, "d", () => $e75a6c24923c03f0$export$4368d992c4eafac0);
$parcel$export(module.exports, "u", () => $e75a6c24923c03f0$export$3b14a55fb2447963);
$parcel$export(module.exports, "f", () => $e75a6c24923c03f0$export$2d1720544b23b823);
$parcel$export(module.exports, "c", () => $e75a6c24923c03f0$export$db3b6bfb95261072);
$parcel$export(module.exports, "i", () => $e75a6c24923c03f0$export$23f2a1d2818174ef);
$parcel$export(module.exports, "r", () => $e75a6c24923c03f0$export$43caf9889c228507);
$parcel$export(module.exports, "n", () => $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "t", () => $e75a6c24923c03f0$export$625550452a3fa3ec);
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $j6G8F = parcelRequire("j6G8F");
//#region src/utils/env.ts
const $e75a6c24923c03f0$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $e75a6c24923c03f0$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $e75a6c24923c03f0$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $e75a6c24923c03f0$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $e75a6c24923c03f0$var$isRouteComponent(obj.default);
}
const $e75a6c24923c03f0$export$b4171a6734a65d42 = Object.assign;
function $e75a6c24923c03f0$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $e75a6c24923c03f0$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $e75a6c24923c03f0$export$78acf4525d8a74c4 = Array.isArray;
function $e75a6c24923c03f0$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $e75a6c24923c03f0$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $e75a6c24923c03f0$var$HASH_RE = /#/g;
const $e75a6c24923c03f0$var$AMPERSAND_RE = /&/g;
const $e75a6c24923c03f0$var$SLASH_RE = /\//g;
const $e75a6c24923c03f0$var$EQUAL_RE = /=/g;
const $e75a6c24923c03f0$var$IM_RE = /\?/g;
const $e75a6c24923c03f0$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $e75a6c24923c03f0$var$ENC_CARET_RE = /%5E/g;
const $e75a6c24923c03f0$var$ENC_BACKTICK_RE = /%60/g;
const $e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $e75a6c24923c03f0$var$ENC_PIPE_RE = /%7C/g;
const $e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $e75a6c24923c03f0$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($e75a6c24923c03f0$var$ENC_PIPE_RE, "|").replace($e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE, "[").replace($e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$encodeQueryValue(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$PLUS_RE, "%2B").replace($e75a6c24923c03f0$var$ENC_SPACE_RE, "+").replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$AMPERSAND_RE, "%26").replace($e75a6c24923c03f0$var$ENC_BACKTICK_RE, "`").replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $e75a6c24923c03f0$var$encodeQueryKey(text) {
    return $e75a6c24923c03f0$var$encodeQueryValue(text).replace($e75a6c24923c03f0$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$2329c99376c9d0a4(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$71cec2538cb2c617(text) {
    return $e75a6c24923c03f0$export$2329c99376c9d0a4(text).replace($e75a6c24923c03f0$var$SLASH_RE, "%2F");
}
function $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $e75a6c24923c03f0$var$TRAILING_SLASH_RE = /\/$/;
const $e75a6c24923c03f0$var$removeTrailingSlash = (path)=>path.replace($e75a6c24923c03f0$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $e75a6c24923c03f0$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $e75a6c24923c03f0$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $e75a6c24923c03f0$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $e75a6c24923c03f0$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $e75a6c24923c03f0$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $e75a6c24923c03f0$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $e75a6c24923c03f0$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $e75a6c24923c03f0$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $e75a6c24923c03f0$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $e75a6c24923c03f0$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(a) ? $e75a6c24923c03f0$var$isEquivalentArray(a, b) : $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? $e75a6c24923c03f0$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $e75a6c24923c03f0$var$isEquivalentArray(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $e75a6c24923c03f0$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $e75a6c24923c03f0$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $e75a6c24923c03f0$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $e75a6c24923c03f0$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $e75a6c24923c03f0$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $e75a6c24923c03f0$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($e75a6c24923c03f0$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $e75a6c24923c03f0$var$removeTrailingSlash(base);
}
const $e75a6c24923c03f0$var$BEFORE_HASH_RE = /^[^#]+#/;
function $e75a6c24923c03f0$export$35e795649ee09318(base, location) {
    return base.replace($e75a6c24923c03f0$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $e75a6c24923c03f0$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $e75a6c24923c03f0$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $e75a6c24923c03f0$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $e75a6c24923c03f0$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $e75a6c24923c03f0$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $e75a6c24923c03f0$var$scrollPositions = /* @__PURE__ */ new Map();
function $e75a6c24923c03f0$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $e75a6c24923c03f0$var$scrollPositions.set(key, scrollPosition);
}
function $e75a6c24923c03f0$export$efccba1c4a2ef57b(key) {
    const scroll = $e75a6c24923c03f0$var$scrollPositions.get(key);
    $e75a6c24923c03f0$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $e75a6c24923c03f0$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $e75a6c24923c03f0$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $e75a6c24923c03f0$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $e75a6c24923c03f0$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $e75a6c24923c03f0$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $e75a6c24923c03f0$var$ErrorTypeMessages = {
    [$e75a6c24923c03f0$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$e75a6c24923c03f0$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $e75a6c24923c03f0$export$4a5767248b18ef41(type, params) {
    return $e75a6c24923c03f0$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$e75a6c24923c03f0$var$NavigationFailureSymbol]: true
    }, params);
}
function $e75a6c24923c03f0$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $e75a6c24923c03f0$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $e75a6c24923c03f0$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $e75a6c24923c03f0$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $e75a6c24923c03f0$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $e75a6c24923c03f0$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($e75a6c24923c03f0$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$e75a6c24923c03f0$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $e75a6c24923c03f0$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $e75a6c24923c03f0$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $e75a6c24923c03f0$var$encodeQueryValue(v)) : [
            value && $e75a6c24923c03f0$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $e75a6c24923c03f0$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $e75a6c24923c03f0$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $e75a6c24923c03f0$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $e75a6c24923c03f0$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $e75a6c24923c03f0$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $e75a6c24923c03f0$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $e75a6c24923c03f0$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $e75a6c24923c03f0$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($e75a6c24923c03f0$export$d141bba7fdc215a3(valid)) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $e75a6c24923c03f0$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $e75a6c24923c03f0$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $e75a6c24923c03f0$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($e75a6c24923c03f0$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $e75a6c24923c03f0$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $e75a6c24923c03f0$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $e75a6c24923c03f0$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$e75a6c24923c03f0$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $e75a6c24923c03f0$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $e75a6c24923c03f0$var$routerId = 0;
function $e75a6c24923c03f0$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $e75a6c24923c03f0$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $e75a6c24923c03f0$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $e75a6c24923c03f0$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $e75a6c24923c03f0$var$PINK_500
                });
            }
            if ($e75a6c24923c03f0$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $e75a6c24923c03f0$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $e75a6c24923c03f0$var$RED_100;
                        textColor = $e75a6c24923c03f0$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $e75a6c24923c03f0$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $e75a6c24923c03f0$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $01W3b.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("beforeEach"),
                from: $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $e75a6c24923c03f0$var$formatDisplay("\u274C");
            } else data.status = $e75a6c24923c03f0$var$formatDisplay("\u2705");
            data.from = $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$e75a6c24923c03f0$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$e75a6c24923c03f0$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($e75a6c24923c03f0$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $e75a6c24923c03f0$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$e75a6c24923c03f0$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $e75a6c24923c03f0$var$PINK_500 = 15485081;
const $e75a6c24923c03f0$var$BLUE_600 = 2450411;
const $e75a6c24923c03f0$var$LIME_500 = 8702998;
const $e75a6c24923c03f0$var$CYAN_400 = 2282478;
const $e75a6c24923c03f0$var$ORANGE_400 = 16486972;
const $e75a6c24923c03f0$var$DARK = 6710886;
const $e75a6c24923c03f0$var$RED_100 = 16704226;
const $e75a6c24923c03f0$var$RED_700 = 12131356;
function $e75a6c24923c03f0$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $e75a6c24923c03f0$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($e75a6c24923c03f0$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($e75a6c24923c03f0$var$formatRouteRecordForInspector)
    };
}
let $e75a6c24923c03f0$var$routeRecordId = 0;
const $e75a6c24923c03f0$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $e75a6c24923c03f0$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $e75a6c24923c03f0$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$e75a6c24923c03f0$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$e75a6c24923c03f0$var$markRouteRecordActive(childRoute, currentRoute));
}
function $e75a6c24923c03f0$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
}
function $e75a6c24923c03f0$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($e75a6c24923c03f0$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
}
function $e75a6c24923c03f0$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}

});
parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});





parcelRegister("9ZY69", function(module, exports) {
module.exports = import.meta.resolve("eRTM3");

});


parcelRegister("7BmyY", function(module, exports) {

$parcel$export(module.exports, "render", () => $588d7daf54c3ff60$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $588d7daf54c3ff60$var$_hoisted_1 = {
    class: "section is-flex is-flex-direction-column is-align-items-center"
};
const $588d7daf54c3ff60$var$_hoisted_2 = {
    class: "section columns is-variable is-8 is-multiline"
};
const $588d7daf54c3ff60$var$_hoisted_3 = {
    class: "column is-full-mobile is-half-tablet is-half-desktop"
};
const $588d7daf54c3ff60$var$_hoisted_4 = {
    class: "control is-large"
};
function $588d7daf54c3ff60$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", $588d7daf54c3ff60$var$_hoisted_1, [
        _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("h1", {
            class: "title center is-size-2"
        }, "Prelo\u017Ete rus\xedn\u010Dinu ihne\u010F!", -1)),
        (0, $TusQn.createElementVNode)("section", $588d7daf54c3ff60$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $588d7daf54c3ff60$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $588d7daf54c3ff60$var$_hoisted_4, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.text = $event),
                        class: "textarea is-large mb-4",
                        placeholder: "Zadajte text v rus\xedn\u010Dine"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $setup.text
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", {
                class: "column is-full-mobile is-half-tablet is-half-desktop is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start"
            }, [
                _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("p", {
                    class: "subtitle",
                    style: {
                        "max-width": "400px"
                    }
                }, "Zadajte ak\xfdko\u013Evek text v rus\xednskom jazyku, a nechajte si ho prelo\u017Ei\u0165 do slovensk\xe9ho jazyka alebo transliterujte do latinskej abecedy.", -1)),
                (0, $TusQn.createElementVNode)("button", {
                    class: "link px-2 py-2 mx-5",
                    onClick: $setup.goToTranslate
                }, "Preklad")
            ])
        ])
    ]);
}

});

parcelRegister("95Qlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ed2f47972f4b4f$export$2e2bcd8739ae039);
let $69ed2f47972f4b4f$var$NOOP = ()=>{};
var $69ed2f47972f4b4f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hG6XS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cdebc2fb43ec6f32$export$2e2bcd8739ae039);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $aOjOf = parcelRequire("aOjOf");
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $eYmJT = parcelRequire("eYmJT");
const $cdebc2fb43ec6f32$var$API_URL = "https://api.rusyn.it";

var $cdebc2fb43ec6f32$export$2e2bcd8739ae039 = {
    __name: 'Preklad',
    setup (__props, { expose: __expose }) {
        __expose();
        const showScanner = (0, $01W3b.ref)(false);
        const scannerTarget = (0, $01W3b.ref)('rusyn'); // Track which field the scanner is for
        const route = (0, $73mM4.useRoute)();
        const openScanner = (target)=>{
            scannerTarget.value = target;
            showScanner.value = true;
        };
        const handleScannedText = (text)=>{
            // Put scanned text in the appropriate field
            if (scannerTarget.value === 'rusyn') {
                if (rusyn_text.value) rusyn_text.value.value = text;
                target_lang = 'slovak'; // Source is Rusyn, translate to Slovak
                slovakIsDisabled.value = true;
                rusynIsDisabled.value = false;
            } else {
                if (slovak_text.value) slovak_text.value.value = text;
                target_lang = 'rusyn'; // Source is Slovak, translate to Rusyn
                rusynIsDisabled.value = true;
                slovakIsDisabled.value = false;
            }
            showScanner.value = false;
            // Automatically translate the scanned text
            setTimeout(()=>translate(), 100);
        };
        (0, $TusQn.onMounted)(()=>{
            if (route.query.text && rusyn_text.value) {
                rusyn_text.value.value = route.query.text;
                slovakIsDisabled.value = true;
                target_lang = 'slovak';
            }
            initWhisper();
        });
        const cyrillicPattern = /[\u0400-\u04FF]/;
        const rusyn_text = (0, $01W3b.ref)(null);
        const slovakIsDisabled = (0, $01W3b.ref)(false);
        const slovak_text = (0, $01W3b.ref)(null);
        const rusynIsDisabled = (0, $01W3b.ref)(false);
        const isRusynLoading = (0, $01W3b.ref)(false);
        const isSlovakLoading = (0, $01W3b.ref)(false);
        const isRusynError = (0, $01W3b.ref)(false);
        const isSlovakError = (0, $01W3b.ref)(false);
        const rusynType = (0, $01W3b.ref)('cyr');
        // Voice recognition state
        const isRecording = (0, $01W3b.ref)(false);
        const isRecording2 = (0, $01W3b.ref)(false);
        const whisperStatus = (0, $01W3b.ref)('');
        const whisperPipeline = (0, $01W3b.ref)(null);
        const mediaRecorder = (0, $01W3b.ref)(null);
        const audioChunks = (0, $01W3b.ref)([]);
        const activeRecordingTarget = (0, $01W3b.ref)(null);
        const isCyrillic = (t)=>cyrillicPattern.test(t);
        const isLatin = (t)=>/[A-Za-z\u00C0-\u017F]/.test(t);
        function toggleRusynScript() {
            const newScript = rusynType.value === 'cyr' ? 'lat' : 'cyr';
            const val = rusyn_text.value?.value || '';
            rusynType.value = newScript;
            if (!val.trim()) return;
            if (newScript === 'lat') {
                if (isCyrillic(val)) rusyn_text.value.value = (0, $aOjOf.translit)(val, 'cyrLat');
            } else if (isLatin(val)) rusyn_text.value.value = (0, $aOjOf.translit)(val, 'latCyr');
        }
        let target_lang = "";
        function onInput(origin) {
            const r = rusyn_text.value?.value || '';
            const s = slovak_text.value?.value || '';
            const val = origin === 'rusyn' ? r : s;
            if (!val.trim()) {
                if (origin === 'rusyn') {
                    if (s.trim()) {
                        if (isCyrillic(s)) {
                            target_lang = 'slovak';
                            slovakIsDisabled.value = true;
                            rusynIsDisabled.value = false;
                        } else {
                            target_lang = 'rusyn';
                            rusynIsDisabled.value = true;
                            slovakIsDisabled.value = false;
                        }
                    } else {
                        rusynIsDisabled.value = false;
                        slovakIsDisabled.value = false;
                        target_lang = '';
                    }
                } else if (r.trim()) {
                    if (isCyrillic(r)) {
                        target_lang = 'slovak';
                        slovakIsDisabled.value = true;
                        rusynIsDisabled.value = false;
                    } else {
                        target_lang = 'rusyn';
                        rusynIsDisabled.value = true;
                        slovakIsDisabled.value = false;
                    }
                } else {
                    rusynIsDisabled.value = false;
                    slovakIsDisabled.value = false;
                    target_lang = '';
                }
                return;
            }
            if (isCyrillic(val)) {
                target_lang = 'slovak';
                slovakIsDisabled.value = true;
                rusynIsDisabled.value = false;
            } else if (origin === 'slovak') {
                target_lang = 'rusyn';
                rusynIsDisabled.value = true;
                slovakIsDisabled.value = false;
            } else {
                target_lang = 'slovak';
                slovakIsDisabled.value = true;
                rusynIsDisabled.value = false;
            }
        }
        function translate() {
            isSlovakError.value = false;
            isRusynError.value = false;
            if (target_lang == "slovak") {
                if (slovak_text.value) slovak_text.value.value = "";
                let translation_text = rusyn_text.value?.value || '';
                if (!isCyrillic(translation_text)) translation_text = (0, $aOjOf.translit)(translation_text, "latCyr");
                isSlovakLoading.value = true;
                (0, $7we3r.default).get($cdebc2fb43ec6f32$var$API_URL + '/translate/rue/sk/' + translation_text).catch(function(error) {
                    if (slovak_text.value) slovak_text.value.value = error.message;
                    isSlovakError.value = true;
                }).then(function(response) {
                    if (slovak_text.value) slovak_text.value.value = response.data;
                }).finally(()=>isSlovakLoading.value = false);
            } else if (target_lang == "rusyn") {
                if (rusyn_text.value) rusyn_text.value.value = "";
                const translation_text = slovak_text.value?.value || '';
                isRusynLoading.value = true;
                (0, $7we3r.default).get($cdebc2fb43ec6f32$var$API_URL + '/translate/sk/rue/' + translation_text).catch(function(error) {
                    if (rusyn_text.value) rusyn_text.value.value = error.message;
                    isRusynError.value = true;
                }).then(function(response) {
                    if (rusyn_text.value) rusyn_text.value.value = response.data;
                }).finally(()=>isRusynLoading.value = false);
            }
        }
        // Whisper.js Voice Recognition
        async function initWhisper() {
            try {
                whisperStatus.value = "Na\u010D\xedtavam Whisper model...";
                const { pipeline: pipeline, env: env } = await (parcelRequire("iRsSD"));
                env.allowLocalModels = false;
                env.useBrowserCache = true;
                whisperPipeline.value = await pipeline('automatic-speech-recognition', 'Xenova/whisper-tiny');
                whisperStatus.value = '';
            } catch (e) {
                console.error('Failed to load Whisper:', e);
                whisperStatus.value = "Chyba pri na\u010D\xedtavan\xed Whisper modelu";
            }
        }
        async function toggleRecording(target) {
            if (target === 'rusyn') {
                if (isRecording.value) stopRecording();
                else startRecording('rusyn');
            } else if (isRecording2.value) stopRecording();
            else startRecording('slovak');
        }
        async function startRecording(target) {
            if (!whisperPipeline.value) {
                whisperStatus.value = "Whisper model e\u0161te nie je na\u010D\xedtan\xfd...";
                return;
            }
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
                activeRecordingTarget.value = target;
                audioChunks.value = [];
                mediaRecorder.value = new MediaRecorder(stream);
                mediaRecorder.value.ondataavailable = (event)=>{
                    audioChunks.value.push(event.data);
                };
                mediaRecorder.value.onstop = async ()=>{
                    const audioBlob = new Blob(audioChunks.value, {
                        type: 'audio/webm'
                    });
                    try {
                        whisperStatus.value = "Sprac\xfavam re\u010D...";
                        const audioContext = new AudioContext({
                            sampleRate: 16000
                        });
                        const arrayBuffer = await audioBlob.arrayBuffer();
                        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
                        const result = await whisperPipeline.value(audioBuffer, {
                            chunk_length_s: 30,
                            stride_length_s: 5
                        });
                        const transcript = result.text?.trim() || '';
                        if (transcript) {
                            if (activeRecordingTarget.value === 'rusyn') {
                                if (rusyn_text.value) rusyn_text.value.value = rusyn_text.value.value ? rusyn_text.value.value + '\n' + transcript : transcript;
                            } else if (slovak_text.value) slovak_text.value.value = slovak_text.value.value ? slovak_text.value.value + '\n' + transcript : transcript;
                        }
                        whisperStatus.value = '';
                    } catch (e) {
                        console.error('Speech recognition failed:', e);
                        whisperStatus.value = "Chyba pri rozpozn\xe1van\xed re\u010Di";
                    }
                    stream.getTracks().forEach((track)=>track.stop());
                };
                mediaRecorder.value.start();
                if (target === 'rusyn') {
                    isRecording.value = true;
                    isRecording2.value = false;
                } else {
                    isRecording2.value = true;
                    isRecording.value = false;
                }
            } catch (e) {
                console.error('Failed to access microphone:', e);
                if (e.name === 'NotAllowedError') whisperStatus.value = "Pr\xedstup k mikrof\xf3nu bol zamietnut\xfd";
                else whisperStatus.value = 'Chyba: ' + e.message;
            }
        }
        function stopRecording() {
            if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') mediaRecorder.value.stop();
            isRecording.value = false;
            isRecording2.value = false;
            activeRecordingTarget.value = null;
        }
        // Watch for recording state changes to stop recording when toggled off
        (0, $01W3b.watch)([
            isRecording,
            isRecording2
        ], ([newRusyn, newSlovak], [oldRusyn, oldSlovak])=>{
            if (oldRusyn && !newRusyn && mediaRecorder.value) stopRecording();
            if (oldSlovak && !newSlovak && mediaRecorder.value) stopRecording();
        });
        const __returned__ = {
            showScanner: showScanner,
            scannerTarget: scannerTarget,
            route: route,
            openScanner: openScanner,
            handleScannedText: handleScannedText,
            API_URL: $cdebc2fb43ec6f32$var$API_URL,
            cyrillicPattern: cyrillicPattern,
            rusyn_text: rusyn_text,
            slovakIsDisabled: slovakIsDisabled,
            slovak_text: slovak_text,
            rusynIsDisabled: rusynIsDisabled,
            isRusynLoading: isRusynLoading,
            isSlovakLoading: isSlovakLoading,
            isRusynError: isRusynError,
            isSlovakError: isSlovakError,
            rusynType: rusynType,
            isRecording: isRecording,
            isRecording2: isRecording2,
            whisperStatus: whisperStatus,
            whisperPipeline: whisperPipeline,
            mediaRecorder: mediaRecorder,
            audioChunks: audioChunks,
            activeRecordingTarget: activeRecordingTarget,
            isCyrillic: isCyrillic,
            isLatin: isLatin,
            toggleRusynScript: toggleRusynScript,
            get target_lang () {
                return target_lang;
            },
            set target_lang (v){
                target_lang = v;
            },
            onInput: onInput,
            translate: translate,
            initWhisper: initWhisper,
            toggleRecording: toggleRecording,
            startRecording: startRecording,
            stopRecording: stopRecording,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            watch: $01W3b.watch,
            get useRoute () {
                return 0, $73mM4.useRoute;
            },
            get translit () {
                return 0, $aOjOf.translit;
            },
            get axios () {
                return 0, $7we3r.default;
            },
            ScannerWindow: $eYmJT.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("aOjOf", function(module, exports) {
/*!
 * Translit v3.0.2 (Rusyn transliteration)
 * Copyright 2014–2025 Braňo Šandala (https://brano.me)
 * 
 * app: https://tota.sk/translit
 * src: https://github.com/surfinzap/translit-rue
 * 
 * Licensed under MIT (https://github.com/surfinzap/translit-rue/blob/main/LICENSE.txt)
 */ !function(e) {
    module.exports = e();
}(function() {
    return (function n(o, a, i) {
        function l(r, e) {
            if (!a[r]) {
                if (!o[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (p) return p(r, !0);
                    throw (e = new Error("Cannot find module '" + r + "'")).code = "MODULE_NOT_FOUND", e;
                }
                t = a[r] = {
                    exports: {}
                }, o[r][0].call(t.exports, function(e) {
                    return l(o[r][1][e] || e);
                }, t, t.exports, n, o, a, i);
            }
            return a[r].exports;
        }
        for(var p = undefined, e = 0; e < i.length; e++)l(i[e]);
        return l;
    })({
        1: [
            function(e, r, t) {
                function n(e, r) {
                    return ((e)=>{
                        if (Array.isArray(e)) return e;
                    })(e) || ((e, r)=>{
                        var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != t) {
                            var n, o, a, i, l = [], p = !0, u = !1;
                            try {
                                if (a = (t = t.call(e)).next, 0 === r) {
                                    if (Object(t) !== t) return;
                                    p = !1;
                                } else for(; !(p = (n = a.call(t)).done) && (l.push(n.value), l.length !== r); p = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!p && null != t.return && (i = t.return(), Object(i) !== i)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    })(e, r) || ((e, r)=>{
                        var t;
                        if (e) return "string" == typeof e ? o(e, r) : "Map" === (t = "Object" === (t = ({}).toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : t) || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? o(e, r) : void 0;
                    })(e, r) || (()=>{
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    })();
                }
                function o(e, r) {
                    (null == r || r > e.length) && (r = e.length);
                    for(var t = 0, n = Array(r); t < r; t++)n[t] = e[t];
                    return n;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.vowelsLowerCase = t.mapping = t.chars = void 0;
                t.vowelsLowerCase = {
                    latin: "aeiouy\u0177",
                    cyrillicHard: "\u0430\u0435\u0456\u043E\u0443\u0438\u044B\u0457",
                    cyrillicSoft: "\u044F\u0454\u0457\u0451\u044E"
                };
                for(var a = "a-z\xe1\xe4\u010D\u010F\xe9\u011B\xed\u013A\u013E\u0148\xf3\xf4\xf6\u0151\u0155\u0159\u0161\u0165\xfa\xfc\u0171\u016F\xfd\u0177\u017E", i = "\u0430\u0431\u0432\u0433\u0491\u0434\u0435\u0437\u0456\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u044A\u044B\u044C\u0446\u0447\u0436\u0448\u0457\u0449\u0451\u0454\u044E\u044F\u0445", l = a + i, p = l.toUpperCase(), a = (t.chars = {
                    latinLowerCase: a,
                    cyrillicLowerCase: i,
                    lowerCase: l,
                    upperCase: p,
                    all: l + p
                }, {
                    text: "\u0442\u0435\u043A\u0441\u0442",
                    taxi: "\u0442\u0430\u043A\u0441\u0456",
                    "jo\u017Ek": "\u0439\u043E\u0436\u043A"
                }), u = {}, s = 0, c = Object.entries(a); s < c.length; s++){
                    var f = n(c[s], 2), y = f[0], f = f[1], y = y.charAt(0).toUpperCase() + y.slice(1), f = f.charAt(0).toUpperCase() + f.slice(1);
                    u[y] = f;
                }
                t.mapping = {
                    homoglyphs: {
                        A: "\u0410",
                        a: "\u0430",
                        B: "\u0412",
                        C: "\u0421",
                        c: "\u0441",
                        E: "\u0415",
                        e: "\u0435",
                        H: "\u041D",
                        I: "\u0406",
                        i: "\u0456",
                        K: "\u041A",
                        M: "\u041C",
                        O: "\u041E",
                        o: "\u043E",
                        P: "\u0420",
                        p: "\u0440",
                        T: "\u0422",
                        X: "\u0425",
                        x: "\u0445",
                        Y: "\u0423",
                        y: "\u0443"
                    },
                    singleChars: {
                        a: "\u0430",
                        b: "\u0431",
                        v: "\u0432",
                        h: "\u0433",
                        g: "\u0491",
                        d: "\u0434",
                        e: "\u0435",
                        z: "\u0437",
                        i: "\u0456",
                        y: "\u0438",
                        j: "\u0439",
                        k: "\u043A",
                        l: "\u043B",
                        m: "\u043C",
                        n: "\u043D",
                        o: "\u043E",
                        p: "\u043F",
                        r: "\u0440",
                        s: "\u0441",
                        t: "\u0442",
                        u: "\u0443",
                        f: "\u0444",
                        "\u0177": "\u044B",
                        c: "\u0446",
                        "\u010D": "\u0447",
                        "\u017E": "\u0436",
                        "\u0161": "\u0448",
                        A: "\u0410",
                        B: "\u0411",
                        V: "\u0412",
                        H: "\u0413",
                        G: "\u0490",
                        D: "\u0414",
                        E: "\u0415",
                        Z: "\u0417",
                        I: "\u0406",
                        Y: "\u0418",
                        J: "\u0419",
                        K: "\u041A",
                        L: "\u041B",
                        M: "\u041C",
                        N: "\u041D",
                        O: "\u041E",
                        P: "\u041F",
                        R: "\u0420",
                        S: "\u0421",
                        T: "\u0422",
                        U: "\u0423",
                        F: "\u0424",
                        "\u0176": "\u042B",
                        C: "\u0426",
                        "\u010C": "\u0427",
                        "\u017D": "\u0416",
                        "\u0160": "\u0428"
                    },
                    digraphs: {
                        ja: "\u044F",
                        Ja: "\u042F",
                        ju: "\u044E",
                        Ju: "\u042E",
                        je: "\u0454",
                        Je: "\u0404",
                        "\u2019o": "\u0451",
                        "\u2019O": "\xcb",
                        ji: "\u0457",
                        Ji: "\u0407",
                        ch: "\u0445",
                        Ch: "\u0425",
                        "\u0161\u010D": "\u0449",
                        "\u0160\u010D": "\u0429",
                        "c\u2019": "\u0446\u044C",
                        "C\u2019": "\u0426\u044C",
                        "s\u2019": "\u0441\u044C",
                        "S\u2019": "\u0421\u044C",
                        "r\u2019": "\u0440\u044C",
                        "R\u2019": "\u0420\u044C",
                        "z\u2019": "\u0437\u044C",
                        "Z\u2019": "\u0417\u044C",
                        "\u017E\u2019": "\u0436\u044C",
                        "\u017D\u2019": "\u0416\u044C"
                    },
                    hardConsonants: {
                        "c\u2019a": "\u0446\u044F",
                        "C\u2019a": "\u0426\u044F",
                        "c\u2019i": "\u0446\u0457",
                        "C\u2019i": "\u0426\u0457",
                        "c\u2019o": "\u0446\u0451",
                        "C\u2019o": "\u0426\u0451",
                        "c\u2019u": "\u0446\u044E",
                        "C\u2019u": "\u0426\u044E",
                        "s\u2019a": "\u0441\u044F",
                        "S\u2019a": "\u0421\u044F",
                        "s\u2019i": "\u0441\u0457",
                        "S\u2019i": "\u0421\u0457",
                        "s\u2019o": "\u0441\u0451",
                        "S\u2019o": "\u0421\u0451",
                        "s\u2019u": "\u0441\u044E",
                        "S\u2019u": "\u0421\u044E",
                        "r\u2019a": "\u0440\u044F",
                        "R\u2019a": "\u0420\u044F",
                        "r\u2019i": "\u0440\u0457",
                        "R\u2019i": "\u0420\u0457",
                        "r\u2019o": "\u0440\u0451",
                        "R\u2019o": "\u0420\u0451",
                        "r\u2019u": "\u0440\u044E",
                        "R\u2019u": "\u0420\u044E",
                        "z\u2019a": "\u0437\u044F",
                        "Z\u2019a": "\u0417\u044F",
                        "z\u2019i": "\u0437\u0457",
                        "Z\u2019i": "\u0417\u0457",
                        "z\u2019o": "\u0437\u0451",
                        "Z\u2019o": "\u0417\u0451",
                        "z\u2019u": "\u0437\u044E",
                        "Z\u2019u": "\u0417\u044E",
                        "\u017E\u2019a": "\u0436\u044F",
                        "\u017D\u2019a": "\u0416\u044F",
                        "\u017E\u2019i": "\u0436\u0457",
                        "\u017D\u2019i": "\u0416\u0457",
                        "\u017E\u2019o": "\u0436\u0451",
                        "\u017D\u2019o": "\u0416\u0451",
                        "\u017E\u2019u": "\u0436\u044E",
                        "\u017D\u2019u": "\u0416\u044E",
                        zja: "\u0437\u044A\u044F",
                        Zja: "\u0417\u044A\u044F",
                        zje: "\u0437\u044A\u0454",
                        Zje: "\u0417\u044A\u0454",
                        zji: "\u0437\u044A\u0457",
                        Zji: "\u0417\u044A\u0457",
                        zjo: "\u0437\u044A\u0451",
                        Zjo: "\u0417\u044A\u0451",
                        zju: "\u0437\u044A\u044E",
                        Zju: "\u0417\u044A\u044E",
                        "R\u2019jo": "\u0420\u044C\u0451",
                        "r\u2019jo": "\u0440\u044C\u0451",
                        bji: "\u0431\u044A\u0457",
                        dja: "\u0434\u044A\u044F",
                        dje: "\u0434\u044A\u0454",
                        dji: "\u0434\u044A\u0457",
                        djo: "\u0434\u044A\u0451",
                        dju: "\u0434\u044A\u044E",
                        Dja: "\u0414\u044A\u044F",
                        Dje: "\u0414\u044A\u0454",
                        Dji: "\u0414\u044A\u0457",
                        Djo: "\u0414\u044A\u0451",
                        Dju: "\u0414\u044A\u044E",
                        nja: "\u043D\u044A\u044F",
                        nje: "\u043D\u044A\u0454",
                        nji: "\u043D\u044A\u0457",
                        njo: "\u043D\u044A\u0451",
                        nju: "\u043D\u044A\u044E",
                        Nja: "\u041D\u044A\u044F",
                        Nje: "\u041D\u044A\u0454",
                        Nji: "\u041D\u044A\u0457",
                        Njo: "\u041D\u044A\u0451",
                        Nju: "\u041D\u044A\u044E"
                    },
                    softVowels: {
                        ja: "\u044F",
                        je: "\u0454",
                        ji: "\u0457",
                        jo: "\u0451",
                        ju: "\u044E",
                        Ja: "\u042F",
                        Je: "\u0404",
                        Ji: "\u0407",
                        Jo: "\u0401",
                        Ju: "\u042E"
                    },
                    dtnlVowel: {
                        "\u010Fa": "\u0434\u044F",
                        "\u010Ea": "\u0414\u044F",
                        "\u0165a": "\u0442\u044F",
                        "\u0164a": "\u0422\u044F",
                        "\u0148a": "\u043D\u044F",
                        "\u0147a": "\u041D\u044F",
                        "\u013Ea": "\u043B\u044F",
                        "\u013Da": "\u041B\u044F",
                        "\u010Fe": "\u0434\u0454",
                        "\u010Ee": "\u0414\u0454",
                        "\u0165e": "\u0442\u0454",
                        "\u0164e": "\u0422\u0454",
                        "\u0148e": "\u043D\u0454",
                        "\u0147e": "H\u0454",
                        "\u013Ee": "\u043B\u0454",
                        "\u013De": "\u041B\u0454",
                        "\u010Fi": "\u0434\u0457",
                        "\u010Ei": "\u0414\u0457",
                        "\u0165i": "\u0442\u0457",
                        "\u0164i": "\u0422\u0457",
                        "\u0148i": "\u043D\u0457",
                        "\u0147i": "\u041D\u0457",
                        "\u013Ei": "\u043B\u0457",
                        "\u013Di": "\u041B\u0457",
                        "\u010Fo": "\u0434\u0451",
                        "\u010Eo": "\u0414\u0451",
                        "\u0165o": "\u0442\u0451",
                        "\u0164o": "\u0422\u0451",
                        "\u0148o": "\u043D\u0451",
                        "\u0147o": "H\u0451",
                        "\u013Eo": "\u043B\u0451",
                        "\u013Do": "\u041B\u0451",
                        "\u010Fu": "\u0434\u044E",
                        "\u010Eu": "\u0414\u044E",
                        "\u0165u": "\u0442\u044E",
                        "\u0164u": "\u0422\u044E",
                        "\u0148u": "\u043D\u044E",
                        "\u0147u": "H\u044E",
                        "\u013Eu": "\u043B\u044E",
                        "\u013Du": "\u041B\u044E"
                    },
                    dtnlDoubled: {
                        "\u010F": "\u0434",
                        "\u010E": "\u0414",
                        "\u0165": "\u0442",
                        "\u0164": "\u0422",
                        "\u0148": "\u043D",
                        "\u0147": "\u041D",
                        "\u013E": "\u043B",
                        "\u013D": "\u041B"
                    },
                    dtnlAtWordEnd: {
                        "\u010F": "\u0434\u044C",
                        "\u010E": "\u0414\u044C",
                        "\u0165": "\u0442\u044C",
                        "\u0164": "\u0422\u044C",
                        "\u0148": "\u043D\u044C",
                        "\u0147": "\u041D\u044C",
                        "\u013E": "\u043B\u044C",
                        "\u013D": "\u041B\u044C"
                    },
                    johoJomu: {
                        joho: "\u0451\u0433\u043E",
                        jomu: "\u0451\u043C\u0443",
                        Joho: "\u0401\u0433\u043E",
                        Jomu: "\u0401\u043C\u0443"
                    },
                    jojJov: {
                        joj: "\u0451\u0439",
                        Joj: "\u0401\u0439",
                        jov: "\u0451\u0432",
                        Jov: "\u0401\u0432"
                    },
                    exceptions: a,
                    exceptionsCapitalized: u
                };
            },
            {}
        ],
        2: [
            function(e, r, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.applyTransformations = function(e) {
                    var r = [
                        i,
                        l,
                        p,
                        n
                    ], t = [
                        o.mapping.exceptionsCapitalized,
                        o.mapping.exceptions,
                        o.mapping.dtnlVowel,
                        o.mapping.hardConsonants,
                        o.mapping.dtnlAtWordEnd,
                        o.mapping.digraphs,
                        o.mapping.singleChars
                    ];
                    return e = r.reduce(function(e, r) {
                        return r(e);
                    }, e), e = t.reduce(function(e, r) {
                        return (0, a.applyTranslitRule)(e, r, "cyrLat");
                    }, e);
                }, t.mapDtnlDoubled = n, t.mapSoftVowelAfterHardVowel = p, t.mapSoftVowelAtWordStart = l, t.mapSoftVowelsSequence = i;
                var o = e("./constants"), a = e("./utils");
                function n(e) {
                    var r = new RegExp("(?<dtnl>[\u0434\u0442\u043D\u043B])(\\k<dtnl>)([\u044F\u0454\u0457\u0451\u044E])", "gi");
                    return e.replace(r, function(e, r, t, n) {
                        return (0, a.applyTranslitRule)(r, o.mapping.dtnlDoubled, "cyrLat") + t + n;
                    });
                }
                function i(e) {
                    var r = "([^" + o.chars.all + "]|^)(([" + o.vowelsLowerCase.cyrillicSoft + "]){2,})", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, a.applyTranslitRule)(t, o.mapping.softVowels, "cyrLat");
                    });
                }
                function l(e) {
                    var r = "([^" + o.chars.all + "]|^)([" + o.vowelsLowerCase.cyrillicSoft + "])", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, a.applyTranslitRule)(t, o.mapping.softVowels, "cyrLat");
                    });
                }
                function p(e) {
                    var r = "([" + o.vowelsLowerCase.cyrillicHard + "])([" + o.vowelsLowerCase.cyrillicSoft + "])", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, a.applyTranslitRule)(t, o.mapping.softVowels, "cyrLat");
                    });
                }
            },
            {
                "./constants": 1,
                "./utils": 5
            }
        ],
        3: [
            function(e, r, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.applyTransformations = function(e) {
                    var r = [
                        l.normalizeApostrophes,
                        o,
                        a,
                        s,
                        c,
                        p,
                        u,
                        n
                    ], t = [
                        i.mapping.exceptionsCapitalized,
                        i.mapping.exceptions,
                        i.mapping.dtnlVowel,
                        i.mapping.johoJomu,
                        i.mapping.hardConsonants,
                        i.mapping.dtnlAtWordEnd,
                        i.mapping.digraphs,
                        i.mapping.singleChars
                    ];
                    return e = r.reduce(function(e, r) {
                        return r(e);
                    }, e), e = t.reduce(function(e, r) {
                        return (0, l.applyTranslitRule)(e, r, "latCyr");
                    }, e);
                }, t.mapDtnlDoubled = n, t.mapJojJovBeginningWord = s, t.mapSingleJo = c, t.mapSoftVowelAfterHardVowel = u, t.mapSoftVowelAtWordStart = p, t.mapSoftVowelsSequence = a, t.mapSuperlative = o;
                var i = e("./constants"), l = e("./utils");
                function n(e) {
                    var r = new RegExp("(?<dtnl>[\u010F\u0165\u0148\u013E])(\\k<dtnl>)([aeiou])", "gi");
                    return e.replace(r, function(e, r, t, n) {
                        return (0, l.applyTranslitRule)(r, i.mapping.dtnlDoubled, "latCyr") + t + n;
                    });
                }
                function o(e) {
                    var r = "(\\b)(naj)([" + i.vowelsLowerCase.latin + "])([" + i.chars.lowerCase + "]+?)(\u0161\u0177j|\u0161oho|\u0161omu|\u0161im|\u0161\u0177m|\u0161\u0177|\u0161\u0177ch|\u0161\u0177ma|\u0161a|\u0161oj|\u0161ij|\u0161u|\u0161ov|\u0161e)", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t, n, o, a) {
                        return r + (0, l.applyTranslitRule)(t, i.mapping.singleChars, "latCyr") + n + o + a;
                    });
                }
                function a(e) {
                    var r = new RegExp("(\\b)((jo|ja|je|ji|ju){2,})", "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, l.applyTranslitRule)(t, i.mapping.softVowels, "latCyr");
                    });
                }
                function p(e) {
                    var r = new RegExp("(\\b)(j)([aeiuy\u0177])", "gi");
                    return e.replace(r, function(e, r, t, n) {
                        return r + (0, l.applyTranslitRule)(t + n, i.mapping.softVowels, "latCyr");
                    });
                }
                function u(e) {
                    var r = "([" + i.vowelsLowerCase.latin + "])(ja|je|ji|jo|ju)", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, l.applyTranslitRule)(t, i.mapping.softVowels, "latCyr");
                    });
                }
                function s(e) {
                    var r = new RegExp("(\\b)(joj|jov)", "gi");
                    return e.replace(r, function(e, r, t) {
                        return r + (0, l.applyTranslitRule)(t, i.mapping.jojJov, "latCyr");
                    });
                }
                function c(e) {
                    var r = "(^|[^" + i.chars.all + "])(jo)([^" + i.chars.all + "]|$)", r = new RegExp(r, "gi");
                    return e.replace(r, function(e, r, t, n) {
                        return r + (0, l.applyTranslitRule)(t, i.mapping.softVowels, "latCyr") + n;
                    });
                }
            },
            {
                "./constants": 1,
                "./utils": 5
            }
        ],
        4: [
            function(e, r, t) {
                function p(e) {
                    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    })(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.translit = function(e, r) {
                    if ("latCyr" !== r && "cyrLat" !== r) throw new Error("Unsupported direction: ".concat(r));
                    return e = (0, n.normalizeHomoglyphs)(e, r), e = (0, n.processUpperCase)(e, r), ("latCyr" === r ? o : a).applyTransformations(e);
                };
                var n = e("./utils"), o = u(e("./lat_to_cyr")), a = u(e("./cyr_to_lat"));
                function u(e, r) {
                    var i, l;
                    return "function" == typeof WeakMap && (i = new WeakMap, l = new WeakMap), (u = function(e, r) {
                        if (!r && e && e.__esModule) return e;
                        var t, n, o = {
                            __proto__: null,
                            default: e
                        };
                        if (null !== e && ("object" == p(e) || "function" == typeof e)) {
                            if (t = r ? l : i) {
                                if (t.has(e)) return t.get(e);
                                t.set(e, o);
                            }
                            for(var a in e)"default" !== a && ({}).hasOwnProperty.call(e, a) && ((n = (t = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, a)) && (n.get || n.set) ? t(o, a, n) : o[a] = e[a]);
                        }
                        return o;
                    })(e, r);
                }
            },
            {
                "./cyr_to_lat": 2,
                "./lat_to_cyr": 3,
                "./utils": 5
            }
        ],
        5: [
            function(e, r, t) {
                function p(e) {
                    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    })(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.applyTranslitRule = u, t.normalizeApostrophes = function(e) {
                    var r = "'\u2019\u02BC\u2018\u201B\xb4`\u2032";
                    return e = (e = (e = e.replace(new RegExp("([csrz\u017E])([" + r + "])([aeiou])", "gi"), "$1\u2019$3")).replace(new RegExp("([csrz\u017E])([" + r + "])(\\B)", "gi"), "$1\u2019$3")).replace(new RegExp("(\\B)([" + r + "])([o])", "gi"), "$1\u2019$3");
                }, t.normalizeHomoglyphs = function(e, o) {
                    var r = new RegExp("[".concat(l.chars.lowerCase, "]+"), "giu"), a = new RegExp("[".concat(l.chars.latinLowerCase, "]"), "giu"), i = new RegExp("[".concat(l.chars.cyrillicLowerCase, "]"), "giu");
                    return e.replace(r, function(e) {
                        var r, t = (e.match(a) || []).length, n = (e.match(i) || []).length;
                        return "latCyr" === o ? r = n <= t ? "cyrLat" : "latCyr" : "cyrLat" === o && (r = t <= n ? "latCyr" : "cyrLat"), u(e, l.mapping.homoglyphs, r);
                    });
                }, t.processUpperCase = function(e, o) {
                    var r = "([" + l.chars.upperCase + "\u2019]{2,})([^" + l.chars.lowerCase + "]|$)", r = new RegExp(r, "g"), r = (e = e.replace(r, function(e, r, t) {
                        switch(o){
                            case "latCyr":
                                return a.applyTransformations(r.toLowerCase()).toUpperCase() + t;
                            case "cyrLat":
                                return i.applyTransformations(r.toLowerCase()).toUpperCase() + t;
                        }
                    }), "([^" + l.chars.upperCase + "\u2019]|^)([" + l.chars.upperCase + "\u2019])(?=[-\u2013\u2014\\s][" + l.chars.upperCase + "][^" + l.chars.lowerCase + "\u2019])"), r = new RegExp(r, "g"), r = (e = e.replace(r, function(e, r, t) {
                        switch(o){
                            case "latCyr":
                                return r + a.applyTransformations(t.toLowerCase()).toUpperCase();
                            case "cyrLat":
                                return r + i.applyTransformations(t.toLowerCase()).toUpperCase();
                        }
                    }), "([" + l.chars.upperCase + "\u2019][\\s])([" + l.chars.upperCase + "])([^" + l.chars.upperCase + "]|$)"), r = new RegExp(r, "g");
                    return e = e.replace(r, function(e, r, t, n) {
                        switch(o){
                            case "latCyr":
                                return r + a.applyTransformations(t.toLowerCase()).toUpperCase() + n;
                            case "cyrLat":
                                return r + i.applyTransformations(t.toLowerCase()).toUpperCase() + n;
                        }
                    });
                };
                var l = e("./constants"), a = n(e("./lat_to_cyr")), i = n(e("./cyr_to_lat"));
                function n(e, r) {
                    var i, l;
                    return "function" == typeof WeakMap && (i = new WeakMap, l = new WeakMap), (n = function(e, r) {
                        if (!r && e && e.__esModule) return e;
                        var t, n, o = {
                            __proto__: null,
                            default: e
                        };
                        if (null !== e && ("object" == p(e) || "function" == typeof e)) {
                            if (t = r ? l : i) {
                                if (t.has(e)) return t.get(e);
                                t.set(e, o);
                            }
                            for(var a in e)"default" !== a && ({}).hasOwnProperty.call(e, a) && ((n = (t = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, a)) && (n.get || n.set) ? t(o, a, n) : o[a] = e[a]);
                        }
                        return o;
                    })(e, r);
                }
                function u(e, r, t) {
                    if ("cyrLat" === t) for(var n in r){
                        var o = new RegExp(r[n], "g");
                        e = e.replace(o, n);
                    }
                    else if ("latCyr" === t) for(var a in r){
                        var i = new RegExp(a, "g");
                        e = e.replace(i, r[a]);
                    }
                    return e;
                }
            },
            {
                "./constants": 1,
                "./cyr_to_lat": 2,
                "./lat_to_cyr": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
const $866cce54f6bdfb0c$var$isValidHeaderValue = (value)=>!/[\r\n]/.test(value);
function $866cce54f6bdfb0c$var$assertValidHeaderValue(value, header) {
    if (value === false || value == null) return;
    if ((0, $gKvUL.default).isArray(value)) {
        value.forEach((v)=>$866cce54f6bdfb0c$var$assertValidHeaderValue(v, header));
        return;
    }
    if (!$866cce54f6bdfb0c$var$isValidHeaderValue(String(value))) throw new Error(`Invalid character in header content ["${header}"]`);
}
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$stripTrailingCRLF(str) {
    let end = str.length;
    while(end > 0){
        const charCode = str.charCodeAt(end - 1);
        if (charCode !== 10 && charCode !== 13) break;
        end -= 1;
    }
    return end === str.length ? str : str.slice(0, end);
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : $866cce54f6bdfb0c$var$stripTrailingCRLF(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
                $866cce54f6bdfb0c$var$assertValidHeaderValue(_value, _header);
                self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
            }
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $gKvUL.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $lk5EI.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $gKvUL.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $gKvUL.default).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $gKvUL.default).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const body = new $e52be20a9fc15e96$var$ReadableStream();
        const hasContentType = new Request((0, $g65xr.default).origin, {
            body: body,
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $eHGD2.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress)));
                    data = (0, $hhnAb.trackStream)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.15.0";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("eYmJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae684ed54b526aa3$export$2e2bcd8739ae039);
let $ae684ed54b526aa3$var$script;




let $ae684ed54b526aa3$var$initialize = ()=>{
    $ae684ed54b526aa3$var$script = (parcelRequire("96rUZ"));
    if ($ae684ed54b526aa3$var$script.__esModule) $ae684ed54b526aa3$var$script = $ae684ed54b526aa3$var$script.default;
    $ae684ed54b526aa3$var$script.render = (parcelRequire("jk6ss")).render;
    $ae684ed54b526aa3$var$script.__cssModules = {};
    (parcelRequire("4yR1Z")).default($ae684ed54b526aa3$var$script);
    $ae684ed54b526aa3$var$script.__scopeId = 'data-v-163c05';
    $ae684ed54b526aa3$var$script.__file = "ImageRecognitionModule.vue";
};
$ae684ed54b526aa3$var$initialize();
var $ae684ed54b526aa3$export$2e2bcd8739ae039 = $ae684ed54b526aa3$var$script;

});
parcelRegister("96rUZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6a0a548cc15ba298$export$2e2bcd8739ae039);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
parcelRequire("4lsKQ");
var $kmNpi = parcelRequire("kmNpi");
var $6a0a548cc15ba298$export$2e2bcd8739ae039 = {
    __name: 'ImageRecognitionModule',
    emits: [
        'close',
        'useText'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const videoEl = (0, $01W3b.ref)(null);
        const canvasEl = (0, $01W3b.ref)(null);
        const isScanning = (0, $01W3b.ref)(false);
        const photoTaken = (0, $01W3b.ref)(false);
        const isModelReady = (0, $01W3b.ref)(false);
        // Store individual text fragments with their coordinates
        const results = (0, $01W3b.ref)([]);
        const imgSize = (0, $01W3b.ref)({
            width: 0,
            height: 0
        });
        let stream = null;
        let ocrService = null;
        (0, $TusQn.onMounted)(async ()=>{
            await startCamera();
            try {
                ocrService = new (0, $kmNpi.PaddleOcrService)({
                    processing: {
                        engine: 'canvas-native'
                    }
                });
                await ocrService.initialize();
                isModelReady.value = true;
            } catch (e) {
                console.error('OCR Init Error:', e);
            }
        });
        (0, $TusQn.onUnmounted)(()=>{
            stopCamera();
            ocrService = null;
        });
        const scanText = async ()=>{
            if (isScanning.value || !ocrService) return;
            isScanning.value = true;
            try {
                const video = videoEl.value;
                const canvas = canvasEl.value;
                const ctx = canvas.getContext('2d');
                imgSize.value = {
                    width: video.videoWidth,
                    height: video.videoHeight
                };
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                ctx.drawImage(video, 0, 0);
                video.pause();
                // Perform recognition
                const res = await ocrService.recognize(canvas);
                // Process regions/lines from the result
                // Note: Structure usually contains { text: string, regions: Array<{text, bbox}> }
                results.value = res.regions || [];
                photoTaken.value = true;
            } catch (e) {
                console.error('OCR failed:', e);
            } finally{
                isScanning.value = false;
            }
        };
        const calculateBoxStyle = (bbox)=>{
            if (!bbox) return {};
            // Assuming bbox format: [xmin, ymin, xmax, ymax]
            const [x1, y1, x2, y2] = bbox;
            return {
                left: `${x1 / imgSize.value.width * 100}%`,
                top: `${y1 / imgSize.value.height * 100}%`,
                width: `${(x2 - x1) / imgSize.value.width * 100}%`,
                height: `${(y2 - y1) / imgSize.value.height * 100}%`,
                position: 'absolute'
            };
        };
        const startCamera = async ()=>{
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: 'environment',
                        width: {
                            ideal: 1280
                        },
                        height: {
                            ideal: 720
                        }
                    }
                });
                videoEl.value.srcObject = stream;
            } catch (e) {
                console.error('Camera access denied:', e);
                alert("Kamera nie je dostupn\xe1. Pros\xedm povo\u013Ete pr\xedstup k kamere.");
            }
        };
        const stopCamera = ()=>{
            if (stream) {
                stream.getTracks().forEach((track)=>track.stop());
                stream = null;
            }
        };
        const retake = ()=>{
            photoTaken.value = false;
            results.value = [];
            const video = videoEl.value;
            video.play();
        };
        const confirmText = ()=>{
            const extractedText = results.value.map((item)=>item.text).join(' ');
            emit('useText', extractedText);
        };
        const save = ()=>{
            const canvas = canvasEl.value;
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = `ocr-scan-${Date.now()}.png`;
            link.click();
        };
        const __returned__ = {
            emit: emit,
            videoEl: videoEl,
            canvasEl: canvasEl,
            isScanning: isScanning,
            photoTaken: photoTaken,
            isModelReady: isModelReady,
            results: results,
            imgSize: imgSize,
            get stream () {
                return stream;
            },
            set stream (v){
                stream = v;
            },
            get ocrService () {
                return ocrService;
            },
            set ocrService (v){
                ocrService = v;
            },
            scanText: scanText,
            calculateBoxStyle: calculateBoxStyle,
            startCamera: startCamera,
            stopCamera: stopCamera,
            retake: retake,
            confirmText: confirmText,
            save: save,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            onUnmounted: $TusQn.onUnmounted,
            get PaddleOcrService () {
                return 0, $kmNpi.PaddleOcrService;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("4lsKQ", function(module, exports) {

$parcel$export(module.exports, "PaddleOcrService", () => (parcelRequire("kmNpi")).PaddleOcrService);

var $kmNpi = parcelRequire("kmNpi");

var $hw71J = parcelRequire("hw71J");

var $cYueb = parcelRequire("cYueb");

var $kKDv9 = parcelRequire("kKDv9");

});
parcelRegister("kmNpi", function(module, exports) {

$parcel$export(module.exports, "PaddleOcrService", () => $ed3c2ff2e6b72a2b$export$f9d9d6bfa04564a2);

var $6E22k = parcelRequire("6E22k");

var $4xkBA = parcelRequire("4xkBA");

var $hw71J = parcelRequire("hw71J");

var $lf5OP = parcelRequire("lf5OP");

var $cYueb = parcelRequire("cYueb");
let $ed3c2ff2e6b72a2b$var$DEFAULT_WEB_SESSION_OPTIONS = {
    executionProviders: [
        "wasm"
    ],
    graphOptimizationLevel: "all"
};
class $ed3c2ff2e6b72a2b$export$f9d9d6bfa04564a2 extends (0, $4xkBA.BasePaddleOcrService) {
    constructor(options){
        super(new (0, $lf5OP.WebPlatformProvider), options);
        if (this.options.session === undefined || Object.keys(this.options.session).length === 0) this.options.session = $ed3c2ff2e6b72a2b$var$DEFAULT_WEB_SESSION_OPTIONS;
    }
    async initSessions() {
        throw new Error("Initialization is handled proactively in PaddleOcrService. Call initialize() instead.");
    }
    async _loadResource(source, defaultUrl) {
        if (source instanceof ArrayBuffer) {
            this.log("Loading resource from ArrayBuffer");
            return source;
        }
        let sourceUrl = typeof source === "string" ? source : defaultUrl;
        this.log(`Fetching resource from URL: ${sourceUrl}`);
        let response = await fetch(sourceUrl);
        if (!response.ok) throw new Error(`Failed to fetch resource from ${sourceUrl}`);
        return response.arrayBuffer();
    }
    async initialize() {
        try {
            this.log("Initializing PaddleOcrService (Web)...");
            let detModelBuffer = await this._loadResource(this.options.model?.detection, `${(0, $4xkBA.MODEL_BASE_URL)}/detection/PP-OCRv5_mobile_det_infer.onnx`);
            this.detectionSession = await $6E22k.InferenceSession.create(new Uint8Array(detModelBuffer), this.options.session);
            this.options.model.detection = detModelBuffer;
            this.log(`Detection ONNX model loaded successfully
	input: ${this.detectionSession.inputNames}
	output: ${this.detectionSession.outputNames}`);
            let recModelBuffer = await this._loadResource(this.options.model?.recognition, `${(0, $4xkBA.MODEL_BASE_URL)}/recognition/multi/en/v5/en_PP-OCRv5_mobile_rec_infer.onnx`);
            this.recognitionSession = await $6E22k.InferenceSession.create(new Uint8Array(recModelBuffer), this.options.session);
            this.options.model.recognition = recModelBuffer;
            this.log(`Recognition ONNX model loaded successfully
	input: ${this.recognitionSession.inputNames}
	output: ${this.recognitionSession.outputNames}`);
            let dictBuffer = await this._loadResource(this.options.model?.charactersDictionary, `${(0, $4xkBA.DICT_BASE_URL)}/recognition/multi/en/v5/ppocrv5_en_dict.txt`);
            let dictionaryContent = new TextDecoder("utf-8").decode(dictBuffer);
            let charactersDictionary = dictionaryContent.split(`
`);
            if (charactersDictionary.length === 0) throw new Error("Character dictionary is empty or could not be loaded.");
            this.options.model.charactersDictionary = dictBuffer;
            this.options.recognition.charactersDictionary = charactersDictionary;
            this.log(`Character dictionary loaded with ${charactersDictionary.length} entries.`);
            this.detector = new (0, $hw71J.DetectionService)(this.detectionSession, this.options.detection, this.options.debugging);
            this.recognitor = new (0, $cYueb.RecognitionService)(this.recognitionSession, this.options.recognition, this.options.debugging);
            this.options.model.detection = undefined;
            this.options.model.recognition = undefined;
        } catch (error) {
            console.error("Failed to initialize PaddleOcrService Web:", error);
            throw error;
        }
    }
    isInitialized() {
        return this.detectionSession !== null && this.recognitionSession !== null;
    }
    async changeDetectionModel(model) {
        this.log("Changing detection model...");
        let modelBuffer = await this._loadResource(model, `${(0, $4xkBA.MODEL_BASE_URL)}/detection/PP-OCRv5_mobile_det_infer.onnx`);
        await this.detectionSession?.release();
        this.detectionSession = await $6E22k.InferenceSession.create(new Uint8Array(modelBuffer), this.options.session);
        this.options.model.detection = modelBuffer;
        this.log("Detection model changed successfully.");
    }
    async changeRecognitionModel(model) {
        this.log("Changing recognition model...");
        let modelBuffer = await this._loadResource(model, `${(0, $4xkBA.MODEL_BASE_URL)}/recognition/multi/en/v5/en_PP-OCRv5_mobile_rec_infer.onnx`);
        await this.recognitionSession?.release();
        this.recognitionSession = await $6E22k.InferenceSession.create(new Uint8Array(modelBuffer), this.options.session);
        this.options.model.recognition = modelBuffer;
        this.log("Recognition model changed successfully.");
    }
    async changeTextDictionary(dictionary) {
        this.log("Changing text dictionary...");
        let dictBuffer = await this._loadResource(dictionary, `${(0, $4xkBA.DICT_BASE_URL)}/recognition/multi/en/v5/ppocrv5_en_dict.txt`);
        let dictionaryContent = new TextDecoder("utf-8").decode(dictBuffer);
        let charactersDictionary = dictionaryContent.split(`
`);
        if (charactersDictionary.length === 0) throw new Error("Character dictionary is empty or could not be loaded.");
        this.options.model.charactersDictionary = dictBuffer;
        this.options.recognition.charactersDictionary = charactersDictionary;
        this.log(`Character dictionary changed successfully with ${charactersDictionary.length} entries.`);
    }
    async recognize(image, options) {
        return super.recognize(image, options);
    }
    async destroy() {
        await this.detectionSession?.release();
        await this.recognitionSession?.release();
        this.detectionSession = null;
        this.recognitionSession = null;
        this.detector = null;
        this.recognitor = null;
    }
}
var $ed3c2ff2e6b72a2b$export$2e2bcd8739ae039 = $ed3c2ff2e6b72a2b$export$f9d9d6bfa04564a2;

});
parcelRegister("6E22k", function(module, exports) {
/*!
 * ONNX Runtime Web v1.24.3
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ "use strict";
var $4d680ef17f3ad71b$var$ort = (()=>{
    var $n = Object.defineProperty;
    var Nu = Object.getOwnPropertyDescriptor;
    var Lu = Object.getOwnPropertyNames;
    var Gu = Object.prototype.hasOwnProperty;
    var vn = ((e1)=>undefined)(function(e1) {
        return undefined(this, arguments);
    });
    var k = (e1, t)=>()=>(e1 && (t = e1(e1 = 0)), t);
    var rt = (e1, t)=>{
        for(var n in t)$n(e1, n, {
            get: t[n],
            enumerable: !0
        });
    }, Wu = (e1, t, n, r)=>{
        if (t && typeof t == "object" || typeof t == "function") for (let o of Lu(t))!Gu.call(e1, o) && o !== n && $n(e1, o, {
            get: ()=>t[o],
            enumerable: !(r = Nu(t, o)) || r.enumerable
        });
        return e1;
    };
    var lt = (e1)=>Wu($n({}, "__esModule", {
            value: !0
        }), e1);
    var St, Ze, Ge, Hu, br, xn = k(()=>{
        "use strict";
        St = new Map, Ze = [], Ge = (e1, t, n)=>{
            if (t && typeof t.init == "function" && typeof t.createInferenceSessionHandler == "function") {
                let r = St.get(e1);
                if (r === void 0) St.set(e1, {
                    backend: t,
                    priority: n
                });
                else {
                    if (r.priority > n) return;
                    if (r.priority === n && r.backend !== t) throw new Error(`cannot register backend "${e1}" using priority ${n}`);
                }
                if (n >= 0) {
                    let o = Ze.indexOf(e1);
                    o !== -1 && Ze.splice(o, 1);
                    for(let i = 0; i < Ze.length; i++)if (St.get(Ze[i]).priority <= n) {
                        Ze.splice(i, 0, e1);
                        return;
                    }
                    Ze.push(e1);
                }
                return;
            }
            throw new TypeError("not a valid backend");
        }, Hu = async (e1)=>{
            let t = St.get(e1);
            if (!t) return "backend not found.";
            if (t.initialized) return t.backend;
            if (t.aborted) return t.error;
            {
                let n = !!t.initPromise;
                try {
                    return n || (t.initPromise = t.backend.init(e1)), await t.initPromise, t.initialized = !0, t.backend;
                } catch (r) {
                    return n || (t.error = `${r}`, t.aborted = !0), t.error;
                } finally{
                    delete t.initPromise;
                }
            }
        }, br = async (e1)=>{
            let t = e1.executionProviders || [], n = t.map((u)=>typeof u == "string" ? u : u.name), r = n.length === 0 ? Ze : n, o, i = [], s = new Set;
            for (let u of r){
                let d = await Hu(u);
                typeof d == "string" ? i.push({
                    name: u,
                    err: d
                }) : (o || (o = d), o === d && s.add(u));
            }
            if (!o) throw new Error(`no available backend found. ERR: ${i.map((u)=>`[${u.name}] ${u.err}`).join(", ")}`);
            for (let { name: u, err: d } of i)n.includes(u) && console.warn(`removing requested execution provider "${u}" from session options because it is not available: ${d}`);
            let a = t.filter((u)=>s.has(typeof u == "string" ? u : u.name));
            return [
                o,
                new Proxy(e1, {
                    get: (u, d)=>d === "executionProviders" ? a : Reflect.get(u, d)
                })
            ];
        };
    });
    var _r = k(()=>{
        "use strict";
        xn();
    });
    var wr, $r = k(()=>{
        "use strict";
        wr = "1.24.3";
    });
    var vr, le, Sn = k(()=>{
        "use strict";
        $r();
        vr = "warning", le = {
            wasm: {},
            webgl: {},
            webgpu: {},
            versions: {
                common: wr
            },
            set logLevel (e){
                if (e !== void 0) {
                    if (typeof e != "string" || [
                        "verbose",
                        "info",
                        "warning",
                        "error",
                        "fatal"
                    ].indexOf(e) === -1) throw new Error(`Unsupported logging level: ${e}`);
                    vr = e;
                }
            },
            get logLevel () {
                return vr;
            }
        };
        Object.defineProperty(le, "logLevel", {
            enumerable: !0
        });
    });
    var te, xr = k(()=>{
        "use strict";
        Sn();
        te = le;
    });
    var Sr, Tr, Ir = k(()=>{
        "use strict";
        Sr = (e1, t)=>{
            let n = typeof document < "u" ? document.createElement("canvas") : new OffscreenCanvas(1, 1);
            n.width = e1.dims[3], n.height = e1.dims[2];
            let r = n.getContext("2d");
            if (r != null) {
                let o, i;
                t?.tensorLayout !== void 0 && t.tensorLayout === "NHWC" ? (o = e1.dims[2], i = e1.dims[3]) : (o = e1.dims[3], i = e1.dims[2]);
                let s = t?.format !== void 0 ? t.format : "RGB", a = t?.norm, u, d;
                a === void 0 || a.mean === void 0 ? u = [
                    255,
                    255,
                    255,
                    255
                ] : typeof a.mean == "number" ? u = [
                    a.mean,
                    a.mean,
                    a.mean,
                    a.mean
                ] : (u = [
                    a.mean[0],
                    a.mean[1],
                    a.mean[2],
                    0
                ], a.mean[3] !== void 0 && (u[3] = a.mean[3])), a === void 0 || a.bias === void 0 ? d = [
                    0,
                    0,
                    0,
                    0
                ] : typeof a.bias == "number" ? d = [
                    a.bias,
                    a.bias,
                    a.bias,
                    a.bias
                ] : (d = [
                    a.bias[0],
                    a.bias[1],
                    a.bias[2],
                    0
                ], a.bias[3] !== void 0 && (d[3] = a.bias[3]));
                let l = i * o, c = 0, p = l, f = l * 2, m = -1;
                s === "RGBA" ? (c = 0, p = l, f = l * 2, m = l * 3) : s === "RGB" ? (c = 0, p = l, f = l * 2) : s === "RBG" && (c = 0, f = l, p = l * 2);
                for(let h = 0; h < i; h++)for(let b = 0; b < o; b++){
                    let y = (e1.data[c++] - d[0]) * u[0], g = (e1.data[p++] - d[1]) * u[1], _ = (e1.data[f++] - d[2]) * u[2], w = m === -1 ? 255 : (e1.data[m++] - d[3]) * u[3];
                    r.fillStyle = "rgba(" + y + "," + g + "," + _ + "," + w + ")", r.fillRect(b, h, 1, 1);
                }
                if ("toDataURL" in n) return n.toDataURL();
                throw new Error("toDataURL is not supported");
            } else throw new Error("Can not access image data");
        }, Tr = (e1, t)=>{
            let n = typeof document < "u" ? document.createElement("canvas").getContext("2d") : new OffscreenCanvas(1, 1).getContext("2d"), r;
            if (n != null) {
                let o, i, s;
                t?.tensorLayout !== void 0 && t.tensorLayout === "NHWC" ? (o = e1.dims[2], i = e1.dims[1], s = e1.dims[3]) : (o = e1.dims[3], i = e1.dims[2], s = e1.dims[1]);
                let a = t !== void 0 && t.format !== void 0 ? t.format : "RGB", u = t?.norm, d, l;
                u === void 0 || u.mean === void 0 ? d = [
                    255,
                    255,
                    255,
                    255
                ] : typeof u.mean == "number" ? d = [
                    u.mean,
                    u.mean,
                    u.mean,
                    u.mean
                ] : (d = [
                    u.mean[0],
                    u.mean[1],
                    u.mean[2],
                    255
                ], u.mean[3] !== void 0 && (d[3] = u.mean[3])), u === void 0 || u.bias === void 0 ? l = [
                    0,
                    0,
                    0,
                    0
                ] : typeof u.bias == "number" ? l = [
                    u.bias,
                    u.bias,
                    u.bias,
                    u.bias
                ] : (l = [
                    u.bias[0],
                    u.bias[1],
                    u.bias[2],
                    0
                ], u.bias[3] !== void 0 && (l[3] = u.bias[3]));
                let c = i * o;
                if (t !== void 0 && (t.format !== void 0 && s === 4 && t.format !== "RGBA" || s === 3 && t.format !== "RGB" && t.format !== "BGR")) throw new Error("Tensor format doesn't match input tensor dims");
                let p = 4, f = 0, m = 1, h = 2, b = 3, y = 0, g = c, _ = c * 2, w = -1;
                a === "RGBA" ? (y = 0, g = c, _ = c * 2, w = c * 3) : a === "RGB" ? (y = 0, g = c, _ = c * 2) : a === "RBG" && (y = 0, _ = c, g = c * 2), r = n.createImageData(o, i);
                for(let v = 0; v < i * o; f += p, m += p, h += p, b += p, v++)r.data[f] = (e1.data[y++] - l[0]) * d[0], r.data[m] = (e1.data[g++] - l[1]) * d[1], r.data[h] = (e1.data[_++] - l[2]) * d[2], r.data[b] = w === -1 ? 255 : (e1.data[w++] - l[3]) * d[3];
            } else throw new Error("Can not access image data");
            return r;
        };
    });
    var Tn, Cr, Ar, Er, kr, Pr, zr = k(()=>{
        "use strict";
        Tt();
        Tn = (e1, t)=>{
            if (e1 === void 0) throw new Error("Image buffer must be defined");
            if (t.height === void 0 || t.width === void 0) throw new Error("Image height and width must be defined");
            if (t.tensorLayout === "NHWC") throw new Error("NHWC Tensor layout is not supported yet");
            let { height: n, width: r } = t, o = t.norm ?? {
                mean: 255,
                bias: 0
            }, i, s;
            typeof o.mean == "number" ? i = [
                o.mean,
                o.mean,
                o.mean,
                o.mean
            ] : i = [
                o.mean[0],
                o.mean[1],
                o.mean[2],
                o.mean[3] ?? 255
            ], typeof o.bias == "number" ? s = [
                o.bias,
                o.bias,
                o.bias,
                o.bias
            ] : s = [
                o.bias[0],
                o.bias[1],
                o.bias[2],
                o.bias[3] ?? 0
            ];
            let a = t.format !== void 0 ? t.format : "RGBA", u = t.tensorFormat !== void 0 && t.tensorFormat !== void 0 ? t.tensorFormat : "RGB", d = n * r, l = u === "RGBA" ? new Float32Array(d * 4) : new Float32Array(d * 3), c = 4, p = 0, f = 1, m = 2, h = 3, b = 0, y = d, g = d * 2, _ = -1;
            a === "RGB" && (c = 3, p = 0, f = 1, m = 2, h = -1), u === "RGBA" ? _ = d * 3 : u === "RBG" ? (b = 0, g = d, y = d * 2) : u === "BGR" && (g = 0, y = d, b = d * 2);
            for(let v = 0; v < d; v++, p += c, m += c, f += c, h += c)l[b++] = (e1[p] + s[0]) / i[0], l[y++] = (e1[f] + s[1]) / i[1], l[g++] = (e1[m] + s[2]) / i[2], _ !== -1 && h !== -1 && (l[_++] = (e1[h] + s[3]) / i[3]);
            return u === "RGBA" ? new fe("float32", l, [
                1,
                4,
                n,
                r
            ]) : new fe("float32", l, [
                1,
                3,
                n,
                r
            ]);
        }, Cr = async (e1, t)=>{
            let n = typeof HTMLImageElement < "u" && e1 instanceof HTMLImageElement, r = typeof ImageData < "u" && e1 instanceof ImageData, o = typeof ImageBitmap < "u" && e1 instanceof ImageBitmap, i = typeof e1 == "string", s, a = t ?? {}, u = ()=>{
                if (typeof document < "u") return document.createElement("canvas");
                if (typeof OffscreenCanvas < "u") return new OffscreenCanvas(1, 1);
                throw new Error("Canvas is not supported");
            }, d = (l)=>typeof HTMLCanvasElement < "u" && l instanceof HTMLCanvasElement || l instanceof OffscreenCanvas ? l.getContext("2d") : null;
            if (n) {
                let l = u();
                l.width = e1.width, l.height = e1.height;
                let c = d(l);
                if (c != null) {
                    let p = e1.height, f = e1.width;
                    if (t !== void 0 && t.resizedHeight !== void 0 && t.resizedWidth !== void 0 && (p = t.resizedHeight, f = t.resizedWidth), t !== void 0) {
                        if (a = t, t.tensorFormat !== void 0) throw new Error("Image input config format must be RGBA for HTMLImageElement");
                        a.tensorFormat = "RGBA", a.height = p, a.width = f;
                    } else a.tensorFormat = "RGBA", a.height = p, a.width = f;
                    c.drawImage(e1, 0, 0), s = c.getImageData(0, 0, f, p).data;
                } else throw new Error("Can not access image data");
            } else if (r) {
                let l, c;
                if (t !== void 0 && t.resizedWidth !== void 0 && t.resizedHeight !== void 0 ? (l = t.resizedHeight, c = t.resizedWidth) : (l = e1.height, c = e1.width), t !== void 0 && (a = t), a.format = "RGBA", a.height = l, a.width = c, t !== void 0) {
                    let p = u();
                    p.width = c, p.height = l;
                    let f = d(p);
                    if (f != null) f.putImageData(e1, 0, 0), s = f.getImageData(0, 0, c, l).data;
                    else throw new Error("Can not access image data");
                } else s = e1.data;
            } else if (o) {
                if (t === void 0) throw new Error("Please provide image config with format for Imagebitmap");
                let l = u();
                l.width = e1.width, l.height = e1.height;
                let c = d(l);
                if (c != null) {
                    let p = e1.height, f = e1.width;
                    return c.drawImage(e1, 0, 0, f, p), s = c.getImageData(0, 0, f, p).data, a.height = p, a.width = f, Tn(s, a);
                } else throw new Error("Can not access image data");
            } else {
                if (i) return new Promise((l, c)=>{
                    let p = u(), f = d(p);
                    if (!e1 || !f) return c();
                    let m = new Image;
                    m.crossOrigin = "Anonymous", m.src = e1, m.onload = ()=>{
                        p.width = m.width, p.height = m.height, f.drawImage(m, 0, 0, p.width, p.height);
                        let h = f.getImageData(0, 0, p.width, p.height);
                        a.height = p.height, a.width = p.width, l(Tn(h.data, a));
                    };
                });
                throw new Error("Input data provided is not supported - aborted tensor creation");
            }
            if (s !== void 0) return Tn(s, a);
            throw new Error("Input data provided is not supported - aborted tensor creation");
        }, Ar = (e1, t)=>{
            let { width: n, height: r, download: o, dispose: i } = t, s = [
                1,
                r,
                n,
                4
            ];
            return new fe({
                location: "texture",
                type: "float32",
                texture: e1,
                dims: s,
                download: o,
                dispose: i
            });
        }, Er = (e1, t)=>{
            let { dataType: n, dims: r, download: o, dispose: i } = t;
            return new fe({
                location: "gpu-buffer",
                type: n ?? "float32",
                gpuBuffer: e1,
                dims: r,
                download: o,
                dispose: i
            });
        }, kr = (e1, t)=>{
            let { dataType: n, dims: r, download: o, dispose: i } = t;
            return new fe({
                location: "ml-tensor",
                type: n ?? "float32",
                mlTensor: e1,
                dims: r,
                download: o,
                dispose: i
            });
        }, Pr = (e1, t, n)=>new fe({
                location: "cpu-pinned",
                type: e1,
                data: t,
                dims: n ?? [
                    t.length
                ]
            });
    });
    var Qe, ct, Br, Dr, Or = k(()=>{
        "use strict";
        Qe = new Map([
            [
                "float32",
                Float32Array
            ],
            [
                "uint8",
                Uint8Array
            ],
            [
                "int8",
                Int8Array
            ],
            [
                "uint16",
                Uint16Array
            ],
            [
                "int16",
                Int16Array
            ],
            [
                "int32",
                Int32Array
            ],
            [
                "bool",
                Uint8Array
            ],
            [
                "float64",
                Float64Array
            ],
            [
                "uint32",
                Uint32Array
            ],
            [
                "int4",
                Uint8Array
            ],
            [
                "uint4",
                Uint8Array
            ]
        ]), ct = new Map([
            [
                Float32Array,
                "float32"
            ],
            [
                Uint8Array,
                "uint8"
            ],
            [
                Int8Array,
                "int8"
            ],
            [
                Uint16Array,
                "uint16"
            ],
            [
                Int16Array,
                "int16"
            ],
            [
                Int32Array,
                "int32"
            ],
            [
                Float64Array,
                "float64"
            ],
            [
                Uint32Array,
                "uint32"
            ]
        ]), Br = !1, Dr = ()=>{
            if (!Br) {
                Br = !0;
                let e1 = typeof BigInt64Array < "u" && BigInt64Array.from, t = typeof BigUint64Array < "u" && BigUint64Array.from, n = globalThis.Float16Array, r = typeof n < "u" && n.from;
                e1 && (Qe.set("int64", BigInt64Array), ct.set(BigInt64Array, "int64")), t && (Qe.set("uint64", BigUint64Array), ct.set(BigUint64Array, "uint64")), r ? (Qe.set("float16", n), ct.set(n, "float16")) : Qe.set("float16", Uint16Array);
            }
        };
    });
    var Mr, Ur, Rr = k(()=>{
        "use strict";
        Tt();
        Mr = (e1)=>{
            let t = 1;
            for(let n = 0; n < e1.length; n++){
                let r = e1[n];
                if (typeof r != "number" || !Number.isSafeInteger(r)) throw new TypeError(`dims[${n}] must be an integer, got: ${r}`);
                if (r < 0) throw new RangeError(`dims[${n}] must be a non-negative integer, got: ${r}`);
                t *= r;
            }
            return t;
        }, Ur = (e1, t)=>{
            switch(e1.location){
                case "cpu":
                    return new fe(e1.type, e1.data, t);
                case "cpu-pinned":
                    return new fe({
                        location: "cpu-pinned",
                        data: e1.data,
                        type: e1.type,
                        dims: t
                    });
                case "texture":
                    return new fe({
                        location: "texture",
                        texture: e1.texture,
                        type: e1.type,
                        dims: t
                    });
                case "gpu-buffer":
                    return new fe({
                        location: "gpu-buffer",
                        gpuBuffer: e1.gpuBuffer,
                        type: e1.type,
                        dims: t
                    });
                case "ml-tensor":
                    return new fe({
                        location: "ml-tensor",
                        mlTensor: e1.mlTensor,
                        type: e1.type,
                        dims: t
                    });
                default:
                    throw new Error(`tensorReshape: tensor location ${e1.location} is not supported`);
            }
        };
    });
    var fe, Tt = k(()=>{
        "use strict";
        Ir();
        zr();
        Or();
        Rr();
        fe = class {
            constructor(t, n, r){
                Dr();
                let o, i;
                if (typeof t == "object" && "location" in t) switch(this.dataLocation = t.location, o = t.type, i = t.dims, t.location){
                    case "cpu-pinned":
                        {
                            let a = Qe.get(o);
                            if (!a) throw new TypeError(`unsupported type "${o}" to create tensor from pinned buffer`);
                            if (!(t.data instanceof a)) throw new TypeError(`buffer should be of type ${a.name}`);
                            this.cpuData = t.data;
                            break;
                        }
                    case "texture":
                        if (o !== "float32") throw new TypeError(`unsupported type "${o}" to create tensor from texture`);
                        this.gpuTextureData = t.texture, this.downloader = t.download, this.disposer = t.dispose;
                        break;
                    case "gpu-buffer":
                        if (o !== "float32" && o !== "float16" && o !== "int32" && o !== "int64" && o !== "uint32" && o !== "uint8" && o !== "bool" && o !== "uint4" && o !== "int4") throw new TypeError(`unsupported type "${o}" to create tensor from gpu buffer`);
                        this.gpuBufferData = t.gpuBuffer, this.downloader = t.download, this.disposer = t.dispose;
                        break;
                    case "ml-tensor":
                        if (o !== "float32" && o !== "float16" && o !== "int32" && o !== "int64" && o !== "uint32" && o !== "uint64" && o !== "int8" && o !== "uint8" && o !== "bool" && o !== "uint4" && o !== "int4") throw new TypeError(`unsupported type "${o}" to create tensor from MLTensor`);
                        this.mlTensorData = t.mlTensor, this.downloader = t.download, this.disposer = t.dispose;
                        break;
                    default:
                        throw new Error(`Tensor constructor: unsupported location '${this.dataLocation}'`);
                }
                else {
                    let a, u;
                    if (typeof t == "string") {
                        if (o = t, u = r, t === "string") {
                            if (!Array.isArray(n)) throw new TypeError("A string tensor's data must be a string array.");
                            a = n;
                        } else {
                            let d = Qe.get(t);
                            if (d === void 0) throw new TypeError(`Unsupported tensor type: ${t}.`);
                            if (Array.isArray(n)) {
                                if (t === "float16" && d === Uint16Array || t === "uint4" || t === "int4") throw new TypeError(`Creating a ${t} tensor from number array is not supported. Please use ${d.name} as data.`);
                                t === "uint64" || t === "int64" ? a = d.from(n, BigInt) : a = d.from(n);
                            } else if (n instanceof d) a = n;
                            else if (n instanceof Uint8ClampedArray) {
                                if (t === "uint8") a = Uint8Array.from(n);
                                else throw new TypeError("A Uint8ClampedArray tensor's data must be type of uint8");
                            } else if (t === "float16" && n instanceof Uint16Array && d !== Uint16Array) a = new globalThis.Float16Array(n.buffer, n.byteOffset, n.length);
                            else throw new TypeError(`A ${o} tensor's data must be type of ${d}`);
                        }
                    } else if (u = n, Array.isArray(t)) {
                        if (t.length === 0) throw new TypeError("Tensor type cannot be inferred from an empty array.");
                        let d = typeof t[0];
                        if (d === "string") o = "string", a = t;
                        else if (d === "boolean") o = "bool", a = Uint8Array.from(t);
                        else throw new TypeError(`Invalid element type of data array: ${d}.`);
                    } else if (t instanceof Uint8ClampedArray) o = "uint8", a = Uint8Array.from(t);
                    else {
                        let d = ct.get(t.constructor);
                        if (d === void 0) throw new TypeError(`Unsupported type for tensor data: ${t.constructor}.`);
                        o = d, a = t;
                    }
                    if (u === void 0) u = [
                        a.length
                    ];
                    else if (!Array.isArray(u)) throw new TypeError("A tensor's dims must be a number array");
                    i = u, this.cpuData = a, this.dataLocation = "cpu";
                }
                let s = Mr(i);
                if (this.cpuData && s !== this.cpuData.length && !((o === "uint4" || o === "int4") && Math.ceil(s / 2) === this.cpuData.length)) throw new Error(`Tensor's size(${s}) does not match data length(${this.cpuData.length}).`);
                this.type = o, this.dims = i, this.size = s;
            }
            static async fromImage(t, n) {
                return Cr(t, n);
            }
            static fromTexture(t, n) {
                return Ar(t, n);
            }
            static fromGpuBuffer(t, n) {
                return Er(t, n);
            }
            static fromMLTensor(t, n) {
                return kr(t, n);
            }
            static fromPinnedBuffer(t, n, r) {
                return Pr(t, n, r);
            }
            toDataURL(t) {
                return Sr(this, t);
            }
            toImageData(t) {
                return Tr(this, t);
            }
            get data() {
                if (this.ensureValid(), !this.cpuData) throw new Error("The data is not on CPU. Use `getData()` to download GPU data to CPU, or use `texture` or `gpuBuffer` property to access the GPU data directly.");
                return this.cpuData;
            }
            get location() {
                return this.dataLocation;
            }
            get texture() {
                if (this.ensureValid(), !this.gpuTextureData) throw new Error("The data is not stored as a WebGL texture.");
                return this.gpuTextureData;
            }
            get gpuBuffer() {
                if (this.ensureValid(), !this.gpuBufferData) throw new Error("The data is not stored as a WebGPU buffer.");
                return this.gpuBufferData;
            }
            get mlTensor() {
                if (this.ensureValid(), !this.mlTensorData) throw new Error("The data is not stored as a WebNN MLTensor.");
                return this.mlTensorData;
            }
            async getData(t) {
                switch(this.ensureValid(), this.dataLocation){
                    case "cpu":
                    case "cpu-pinned":
                        return this.data;
                    case "texture":
                    case "gpu-buffer":
                    case "ml-tensor":
                        if (!this.downloader) throw new Error("The current tensor is not created with a specified data downloader.");
                        if (this.isDownloading) throw new Error("The current tensor is being downloaded.");
                        try {
                            this.isDownloading = !0;
                            let n = await this.downloader();
                            return this.downloader = void 0, this.dataLocation = "cpu", this.cpuData = n, t && this.disposer && (this.disposer(), this.disposer = void 0), n;
                        } finally{
                            this.isDownloading = !1;
                        }
                    default:
                        throw new Error(`cannot get data from location: ${this.dataLocation}`);
                }
            }
            dispose() {
                if (this.isDownloading) throw new Error("The current tensor is being downloaded.");
                this.disposer && (this.disposer(), this.disposer = void 0), this.cpuData = void 0, this.gpuTextureData = void 0, this.gpuBufferData = void 0, this.mlTensorData = void 0, this.downloader = void 0, this.isDownloading = void 0, this.dataLocation = "none";
            }
            ensureValid() {
                if (this.dataLocation === "none") throw new Error("The tensor is disposed.");
            }
            reshape(t) {
                if (this.ensureValid(), this.downloader || this.disposer) throw new Error("Cannot reshape a tensor that owns GPU resource.");
                return Ur(this, t);
            }
        };
    });
    var xe, In = k(()=>{
        "use strict";
        Tt();
        xe = fe;
    });
    var pt, Vr, ye, he, Ue, Re, Cn = k(()=>{
        "use strict";
        Sn();
        pt = (e1, t)=>{
            (typeof le.trace > "u" ? !le.wasm.trace : !le.trace) || console.timeStamp(`${e1}::ORT::${t}`);
        }, Vr = (e1, t)=>{
            let n = new Error().stack?.split(/\r\n|\r|\n/g) || [], r = !1;
            for(let o = 0; o < n.length; o++){
                if (r && !n[o].includes("TRACE_FUNC")) {
                    let i = `FUNC_${e1}::${n[o].trim().split(" ")[1]}`;
                    t && (i += `::${t}`), pt("CPU", i);
                    return;
                }
                n[o].includes("TRACE_FUNC") && (r = !0);
            }
        }, ye = (e1)=>{
            (typeof le.trace > "u" ? !le.wasm.trace : !le.trace) || Vr("BEGIN", e1);
        }, he = (e1)=>{
            (typeof le.trace > "u" ? !le.wasm.trace : !le.trace) || Vr("END", e1);
        }, Ue = (e1)=>{
            (typeof le.trace > "u" ? !le.wasm.trace : !le.trace) || console.time(`ORT::${e1}`);
        }, Re = (e1)=>{
            (typeof le.trace > "u" ? !le.wasm.trace : !le.trace) || console.timeEnd(`ORT::${e1}`);
        };
    });
    var It, Nr = k(()=>{
        "use strict";
        xn();
        In();
        Cn();
        It = class e1 {
            constructor(t){
                this.handler = t;
            }
            async run(t, n, r) {
                ye(), Ue("InferenceSession.run");
                let o = {}, i = {};
                if (typeof t != "object" || t === null || t instanceof xe || Array.isArray(t)) throw new TypeError("'feeds' must be an object that use input names as keys and OnnxValue as corresponding values.");
                let s = !0;
                if (typeof n == "object") {
                    if (n === null) throw new TypeError("Unexpected argument[1]: cannot be null.");
                    if (n instanceof xe) throw new TypeError("'fetches' cannot be a Tensor");
                    if (Array.isArray(n)) {
                        if (n.length === 0) throw new TypeError("'fetches' cannot be an empty array.");
                        s = !1;
                        for (let d of n){
                            if (typeof d != "string") throw new TypeError("'fetches' must be a string array or an object.");
                            if (this.outputNames.indexOf(d) === -1) throw new RangeError(`'fetches' contains invalid output name: ${d}.`);
                            o[d] = null;
                        }
                        if (typeof r == "object" && r !== null) i = r;
                        else if (typeof r < "u") throw new TypeError("'options' must be an object.");
                    } else {
                        let d = !1, l = Object.getOwnPropertyNames(n);
                        for (let c of this.outputNames)if (l.indexOf(c) !== -1) {
                            let p = n[c];
                            (p === null || p instanceof xe) && (d = !0, s = !1, o[c] = p);
                        }
                        if (d) {
                            if (typeof r == "object" && r !== null) i = r;
                            else if (typeof r < "u") throw new TypeError("'options' must be an object.");
                        } else i = n;
                    }
                } else if (typeof n < "u") throw new TypeError("Unexpected argument[1]: must be 'fetches' or 'options'.");
                for (let d of this.inputNames)if (typeof t[d] > "u") throw new Error(`input '${d}' is missing in 'feeds'.`);
                if (s) for (let d of this.outputNames)o[d] = null;
                let a = await this.handler.run(t, o, i), u = {};
                for(let d in a)if (Object.hasOwnProperty.call(a, d)) {
                    let l = a[d];
                    l instanceof xe ? u[d] = l : u[d] = new xe(l.type, l.data, l.dims);
                }
                return Re("InferenceSession.run"), he(), u;
            }
            async release() {
                return this.handler.dispose();
            }
            static async create(t, n, r, o) {
                ye(), Ue("InferenceSession.create");
                let i, s = {};
                if (typeof t == "string") {
                    if (i = t, typeof n == "object" && n !== null) s = n;
                    else if (typeof n < "u") throw new TypeError("'options' must be an object.");
                } else if (t instanceof Uint8Array) {
                    if (i = t, typeof n == "object" && n !== null) s = n;
                    else if (typeof n < "u") throw new TypeError("'options' must be an object.");
                } else if (t instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && t instanceof SharedArrayBuffer) {
                    let l = t, c = 0, p = t.byteLength;
                    if (typeof n == "object" && n !== null) s = n;
                    else if (typeof n == "number") {
                        if (c = n, !Number.isSafeInteger(c)) throw new RangeError("'byteOffset' must be an integer.");
                        if (c < 0 || c >= l.byteLength) throw new RangeError(`'byteOffset' is out of range [0, ${l.byteLength}).`);
                        if (p = t.byteLength - c, typeof r == "number") {
                            if (p = r, !Number.isSafeInteger(p)) throw new RangeError("'byteLength' must be an integer.");
                            if (p <= 0 || c + p > l.byteLength) throw new RangeError(`'byteLength' is out of range (0, ${l.byteLength - c}].`);
                            if (typeof o == "object" && o !== null) s = o;
                            else if (typeof o < "u") throw new TypeError("'options' must be an object.");
                        } else if (typeof r < "u") throw new TypeError("'byteLength' must be a number.");
                    } else if (typeof n < "u") throw new TypeError("'options' must be an object.");
                    i = new Uint8Array(l, c, p);
                } else throw new TypeError("Unexpected argument[0]: must be 'path' or 'buffer'.");
                let [a, u] = await br(s), d = await a.createInferenceSessionHandler(i, u);
                return Re("InferenceSession.create"), he(), new e1(d);
            }
            startProfiling() {
                this.handler.startProfiling();
            }
            endProfiling() {
                this.handler.endProfiling();
            }
            get inputNames() {
                return this.handler.inputNames;
            }
            get outputNames() {
                return this.handler.outputNames;
            }
            get inputMetadata() {
                return this.handler.inputMetadata;
            }
            get outputMetadata() {
                return this.handler.outputMetadata;
            }
        };
    });
    var Lr, Gr = k(()=>{
        "use strict";
        Nr();
        Lr = It;
    });
    var Wr = k(()=>{
        "use strict";
    });
    var Hr = k(()=>{
        "use strict";
    });
    var qr = k(()=>{
        "use strict";
    });
    var Fr = k(()=>{
        "use strict";
    });
    var An = {};
    rt(An, {
        InferenceSession: ()=>Lr,
        TRACE: ()=>pt,
        TRACE_EVENT_BEGIN: ()=>Ue,
        TRACE_EVENT_END: ()=>Re,
        TRACE_FUNC_BEGIN: ()=>ye,
        TRACE_FUNC_END: ()=>he,
        Tensor: ()=>xe,
        env: ()=>te,
        registerBackend: ()=>Ge
    });
    var _e = k(()=>{
        "use strict";
        _r();
        xr();
        Gr();
        In();
        Wr();
        Hr();
        Cn();
        qr();
        Fr();
    });
    var Ct = k(()=>{
        "use strict";
    });
    var Qr = {};
    rt(Qr, {
        default: ()=>qu
    });
    var jr, Zr, qu, Xr = k(()=>{
        "use strict";
        En();
        We();
        At();
        jr = "ort-wasm-proxy-worker", Zr = globalThis.self?.name === jr;
        Zr && (self.onmessage = (e1)=>{
            let { type: t, in: n } = e1.data;
            try {
                switch(t){
                    case "init-wasm":
                        Et(n.wasm).then(()=>{
                            kt(n).then(()=>{
                                postMessage({
                                    type: t
                                });
                            }, (r)=>{
                                postMessage({
                                    type: t,
                                    err: r
                                });
                            });
                        }, (r)=>{
                            postMessage({
                                type: t,
                                err: r
                            });
                        });
                        break;
                    case "init-ep":
                        {
                            let { epName: r, env: o } = n;
                            Pt(o, r).then(()=>{
                                postMessage({
                                    type: t
                                });
                            }, (i)=>{
                                postMessage({
                                    type: t,
                                    err: i
                                });
                            });
                            break;
                        }
                    case "copy-from":
                        {
                            let { buffer: r } = n, o = mt(r);
                            postMessage({
                                type: t,
                                out: o
                            });
                            break;
                        }
                    case "create":
                        {
                            let { model: r, options: o } = n;
                            zt(r, o).then((i)=>{
                                postMessage({
                                    type: t,
                                    out: i
                                });
                            }, (i)=>{
                                postMessage({
                                    type: t,
                                    err: i
                                });
                            });
                            break;
                        }
                    case "release":
                        Bt(n), postMessage({
                            type: t
                        });
                        break;
                    case "run":
                        {
                            let { sessionId: r, inputIndices: o, inputs: i, outputIndices: s, options: a } = n;
                            Dt(r, o, i, s, new Array(s.length).fill(null), a).then((u)=>{
                                u.some((d)=>d[3] !== "cpu") ? postMessage({
                                    type: t,
                                    err: "Proxy does not support non-cpu tensor location."
                                }) : postMessage({
                                    type: t,
                                    out: u
                                }, Mt([
                                    ...i,
                                    ...u
                                ]));
                            }, (u)=>{
                                postMessage({
                                    type: t,
                                    err: u
                                });
                            });
                            break;
                        }
                    case "end-profiling":
                        Ot(n), postMessage({
                            type: t
                        });
                        break;
                    default:
                }
            } catch (r) {
                postMessage({
                    type: t,
                    err: r
                });
            }
        });
        qu = Zr ? null : (e1)=>new Worker(e1 ?? we, {
                type: "classic",
                name: jr
            });
    });
    var Fu, Ku, we, Ut, kn, ju, Zu, eo, Qu, Yr, to, Jr, no, At = k(()=>{
        "use strict";
        Ct();
        Fu = typeof location > "u" ? void 0 : location.origin, Ku = ()=>{
            return typeof document < "u" ? document.currentScript?.src : typeof self < "u" ? self.location?.href : void 0;
        }, we = Ku(), Ut = ()=>{
            if (we && !we.startsWith("blob:")) return we.substring(0, we.lastIndexOf("/") + 1);
        }, kn = (e1, t)=>{
            try {
                let n = t ?? we;
                return (n ? new URL(e1, n) : new URL(e1)).origin === Fu;
            } catch  {
                return !1;
            }
        }, ju = (e1, t)=>{
            let n = t ?? we;
            try {
                return (n ? new URL(e1, n) : new URL(e1)).href;
            } catch  {
                return;
            }
        }, Zu = (e1, t)=>`${t ?? "./"}${e1}`, eo = async (e1)=>{
            let n = await (await fetch(e1, {
                credentials: "same-origin"
            })).blob();
            return URL.createObjectURL(n);
        }, Qu = async (e1)=>(await import(/*webpackIgnore:true*/ /*@vite-ignore*/ e1)).default, Yr = (Xr(), lt(Qr)).default, to = async ()=>{
            if (!we) throw new Error("Failed to load proxy worker: cannot determine the script source URL.");
            if (kn(we)) return [
                void 0,
                Yr()
            ];
            let e1 = await eo(we);
            return [
                e1,
                Yr(e1)
            ];
        }, Jr = void 0, no = async (e1, t, n, r)=>{
            let o = Jr && !(e1 || t);
            if (o) {
                if (we) o = kn(we) || r && !n;
                else if (r && !n) o = !0;
                else throw new Error("cannot determine the script source URL.");
            }
            if (o) return [
                void 0,
                Jr
            ];
            {
                let i = "ort-wasm-simd-threaded.jsep.mjs", s = e1 ?? ju(i, t), a = n && s && !kn(s, t), u = a ? await eo(s) : s ?? Zu(i, t);
                return [
                    a ? u : void 0,
                    await Qu(u)
                ];
            }
        };
    });
    var Pn, zn, Rt, ro, Xu, Yu, Ju, Et, ne, We = k(()=>{
        "use strict";
        At();
        zn = !1, Rt = !1, ro = !1, Xu = ()=>{
            if (typeof SharedArrayBuffer > "u") return !1;
            try {
                return typeof MessageChannel < "u" && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(new Uint8Array([
                    0,
                    97,
                    115,
                    109,
                    1,
                    0,
                    0,
                    0,
                    1,
                    4,
                    1,
                    96,
                    0,
                    0,
                    3,
                    2,
                    1,
                    0,
                    5,
                    4,
                    1,
                    3,
                    1,
                    1,
                    10,
                    11,
                    1,
                    9,
                    0,
                    65,
                    0,
                    254,
                    16,
                    2,
                    0,
                    26,
                    11
                ]));
            } catch  {
                return !1;
            }
        }, Yu = ()=>{
            try {
                return WebAssembly.validate(new Uint8Array([
                    0,
                    97,
                    115,
                    109,
                    1,
                    0,
                    0,
                    0,
                    1,
                    4,
                    1,
                    96,
                    0,
                    0,
                    3,
                    2,
                    1,
                    0,
                    10,
                    30,
                    1,
                    28,
                    0,
                    65,
                    0,
                    253,
                    15,
                    253,
                    12,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    253,
                    186,
                    1,
                    26,
                    11
                ]));
            } catch  {
                return !1;
            }
        }, Ju = ()=>{
            try {
                return WebAssembly.validate(new Uint8Array([
                    0,
                    97,
                    115,
                    109,
                    1,
                    0,
                    0,
                    0,
                    1,
                    5,
                    1,
                    96,
                    0,
                    1,
                    123,
                    3,
                    2,
                    1,
                    0,
                    10,
                    19,
                    1,
                    17,
                    0,
                    65,
                    1,
                    253,
                    15,
                    65,
                    2,
                    253,
                    15,
                    65,
                    3,
                    253,
                    15,
                    253,
                    147,
                    2,
                    11
                ]));
            } catch  {
                return !1;
            }
        }, Et = async (e1)=>{
            if (zn) return Promise.resolve();
            if (Rt) throw new Error("multiple calls to 'initializeWebAssembly()' detected.");
            if (ro) throw new Error("previous call to 'initializeWebAssembly()' failed.");
            Rt = !0;
            let t = e1.initTimeout, n = e1.numThreads;
            if (e1.simd !== !1) {
                if (e1.simd === "relaxed") {
                    if (!Ju()) throw new Error("Relaxed WebAssembly SIMD is not supported in the current environment.");
                } else if (!Yu()) throw new Error("WebAssembly SIMD is not supported in the current environment.");
            }
            let r = Xu();
            n > 1 && !r && (typeof self < "u" && !self.crossOriginIsolated && console.warn("env.wasm.numThreads is set to " + n + ", but this will not work unless you enable crossOriginIsolated mode. See https://web.dev/cross-origin-isolation-guide/ for more info."), console.warn("WebAssembly multi-threading is not supported in the current environment. Falling back to single-threading."), e1.numThreads = n = 1);
            let o = e1.wasmPaths, i = typeof o == "string" ? o : void 0, s = o?.mjs, a = s?.href ?? s, u = o?.wasm, d = u?.href ?? u, l = e1.wasmBinary, [c, p] = await no(a, i, n > 1, !!l || !!d), f = !1, m = [];
            if (t > 0 && m.push(new Promise((h)=>{
                setTimeout(()=>{
                    f = !0, h();
                }, t);
            })), m.push(new Promise((h, b)=>{
                let y = {
                    numThreads: n
                };
                if (l) y.wasmBinary = l, y.locateFile = (g)=>g;
                else if (d || i) y.locateFile = (g)=>d ?? i + g;
                else if (a && a.indexOf("blob:") !== 0) y.locateFile = (g)=>new URL(g, a).href;
                else if (c) {
                    let g = Ut();
                    g && (y.locateFile = (_)=>g + _);
                }
                p(y).then((g)=>{
                    Rt = !1, zn = !0, Pn = g, h(), c && URL.revokeObjectURL(c);
                }, (g)=>{
                    Rt = !1, ro = !0, b(g);
                });
            })), await Promise.race(m), f) throw new Error(`WebAssembly backend initializing failed due to timeout: ${t}ms`);
        }, ne = ()=>{
            if (zn && Pn) return Pn;
            throw new Error("WebAssembly is not initialized yet.");
        };
    });
    var $e, ft, Y, Vt = k(()=>{
        "use strict";
        We();
        $e = (e1, t)=>{
            let n = ne(), r = n.lengthBytesUTF8(e1) + 1, o = n._malloc(r);
            return n.stringToUTF8(e1, o, r), t.push(o), o;
        }, ft = (e1, t, n, r)=>{
            if (typeof e1 == "object" && e1 !== null) {
                if (n.has(e1)) throw new Error("Circular reference in options");
                n.add(e1);
            }
            Object.entries(e1).forEach(([o, i])=>{
                let s = t ? t + o : o;
                if (typeof i == "object") ft(i, s + ".", n, r);
                else if (typeof i == "string" || typeof i == "number") r(s, i.toString());
                else if (typeof i == "boolean") r(s, i ? "1" : "0");
                else throw new Error(`Can't handle extra config type: ${typeof i}`);
            });
        }, Y = (e1)=>{
            let t = ne(), n = t.stackSave();
            try {
                let r = t.PTR_SIZE, o = t.stackAlloc(2 * r);
                t._OrtGetLastError(o, o + r);
                let i = Number(t.getValue(o, r === 4 ? "i32" : "i64")), s = t.getValue(o + r, "*"), a = s ? t.UTF8ToString(s) : "";
                throw new Error(`${e1} ERROR_CODE: ${i}, ERROR_MESSAGE: ${a}`);
            } finally{
                t.stackRestore(n);
            }
        };
    });
    var oo, io = k(()=>{
        "use strict";
        We();
        Vt();
        oo = (e1)=>{
            let t = ne(), n = 0, r = [], o = e1 || {};
            try {
                if (e1?.logSeverityLevel === void 0) o.logSeverityLevel = 2;
                else if (typeof e1.logSeverityLevel != "number" || !Number.isInteger(e1.logSeverityLevel) || e1.logSeverityLevel < 0 || e1.logSeverityLevel > 4) throw new Error(`log severity level is not valid: ${e1.logSeverityLevel}`);
                if (e1?.logVerbosityLevel === void 0) o.logVerbosityLevel = 0;
                else if (typeof e1.logVerbosityLevel != "number" || !Number.isInteger(e1.logVerbosityLevel)) throw new Error(`log verbosity level is not valid: ${e1.logVerbosityLevel}`);
                e1?.terminate === void 0 && (o.terminate = !1);
                let i = 0;
                return e1?.tag !== void 0 && (i = $e(e1.tag, r)), n = t._OrtCreateRunOptions(o.logSeverityLevel, o.logVerbosityLevel, !!o.terminate, i), n === 0 && Y("Can't create run options."), e1?.extra !== void 0 && ft(e1.extra, "", new WeakSet, (s, a)=>{
                    let u = $e(s, r), d = $e(a, r);
                    t._OrtAddRunConfigEntry(n, u, d) !== 0 && Y(`Can't set a run config entry: ${s} - ${a}.`);
                }), [
                    n,
                    r
                ];
            } catch (i) {
                throw n !== 0 && t._OrtReleaseRunOptions(n), r.forEach((s)=>t._free(s)), i;
            }
        };
    });
    var ed, td, nd, Nt, rd, so, ao = k(()=>{
        "use strict";
        We();
        Vt();
        ed = (e1)=>{
            switch(e1){
                case "disabled":
                    return 0;
                case "basic":
                    return 1;
                case "extended":
                    return 2;
                case "layout":
                    return 3;
                case "all":
                    return 99;
                default:
                    throw new Error(`unsupported graph optimization level: ${e1}`);
            }
        }, td = (e1)=>{
            switch(e1){
                case "sequential":
                    return 0;
                case "parallel":
                    return 1;
                default:
                    throw new Error(`unsupported execution mode: ${e1}`);
            }
        }, nd = (e1)=>{
            e1.extra || (e1.extra = {}), e1.extra.session || (e1.extra.session = {});
            let t = e1.extra.session;
            t.use_ort_model_bytes_directly || (t.use_ort_model_bytes_directly = "1"), e1.executionProviders && e1.executionProviders.some((n)=>(typeof n == "string" ? n : n.name) === "webgpu") && (e1.enableMemPattern = !1);
        }, Nt = (e1, t, n, r)=>{
            let o = $e(t, r), i = $e(n, r);
            ne()._OrtAddSessionConfigEntry(e1, o, i) !== 0 && Y(`Can't set a session config entry: ${t} - ${n}.`);
        }, rd = async (e1, t, n)=>{
            let r = t.executionProviders;
            for (let o of r){
                let i = typeof o == "string" ? o : o.name, s = [];
                switch(i){
                    case "webnn":
                        if (i = "WEBNN", typeof o != "string") {
                            let p = o?.deviceType;
                            p && Nt(e1, "deviceType", p, n);
                        }
                        break;
                    case "webgpu":
                        if (i = "JS", typeof o != "string") {
                            let c = o;
                            if (c?.preferredLayout) {
                                if (c.preferredLayout !== "NCHW" && c.preferredLayout !== "NHWC") throw new Error(`preferredLayout must be either 'NCHW' or 'NHWC': ${c.preferredLayout}`);
                                Nt(e1, "preferredLayout", c.preferredLayout, n);
                            }
                        }
                        break;
                    case "wasm":
                    case "cpu":
                        continue;
                    default:
                        throw new Error(`not supported execution provider: ${i}`);
                }
                let a = $e(i, n), u = s.length, d = 0, l = 0;
                if (u > 0) {
                    d = ne()._malloc(u * ne().PTR_SIZE), n.push(d), l = ne()._malloc(u * ne().PTR_SIZE), n.push(l);
                    for(let c = 0; c < u; c++)ne().setValue(d + c * ne().PTR_SIZE, s[c][0], "*"), ne().setValue(l + c * ne().PTR_SIZE, s[c][1], "*");
                }
                await ne()._OrtAppendExecutionProvider(e1, a, d, l, u) !== 0 && Y(`Can't append execution provider: ${i}.`);
            }
        }, so = async (e1)=>{
            let t = ne(), n = 0, r = [], o = e1 || {};
            nd(o);
            try {
                let i = ed(o.graphOptimizationLevel ?? "all"), s = td(o.executionMode ?? "sequential"), a = typeof o.logId == "string" ? $e(o.logId, r) : 0, u = o.logSeverityLevel ?? 2;
                if (!Number.isInteger(u) || u < 0 || u > 4) throw new Error(`log severity level is not valid: ${u}`);
                let d = o.logVerbosityLevel ?? 0;
                if (!Number.isInteger(d) || d < 0 || d > 4) throw new Error(`log verbosity level is not valid: ${d}`);
                let l = typeof o.optimizedModelFilePath == "string" ? $e(o.optimizedModelFilePath, r) : 0;
                if (n = t._OrtCreateSessionOptions(i, !!o.enableCpuMemArena, !!o.enableMemPattern, s, !!o.enableProfiling, 0, a, u, d, l), n === 0 && Y("Can't create session options."), o.executionProviders && await rd(n, o, r), o.enableGraphCapture !== void 0) {
                    if (typeof o.enableGraphCapture != "boolean") throw new Error(`enableGraphCapture must be a boolean value: ${o.enableGraphCapture}`);
                    Nt(n, "enableGraphCapture", o.enableGraphCapture.toString(), r);
                }
                if (o.freeDimensionOverrides) for (let [c, p] of Object.entries(o.freeDimensionOverrides)){
                    if (typeof c != "string") throw new Error(`free dimension override name must be a string: ${c}`);
                    if (typeof p != "number" || !Number.isInteger(p) || p < 0) throw new Error(`free dimension override value must be a non-negative integer: ${p}`);
                    let f = $e(c, r);
                    t._OrtAddFreeDimensionOverride(n, f, p) !== 0 && Y(`Can't set a free dimension override: ${c} - ${p}.`);
                }
                return o.extra !== void 0 && ft(o.extra, "", new WeakSet, (c, p)=>{
                    Nt(n, c, p, r);
                }), [
                    n,
                    r
                ];
            } catch (i) {
                throw n !== 0 && t._OrtReleaseSessionOptions(n) !== 0 && Y("Can't release session options."), r.forEach((s)=>t._free(s)), i;
            }
        };
    });
    var He, Ee, qe, ot, ht, Lt, Gt, Bn, L = k(()=>{
        "use strict";
        He = (e1)=>{
            switch(e1){
                case "int8":
                    return 3;
                case "uint8":
                    return 2;
                case "bool":
                    return 9;
                case "int16":
                    return 5;
                case "uint16":
                    return 4;
                case "int32":
                    return 6;
                case "uint32":
                    return 12;
                case "float16":
                    return 10;
                case "float32":
                    return 1;
                case "float64":
                    return 11;
                case "string":
                    return 8;
                case "int64":
                    return 7;
                case "uint64":
                    return 13;
                case "int4":
                    return 22;
                case "uint4":
                    return 21;
                default:
                    throw new Error(`unsupported data type: ${e1}`);
            }
        }, Ee = (e1)=>{
            switch(e1){
                case 3:
                    return "int8";
                case 2:
                    return "uint8";
                case 9:
                    return "bool";
                case 5:
                    return "int16";
                case 4:
                    return "uint16";
                case 6:
                    return "int32";
                case 12:
                    return "uint32";
                case 10:
                    return "float16";
                case 1:
                    return "float32";
                case 11:
                    return "float64";
                case 8:
                    return "string";
                case 7:
                    return "int64";
                case 13:
                    return "uint64";
                case 22:
                    return "int4";
                case 21:
                    return "uint4";
                default:
                    throw new Error(`unsupported data type: ${e1}`);
            }
        }, qe = (e1, t)=>{
            let n = [
                -1,
                4,
                1,
                1,
                2,
                2,
                4,
                8,
                -1,
                1,
                2,
                8,
                4,
                8,
                -1,
                -1,
                -1,
                -1,
                -1,
                -1,
                -1,
                .5,
                .5
            ][e1], r = typeof t == "number" ? t : t.reduce((o, i)=>o * i, 1);
            return n > 0 ? Math.ceil(r * n) : void 0;
        }, ot = (e1)=>{
            switch(e1){
                case "float16":
                    return typeof Float16Array < "u" && Float16Array.from ? Float16Array : Uint16Array;
                case "float32":
                    return Float32Array;
                case "uint8":
                    return Uint8Array;
                case "int8":
                    return Int8Array;
                case "uint16":
                    return Uint16Array;
                case "int16":
                    return Int16Array;
                case "int32":
                    return Int32Array;
                case "bool":
                    return Uint8Array;
                case "float64":
                    return Float64Array;
                case "uint32":
                    return Uint32Array;
                case "int64":
                    return BigInt64Array;
                case "uint64":
                    return BigUint64Array;
                default:
                    throw new Error(`unsupported type: ${e1}`);
            }
        }, ht = (e1)=>{
            switch(e1){
                case "verbose":
                    return 0;
                case "info":
                    return 1;
                case "warning":
                    return 2;
                case "error":
                    return 3;
                case "fatal":
                    return 4;
                default:
                    throw new Error(`unsupported logging level: ${e1}`);
            }
        }, Lt = (e1)=>e1 === "float32" || e1 === "float16" || e1 === "int32" || e1 === "int64" || e1 === "uint32" || e1 === "uint8" || e1 === "bool" || e1 === "uint4" || e1 === "int4", Gt = (e1)=>e1 === "float32" || e1 === "float16" || e1 === "int32" || e1 === "int64" || e1 === "uint32" || e1 === "uint64" || e1 === "int8" || e1 === "uint8" || e1 === "bool" || e1 === "uint4" || e1 === "int4", Bn = (e1)=>{
            switch(e1){
                case "none":
                    return 0;
                case "cpu":
                    return 1;
                case "cpu-pinned":
                    return 2;
                case "texture":
                    return 3;
                case "gpu-buffer":
                    return 4;
                case "ml-tensor":
                    return 5;
                default:
                    throw new Error(`unsupported data location: ${e1}`);
            }
        };
    });
    var gt, Dn = k(()=>{
        "use strict";
        Ct();
        gt = async (e1)=>{
            if (typeof e1 == "string") {
                var t;
                {
                    let t = await fetch(e1);
                    if (!t.ok) throw new Error(`failed to load external data file: ${e1}`);
                    let n = t.headers.get("Content-Length"), r = n ? parseInt(n, 10) : 0;
                    if (r < 1073741824) return new Uint8Array(await t.arrayBuffer());
                    {
                        if (!t.body) throw new Error(`failed to load external data file: ${e1}, no response body.`);
                        let o = t.body.getReader(), i;
                        try {
                            i = new ArrayBuffer(r);
                        } catch (a) {
                            if (a instanceof RangeError) {
                                let u = Math.ceil(r / 65536);
                                i = new WebAssembly.Memory({
                                    initial: u,
                                    maximum: u
                                }).buffer;
                            } else throw a;
                        }
                        let s = 0;
                        for(;;){
                            let { done: a, value: u } = await o.read();
                            if (a) break;
                            let d = u.byteLength;
                            new Uint8Array(i, s, d).set(u), s += d;
                        }
                        return new Uint8Array(i, 0, r);
                    }
                }
            } else return e1 instanceof Blob ? new Uint8Array(await e1.arrayBuffer()) : e1 instanceof Uint8Array ? e1 : new Uint8Array(e1);
        };
    });
    var od, id, uo, lo, Wt, sd, Z, ke = k(()=>{
        "use strict";
        L();
        od = [
            "V",
            "I",
            "W",
            "E",
            "F"
        ], id = (e1, t)=>{
            console.log(`[${od[e1]},${new Date().toISOString()}]${t}`);
        }, Wt = (e1, t)=>{
            uo = e1, lo = t;
        }, sd = (e1, t)=>{
            let n = ht(e1), r = ht(uo);
            n >= r && id(n, typeof t == "function" ? t() : t);
        }, Z = (...e1)=>{
            lo && sd(...e1);
        };
    });
    var On, Pe, x, Ye, Ht, co, po, F = k(()=>{
        "use strict";
        On = class {
            static calcMatMulShape(t, n) {
                return t[1] !== n[0] ? void 0 : [
                    t[0],
                    n[1]
                ];
            }
        }, Pe = class {
            static calcShape(t, n, r = !1) {
                let o = t.length, i = n.length;
                if (o === 0) return n;
                if (i === 0) return t;
                let s = Math.max(t.length, n.length), a = new Array(s);
                if (r) {
                    if (o < 2 || i < 2) return;
                    let u = On.calcMatMulShape([
                        t[o - 2],
                        t[o - 1]
                    ], [
                        n[i - 2],
                        n[i - 1]
                    ]);
                    if (u === void 0) return;
                    [a[s - 2], a[s - 1]] = u;
                }
                for(let u = r ? 3 : 1; u <= s; u++){
                    let d = o - u < 0 ? 1 : t[o - u], l = i - u < 0 ? 1 : n[i - u];
                    if (d !== l && d > 1 && l > 1) return;
                    let c = Math.max(d, l);
                    if (d && l) a[s - u] = Math.max(d, l);
                    else {
                        if (c > 1) return;
                        a[s - u] = 0;
                    }
                }
                return a;
            }
            static isValidBroadcast(t, n) {
                let r = t.length, o = n.length;
                if (r > o) return !1;
                for(let i = 1; i <= r; i++)if (t[r - i] !== 1 && t[r - i] !== n[o - i]) return !1;
                return !0;
            }
        }, x = class e1 {
            static size(t) {
                return e1.getSizeFromDimensionRange(t, 0, t.length);
            }
            static convertShape(t, n = 4) {
                let r = t.length;
                if (r === 0) return [];
                let o = new Array(r), i = r - 1;
                for(; i >= 0;){
                    if (t[i] % n === 0) {
                        o[i] = t[i] / n;
                        break;
                    }
                    if (n % t[i] !== 0) throw new Error("cannot convert shape");
                    o[i] = 1, n /= t[i], i--;
                }
                for(i--; i >= 0; i--)o[i] = t[i];
                return o;
            }
            static sizeFromDimension(t, n) {
                if (n < 0 || n > t.length) throw new Error(`invalid dimension of ${n} for sizeFromDimension as Tensor has ${t.length} dimensions.`);
                return e1.getSizeFromDimensionRange(t, n, t.length);
            }
            static sizeToDimension(t, n) {
                if (n < 0 || n > t.length) throw new Error(`invalid dimension of ${n} for sizeToDimension as Tensor has ${t.length} dimensions.`);
                return e1.getSizeFromDimensionRange(t, 0, n);
            }
            static getSizeFromDimensionRange(t, n, r) {
                let o = 1;
                for(let i = n; i < r; i++){
                    if (t[i] < 0) throw new Error("cannot get valid size from specified dimension range. Most likely the range contains negative values in them.");
                    o *= Number(t[i]);
                }
                return o;
            }
            static computeStrides(t) {
                let n = t.length;
                if (n === 0) return [];
                if (n === 1) return [
                    1
                ];
                let r = new Array(n);
                r[n - 1] = 1, r[n - 2] = t[n - 1];
                for(let o = n - 3; o >= 0; --o)r[o] = r[o + 1] * t[o + 1];
                return r;
            }
            static normalizeAxis(t, n) {
                if (t < -n && t >= n) throw new Error("unsupported axis for this operation.");
                return t < 0 ? t + n : t;
            }
            static normalizeAxes(t, n) {
                return t.map((r)=>this.normalizeAxis(r, n ?? t.length));
            }
            static sortBasedOnPerm(t, n) {
                return n ? n.map((r)=>t[r]) : t.slice().reverse();
            }
            static padShape(t, n) {
                let r = t.length;
                return t.map((o, i)=>o + n[i] + n[i + r]);
            }
            static areEqual(t, n) {
                return t.length !== n.length ? !1 : t.every((r, o)=>r === n[o]);
            }
        }, Ye = class e1 {
            static adjustPoolAttributes(t, n, r, o, i, s) {
                if (!t && r.length !== n.length - 2) throw new Error("length of specified kernel shapes should be 2 less than length of input dimensions");
                if (t) for(let a = 0; a < n.length - 2; a++)a >= r.length ? r.push(n[a + 2]) : r[a] = n[a + 2];
                for(let a = 0; a < r.length; a++)if (a < o.length) {
                    if (o[a] < 0) throw new Error("strides should be greater than or equal to 1");
                } else o.push(1);
                for(let a = 0; a < r.length; a++)if (a < i.length) {
                    if (i[a] < 0) throw new Error("dilations should be greater than or equal to 1");
                } else i.push(1);
                for(let a = 0; a < r.length * 2; a++)if (a < s.length) {
                    if (s[a] < 0) throw new Error("pad should be greater than or equal to 1");
                } else s.push(0);
                for(let a = 0; a < r.length; a++){
                    if (r[a] <= 0) throw new Error("kernel shapes need to be greater than 0");
                    if (s[a] >= r[a] || s[a + r.length] >= r[a]) throw new Error("pads should be smaller than kernel");
                }
            }
            static adjustPadsBasedOnAutoPad(t, n, r, o, i, s, a) {
                if (a) {
                    if (i.length !== 2 * (t.length - 2)) throw new Error("length of pads should be twice the length of data dimensions");
                    if (n.length !== t.length - 2) throw new Error("length of strides should be the length of data dimensions");
                    if (o.length !== t.length - 2) throw new Error("length of kernel shapes should be the length of data dimensions");
                    for(let u = 0; u < t.length - 2; u++)e1.adjustPadAndReturnShape(t[u + (s ? 1 : 2)], n[u], r[u], o[u], i, u, u + t.length - 2, a);
                }
            }
            static computePoolOutputShape(t, n, r, o, i, s, a) {
                if (n.length <= 0) throw new Error("input shape must be of size greater than 0");
                let u = [
                    n[0],
                    n[1]
                ];
                return e1.computeShapeHelper(t, n, u, r, o, i, s, a), u;
            }
            static computeConvOutputShape(t, n, r, o, i, s, a) {
                if (t.length <= 0 || n.length <= 0) throw new Error("invalid input tensor dims or invalid filter tensor dims");
                let u = [
                    t[0],
                    n[0]
                ];
                return e1.computeShapeHelper(!1, t, u, r, o, i, s, a), u;
            }
            static computeShapeHelper(t, n, r, o, i, s, a, u) {
                if (t) for(let d = 0; d < n.length - 2; d++)r.push(1);
                else for(let d = 0; d < n.length - 2; d++)r.push(e1.adjustPadAndReturnShape(n[d + 2], o[d], i[d], s[d], a, d, d + n.length - 2, u));
            }
            static adjustPadAndReturnShape(t, n, r, o, i, s, a, u) {
                let d = r * (o - 1) + 1;
                if (u && u !== "NOTSET") switch(u){
                    case "VALID":
                        return i[s] = 0, i[a] = 0, Math.floor((t - d) / n + 1);
                    case "SAME_LOWER":
                    case "SAME_UPPER":
                        if (r !== 1) throw new Error("Dilation not supported for SAME_UPPER or SAME_LOWER");
                        {
                            let c = ((t + n - 1) / n - 1) * n + o - t;
                            return i[s] = Math.floor(u === "SAME_LOWER" ? (c + 1) / 2 : c / 2), i[a] = c - i[s], Math.floor((t + c - o) / n + 1);
                        }
                    default:
                        throw new Error("Unsupported AutoPad type");
                }
                else return Math.floor((t + i[s] + i[a] - d) / n + 1);
            }
        }, Ht = class {
            static getShapeOfGemmResult(t, n, r, o, i) {
                if (t.length !== 2 || r.length !== 2) throw new Error("shape need to be of size 2");
                let s, a, u;
                n ? (s = t[1], a = t[0]) : (s = t[0], a = t[1]);
                let d = -1;
                if (o ? (u = r[0], d = 1) : (u = r[1], d = 0), r[d] !== a) throw new Error("dimension mismatch");
                if (s <= 0 || u <= 0 || a <= 0) throw new Error("invalid shape specified");
                if (i && !Pe.isValidBroadcast(i, [
                    s,
                    u
                ])) throw new Error("gemm: invalid bias shape for broadcast");
                return [
                    s,
                    u,
                    a
                ];
            }
        }, co = -340282346638528860000000000000000000000, po = 34028234663852886e22;
    });
    var qt, Mn = k(()=>{
        "use strict";
        L();
        qt = (e1, t)=>new (ot(t))(e1);
    });
    var fo, Rn, ho, ad, mo, ud, go, Ft, Kt, Un, yo, bo = k(()=>{
        "use strict";
        L();
        ke();
        fo = new Map([
            [
                "float32",
                32
            ],
            [
                "float16",
                16
            ],
            [
                "int32",
                32
            ],
            [
                "uint32",
                32
            ],
            [
                "int64",
                64
            ],
            [
                "uint64",
                64
            ],
            [
                "int8",
                8
            ],
            [
                "uint8",
                8
            ],
            [
                "int4",
                4
            ],
            [
                "uint4",
                4
            ]
        ]), Rn = (e1, t)=>{
            if (t === "int32") return e1;
            let n = fo.get(t);
            if (!n) throw new Error(`WebNN backend does not support data type: ${t}`);
            let r = n / 8;
            if (e1.byteLength % r !== 0) throw new Error(`Invalid Uint8Array length - must be a multiple of ${r}.`);
            let o = e1.byteLength / r, i = new (ot(t))(e1.buffer, e1.byteOffset, o);
            switch(t){
                case "int64":
                case "uint64":
                    {
                        let s = new Int32Array(o);
                        for(let a = 0; a < o; a++){
                            let u = i[a];
                            if (u > 2147483647n || u < -2147483648n) throw new Error("Can not convert int64 data to int32 - value out of range.");
                            s[a] = Number(u);
                        }
                        return new Uint8Array(s.buffer);
                    }
                case "int8":
                case "uint8":
                case "uint32":
                    {
                        if (t === "uint32" && i.some((a)=>a > 2147483647)) throw new Error("Can not convert uint32 data to int32 - value out of range.");
                        let s = Int32Array.from(i, Number);
                        return new Uint8Array(s.buffer);
                    }
                default:
                    throw new Error(`Unsupported data conversion from ${t} to 'int32'`);
            }
        }, ho = (e1, t)=>{
            if (t === "int32") return e1;
            if (e1.byteLength % 4 !== 0) throw new Error("Invalid Uint8Array length - must be a multiple of 4 (int32).");
            let n = e1.byteLength / 4, r = new Int32Array(e1.buffer, e1.byteOffset, n);
            switch(t){
                case "int64":
                    {
                        let o = BigInt64Array.from(r, BigInt);
                        return new Uint8Array(o.buffer);
                    }
                case "uint64":
                    {
                        if (r.some((i)=>i < 0)) throw new Error("Can not convert int32 data to uin64 - negative value found.");
                        let o = BigUint64Array.from(r, BigInt);
                        return new Uint8Array(o.buffer);
                    }
                case "int8":
                    {
                        if (r.some((i)=>i < -128 || i > 127)) throw new Error("Can not convert int32 data to int8 - value out of range.");
                        let o = Int8Array.from(r, Number);
                        return new Uint8Array(o.buffer);
                    }
                case "uint8":
                    if (r.some((o)=>o < 0 || o > 255)) throw new Error("Can not convert int32 data to uint8 - value out of range.");
                    return Uint8Array.from(r, Number);
                case "uint32":
                    {
                        if (r.some((i)=>i < 0)) throw new Error("Can not convert int32 data to uint32 - negative value found.");
                        let o = Uint32Array.from(r, Number);
                        return new Uint8Array(o.buffer);
                    }
                default:
                    throw new Error(`Unsupported data conversion from 'int32' to ${t}`);
            }
        }, ad = 1, mo = ()=>ad++, ud = new Map([
            [
                "int8",
                "int32"
            ],
            [
                "uint8",
                "int32"
            ],
            [
                "uint32",
                "int32"
            ],
            [
                "int64",
                "int32"
            ]
        ]), go = (e1, t)=>{
            let n = fo.get(e1);
            if (!n) throw new Error(`WebNN backend does not support data type: ${e1}`);
            return t.length > 0 ? Math.ceil(t.reduce((r, o)=>r * o) * n / 8) : 0;
        }, Ft = class {
            constructor(t){
                this.isDataConverted = !1;
                let { sessionId: n, context: r, tensor: o, dataType: i, shape: s, fallbackDataType: a } = t;
                this.sessionId = n, this.mlContext = r, this.mlTensor = o, this.dataType = i, this.tensorShape = s, this.fallbackDataType = a;
            }
            get tensor() {
                return this.mlTensor;
            }
            get type() {
                return this.dataType;
            }
            get fallbackType() {
                return this.fallbackDataType;
            }
            get shape() {
                return this.tensorShape;
            }
            get byteLength() {
                return go(this.dataType, this.tensorShape);
            }
            destroy() {
                Z("verbose", ()=>"[WebNN] TensorWrapper.destroy"), this.mlTensor.destroy();
            }
            write(t) {
                this.mlContext.writeTensor(this.mlTensor, t);
            }
            async read(t) {
                if (this.fallbackDataType) {
                    let n = await this.mlContext.readTensor(this.mlTensor), r = ho(new Uint8Array(n), this.dataType);
                    if (t) {
                        (t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength)).set(r);
                        return;
                    } else return r.buffer;
                } else return t ? this.mlContext.readTensor(this.mlTensor, t) : this.mlContext.readTensor(this.mlTensor);
            }
            canReuseTensor(t, n, r) {
                return this.mlContext === t && this.dataType === n && this.tensorShape.length === r.length && this.tensorShape.every((o, i)=>o === r[i]);
            }
            setIsDataConverted(t) {
                this.isDataConverted = t;
            }
        }, Kt = class {
            constructor(t, n){
                this.tensorManager = t;
                this.wrapper = n;
            }
            get tensorWrapper() {
                return this.wrapper;
            }
            releaseTensor() {
                this.tensorWrapper && (this.tensorManager.releaseTensor(this.tensorWrapper), this.wrapper = void 0);
            }
            async ensureTensor(t, n, r, o) {
                let i = this.tensorManager.getMLContext(t), s = this.tensorManager.getMLOpSupportLimits(t), a;
                if (!s?.input.dataTypes.includes(n)) {
                    if (a = ud.get(n), !a || s?.input.dataTypes.includes(a)) throw new Error(`WebNN backend does not support data type: ${n}`);
                    Z("verbose", ()=>`[WebNN] TensorIdTracker.ensureTensor: fallback dataType from ${n} to ${a}`);
                }
                if (this.wrapper) {
                    if (this.wrapper.canReuseTensor(i, n, r)) return this.wrapper.tensor;
                    if (o) {
                        if (this.wrapper.byteLength !== go(n, r)) throw new Error("Unable to copy data to tensor with different size.");
                        this.activeUpload = new Uint8Array(await this.wrapper.read());
                    }
                    this.tensorManager.releaseTensor(this.wrapper);
                }
                let u = typeof MLTensorUsage > "u" ? void 0 : MLTensorUsage.READ | MLTensorUsage.WRITE;
                return this.wrapper = await this.tensorManager.getCachedTensor(t, n, r, u, !0, !0, a), o && this.activeUpload && (this.wrapper.write(this.activeUpload), this.activeUpload = void 0), this.wrapper.tensor;
            }
            upload(t) {
                let n = t;
                if (this.wrapper) {
                    if (this.wrapper.fallbackType) {
                        if (this.wrapper.fallbackType === "int32") n = Rn(t, this.wrapper.type), this.wrapper.setIsDataConverted(!0);
                        else throw new Error(`Unsupported fallback data type: ${this.wrapper.fallbackType}`);
                    }
                    if (t.byteLength === this.wrapper.byteLength) {
                        this.wrapper.write(n);
                        return;
                    } else Z("verbose", ()=>"Data size does not match tensor size. Releasing tensor."), this.releaseTensor();
                }
                this.activeUpload ? this.activeUpload.set(n) : this.activeUpload = new Uint8Array(n);
            }
            async download(t) {
                if (this.activeUpload) {
                    let n = this.wrapper?.isDataConverted ? ho(this.activeUpload, this.wrapper?.type) : this.activeUpload;
                    if (t) {
                        t instanceof ArrayBuffer ? new Uint8Array(t).set(n) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength).set(n);
                        return;
                    } else return n.buffer;
                }
                if (!this.wrapper) throw new Error("Tensor has not been created.");
                return t ? this.wrapper.read(t) : this.wrapper.read();
            }
        }, Un = class {
            constructor(t){
                this.backend = t;
                this.tensorTrackersById = new Map;
                this.freeTensors = [];
                this.externalTensors = new Set;
            }
            getMLContext(t) {
                let n = this.backend.getMLContext(t);
                if (!n) throw new Error("MLContext not found for session.");
                return n;
            }
            getMLOpSupportLimits(t) {
                return this.backend.getMLOpSupportLimits(t);
            }
            reserveTensorId() {
                let t = mo();
                return this.tensorTrackersById.set(t, new Kt(this)), t;
            }
            releaseTensorId(t) {
                let n = this.tensorTrackersById.get(t);
                n && (this.tensorTrackersById.delete(t), n.tensorWrapper && this.releaseTensor(n.tensorWrapper));
            }
            async ensureTensor(t, n, r, o, i) {
                Z("verbose", ()=>`[WebNN] TensorManager.ensureTensor {tensorId: ${n}, dataType: ${r}, shape: ${o}, copyOld: ${i}}`);
                let s = this.tensorTrackersById.get(n);
                if (!s) throw new Error("Tensor not found.");
                return s.ensureTensor(t, r, o, i);
            }
            upload(t, n) {
                let r = this.tensorTrackersById.get(t);
                if (!r) throw new Error("Tensor not found.");
                r.upload(n);
            }
            async download(t, n) {
                Z("verbose", ()=>`[WebNN] TensorManager.download {tensorId: ${t}, dstBuffer: ${n?.byteLength}}`);
                let r = this.tensorTrackersById.get(t);
                if (!r) throw new Error("Tensor not found.");
                return r.download(n);
            }
            releaseTensorsForSession(t) {
                for (let n of this.freeTensors)n.sessionId === t && n.destroy();
                this.freeTensors = this.freeTensors.filter((n)=>n.sessionId !== t);
            }
            registerTensor(t, n, r, o) {
                let i = this.getMLContext(t), s = mo(), a = new Ft({
                    sessionId: t,
                    context: i,
                    tensor: n,
                    dataType: r,
                    shape: o
                });
                return this.tensorTrackersById.set(s, new Kt(this, a)), this.externalTensors.add(a), s;
            }
            async getCachedTensor(t, n, r, o, i, s, a) {
                let u = this.getMLContext(t);
                for (let [l, c] of this.freeTensors.entries())if (c.canReuseTensor(u, n, r)) {
                    Z("verbose", ()=>`[WebNN] Reusing tensor {dataType: ${n}, ${a ? `fallbackDataType: ${a},` : ""} shape: ${r}`);
                    let p = this.freeTensors.splice(l, 1)[0];
                    return p.sessionId = t, p;
                }
                Z("verbose", ()=>`[WebNN] MLContext.createTensor {dataType: ${n}, ${a ? `fallbackDataType: ${a},` : ""} shape: ${r}}`);
                let d = await u.createTensor({
                    dataType: a ?? n,
                    shape: r,
                    dimensions: r,
                    usage: o,
                    writable: i,
                    readable: s
                });
                return new Ft({
                    sessionId: t,
                    context: u,
                    tensor: d,
                    dataType: n,
                    shape: r,
                    fallbackDataType: a
                });
            }
            releaseTensor(t) {
                this.externalTensors.has(t) && this.externalTensors.delete(t), this.freeTensors.push(t);
            }
        }, yo = (...e1)=>new Un(...e1);
    });
    var jt, dd, Zt, _o = k(()=>{
        "use strict";
        L();
        We();
        Mn();
        bo();
        ke();
        jt = new Map([
            [
                1,
                "float32"
            ],
            [
                10,
                "float16"
            ],
            [
                6,
                "int32"
            ],
            [
                12,
                "uint32"
            ],
            [
                7,
                "int64"
            ],
            [
                13,
                "uint64"
            ],
            [
                22,
                "int4"
            ],
            [
                21,
                "uint4"
            ],
            [
                3,
                "int8"
            ],
            [
                2,
                "uint8"
            ],
            [
                9,
                "uint8"
            ]
        ]), dd = (e1, t)=>{
            if (e1 === t) return !0;
            if (e1 === void 0 || t === void 0) return !1;
            let n = Object.keys(e1).sort(), r = Object.keys(t).sort();
            return n.length === r.length && n.every((o, i)=>o === r[i] && e1[o] === t[o]);
        }, Zt = class {
            constructor(t){
                this.tensorManager = yo(this);
                this.mlContextBySessionId = new Map;
                this.sessionIdsByMLContext = new Map;
                this.mlContextCache = [];
                this.sessionGraphInputs = new Map;
                this.sessionGraphOutputs = new Map;
                this.temporaryGraphInputs = [];
                this.temporaryGraphOutputs = [];
                this.temporarySessionTensorIds = new Map;
                this.mlOpSupportLimitsBySessionId = new Map;
                Wt(t.logLevel, !!t.debug);
            }
            get currentSessionId() {
                if (this.activeSessionId === void 0) throw new Error("No active session");
                return this.activeSessionId;
            }
            onRunStart(t) {
                Z("verbose", ()=>`[WebNN] onRunStart {sessionId: ${t}}`), this.activeSessionId = t;
            }
            onRunEnd(t) {
                Z("verbose", ()=>`[WebNN] onRunEnd {sessionId: ${t}}`);
                let n = this.temporarySessionTensorIds.get(t);
                if (n) {
                    for (let r of n)Z("verbose", ()=>`[WebNN] releasing temporary tensor {tensorId: ${r}}`), this.tensorManager.releaseTensorId(r);
                    this.temporarySessionTensorIds.delete(t), this.activeSessionId = void 0;
                }
            }
            async createMLContext(t) {
                if (t instanceof GPUDevice) {
                    let r = this.mlContextCache.findIndex((o)=>o.gpuDevice === t);
                    if (r !== -1) return this.mlContextCache[r].mlContext;
                    {
                        let o = await navigator.ml.createContext(t);
                        return this.mlContextCache.push({
                            gpuDevice: t,
                            mlContext: o
                        }), o;
                    }
                } else if (t === void 0) {
                    let r = this.mlContextCache.findIndex((o)=>o.options === void 0 && o.gpuDevice === void 0);
                    if (r !== -1) return this.mlContextCache[r].mlContext;
                    {
                        let o = await navigator.ml.createContext();
                        return this.mlContextCache.push({
                            mlContext: o
                        }), o;
                    }
                }
                let n = this.mlContextCache.findIndex((r)=>dd(r.options, t));
                if (n !== -1) return this.mlContextCache[n].mlContext;
                {
                    let r = await navigator.ml.createContext(t);
                    return this.mlContextCache.push({
                        options: t,
                        mlContext: r
                    }), r;
                }
            }
            registerMLContext(t, n) {
                this.mlContextBySessionId.set(t, n);
                let r = this.sessionIdsByMLContext.get(n);
                r || (r = new Set, this.sessionIdsByMLContext.set(n, r)), r.add(t), this.mlOpSupportLimitsBySessionId.has(t) || this.mlOpSupportLimitsBySessionId.set(t, n.opSupportLimits()), this.temporaryGraphInputs.length > 0 && (this.sessionGraphInputs.set(t, this.temporaryGraphInputs), this.temporaryGraphInputs = []), this.temporaryGraphOutputs.length > 0 && (this.sessionGraphOutputs.set(t, this.temporaryGraphOutputs), this.temporaryGraphOutputs = []);
            }
            onReleaseSession(t) {
                this.sessionGraphInputs.delete(t), this.sessionGraphOutputs.delete(t);
                let n = this.mlContextBySessionId.get(t);
                if (!n) return;
                this.tensorManager.releaseTensorsForSession(t), this.mlContextBySessionId.delete(t), this.mlOpSupportLimitsBySessionId.delete(t);
                let r = this.sessionIdsByMLContext.get(n);
                if (r.delete(t), r.size === 0) {
                    this.sessionIdsByMLContext.delete(n);
                    let o = this.mlContextCache.findIndex((i)=>i.mlContext === n);
                    o !== -1 && this.mlContextCache.splice(o, 1);
                }
            }
            getMLContext(t) {
                return this.mlContextBySessionId.get(t);
            }
            getMLOpSupportLimits(t) {
                return this.mlOpSupportLimitsBySessionId.get(t);
            }
            reserveTensorId() {
                return this.tensorManager.reserveTensorId();
            }
            releaseTensorId(t) {
                Z("verbose", ()=>`[WebNN] releaseTensorId {tensorId: ${t}}`), this.tensorManager.releaseTensorId(t);
            }
            async ensureTensor(t, n, r, o, i) {
                let s = jt.get(r);
                if (!s) throw new Error(`Unsupported ONNX data type: ${r}`);
                return this.tensorManager.ensureTensor(t ?? this.currentSessionId, n, s, o, i);
            }
            async createTemporaryTensor(t, n, r) {
                Z("verbose", ()=>`[WebNN] createTemporaryTensor {onnxDataType: ${n}, shape: ${r}}`);
                let o = jt.get(n);
                if (!o) throw new Error(`Unsupported ONNX data type: ${n}`);
                let i = this.tensorManager.reserveTensorId();
                await this.tensorManager.ensureTensor(t, i, o, r, !1);
                let s = this.temporarySessionTensorIds.get(t);
                return s ? s.push(i) : this.temporarySessionTensorIds.set(t, [
                    i
                ]), i;
            }
            uploadTensor(t, n) {
                if (!ne().shouldTransferToMLTensor) throw new Error("Trying to upload to a MLTensor while shouldTransferToMLTensor is false");
                Z("verbose", ()=>`[WebNN] uploadTensor {tensorId: ${t}, data: ${n.byteLength}}`), this.tensorManager.upload(t, n);
            }
            async downloadTensor(t, n) {
                return this.tensorManager.download(t, n);
            }
            createMLTensorDownloader(t, n) {
                return async ()=>{
                    let r = await this.tensorManager.download(t);
                    return qt(r, n);
                };
            }
            registerMLTensor(t, n, r, o) {
                let i = jt.get(r);
                if (!i) throw new Error(`Unsupported ONNX data type: ${r}`);
                let s = this.tensorManager.registerTensor(t, n, i, o);
                return Z("verbose", ()=>`[WebNN] registerMLTensor {tensor: ${n}, dataType: ${i}, dimensions: ${o}} -> {tensorId: ${s}}`), s;
            }
            registerMLConstant(t, n, r, o, i, s, a = !1) {
                if (!s) throw new Error("External mounted files are not available.");
                let u = t;
                t.startsWith("./") && (u = t.substring(2));
                let d = s.get(u);
                if (!d) throw new Error(`File with name ${u} not found in preloaded files.`);
                if (n + r > d.byteLength) throw new Error("Out of bounds: data offset and length exceed the external file data size.");
                let l = d.slice(n, n + r).buffer, c;
                switch(i.dataType){
                    case "float32":
                        c = new Float32Array(l);
                        break;
                    case "float16":
                        c = typeof Float16Array < "u" && Float16Array.from ? new Float16Array(l) : new Uint16Array(l);
                        break;
                    case "int32":
                        c = new Int32Array(l);
                        break;
                    case "uint32":
                        c = new Uint32Array(l);
                        break;
                    case "int64":
                        if (a) {
                            let p = Rn(new Uint8Array(l), "int64");
                            c = new Int32Array(p.buffer), i.dataType = "int32";
                        } else c = new BigInt64Array(l);
                        break;
                    case "uint64":
                        c = new BigUint64Array(l);
                        break;
                    case "int8":
                        c = new Int8Array(l);
                        break;
                    case "int4":
                    case "uint4":
                    case "uint8":
                        c = new Uint8Array(l);
                        break;
                    default:
                        throw new Error(`Unsupported data type: ${i.dataType} in creating WebNN Constant from external data.`);
                }
                return Z("verbose", ()=>`[WebNN] registerMLConstant {dataType: ${i.dataType}, shape: ${i.shape}}} ${a ? "(Note: it was int64 data type and registered to int32 as workaround)" : ""}`), o.constant(i, c);
            }
            registerGraphInput(t) {
                this.temporaryGraphInputs.push(t);
            }
            registerGraphOutput(t) {
                this.temporaryGraphOutputs.push(t);
            }
            isGraphInput(t, n) {
                let r = this.sessionGraphInputs.get(t);
                return r ? r.includes(n) : !1;
            }
            isGraphOutput(t, n) {
                let r = this.sessionGraphOutputs.get(t);
                return r ? r.includes(n) : !1;
            }
            isGraphInputOutputTypeSupported(t, n, r = !0) {
                let o = jt.get(He(n)), i = this.mlOpSupportLimitsBySessionId.get(t);
                return typeof o > "u" ? !1 : r ? !!i?.input.dataTypes.includes(o) : !!i?.output.dataTypes.includes(o);
            }
            flush() {}
        };
    });
    var Qt = k(()=>{
        "use strict";
    });
    var wo, Vn, Nn, ld, cd, $o, Gn, Ln, xo, So = k(()=>{
        "use strict";
        ke();
        Qt();
        wo = new Map([
            [
                64,
                250
            ],
            [
                128,
                200
            ],
            [
                256,
                200
            ],
            [
                512,
                200
            ],
            [
                2048,
                230
            ],
            [
                4096,
                200
            ],
            [
                8192,
                50
            ],
            [
                16384,
                50
            ],
            [
                32768,
                50
            ],
            [
                65536,
                50
            ],
            [
                131072,
                50
            ],
            [
                262144,
                50
            ],
            [
                524288,
                50
            ],
            [
                1048576,
                50
            ],
            [
                2097152,
                30
            ],
            [
                4194304,
                20
            ],
            [
                8388608,
                10
            ],
            [
                12582912,
                10
            ],
            [
                16777216,
                10
            ],
            [
                26214400,
                15
            ],
            [
                33554432,
                22
            ],
            [
                44236800,
                2
            ],
            [
                58982400,
                6
            ],
            [
                67108864,
                6
            ],
            [
                134217728,
                6
            ],
            [
                167772160,
                6
            ]
        ]), Vn = [], Nn = (e1)=>Math.ceil(Number(e1) / 16) * 16, ld = (e1)=>{
            for(let t = 0; t < Vn.length; t++){
                let n = Vn[t];
                if (e1 <= n) return n;
            }
            return Math.ceil(e1 / 16) * 16;
        }, cd = 1, $o = ()=>cd++, Gn = async (e1, t, n, r)=>{
            let o = Nn(n), i = e1.device.createBuffer({
                size: o,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            });
            try {
                let s = e1.getCommandEncoder();
                e1.endComputePass(), s.copyBufferToBuffer(t, 0, i, 0, o), e1.flush(), await i.mapAsync(GPUMapMode.READ);
                let a = i.getMappedRange();
                if (r) {
                    let u = r();
                    return u.set(new Uint8Array(a, 0, n)), u;
                } else return new Uint8Array(a.slice(0, n));
            } finally{
                i.destroy();
            }
        }, Ln = class {
            constructor(t){
                this.backend = t;
                this.storageCache = new Map, this.freeBuffers = new Map, this.freeUniformBuffers = new Map, this.buffersPending = [], this.capturedPendingBuffers = new Map;
                for (let [n] of wo)Vn.push(n), this.freeBuffers.set(n, []), this.freeUniformBuffers.set(n, []);
                this.sessionCount = 0;
            }
            upload(t, n) {
                let r = n.buffer, o = n.byteOffset, i = n.byteLength, s = Nn(i), a = this.storageCache.get(t);
                if (!a) throw new Error("gpu data for uploading does not exist");
                if (Number(a.originalSize) !== i) throw new Error(`inconsistent data size. gpu data size=${a.originalSize}, data size=${i}`);
                let u = this.backend.device.createBuffer({
                    mappedAtCreation: !0,
                    size: s,
                    usage: GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC
                }), d = u.getMappedRange();
                new Uint8Array(d).set(new Uint8Array(r, o, i)), u.unmap();
                let l = this.backend.device.createCommandEncoder();
                l.copyBufferToBuffer(u, 0, a.gpuData.buffer, 0, s), this.backend.device.queue.submit([
                    l.finish()
                ]), u.destroy(), Z("verbose", ()=>`[WebGPU] GpuDataManager.upload(id=${t})`);
            }
            memcpy(t, n) {
                let r = this.storageCache.get(t);
                if (!r) throw new Error("source gpu data for memcpy does not exist");
                let o = this.storageCache.get(n);
                if (!o) throw new Error("destination gpu data for memcpy does not exist");
                if (r.originalSize !== o.originalSize) throw new Error("inconsistent source and destination gpu data size");
                let i = Nn(r.originalSize), s = this.backend.getCommandEncoder();
                this.backend.endComputePass(), s.copyBufferToBuffer(r.gpuData.buffer, 0, o.gpuData.buffer, 0, i);
            }
            registerExternalBuffer(t, n, r) {
                let o;
                if (r) {
                    if (o = r[0], t === r[1]) return Z("verbose", ()=>`[WebGPU] GpuDataManager.registerExternalBuffer(size=${n}) => id=${o}, buffer is the same, skip.`), o;
                    if (this.backend.capturedCommandList.has(this.backend.currentSessionId)) throw new Error(`Registering a different external buffer under graph capture mode is not supported yet.
             Please use the previous external buffer!`);
                } else o = $o();
                return this.storageCache.set(o, {
                    gpuData: {
                        id: o,
                        type: 0,
                        buffer: t
                    },
                    originalSize: n
                }), Z("verbose", ()=>`[WebGPU] GpuDataManager.registerExternalBuffer(size=${n}) => id=${o}, registered.`), o;
            }
            unregisterExternalBuffer(t) {
                t !== void 0 && (this.storageCache.delete(t), Z("verbose", ()=>`[WebGPU] GpuDataManager.unregisterExternalBuffer() => id=${t}`));
            }
            create(t, n = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST) {
                let r = ld(t), o, i = (n & GPUBufferUsage.STORAGE) === GPUBufferUsage.STORAGE, s = (n & GPUBufferUsage.UNIFORM) === GPUBufferUsage.UNIFORM;
                if (i || s) {
                    let d = (i ? this.freeBuffers : this.freeUniformBuffers).get(r);
                    d ? d.length > 0 ? o = d.pop() : o = this.backend.device.createBuffer({
                        size: r,
                        usage: n
                    }) : o = this.backend.device.createBuffer({
                        size: r,
                        usage: n
                    });
                } else o = this.backend.device.createBuffer({
                    size: r,
                    usage: n
                });
                let a = {
                    id: $o(),
                    type: 0,
                    buffer: o
                };
                return this.storageCache.set(a.id, {
                    gpuData: a,
                    originalSize: Number(t)
                }), Z("verbose", ()=>`[WebGPU] GpuDataManager.create(size=${t}) => id=${a.id}`), a;
            }
            get(t) {
                return this.storageCache.get(t)?.gpuData;
            }
            release(t) {
                let n = typeof t == "bigint" ? Number(t) : t, r = this.storageCache.get(n);
                if (!r) {
                    if (this.storageCache.size === 0) return 0;
                    throw new Error("releasing data does not exist");
                }
                return Z("verbose", ()=>`[WebGPU] GpuDataManager.release(id=${n}), gpuDataId=${r.gpuData.id}`), this.storageCache.delete(n), this.buffersPending.push(r.gpuData.buffer), r.originalSize;
            }
            async download(t, n) {
                let r = this.storageCache.get(Number(t));
                if (!r) throw new Error("data does not exist");
                await Gn(this.backend, r.gpuData.buffer, r.originalSize, n);
            }
            refreshPendingBuffers() {
                if (this.buffersPending.length !== 0) {
                    if (this.backend.sessionStatus === "default") {
                        for (let t of this.buffersPending){
                            let n = wo.get(t.size);
                            if ((t.usage & GPUBufferUsage.STORAGE) === GPUBufferUsage.STORAGE) {
                                let r = this.freeBuffers.get(t.size) || [];
                                n === void 0 || r.length >= n ? t.destroy() : r.push(t);
                            } else if ((t.usage & GPUBufferUsage.UNIFORM) === GPUBufferUsage.UNIFORM) {
                                let r = this.freeUniformBuffers.get(t.size) || [];
                                n === void 0 || r.length >= n ? t.destroy() : r.push(t);
                            } else t.destroy();
                        }
                        this.buffersPending = [];
                    } else {
                        let t = this.capturedPendingBuffers.get(this.backend.currentSessionId);
                        t || (t = [], this.capturedPendingBuffers.set(this.backend.currentSessionId, t));
                        for (let n of this.buffersPending)t.push(n);
                        this.buffersPending = [];
                    }
                }
            }
            dispose() {
                this.freeBuffers.forEach((t)=>{
                    t.forEach((n)=>{
                        n.destroy();
                    });
                }), this.freeUniformBuffers.forEach((t)=>{
                    t.forEach((n)=>{
                        n.destroy();
                    });
                }), this.storageCache.forEach((t)=>{
                    t.gpuData.buffer.destroy();
                }), this.capturedPendingBuffers.forEach((t)=>{
                    t.forEach((n)=>{
                        n.destroy();
                    });
                }), this.storageCache = new Map, this.freeBuffers = new Map, this.freeUniformBuffers = new Map, this.capturedPendingBuffers = new Map;
            }
            onCreateSession() {
                this.sessionCount += 1;
            }
            onReleaseSession(t) {
                let n = this.capturedPendingBuffers.get(t);
                n && (n.forEach((r)=>{
                    r.destroy();
                }), this.capturedPendingBuffers.delete(t)), this.sessionCount -= 1, this.sessionCount === 0 && (Z("warning", ()=>"[WebGPU] Clearing webgpu buffer cache"), this.storageCache.forEach((r)=>{
                    r.gpuData.buffer.destroy();
                }), this.storageCache = new Map);
            }
        }, xo = (...e1)=>new Ln(...e1);
    });
    var Wn, G, ie = k(()=>{
        "use strict";
        Wn = class {
            constructor(t){
                Object.assign(this, t);
            }
            get cacheKey() {
                return this.key || (this.key = Object.getOwnPropertyNames(this).sort().map((t)=>`${this[t]}`).join(";")), this.key;
            }
        }, G = (e1)=>new Wn(e1);
    });
    var Je, qn, re, ce, P, J, Fn, et, Te, B, Xt, S, C, To, Yt, Hn, Io, j = k(()=>{
        "use strict";
        L();
        F();
        Je = 64, qn = (e1, t)=>{
            if (t === 3) throw new Error("vec3 has same alignment as vec4, use vec4 instead");
            switch(Number(e1)){
                case 10:
                    return t > 1 ? `vec${t}<f16>` : "f16";
                case 1:
                    return t > 1 ? `vec${t}<f32>` : "f32";
                case 6:
                    return t > 1 ? `vec${t}<i32>` : "i32";
                case 12:
                    return t > 1 ? `vec${t}<u32>` : "u32";
                case 7:
                    if (t > 1) throw new Error("currently not supported vecX of uint64 yet");
                    return [
                        "vec2<u32>",
                        "i32"
                    ];
                case 13:
                    if (t > 1) throw new Error("currently not supported vecX of uint64 yet");
                    return [
                        "vec2<u32>",
                        "u32"
                    ];
                case 9:
                    if (t !== 4) throw new Error("bool must be vec4");
                    return [
                        "u32",
                        "vec4<bool>"
                    ];
                case 22:
                    return "i32";
                case 21:
                    return "u32";
                default:
                    throw new Error(`Unknown data type: ${e1}`);
            }
        }, re = (e1, t = 1)=>{
            let n = qn(e1, t);
            return typeof n == "string" ? n : n[0];
        }, ce = (e1, t = 1)=>{
            let n = qn(e1, t);
            return typeof n == "string" ? n : n[1];
        }, P = (...e1)=>{
            let t = [];
            return e1.forEach((n)=>{
                n.length !== 0 && t.push({
                    type: 12,
                    data: n
                }, {
                    type: 12,
                    data: x.computeStrides(n)
                });
            }), t;
        }, J = (e1)=>e1 % 4 === 0 ? 4 : e1 % 2 === 0 ? 2 : 1, Fn = (e1 = "f32", t, n = "0")=>!t || t === 1 ? `${e1}(${n})` : `vec${t}<${e1}>(${n})`, et = (e1, t, n)=>e1 === "f32" ? n : t === 1 ? `f32(${n})` : `vec${t}<f32>(${n})`, Te = (e1, t)=>t === 4 ? `(${e1}.x + ${e1}.y + ${e1}.z + ${e1}.w)` : t === 2 ? `(${e1}.x + ${e1}.y)` : t === 3 ? `(${e1}.x + ${e1}.y + ${e1}.z)` : e1, B = (e1, t, n, r)=>e1.startsWith("uniforms.") && n > 4 ? typeof t == "string" ? r === "f16" ? `${e1}[(${t}) / 8][(${t}) % 8 / 4][(${t}) % 8 % 4]` : `${e1}[(${t}) / 4][(${t}) % 4]` : r === "f16" ? `${e1}[${Math.floor(t / 8)}][${Math.floor(t % 8 / 4)}][${t % 8 % 4}]` : `${e1}[${Math.floor(t / 4)}][${t % 4}]` : n > 1 ? `${e1}[${t}]` : e1, Xt = (e1, t, n, r, o)=>{
            let i = typeof n == "number", s = i ? n : n.length, a = [
                ...new Array(s).keys()
            ], u = s < 2 ? "u32" : s <= 4 ? `vec${s}<u32>` : `array<u32, ${s}>`, d = qn(t, o), l = typeof d == "string" ? d : d[1], c = typeof d == "string" ? d : d[0], p = {
                indices: u,
                value: l,
                storage: c,
                tensor: t
            }, f = (E)=>typeof E == "string" ? E : `${E}u`, m = {
                offsetToIndices: !1,
                indicesToOffset: !1,
                broadcastedIndicesToOffset: !1,
                set: !1,
                setByIndices: !1,
                get: !1,
                getByIndices: !1
            }, h = i ? "uniforms." : "", b = `${h}${e1}_shape`, y = `${h}${e1}_strides`, g = "";
            for(let E = 0; E < s - 1; E++)g += `
    let dim${E} = current / ${B(y, E, s)};
    let rest${E} = current % ${B(y, E, s)};
    indices[${E}] = dim${E};
    current = rest${E};
    `;
            g += `indices[${s - 1}] = current;`;
            let _ = s < 2 ? "" : `
  fn o2i_${e1}(offset: u32) -> ${p.indices} {
    var indices: ${p.indices};
    var current = offset;
    ${g}
    return indices;
  }`, w = (E)=>(m.offsetToIndices = !0, s < 2 ? E : `o2i_${e1}(${E})`), v = [];
            if (s >= 2) for(let E = s - 1; E >= 0; E--)v.push(`${B(y, E, s)} * (indices[${E}])`);
            let $ = s < 2 ? "" : `
  fn i2o_${e1}(indices: ${p.indices}) -> u32 {
    return ${v.join("+")};
  }`, T = (E)=>(m.indicesToOffset = !0, s < 2 ? E : `i2o_${e1}(${E})`), I = (...E)=>s === 0 ? "0u" : `${p.indices}(${E.map(f).join(",")})`, A = (E, N)=>s < 2 ? `${E}` : `${B(E, N, s)}`, z = (E, N, se)=>s < 2 ? `${E}=${se};` : `${B(E, N, s)}=${se};`, R = {}, D = (E, N)=>{
                m.broadcastedIndicesToOffset = !0;
                let se = `${N.name}broadcastedIndicesTo${e1}Offset`;
                if (se in R) return `${se}(${E})`;
                let ve = [];
                for(let ge = s - 1; ge >= 0; ge--){
                    let je = N.indicesGet("outputIndices", ge + N.rank - s);
                    ve.push(`${A(y, ge)} * (${je} % ${A(b, ge)})`);
                }
                return R[se] = `fn ${se}(outputIndices: ${N.type.indices}) -> u32 {
             return ${ve.length > 0 ? ve.join("+") : "0u"};
           }`, `${se}(${E})`;
            }, U = (E, N)=>(()=>{
                    if (p.storage === p.value) return `${e1}[${E}]=${N};`;
                    if (p.storage === "vec2<u32>" && p.value === "i32") return `${e1}[${E}]=vec2<u32>(u32(${N}), select(0u, 0xFFFFFFFFu, ${N} < 0));`;
                    if (p.storage === "vec2<u32>" && p.value === "u32") return `${e1}[${E}]=vec2<u32>(u32(${N}), 0u);`;
                    if (p.storage === "u32" && p.value === "vec4<bool>") return `${e1}[${E}]=dot(vec4<u32>(0x1, 0x100, 0x10000, 0x1000000), vec4<u32>(${N}));`;
                    throw new Error(`not supported combination of storage type ${p.storage} and value type ${p.value} yet`);
                })(), Q = (E)=>(()=>{
                    if (p.storage === p.value) return `${e1}[${E}]`;
                    if (p.storage === "vec2<u32>" && p.value === "i32") return `i32(${e1}[${E}].x)`;
                    if (p.storage === "vec2<u32>" && p.value === "u32") return `u32(${e1}[${E}].x)`;
                    if (p.storage === "u32" && p.value === "vec4<bool>") return `vec4<bool>(bool(${e1}[${E}] & 0xFFu), bool(${e1}[${E}] & 0xFF00u), bool(${e1}[${E}] & 0xFF0000u), bool(${e1}[${E}] & 0xFF000000u))`;
                    throw new Error(`not supported combination of storage type ${p.storage} and value type ${p.value} yet`);
                })(), O = s < 2 ? "" : `
  fn get_${e1}ByIndices(indices: ${p.indices}) -> ${l} {
    return ${Q(`i2o_${e1}(indices)`)};
  }`, M = s < 2 ? "" : (()=>{
                let E = a.map((se)=>`d${se}: u32`).join(", "), N = a.map((se)=>`d${se}`).join(", ");
                return `
  fn get_${e1}(${E}) -> ${l} {
    return get_${e1}ByIndices(${I(N)});
  }`;
            })(), V = (...E)=>{
                if (E.length !== s) throw new Error(`indices length must be ${s}`);
                let N = E.map(f).join(",");
                return s === 0 ? Q("0u") : s === 1 ? Q(N[0]) : (m.get = !0, m.getByIndices = !0, m.indicesToOffset = !0, `get_${e1}(${N})`);
            }, W = (E)=>s < 2 ? Q(E) : (m.getByIndices = !0, m.indicesToOffset = !0, `get_${e1}ByIndices(${E})`), H = s < 2 ? "" : `
  fn set_${e1}ByIndices(indices: ${p.indices}, value: ${l}) {
    ${U(`i2o_${e1}(indices)`, "value")}
  }`, X = s < 2 ? "" : (()=>{
                let E = a.map((se)=>`d${se}: u32`).join(", "), N = a.map((se)=>`d${se}`).join(", ");
                return `
  fn set_${e1}(${E}, value: ${l}) {
    set_${e1}ByIndices(${I(N)}, value);
  }`;
            })();
            return {
                impl: ()=>{
                    let E = [], N = !1;
                    return m.offsetToIndices && (E.push(_), N = !0), m.indicesToOffset && (E.push($), N = !0), m.broadcastedIndicesToOffset && (Object.values(R).forEach((se)=>E.push(se)), N = !0), m.set && (E.push(X), N = !0), m.setByIndices && (E.push(H), N = !0), m.get && (E.push(M), N = !0), m.getByIndices && (E.push(O), N = !0), !i && N && E.unshift(`const ${b} = ${p.indices}(${n.join(",")});`, `const ${y} = ${p.indices}(${x.computeStrides(n).join(",")});`), E.join(`
`);
                },
                type: p,
                offsetToIndices: w,
                indicesToOffset: T,
                broadcastedIndicesToOffset: D,
                indices: I,
                indicesGet: A,
                indicesSet: z,
                set: (...E)=>{
                    if (E.length !== s + 1) throw new Error(`indices length must be ${s}`);
                    let N = E[s];
                    if (typeof N != "string") throw new Error("value must be string");
                    let se = E.slice(0, s).map(f).join(",");
                    return s === 0 ? U("0u", N) : s === 1 ? U(se[0], N) : (m.set = !0, m.setByIndices = !0, m.indicesToOffset = !0, `set_${e1}(${se}, ${N})`);
                },
                setByOffset: U,
                setByIndices: (E, N)=>s < 2 ? U(E, N) : (m.setByIndices = !0, m.indicesToOffset = !0, `set_${e1}ByIndices(${E}, ${N});`),
                get: V,
                getByOffset: Q,
                getByIndices: W,
                usage: r,
                name: e1,
                strides: y,
                shape: b,
                rank: s
            };
        }, S = (e1, t, n, r = 1)=>Xt(e1, t, n, "input", r), C = (e1, t, n, r = 1)=>Xt(e1, t, n, "output", r), To = (e1, t, n)=>Xt(e1, t, n, "atomicOutput", 1), Yt = (e1, t, n, r = 1)=>Xt(e1, t, n, "internal", r), Hn = class {
            constructor(t, n){
                this.normalizedDispatchGroup = t;
                this.limits = n;
                this.internalVariables = [];
                this.variables = [];
                this.uniforms = [];
                this.variableIndex = 0;
            }
            guardAgainstOutOfBoundsWorkgroupSizes(t) {
                return `if (global_idx >= ${typeof t == "number" ? `${t}u` : t}) { return; }`;
            }
            mainStart(t = Je) {
                let n = typeof t == "number" ? t : t[0], r = typeof t == "number" ? 1 : t[1], o = typeof t == "number" ? 1 : t[2];
                if (n > this.limits.maxComputeWorkgroupSizeX || r > this.limits.maxComputeWorkgroupSizeY || o > this.limits.maxComputeWorkgroupSizeZ) throw new Error(`workgroup size [${n}, ${r}, ${o}] exceeds the maximum workgroup size [${this.limits.maxComputeWorkgroupSizeX}, ${this.limits.maxComputeWorkgroupSizeY}, ${this.limits.maxComputeWorkgroupSizeZ}].`);
                if (n * r * o > this.limits.maxComputeInvocationsPerWorkgroup) throw new Error(`workgroup size [${n}, ${r}, ${o}] exceeds the maximum workgroup invocations ${this.limits.maxComputeInvocationsPerWorkgroup}.`);
                let i = this.normalizedDispatchGroup[1] === 1 && this.normalizedDispatchGroup[2] === 1, s = i ? `@builtin(global_invocation_id) global_id : vec3<u32>,
    @builtin(workgroup_id) workgroup_id : vec3<u32>,
    @builtin(local_invocation_index) local_idx : u32,
    @builtin(local_invocation_id) local_id : vec3<u32>` : `@builtin(global_invocation_id) global_id : vec3<u32>,
                                             @builtin(local_invocation_id) local_id : vec3<u32>,
    @builtin(local_invocation_index) local_idx : u32,
    @builtin(workgroup_id) workgroup_id : vec3<u32>,
    @builtin(num_workgroups) num_workgroups : vec3<u32>`, a = i ? `let global_idx = global_id.x;
         let workgroup_index = workgroup_id.x;` : `let workgroup_index = workgroup_id.z * num_workgroups[0] * num_workgroups[1] +
             workgroup_id.y * num_workgroups[0] + workgroup_id.x;
         let global_idx = workgroup_index * ${n * r * o}u + local_idx;`;
                return `@compute @workgroup_size(${n}, ${r}, ${o})
  fn main(${s}) {
    ${a}
  `;
            }
            appendVariableUniforms(t) {
                t.rank !== 0 && (t.shape.startsWith("uniforms.") && this.uniforms.push({
                    name: t.shape.replace("uniforms.", ""),
                    type: "u32",
                    length: t.rank
                }), t.strides.startsWith("uniforms.") && this.uniforms.push({
                    name: t.strides.replace("uniforms.", ""),
                    type: "u32",
                    length: t.rank
                }));
            }
            declareVariable(t, n) {
                if (t.usage === "internal") throw new Error("cannot use internal variable with declareVariable(). use registerInternalVariables() instead.");
                this.variables.push(t), this.appendVariableUniforms(t);
                let r = t.usage === "input" ? "read" : "read_write", o = t.usage === "atomicOutput" ? "atomic<i32>" : t.type.storage;
                return `@group(0) @binding(${n}) var<storage, ${r}> ${t.name}: array<${o}>;`;
            }
            declareVariables(...t) {
                return t.map((n)=>this.declareVariable(n, this.variableIndex++)).join(`
`);
            }
            registerInternalVariable(t) {
                if (t.usage !== "internal") throw new Error("cannot use input or output variable with registerInternalVariable(). use declareVariables() instead.");
                this.internalVariables.push(t), this.appendVariableUniforms(t);
            }
            registerInternalVariables(...t) {
                return t.forEach((n)=>this.registerInternalVariable(n)), this;
            }
            registerUniform(t, n, r = 1) {
                return this.uniforms.push({
                    name: t,
                    type: n,
                    length: r
                }), this;
            }
            registerUniforms(t) {
                return this.uniforms = this.uniforms.concat(t), this;
            }
            uniformDeclaration() {
                if (this.uniforms.length === 0) return "";
                let t = [];
                for (let { name: n, type: r, length: o } of this.uniforms)if (o && o > 4) r === "f16" ? t.push(`@align(16) ${n}:array<mat2x4<${r}>, ${Math.ceil(o / 8)}>`) : t.push(`${n}:array<vec4<${r}>, ${Math.ceil(o / 4)}>`);
                else {
                    let i = o == null || o === 1 ? r : `vec${o}<${r}>`;
                    t.push(`${n}:${i}`);
                }
                return `
      struct Uniforms { ${t.join(", ")} };
      @group(0) @binding(${this.variableIndex}) var<uniform> uniforms: Uniforms;`;
            }
            get additionalImplementations() {
                return this.uniformDeclaration() + this.variables.map((t)=>t.impl()).join(`
`) + this.internalVariables.map((t)=>t.impl()).join(`
`);
            }
            get variablesInfo() {
                if (this.uniforms.length === 0) return;
                let t = (n)=>[
                        12,
                        10,
                        1,
                        6
                    ][[
                        "u32",
                        "f16",
                        "f32",
                        "i32"
                    ].indexOf(n)];
                return this.uniforms.map((n)=>[
                        t(n.type),
                        n.length ?? 1
                    ]);
            }
        }, Io = (e1, t)=>new Hn(e1, t);
    });
    var pd, Co, md, fd, hd, gd, pe, Ao, Eo, Ve = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        pd = (e1, t)=>{
            if (!e1 || e1.length !== 1) throw new Error("Transpose requires 1 input.");
            if (t.length !== 0 && t.length !== e1[0].dims.length) throw new Error(`perm size ${t.length} does not match input rank ${e1[0].dims.length}`);
        }, Co = (e1, t)=>t.length !== 0 ? t : [
                ...new Array(e1).keys()
            ].reverse(), md = (e1, t)=>x.sortBasedOnPerm(e1, Co(e1.length, t)), fd = (e1, t, n, r)=>{
            let o = `fn perm(i: ${r.type.indices}) -> ${n.type.indices} {
    var a: ${n.type.indices};`;
            for(let i = 0; i < t; ++i)o += `a[${e1[i]}]=i[${i}];`;
            return o += "return a;}";
        }, hd = (e1, t)=>{
            let n = [], r = [];
            for(let o = 0; o < e1.length; ++o)e1[o] !== 1 && n.push(e1[o]), e1[t[o]] !== 1 && r.push(t[o]);
            return {
                newShape: n,
                newPerm: r
            };
        }, gd = (e1, t)=>{
            let n = 0;
            for(let r = 0; r < e1.length; ++r)if (t[e1[r]] !== 1) {
                if (e1[r] < n) return !1;
                n = e1[r];
            }
            return !0;
        }, pe = (e1, t)=>{
            let n = e1.dataType, r = e1.dims.length, o = Co(r, t), i = md(e1.dims, o), s = e1.dims, a = i, u = r < 2 || gd(o, e1.dims), d;
            if (u) return d = (h)=>{
                let b = S("input", n, s, 4), y = C("output", n, a, 4);
                return `
  ${h.registerUniform("output_size", "u32").declareVariables(b, y)}
  ${h.mainStart()}
    ${h.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    output[global_idx] = input[global_idx];
  }`;
            }, {
                name: "TransposeCopy",
                shaderCache: {
                    inputDependencies: [
                        "type"
                    ]
                },
                getRunData: ()=>{
                    let h = x.size(i);
                    return {
                        outputs: [
                            {
                                dims: i,
                                dataType: e1.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(h / 64 / 4)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: Math.ceil(h / 4)
                            }
                        ]
                    };
                },
                getShaderSource: d
            };
            let { newShape: l, newPerm: c } = hd(e1.dims, o), p = x.areEqual(c, [
                2,
                3,
                1
            ]), f = x.areEqual(c, [
                3,
                1,
                2
            ]);
            if (l.length === 2 || p || f) {
                s = p ? [
                    l[0],
                    l[1] * l[2]
                ] : f ? [
                    l[0] * l[1],
                    l[2]
                ] : l, a = [
                    s[1],
                    s[0]
                ];
                let h = 16;
                return d = (b)=>{
                    let y = S("a", n, s.length), g = C("output", n, a.length);
                    return `
  ${b.registerUniform("output_size", "u32").declareVariables(y, g)}
  var<workgroup> tile : array<array<${g.type.value}, ${h + 1}>, ${h}>;
  ${b.mainStart([
                        h,
                        h,
                        1
                    ])}
    let stride = (uniforms.output_shape[1] - 1) / ${h} + 1;
    let workgroup_id_x = workgroup_index % stride;
    let workgroup_id_y = workgroup_index / stride;
    let input_col = workgroup_id_y * ${h}u + local_id.x;
    let input_row = workgroup_id_x * ${h}u + local_id.y;
    if (input_row < uniforms.a_shape[0] && input_col < uniforms.a_shape[1]) {
      tile[local_id.y][local_id.x] = ${y.getByIndices(`${y.type.indices}(input_row, input_col)`)};
    }
    workgroupBarrier();

    let output_col = workgroup_id_x * ${h}u + local_id.x;
    let output_row = workgroup_id_y * ${h}u + local_id.y;
    if (output_row < uniforms.output_shape[0] && output_col < uniforms.output_shape[1]) {
      ${g.setByIndices(`${g.type.indices}(output_row, output_col)`, "tile[local_id.x][local_id.y]")}
    }
  }`;
                }, {
                    name: "TransposeShared",
                    shaderCache: {
                        inputDependencies: [
                            "type"
                        ]
                    },
                    getRunData: ()=>{
                        let b = x.size(i);
                        return {
                            outputs: [
                                {
                                    dims: i,
                                    dataType: e1.dataType
                                }
                            ],
                            dispatchGroup: {
                                x: Math.ceil(a[1] / h),
                                y: Math.ceil(a[0] / h)
                            },
                            programUniforms: [
                                {
                                    type: 12,
                                    data: b
                                },
                                ...P(s, a)
                            ]
                        };
                    },
                    getShaderSource: d
                };
            }
            return d = (h)=>{
                let b = S("a", n, s.length), y = C("output", n, a.length);
                return `
  ${h.registerUniform("output_size", "u32").declareVariables(b, y)}

  ${fd(o, r, b, y)}

  ${h.mainStart()}
    ${h.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}

    let indices = ${y.offsetToIndices("global_idx")};
    let aIndices = perm(indices);

    ${y.setByOffset("global_idx", b.getByIndices("aIndices"))}
  }`;
            }, {
                name: "Transpose",
                shaderCache: {
                    hint: `${t}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getRunData: ()=>{
                    let h = x.size(i);
                    return {
                        outputs: [
                            {
                                dims: i,
                                dataType: e1.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(h / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: h
                            },
                            ...P(s, a)
                        ]
                    };
                },
                getShaderSource: d
            };
        }, Ao = (e1, t)=>{
            pd(e1.inputs, t.perm), e1.compute(pe(e1.inputs[0], t.perm));
        }, Eo = (e1)=>G({
                perm: e1.perm
            });
    });
    var yd, bd, _d, wd, $d, vd, xd, Sd, Td, Id, ze, ko, Po, zo, Bo, Do, Oo, Mo, Uo, Ro, Vo, No = k(()=>{
        "use strict";
        L();
        F();
        j();
        Jt();
        Ve();
        yd = {
            max: "select(bestValue, candidate, candidate > bestValue)",
            min: "select(bestValue, candidate, candidate < bestValue)",
            mean: "bestValue + candidate",
            sum: "bestValue + candidate",
            prod: "bestValue * candidate",
            sumSquare: "bestValue + candidate * candidate",
            logSumExp: "bestValue + exp(candidate)",
            l1: "bestValue + abs(candidate)",
            l2: "bestValue + candidate * candidate",
            logSum: "bestValue + candidate"
        }, bd = {
            max: "select(bestValue, candidate, candidate > bestValue)",
            min: "select(bestValue, candidate, candidate < bestValue)",
            mean: "bestValue + candidate",
            sum: "bestValue + candidate",
            prod: "bestValue * candidate",
            sumSquare: "bestValue + candidate",
            logSumExp: "bestValue + candidate",
            l1: "bestValue + candidate",
            l2: "bestValue + candidate",
            logSum: "bestValue + candidate"
        }, _d = {
            max: "_A[offset]",
            min: "_A[offset]",
            mean: "0",
            sum: "0",
            prod: "1",
            sumSquare: "0",
            logSumExp: "0",
            l1: "0",
            l2: "0",
            logSum: "0"
        }, wd = {
            max: "bestValue",
            min: "bestValue",
            sum: "bestValue",
            prod: "bestValue",
            sumSquare: "bestValue",
            logSumExp: "log(bestValue)",
            l1: "bestValue",
            l2: "sqrt(bestValue)",
            logSum: "log(bestValue)"
        }, $d = (e1, t)=>{
            let n = [];
            for(let r = t - e1; r < t; ++r)n.push(r);
            return n;
        }, vd = (e1, t)=>{
            let n = [], r = e1.length;
            for(let i = 0; i < r; i++)t.indexOf(i) === -1 && n.push(e1[i]);
            let o = t.map((i)=>e1[i]);
            return [
                n,
                o
            ];
        }, xd = (e1, t)=>{
            let n = e1.length + t.length, r = [], o = 0;
            for(let i = 0; i < n; i++)t.indexOf(i) === -1 ? r.push(e1[o++]) : r.push(1);
            return r;
        }, Sd = (e1, t)=>{
            for(let n = 0; n < e1.length; ++n)if (e1[e1.length - n - 1] !== t - 1 - n) return !1;
            return !0;
        }, Td = (e1, t)=>{
            let n = [];
            if (!Sd(e1, t)) {
                for(let r = 0; r < t; ++r)e1.indexOf(r) === -1 && n.push(r);
                e1.forEach((r)=>n.push(r));
            }
            return n;
        }, Id = (e1, t, n, r, o, i, s)=>{
            let a = n[0].dims, u = x.size(i), d = x.size(s), l = S("_A", n[0].dataType, a), c = C("output", o, i), p = 64;
            u === 1 && (p = 256);
            let f = `
          var<workgroup> aBestValues : array<f32, ${p}>;
       `, m = (h)=>`
        ${h.registerUniform("reduceSize", "u32").declareVariables(l, c)}
        ${f}
        fn DIV_CEIL(a : u32, b : u32) -> u32 {
          return ((a - 1u) / b + 1u);
         }
         ${h.mainStart(p)}

          let outputIndex = global_idx / ${p};
          let offset = outputIndex * uniforms.reduceSize;

          var bestValue = f32(${_d[r]});
          let Length = uniforms.reduceSize;
          for (var k = local_idx; k < Length; k = k + ${p}) {
           let candidate = f32(${l.getByOffset("offset + k")});
           bestValue = ${yd[r]};
          }
          aBestValues[local_idx] = bestValue;
          workgroupBarrier();

         var reduceSize = min(Length, ${p}u);
         for (var currentSize = reduceSize / 2u; reduceSize > 1u;
             currentSize = reduceSize / 2u) {
           let interval = DIV_CEIL(reduceSize, 2u);
           if (local_idx < currentSize) {
            let candidate = aBestValues[local_idx + interval];
            bestValue = ${bd[r]};
            aBestValues[local_idx] = bestValue;
           }
           reduceSize = interval;
           workgroupBarrier();
         }

         if (local_idx == 0u) {
          ${c.setByOffset("outputIndex", `${r === "mean" ? `${c.type.storage}(bestValue / f32(uniforms.reduceSize))` : `${c.type.storage}(${wd[r]})`}`)};
         }
        }`;
            return {
                name: e1,
                shaderCache: {
                    hint: `${t};${p}`,
                    inputDependencies: [
                        "type"
                    ]
                },
                getShaderSource: m,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i,
                                dataType: o
                            }
                        ],
                        dispatchGroup: {
                            x: u
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: d
                            }
                        ]
                    })
            };
        }, ze = (e1, t, n, r)=>{
            let o = e1.inputs.length === 1 ? n : Kn(e1.inputs, n), i = o.axes;
            i.length === 0 && !o.noopWithEmptyAxes && (i = e1.inputs[0].dims.map((f, m)=>m));
            let s = x.normalizeAxes(i, e1.inputs[0].dims.length), a = s, u = e1.inputs[0], d = Td(a, e1.inputs[0].dims.length);
            d.length > 0 && (u = e1.compute(pe(e1.inputs[0], d), {
                inputs: [
                    0
                ],
                outputs: [
                    -1
                ]
            })[0], a = $d(a.length, u.dims.length));
            let [l, c] = vd(u.dims, a), p = l;
            o.keepDims && (p = xd(l, s)), e1.compute(Id(t, o.cacheKey, [
                u
            ], r, e1.inputs[0].dataType, p, c), {
                inputs: [
                    u
                ]
            });
        }, ko = (e1, t)=>{
            ze(e1, "ReduceMeanShared", t, "mean");
        }, Po = (e1, t)=>{
            ze(e1, "ReduceL1Shared", t, "l1");
        }, zo = (e1, t)=>{
            ze(e1, "ReduceL2Shared", t, "l2");
        }, Bo = (e1, t)=>{
            ze(e1, "ReduceLogSumExpShared", t, "logSumExp");
        }, Do = (e1, t)=>{
            ze(e1, "ReduceMaxShared", t, "max");
        }, Oo = (e1, t)=>{
            ze(e1, "ReduceMinShared", t, "min");
        }, Mo = (e1, t)=>{
            ze(e1, "ReduceProdShared", t, "prod");
        }, Uo = (e1, t)=>{
            ze(e1, "ReduceSumShared", t, "sum");
        }, Ro = (e1, t)=>{
            ze(e1, "ReduceSumSquareShared", t, "sumSquare");
        }, Vo = (e1, t)=>{
            ze(e1, "ReduceLogSumShared", t, "logSum");
        };
    });
    var Be, Cd, en, Kn, De, Ad, Ed, kd, Pd, zd, Bd, Dd, Od, Md, Ud, Oe, Lo, Go, Wo, Ho, qo, Fo, Ko, jo, Zo, Qo, Jt = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        No();
        Be = (e1)=>{
            if (!e1 || e1.length === 0 || e1.length > 2) throw new Error("Reduce op requires 1 or 2 inputs.");
            if (e1.length === 2 && e1[1].dims.length !== 1) throw new Error("Invalid axes input dims.");
        }, Cd = (e1)=>[
                "",
                "",
                `var value = ${e1.getByIndices("input_indices")};`,
                ""
            ], en = (e1, t, n, r, o, i, s = !1, a = !1)=>{
            let u = [], d = n[0].dims, l = d.length, c = x.normalizeAxes(o, l), p = !a && c.length === 0;
            d.forEach((b, y)=>{
                p || c.indexOf(y) >= 0 ? s && u.push(1) : u.push(b);
            });
            let f = u.length, m = x.size(u);
            return {
                name: e1,
                shaderCache: t,
                getShaderSource: (b)=>{
                    let y = [], g = S("_A", n[0].dataType, l), _ = C("output", i, f), w = r(g, _, c), v = w[2];
                    for(let $ = 0, T = 0; $ < l; $++)p || c.indexOf($) >= 0 ? (s && T++, v = `for(var j${$}: u32 = 0; j${$} < ${d[$]}; j${$}++) {
                  ${w[2].includes("last_index") ? `let last_index = j${$};` : ""}
                  ${g.indicesSet("input_indices", $, `j${$}`)}
                  ${v}
                }`) : (y.push(`${g.indicesSet("input_indices", $, _.indicesGet("output_indices", T))};`), T++);
                    return `

        ${b.registerUniform("output_size", "u32").declareVariables(g, _)}

        ${b.mainStart()}
          ${b.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
          var input_indices: ${g.type.indices};
          let output_indices = ${_.offsetToIndices("global_idx")};

          ${y.join(`
`)}
          ${w[0]}       // init ops for reduce max/min
          ${w[1]}
          ${v}
          ${w[3]}
          ${w.length === 4 ? _.setByOffset("global_idx", "value") : w.slice(4).join(`
`)}
        }`;
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: u,
                                dataType: i
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(m / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: m
                            },
                            ...P(d, u)
                        ]
                    })
            };
        }, Kn = (e1, t)=>{
            let n = [];
            return e1[1].dims[0] > 0 && e1[1].getBigInt64Array().forEach((r)=>n.push(Number(r))), G({
                axes: n,
                keepDims: t.keepDims,
                noopWithEmptyAxes: t.noopWithEmptyAxes
            });
        }, De = (e1, t, n, r)=>{
            let o = e1.inputs, i = o.length === 1 ? n : Kn(o, n);
            e1.compute(en(t, {
                hint: i.cacheKey,
                inputDependencies: [
                    "rank"
                ]
            }, [
                o[0]
            ], i.noopWithEmptyAxes && i.axes.length === 0 ? Cd : r, i.axes, o[0].dataType, i.keepDims, i.noopWithEmptyAxes), {
                inputs: [
                    0
                ]
            });
        }, Ad = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceLogSum", t, (r, o)=>[
                    `var value = ${o.type.storage}(0);`,
                    "",
                    `value += ${r.getByIndices("input_indices")};`,
                    "value = log(value);"
                ]);
        }, Ed = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceL1", t, (r, o)=>[
                    `var value = ${o.type.storage}(0);`,
                    "",
                    `value += abs(${r.getByIndices("input_indices")});`,
                    ""
                ]);
        }, kd = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceL2", t, (r, o)=>[
                    `var t = ${o.type.value}(0); var value = ${o.type.value}(0);`,
                    "",
                    `t = ${r.getByIndices("input_indices")}; value += (t * t);`,
                    "value = sqrt(value);"
                ]);
        }, Pd = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceLogSumExp", t, (r, o)=>[
                    `var value = ${o.type.storage}(0);`,
                    "",
                    `value += exp(${r.getByIndices("input_indices")});`,
                    "value = log(value);"
                ]);
        }, zd = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceMax", t, (r, o, i)=>{
                let s = [];
                for(let a = 0; a < r.rank; a++)(i.indexOf(a) >= 0 || i.length === 0) && s.push(r.indicesSet("input_indices", a, 0));
                return [
                    `${s.join(`
`)}`,
                    `var value = ${r.getByIndices("input_indices")};`,
                    `value = max(value, ${r.getByIndices("input_indices")});`,
                    ""
                ];
            });
        }, Bd = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceMean", t, (r, o, i)=>{
                let s = 1;
                for(let a = 0; a < r.rank; a++)(i.indexOf(a) >= 0 || i.length === 0) && (s *= e1.inputs[0].dims[a]);
                return [
                    "var sum = f32(0);",
                    "",
                    `sum += f32(${r.getByIndices("input_indices")});`,
                    `let value = ${o.type.value}(sum / ${s});`
                ];
            });
        }, Dd = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceMin", t, (r, o, i)=>{
                let s = [];
                for(let a = 0; a < r.rank; a++)(i.indexOf(a) >= 0 || i.length === 0) && s.push(`input_indices[${a}] = 0;`);
                return [
                    `${s.join(`
`)}`,
                    `var value = ${r.getByIndices("input_indices")};`,
                    `value = min(value, ${r.getByIndices("input_indices")});`,
                    ""
                ];
            });
        }, Od = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceProd", t, (r, o)=>[
                    `var value = ${o.type.storage}(1);`,
                    "",
                    `value *= ${r.getByIndices("input_indices")};`,
                    ""
                ]);
        }, Md = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceSum", t, (r, o)=>[
                    `var value = ${o.type.storage}(0);`,
                    "",
                    `value += ${r.getByIndices("input_indices")};`,
                    ""
                ]);
        }, Ud = (e1, t)=>{
            Be(e1.inputs), De(e1, "ReduceSumSquare", t, (r, o)=>[
                    `var t = ${o.type.value}(0); var value = ${o.type.value}(0);`,
                    "",
                    `t = ${r.getByIndices("input_indices")}; value += t * t;`,
                    ""
                ]);
        }, Oe = (e1, t, n)=>{
            if (t.length === 0) return n;
            let r = 1, o = 1;
            for(let i = 0; i < t.length; i++)t.indexOf(i) === -1 ? r *= e1[i] : o *= e1[i];
            return o < 32 && r > 1024;
        }, Lo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Bd(e1, t) : ko(e1, t);
        }, Go = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Ed(e1, t) : Po(e1, t);
        }, Wo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? kd(e1, t) : zo(e1, t);
        }, Ho = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Pd(e1, t) : Bo(e1, t);
        }, qo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? zd(e1, t) : Do(e1, t);
        }, Fo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Dd(e1, t) : Oo(e1, t);
        }, Ko = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Od(e1, t) : Mo(e1, t);
        }, jo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Md(e1, t) : Uo(e1, t);
        }, Zo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Ud(e1, t) : Ro(e1, t);
        }, Qo = (e1, t)=>{
            Oe(e1.inputs[0].dims, t.axes, t.noopWithEmptyAxes) ? Ad(e1, t) : Vo(e1, t);
        };
    });
    var Xo, Yo, Jo, jn, ei = k(()=>{
        "use strict";
        L();
        ie();
        Jt();
        Xo = (e1)=>{
            if (!e1 || e1.length === 0 || e1.length > 2) throw new Error("ArgMinMaxOp op requires 1 or 2 inputs.");
            if (e1[0].dataType !== 1) throw new Error("Invalid input type.");
        }, Yo = (e1, t)=>{
            Xo(e1.inputs);
            let n = (r, o, i)=>{
                let s = [];
                for(let a = 0; a < r.rank; a++)(i.indexOf(a) >= 0 || i.length === 0) && s.push(`input_indices[${a}] = 0;`);
                return [
                    `${s.join(`
`)}`,
                    `var value = ${r.getByIndices("input_indices")};
var best_index : i32 = 0;`,
                    `if (${r.getByIndices("input_indices")} ${t.selectLastIndex > 0 ? "<=" : "<"} value) {
         value = ${r.getByIndices("input_indices")};
         best_index = i32(last_index);
       }`,
                    "",
                    o.setByOffset("global_idx", "best_index")
                ];
            };
            e1.compute(en("ArgMin", {
                hint: t.cacheKey,
                inputDependencies: [
                    "rank"
                ]
            }, [
                e1.inputs[0]
            ], n, [
                t.axis
            ], 7, t.keepDims), {
                inputs: [
                    0
                ]
            });
        }, Jo = (e1, t)=>{
            Xo(e1.inputs);
            let n = (r, o, i)=>{
                let s = [];
                for(let a = 0; a < r.rank; a++)(i.indexOf(a) >= 0 || i.length === 0) && s.push(`input_indices[${a}] = 0;`);
                return [
                    `${s.join(`
`)}`,
                    `var value = ${r.getByIndices("input_indices")};
var best_index : i32 = 0;`,
                    `if (${r.getByIndices("input_indices")} ${t.selectLastIndex > 0 ? ">=" : ">"} value) {
         value = ${r.getByIndices("input_indices")};
         best_index = i32(last_index);
       }`,
                    "",
                    o.setByOffset("global_idx", "best_index")
                ];
            };
            e1.compute(en("argMax", {
                hint: t.cacheKey,
                inputDependencies: [
                    "rank"
                ]
            }, [
                e1.inputs[0]
            ], n, [
                t.axis
            ], 7, t.keepDims), {
                inputs: [
                    0
                ]
            });
        }, jn = (e1)=>G(e1);
    });
    var Rd, Zn, Vd, Nd, Ld, it, Gd, ti, tn = k(()=>{
        "use strict";
        L();
        F();
        Qt();
        j();
        Rd = (e1, t)=>{
            let n = e1[0], r = e1[1], o = e1[2], i = e1[3], s = e1[4], a = e1[5];
            if (s && a) throw new Error("Attention cannot have both past and attention_bias");
            if (n.dims.length !== 3) throw new Error('Input "input" must have 3 dimensions');
            let u = n.dims[0], d = n.dims[1], l = n.dims[2];
            if (o.dims.length !== 1) throw new Error('Input "bias" is expected to have 1 dimensions');
            if (r.dims.length !== 2) throw new Error('Input "weights" is expected to have 2 dimensions');
            if (r.dims[0] !== l) throw new Error("Input 1 dimension 0 should have same length as dimension 2 of input 0");
            if (o.dims[0] !== r.dims[1]) throw new Error('Input "bias" dimension 0 should have same length as dimension 1 of input "weights"');
            let c = o.dims[0] / 3, p = c, f = p;
            if (t.qkvHiddenSizes.length > 0) {
                if (t.qkvHiddenSizes.length !== 3) throw new Error("qkv_hidden_sizes attribute should have 3 elements");
                for (let _ of t.qkvHiddenSizes)if (_ % t.numHeads !== 0) throw new Error("qkv_hidden_sizes should be divisible by num_heads");
                c = t.qkvHiddenSizes[0], p = t.qkvHiddenSizes[1], f = t.qkvHiddenSizes[2];
            }
            let m = d;
            if (c !== p) throw new Error("qkv_hidden_sizes first element should be same as the second");
            if (o.dims[0] !== c + p + f) throw new Error('Input "bias" dimension 0 should have same length as sum of Q/K/V hidden sizes');
            let h = 0;
            if (s) {
                if (p !== f) throw new Error('Input "past" expect k_hidden_size == v_hidden_size');
                if (s.dims.length !== 5) throw new Error('Input "past" must have 5 dimensions');
                if (s.dims[0] !== 2) throw new Error('Input "past" first dimension must be 2');
                if (s.dims[1] !== u) throw new Error('Input "past" second dimension must be batch_size');
                if (s.dims[2] !== t.numHeads) throw new Error('Input "past" third dimension must be num_heads');
                if (s.dims[4] !== p / t.numHeads) throw new Error('Input "past" fifth dimension must be k_hidden_size / num_heads');
                t.pastPresentShareBuffer || (h = s.dims[3]);
            }
            let b = m + h, y = -1, g = 0;
            if (i) throw new Error("Mask not supported");
            if (s) throw new Error("past is not supported");
            if (a) {
                if (a.dims.length !== 4) throw new Error('Input "attention_bias" must have 4 dimensions');
                if (a.dims[0] !== u || a.dims[1] !== t.numHeads || a.dims[2] !== d || a.dims[3] !== b) throw new Error('Expect "attention_bias" shape (batch_size, num_heads, sequence_length, total_sequence_length)');
            }
            return {
                batchSize: u,
                sequenceLength: d,
                pastSequenceLength: h,
                kvSequenceLength: m,
                totalSequenceLength: b,
                maxSequenceLength: y,
                inputHiddenSize: l,
                hiddenSize: c,
                vHiddenSize: f,
                headSize: Math.floor(c / t.numHeads),
                vHeadSize: Math.floor(f / t.numHeads),
                numHeads: t.numHeads,
                isUnidirectional: !1,
                pastPresentShareBuffer: !1,
                maskFilterValue: t.maskFilterValue,
                maskType: g,
                scale: t.scale,
                broadcastResPosBias: !1,
                passPastInKv: !1,
                qkvFormat: 1
            };
        }, Zn = (e1, t, n)=>t && e1 ? `
      let total_sequence_length_input = u32(${t.getByOffset("0")});
      let present_sequence_length = max(total_sequence_length_input, uniforms.past_sequence_length);
      let is_subsequent_prompt: bool = sequence_length > 1 && sequence_length != total_sequence_length_input;
      let is_first_prompt: bool = is_subsequent_prompt == false && sequence_length == total_sequence_length_input;
      total_sequence_length = u32(${e1?.getByOffset("batchIdx")}) + 1;
      var past_sequence_length: u32 = 0;
      if (is_first_prompt == false) {
        past_sequence_length = total_sequence_length - sequence_length;
      }
       ` : `
    ${n ? "let past_sequence_length = uniforms.past_sequence_length" : ""};
    let present_sequence_length = total_sequence_length;
    `, Vd = (e1, t, n, r, o, i, s, a)=>{
            let u = J(s ? 1 : i), d = 64, l = i / u;
            l < d && (d = 32);
            let c = Math.ceil(i / u / d), p = [
                {
                    type: 12,
                    data: t
                },
                {
                    type: 12,
                    data: n
                },
                {
                    type: 12,
                    data: r
                },
                {
                    type: 12,
                    data: o
                },
                {
                    type: 12,
                    data: l
                },
                {
                    type: 12,
                    data: c
                }
            ], f = re(e1.dataType, u), m = ce(1, u), h = [
                "type"
            ];
            s && h.push("type"), a && h.push("type");
            let b = (y)=>{
                let g = C("x", e1.dataType, e1.dims, u), _ = [
                    g
                ], w = s ? S("seq_lens", s.dataType, s.dims) : void 0;
                w && _.push(w);
                let v = a ? S("total_sequence_length_input", a.dataType, a.dims) : void 0;
                v && _.push(v);
                let $ = ce(e1.dataType), T = [
                    {
                        name: "batch_size",
                        type: "u32"
                    },
                    {
                        name: "num_heads",
                        type: "u32"
                    },
                    {
                        name: "past_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "sequence_length",
                        type: "u32"
                    },
                    {
                        name: "total_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "elements_per_thread",
                        type: "u32"
                    }
                ];
                return `
  var<workgroup> thread_max: array<f32, ${d}>;
  var<workgroup> thread_sum: array<f32, ${d}>;
  ${y.registerUniforms(T).declareVariables(..._)}
  ${y.mainStart([
                    d,
                    1,
                    1
                ])}
    let batchIdx = workgroup_id.z / uniforms.num_heads;
    let headIdx = workgroup_id.z % uniforms.num_heads;
    let sequence_length = uniforms.sequence_length;
    var total_sequence_length = uniforms.total_sequence_length;
    ${Zn(w, v, !1)}
    let local_offset = local_idx * uniforms.elements_per_thread;
    let offset = (global_idx / ${d}) * uniforms.total_sequence_length + local_offset;
    let seq_causal_length = ${s ? "u32(past_sequence_length + workgroup_id.y + 1)" : "total_sequence_length"};
    var thread_max_vector = ${m}(-3.4028234663852886e+38f);
    for (var i: u32 = 0; i < uniforms.elements_per_thread && i + local_offset < seq_causal_length; i++) {
      thread_max_vector = max(${m}(x[offset + i]), thread_max_vector);
    }
    thread_max[local_idx] = ${(()=>{
                    switch(u){
                        case 1:
                            return "thread_max_vector";
                        case 2:
                            return "max(thread_max_vector.x, thread_max_vector.y)";
                        case 4:
                            return "max(max(thread_max_vector.x, thread_max_vector.y), max(thread_max_vector.z, thread_max_vector.w))";
                        default:
                            throw new Error(`Unsupported components: ${u}`);
                    }
                })()};
    workgroupBarrier();

    var max_value =  f32(-3.4028234663852886e+38f);
    for (var i = 0u; i < ${d}; i++) {
      max_value = max(thread_max[i], max_value);
    }

    var sum_vector = ${m}(0);
    for (var i: u32 = 0; i < uniforms.elements_per_thread && i + local_offset < seq_causal_length; i++) {
      sum_vector += exp(${m}(x[offset + i]) - max_value);
    }
    thread_sum[local_idx] = ${(()=>{
                    switch(u){
                        case 1:
                            return "sum_vector";
                        case 2:
                            return "sum_vector.x + sum_vector.y";
                        case 4:
                            return "sum_vector.x + sum_vector.y + sum_vector.z + sum_vector.w";
                        default:
                            throw new Error(`Unsupported components: ${u}`);
                    }
                })()};
    workgroupBarrier();

    var sum: f32 = 0;
    for (var i = 0u; i < ${d}; i++) {
      sum += thread_sum[i];
    }

    if (sum == 0) {
      for (var i: u32 = 0; i < uniforms.elements_per_thread && i + local_offset < seq_causal_length; i++) {
        x[offset + i] = ${g.type.value}(${$}(1.0) / ${$}(seq_causal_length));
      }
    } else {
      for (var i: u32 = 0; i < uniforms.elements_per_thread && i + local_offset < seq_causal_length; i++) {
        var f32input = ${m}(x[offset + i]);
        x[offset + i] = ${g.type.value}(exp(f32input - max_value) / sum);
      }
    }
      ${s ? `
        for (var total_seq_id: u32 = seq_causal_length; total_seq_id + local_offset < uniforms.total_sequence_length; total_seq_id++) {
          x[offset + total_seq_id] = ${g.type.value}(${$}(0));
        }` : ""};
  }`;
            };
            return {
                name: "AttentionProbsSoftmax",
                shaderCache: {
                    hint: `${d};${f};${u}`,
                    inputDependencies: h
                },
                getShaderSource: b,
                getRunData: ()=>({
                        outputs: [],
                        dispatchGroup: {
                            x: 1,
                            y: o,
                            z: t * n
                        },
                        programUniforms: p
                    })
            };
        }, Nd = (e1, t, n, r, o, i, s, a, u)=>{
            let d = s + i.kvSequenceLength, l = [
                i.batchSize,
                i.numHeads,
                i.sequenceLength,
                d
            ], c = e1 > 1 && r, p = i.kvNumHeads ? i.kvNumHeads : i.numHeads, f = c ? [
                i.batchSize,
                p,
                d,
                i.headSize
            ] : void 0, m = i.nReps ? i.nReps : 1, h = i.scale === 0 ? 1 / Math.sqrt(i.headSize) : i.scale, b = J(i.headSize), y = i.headSize / b, g = 12, _ = {
                x: Math.ceil(d / g),
                y: Math.ceil(i.sequenceLength / g),
                z: i.batchSize * i.numHeads
            }, w = [
                {
                    type: 12,
                    data: i.sequenceLength
                },
                {
                    type: 12,
                    data: y
                },
                {
                    type: 12,
                    data: d
                },
                {
                    type: 12,
                    data: i.numHeads
                },
                {
                    type: 12,
                    data: i.headSize
                },
                {
                    type: 1,
                    data: h
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 12,
                    data: i.kvSequenceLength
                },
                {
                    type: 12,
                    data: m
                }
            ], v = c && r && x.size(r.dims) > 0, $ = [
                "type",
                "type"
            ];
            v && $.push("type"), o && $.push("type"), a && $.push("type"), u && $.push("type");
            let T = [
                {
                    dims: l,
                    dataType: t.dataType,
                    gpuDataType: 0
                }
            ];
            c && T.push({
                dims: f,
                dataType: t.dataType,
                gpuDataType: 0
            });
            let I = (A)=>{
                let z = S("q", t.dataType, t.dims, b), R = S("key", n.dataType, n.dims, b), D = [
                    z,
                    R
                ];
                if (v) {
                    let H = S("past_key", r.dataType, r.dims, b);
                    D.push(H);
                }
                o && D.push(S("attention_bias", o.dataType, o.dims));
                let U = a ? S("seq_lens", a.dataType, a.dims) : void 0;
                U && D.push(U);
                let Q = u ? S("total_sequence_length_input", u.dataType, u.dims) : void 0;
                Q && D.push(Q);
                let O = C("output", t.dataType, l), M = [
                    O
                ];
                c && M.push(C("present_key", t.dataType, f, b));
                let V = ce(1, b), W = [
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "num_heads",
                        type: "u32"
                    },
                    {
                        name: "head_size",
                        type: "u32"
                    },
                    {
                        name: "alpha",
                        type: "f32"
                    },
                    {
                        name: "past_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "kv_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "n_reps",
                        type: "u32"
                    }
                ];
                return `
  const TILE_SIZE = ${g}u;

  var<workgroup> tileQ: array<${z.type.storage}, ${g * g}>;
  var<workgroup> tileK: array<${z.type.storage}, ${g * g}>;
  ${A.registerUniforms(W).declareVariables(...D, ...M)}
  ${A.mainStart([
                    g,
                    g,
                    1
                ])}
    // x holds the N and y holds the M
    let headIdx = workgroup_id.z % uniforms.num_heads;
    let kvHeadIdx = ${m === 1 ? "headIdx" : "headIdx / uniforms.n_reps"};
    let kv_num_heads = ${m === 1 ? "uniforms.num_heads" : "uniforms.num_heads / uniforms.n_reps"};
    let batchIdx = workgroup_id.z / uniforms.num_heads;
    let m = workgroup_id.y * TILE_SIZE;
    let n = workgroup_id.x * TILE_SIZE;
    let sequence_length = uniforms.M;
    var total_sequence_length = uniforms.N;
    ${Zn(U, Q, !0)}
    let absKvHeadIdx = batchIdx * kv_num_heads + kvHeadIdx;
    let qOffset = workgroup_id.z * uniforms.M * uniforms.K + m * uniforms.K;
    ${v && c ? "let pastKeyOffset = absKvHeadIdx * uniforms.past_sequence_length * uniforms.K;" : ""};
    let kOffset = absKvHeadIdx * uniforms.kv_sequence_length * uniforms.K;
    ${c ? "let presentKeyOffset = absKvHeadIdx * uniforms.N * uniforms.K;" : ""}
    var value = ${V}(0);
    for (var w: u32 = 0u; w < uniforms.K; w += TILE_SIZE) {
      if (global_id.y < uniforms.M && w + local_id.x < uniforms.K) {
        tileQ[TILE_SIZE * local_id.y + local_id.x] = q[qOffset + local_id.y * uniforms.K + w + local_id.x];
      }
      if (n + local_id.y < uniforms.N && w + local_id.x < uniforms.K) {
        var idx = TILE_SIZE * local_id.y + local_id.x;
      ${v && c ? `
              if (n + local_id.y < past_sequence_length) {
                tileK[idx] = past_key[pastKeyOffset + (n + local_id.y) * uniforms.K + w + local_id.x];
              } else if (n + local_id.y - past_sequence_length < uniforms.kv_sequence_length) {
                tileK[idx] = key[kOffset + (n + local_id.y - past_sequence_length) * uniforms.K + w + local_id.x];
              }` : `
          if (n + local_id.y < uniforms.kv_sequence_length) {
            tileK[idx] = key[kOffset + (n + local_id.y) * uniforms.K + w + local_id.x];
          }`}
      ${c ? `if (n + local_id.y < present_sequence_length) {
        present_key[presentKeyOffset + (n + local_id.y) * uniforms.K + w + local_id.x] = tileK[idx];
      }` : ""}
      }
      workgroupBarrier();

      for (var k: u32 = 0u; k < TILE_SIZE && w+k < uniforms.K; k++) {
          value += ${V}(tileQ[TILE_SIZE * local_id.y + k] * tileK[TILE_SIZE * local_id.x + k]);
      }

      workgroupBarrier();
    }

    if (global_id.y < uniforms.M && global_id.x < total_sequence_length) {
      let headOffset = workgroup_id.z * uniforms.M * uniforms.N;
      let outputIdx = headOffset + global_id.y * uniforms.N + global_id.x;
      var sum: f32 = ${(()=>{
                    switch(b){
                        case 1:
                            return "value";
                        case 2:
                            return "value.x + value.y";
                        case 4:
                            return "value.x + value.y + value.z + value.w";
                        default:
                            throw new Error(`Unsupported components: ${b}`);
                    }
                })()};
        output[outputIdx] = ${O.type.value} (sum * uniforms.alpha) + ${o ? "attention_bias[outputIdx]" : "0.0"};
    }
  }`;
            };
            return {
                name: "AttentionProbs",
                shaderCache: {
                    hint: `${b};${o !== void 0};${r !== void 0};${e1}`,
                    inputDependencies: $
                },
                getRunData: ()=>({
                        outputs: T,
                        dispatchGroup: _,
                        programUniforms: w
                    }),
                getShaderSource: I
            };
        }, Ld = (e1, t, n, r, o, i, s, a)=>{
            let u = i + o.kvSequenceLength, d = o.nReps ? o.nReps : 1, l = o.vHiddenSize * d, c = e1 > 1 && r, p = o.kvNumHeads ? o.kvNumHeads : o.numHeads, f = c ? [
                o.batchSize,
                p,
                u,
                o.headSize
            ] : void 0, m = [
                o.batchSize,
                o.sequenceLength,
                l
            ], h = 12, b = {
                x: Math.ceil(o.vHeadSize / h),
                y: Math.ceil(o.sequenceLength / h),
                z: o.batchSize * o.numHeads
            }, y = [
                {
                    type: 12,
                    data: o.sequenceLength
                },
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: o.vHeadSize
                },
                {
                    type: 12,
                    data: o.numHeads
                },
                {
                    type: 12,
                    data: o.headSize
                },
                {
                    type: 12,
                    data: l
                },
                {
                    type: 12,
                    data: i
                },
                {
                    type: 12,
                    data: o.kvSequenceLength
                },
                {
                    type: 12,
                    data: d
                }
            ], g = c && r && x.size(r.dims) > 0, _ = [
                "type",
                "type"
            ];
            g && _.push("type"), s && _.push("type"), a && _.push("type");
            let w = [
                {
                    dims: m,
                    dataType: t.dataType,
                    gpuDataType: 0
                }
            ];
            c && w.push({
                dims: f,
                dataType: t.dataType,
                gpuDataType: 0
            });
            let v = ($)=>{
                let T = S("probs", t.dataType, t.dims), I = S("v", n.dataType, n.dims), A = [
                    T,
                    I
                ];
                g && A.push(S("past_value", r.dataType, r.dims));
                let z = s ? S("seq_lens", s.dataType, s.dims) : void 0;
                s && A.push(z);
                let R = a ? S("total_sequence_length_input", a.dataType, a.dims) : void 0;
                a && A.push(R);
                let U = [
                    C("output", t.dataType, m)
                ];
                c && U.push(C("present_value", t.dataType, f));
                let Q = [
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "num_heads",
                        type: "u32"
                    },
                    {
                        name: "head_size",
                        type: "u32"
                    },
                    {
                        name: "v_hidden_size",
                        type: "u32"
                    },
                    {
                        name: "past_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "kv_sequence_length",
                        type: "u32"
                    },
                    {
                        name: "n_reps",
                        type: "u32"
                    }
                ];
                return `
  const TILE_SIZE = ${h}u;
  var<workgroup> tileQ: array<${T.type.value}, ${h * h}>;
  var<workgroup> tileV: array<${T.type.value}, ${h * h}>;
  ${$.registerUniforms(Q).declareVariables(...A, ...U)}
  ${$.mainStart([
                    h,
                    h,
                    1
                ])}
   let headIdx = workgroup_id.z % uniforms.num_heads;
   let batchIdx = workgroup_id.z / uniforms.num_heads;
   let kvHeadIdx = ${d === 1 ? "headIdx" : "headIdx / uniforms.n_reps"};
   let kv_num_heads = ${d === 1 ? "uniforms.num_heads" : "uniforms.num_heads / uniforms.n_reps"};
   let m = global_id.y;
   let n = global_id.x;
   let sequence_length = uniforms.M;
   var total_sequence_length = uniforms.K;
   ${Zn(z, R, !0)}
   let offsetA = workgroup_id.z * uniforms.M * uniforms.K + m * uniforms.K;
   let absKvHeadIdx = batchIdx * kv_num_heads + kvHeadIdx; // kvHeadIdx is relative to the batch
   ${g && c ? "let pastValueOffset = absKvHeadIdx * uniforms.N * uniforms.past_sequence_length + n;" : ""};
   let vOffset = absKvHeadIdx * uniforms.N * uniforms.kv_sequence_length + n;
   ${c ? "let presentValueOffset = absKvHeadIdx * uniforms.N * uniforms.K + n;" : ""}
   var value = ${T.type.storage}(0);
   for (var w: u32 = 0u; w < uniforms.K; w += TILE_SIZE) {
      if (m < uniforms.M && w + local_id.x < uniforms.K) {
        tileQ[TILE_SIZE * local_id.y + local_id.x] = probs[offsetA + w + local_id.x];
      }
      if (n < uniforms.N && w + local_id.y < uniforms.K) {
        var idx = TILE_SIZE * local_id.y + local_id.x;
        ${g && c ? `
        if (w + local_id.y < past_sequence_length) {
          tileV[idx] = past_value[pastValueOffset + (w + local_id.y) * uniforms.N];
        } else if (w + local_id.y - past_sequence_length < uniforms.kv_sequence_length) {
          tileV[idx] = v[vOffset + (w + local_id.y - past_sequence_length) * uniforms.N];
        }
      ` : `
            if (w + local_id.y < uniforms.kv_sequence_length) {
              tileV[idx] = v[vOffset + (w + local_id.y) * uniforms.N];
            }`}
        ${c ? `
            if (w + local_id.y < present_sequence_length) {
          present_value[presentValueOffset + (w + local_id.y) * uniforms.N] = tileV[idx];
        }` : ""}
      }
     workgroupBarrier();
     for (var k: u32 = 0u; k < TILE_SIZE && w+k < total_sequence_length; k++) {
       value += tileQ[TILE_SIZE * local_id.y + k] * tileV[TILE_SIZE * k + local_id.x];
     }
     workgroupBarrier();
   }

   // we need to transpose output from BNSH_v to BSND_v
   if (m < uniforms.M && n < uniforms.N) {
     let outputIdx = batchIdx * uniforms.M * uniforms.v_hidden_size + m * uniforms.v_hidden_size
       + headIdx * uniforms.N + n;
     output[outputIdx] = value;
   }
  }`;
            };
            return {
                name: "AttentionScore",
                shaderCache: {
                    hint: `${r !== void 0};${e1}`,
                    inputDependencies: _
                },
                getRunData: ()=>({
                        outputs: w,
                        dispatchGroup: b,
                        programUniforms: y
                    }),
                getShaderSource: v
            };
        }, it = (e1, t, n, r, o, i, s, a, u, d, l, c)=>{
            let p = Math.min(e1.outputCount, 1 + (s ? 1 : 0) + (a ? 1 : 0)), f = p > 1 ? d.pastSequenceLength : 0, m = f + d.kvSequenceLength, h = u && x.size(u.dims) > 0 ? u : void 0, b = [
                t,
                n
            ];
            p > 1 && s && x.size(s.dims) > 0 && b.push(s), h && b.push(h), l && b.push(l), c && b.push(c);
            let y = e1.compute(Nd(p, t, n, s, h, d, f, l, c), {
                inputs: b,
                outputs: p > 1 ? [
                    -1,
                    1
                ] : [
                    -1
                ]
            })[0];
            e1.compute(Vd(y, d.batchSize, d.numHeads, f, d.sequenceLength, m, l, c), {
                inputs: l && c ? [
                    y,
                    l,
                    c
                ] : [
                    y
                ],
                outputs: []
            });
            let g = [
                y,
                r
            ];
            p > 1 && a && x.size(a.dims) > 0 && g.push(a), l && g.push(l), c && g.push(c), e1.compute(Ld(p, y, r, a, d, f, l, c), {
                inputs: g,
                outputs: p > 1 ? [
                    0,
                    2
                ] : [
                    0
                ]
            });
        }, Gd = (e1, t)=>{
            let n = [
                t.batchSize,
                t.numHeads,
                t.sequenceLength,
                t.headSize
            ], r = t.sequenceLength, o = t.inputHiddenSize, i = t.headSize, s = 12, a = {
                x: Math.ceil(t.headSize / s),
                y: Math.ceil(t.sequenceLength / s),
                z: t.batchSize * t.numHeads
            }, u = [
                e1.inputs[0],
                e1.inputs[1],
                e1.inputs[2]
            ], d = [
                {
                    type: 12,
                    data: r
                },
                {
                    type: 12,
                    data: o
                },
                {
                    type: 12,
                    data: i
                },
                {
                    type: 12,
                    data: t.numHeads
                },
                {
                    type: 12,
                    data: t.headSize
                },
                {
                    type: 12,
                    data: t.hiddenSize
                },
                {
                    type: 12,
                    data: t.hiddenSize + t.hiddenSize + t.vHiddenSize
                }
            ], l = (c)=>{
                let p = C("output_q", u[0].dataType, n), f = C("output_k", u[0].dataType, n), m = C("output_v", u[0].dataType, n), h = S("input", u[0].dataType, u[0].dims), b = S("weight", u[1].dataType, u[1].dims), y = S("bias", u[2].dataType, u[2].dims), g = h.type.storage, _ = [
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "num_heads",
                        type: "u32"
                    },
                    {
                        name: "head_size",
                        type: "u32"
                    },
                    {
                        name: "hidden_size",
                        type: "u32"
                    },
                    {
                        name: "ldb",
                        type: "u32"
                    }
                ];
                return `
  const TILE_SIZE = ${s}u;
  var<workgroup> tileInput: array<${g}, ${s * s}>;
  var<workgroup> tileWeightQ: array<${g}, ${s * s}>;
  var<workgroup> tileWeightK: array<${g}, ${s * s}>;
  var<workgroup> tileWeightV: array<${g}, ${s * s}>;
  ${c.registerUniforms(_).declareVariables(h, b, y, p, f, m)}
  ${c.mainStart([
                    s,
                    s,
                    1
                ])}
    let batchIndex = workgroup_id.z / uniforms.num_heads;
    let headNumber = workgroup_id.z % uniforms.num_heads;
    let m = global_id.y;
    let n = global_id.x;

    let inputOffset = batchIndex * (uniforms.M * uniforms.K) + m * uniforms.K;
    let biasOffsetQ = headNumber * uniforms.head_size;
    let biasOffsetK = uniforms.hidden_size + biasOffsetQ;
    let biasOffsetV = uniforms.hidden_size + biasOffsetK;

    var valueQ = ${g}(0);
    var valueK = ${g}(0);
    var valueV = ${g}(0);
    for (var w: u32 = 0u; w < uniforms.K; w += TILE_SIZE) {
      if (m < uniforms.M && w + local_id.x < uniforms.K) {
        tileInput[TILE_SIZE * local_id.y + local_id.x] = input[inputOffset + w + local_id.x];
      }
      if (n < uniforms.N && w + local_id.y < uniforms.K) {
        let offset = n + (w + local_id.y) * uniforms.ldb;
        tileWeightQ[TILE_SIZE * local_id.y + local_id.x] = weight[biasOffsetQ + offset];
        tileWeightK[TILE_SIZE * local_id.y + local_id.x] = weight[biasOffsetK + offset];
        tileWeightV[TILE_SIZE * local_id.y + local_id.x] = weight[biasOffsetV + offset];
      }
      workgroupBarrier();
      for (var k: u32 = 0u; k<TILE_SIZE && w+k < uniforms.K; k++) {
        let inputTileOffset = TILE_SIZE * local_id.y + k;
        let weightTileOffset = TILE_SIZE * k + local_id.x;
        valueQ += tileInput[inputTileOffset] * tileWeightQ[weightTileOffset];
        valueK += tileInput[inputTileOffset] * tileWeightK[weightTileOffset];
        valueV += tileInput[inputTileOffset] * tileWeightV[weightTileOffset];
      }

      workgroupBarrier();
    }

    let headOffset = (m * uniforms.N + n) % uniforms.head_size;
    valueQ += bias[headOffset + biasOffsetQ];
    valueK += bias[headOffset + biasOffsetK];
    valueV += bias[headOffset + biasOffsetV];

    let offset = workgroup_id.z * uniforms.M * uniforms.N;
    if (m < uniforms.M && n < uniforms.N) {
      let outputIdx = offset + m * uniforms.N + n;
      output_q[outputIdx] = valueQ;
      output_k[outputIdx] = valueK;
      output_v[outputIdx] = valueV;
    }
  }`;
            };
            return e1.compute({
                name: "AttentionPrepare",
                shaderCache: {
                    inputDependencies: [
                        "type",
                        "type",
                        "type"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: n,
                                dataType: e1.inputs[0].dataType,
                                gpuDataType: 0
                            },
                            {
                                dims: n,
                                dataType: e1.inputs[0].dataType,
                                gpuDataType: 0
                            },
                            {
                                dims: n,
                                dataType: e1.inputs[0].dataType,
                                gpuDataType: 0
                            }
                        ],
                        dispatchGroup: a,
                        programUniforms: d
                    }),
                getShaderSource: l
            }, {
                inputs: u,
                outputs: [
                    -1,
                    -1,
                    -1
                ]
            });
        }, ti = (e1, t)=>{
            let n = Rd(e1.inputs, t), [r, o, i] = Gd(e1, n);
            return it(e1, r, o, i, e1.inputs[4], void 0, void 0, void 0, e1.inputs[5], n);
        };
    });
    var Wd, Hd, qd, ni, ri = k(()=>{
        "use strict";
        _e();
        L();
        F();
        ie();
        j();
        Wd = (e1, t)=>{
            if (!e1 || e1.length !== 5) throw new Error("BatchNormalization requires 5 inputs");
            let n = (r, o, i)=>{
                let s = o.length;
                if (s !== r.length) throw new Error(`${i}: num dimensions != ${s}`);
                o.forEach((a, u)=>{
                    if (a !== r[u]) throw new Error(`${i}: dim[${u}] do not match`);
                });
            };
            if (e1[0].dims.length > 1) {
                let r = t.format === "NHWC" ? t.spatial ? e1[0].dims.slice(-1) : e1[0].dims.slice(-1).concat(e1[0].dims.slice(1, e1[0].dims.length - 1)) : e1[0].dims.slice(1, t.spatial ? 2 : void 0);
                n(e1[1].dims, r, "Invalid input scale"), n(e1[2].dims, r, "Invalid input B"), n(e1[3].dims, r, "Invalid input mean"), n(e1[4].dims, r, "Invalid input var");
            } else n(e1[1].dims, [
                1
            ], "Invalid input scale"), n(e1[2].dims, [
                1
            ], "Invalid input B"), n(e1[3].dims, [
                1
            ], "Invalid input mean"), n(e1[4].dims, [
                1
            ], "Invalid input var");
        }, Hd = (e1, t)=>{
            let { epsilon: n, spatial: r, format: o } = t, i = e1[0].dims, s = r ? J(i[i.length - 1]) : 1, a = o === "NHWC" && i.length > 1 ? s : 1, u = x.size(i) / s, d = r, l = d ? i.length : i, c = S("x", e1[0].dataType, e1[0].dims, s), p = S("scale", e1[1].dataType, e1[1].dims, a), f = S("bias", e1[2].dataType, e1[2].dims, a), m = S("inputMean", e1[3].dataType, e1[3].dims, a), h = S("inputVar", e1[4].dataType, e1[4].dims, a), b = C("y", e1[0].dataType, l, s), y = ()=>{
                let _ = "";
                if (r) _ = `let cOffset = ${i.length === 1 ? "0u" : o === "NHWC" ? `outputIndices[${i.length - 1}] / ${s}` : "outputIndices[1]"};`;
                else if (o === "NCHW") _ = `
            ${b.indicesSet("outputIndices", "0", "0")}
            let cOffset = ${b.indicesToOffset("outputIndices")};`;
                else {
                    _ = `var cIndices = ${p.type.indices}(0);
                       cIndices[0] = outputIndices[${i.length - 1}];`;
                    for(let w = 1; w < p.rank; w++)_ += `cIndices[${w}] = outputIndices[${w}];`;
                    _ += `let cOffset = ${p.indicesToOffset("cIndices")};`;
                }
                return _;
            }, g = (_)=>`
  const epsilon = ${n};
  ${_.registerUniform("outputSize", "u32").declareVariables(c, p, f, m, h, b)}
  ${_.mainStart()}
  ${_.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
    var outputIndices = ${b.offsetToIndices(`global_idx * ${s}`)};
    ${y()}
    let scale = ${p.getByOffset("cOffset")};
    let bias = ${f.getByOffset("cOffset")};
    let inputMean = ${m.getByOffset("cOffset")};
    let inputVar = ${h.getByOffset("cOffset")};
    let x = ${c.getByOffset("global_idx")};
    let value = (x - inputMean) * inverseSqrt(inputVar + epsilon) * scale + bias;
    ${b.setByOffset("global_idx", "value")}
  }`;
            return {
                name: "BatchNormalization",
                shaderCache: {
                    hint: `${t.epsilon}_${t.format}_${r}_${s}`,
                    inputDependencies: d ? [
                        "rank",
                        "type",
                        "type",
                        "type",
                        "type"
                    ] : void 0
                },
                getShaderSource: g,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: e1[0].dims,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(u / 64)
                        },
                        programUniforms: d ? [
                            {
                                type: 12,
                                data: u
                            },
                            ...P(i)
                        ] : [
                            {
                                type: 12,
                                data: u
                            }
                        ]
                    })
            };
        }, qd = (e1)=>G(e1), ni = (e1, t)=>{
            let { inputs: n, outputCount: r } = e1, o = qd({
                ...t,
                outputCount: r
            });
            if (te.webgpu.validateInputContent && Wd(n, o), t.trainingMode) throw new Error("BatchNormalization trainingMode is not supported yet.");
            e1.compute(Hd(n, o));
        };
    });
    var Fd, Kd, oi, ii = k(()=>{
        "use strict";
        F();
        j();
        Fd = (e1)=>{
            if (e1[0].dims.length !== 3) throw new Error("input should have 3 dimensions");
            if (![
                320,
                640,
                1280
            ].includes(e1[0].dims[2])) throw new Error("number of channels should be 320, 640 or 1280");
            if (e1[1].dims.length !== 1) throw new Error("bias is expected to have 1 dimensions");
            if (e1[0].dims[2] !== e1[1].dims[0]) throw new Error("last dimension of input and bias are not the same");
        }, Kd = (e1)=>{
            let t = e1[0].dims, n = e1[0].dims[2], r = x.size(t) / 4, o = e1[0].dataType, i = S("input", o, t, 4), s = S("bias", o, [
                n
            ], 4), a = S("residual", o, t, 4), u = C("output", o, t, 4);
            return {
                name: "BiasAdd",
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: t,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(r / 64)
                        }
                    }),
                getShaderSource: (l)=>`
  const channels = ${n}u / 4;
  ${l.declareVariables(i, s, a, u)}

  ${l.mainStart()}
    ${l.guardAgainstOutOfBoundsWorkgroupSizes(r)}
    let value = ${i.getByOffset("global_idx")}
      + ${s.getByOffset("global_idx % channels")} + ${a.getByOffset("global_idx")};
    ${u.setByOffset("global_idx", "value")}
  }`
            };
        }, oi = (e1)=>{
            Fd(e1.inputs), e1.compute(Kd(e1.inputs));
        };
    });
    var jd, ee, si, ai, ui, di, li, ci, pi, mi, fi, Zd, hi, gi, yi, bi, yt, _i, nn, wi, $i, vi, xi, Si, Ti, Ii, Ci, Ai, Ei, ki, Pi, zi, Bi, Di, Oi, Mi, Ui, Qn, Xn, Ri, Vi, Ni, Qd, Xd, Li, rn = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        jd = (e1, t, n, r, o, i, s)=>{
            let a = Math.ceil(t / 4), u = "";
            typeof o == "string" ? u = `${o}(a)` : u = o("a");
            let d = S("inputData", n, [
                a
            ], 4), l = C("outputData", r, [
                a
            ], 4), c = [
                {
                    name: "vec_size",
                    type: "u32"
                }
            ];
            return s && c.push(...s), `
      ${e1.registerUniforms(c).declareVariables(d, l)}

  ${i ?? ""}

  ${e1.mainStart()}
    ${e1.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.vec_size")}

    let a = ${d.getByOffset("global_idx")};
    ${l.setByOffset("global_idx", u)}
  }`;
        }, ee = (e1, t, n, r, o, i = e1.dataType, s, a)=>{
            let u = [
                {
                    type: 12,
                    data: Math.ceil(x.size(e1.dims) / 4)
                }
            ];
            return s && u.push(...s), {
                name: t,
                shaderCache: {
                    hint: o,
                    inputDependencies: [
                        "type"
                    ]
                },
                getShaderSource: (d)=>jd(d, x.size(e1.dims), e1.dataType, i, n, r, a),
                getRunData: (d)=>({
                        outputs: [
                            {
                                dims: e1.dims,
                                dataType: i
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(x.size(d[0].dims) / 64 / 4)
                        },
                        programUniforms: u
                    })
            };
        }, si = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Abs", "abs"));
        }, ai = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Acos", "acos"));
        }, ui = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Acosh", "acosh"));
        }, di = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Asin", "asin"));
        }, li = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Asinh", "asinh"));
        }, ci = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Atan", "atan"));
        }, pi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Atanh", "atanh"));
        }, mi = (e1)=>G(e1), fi = (e1, t)=>{
            let n;
            switch(t.to){
                case 10:
                    n = "vec4<f16>";
                    break;
                case 1:
                    n = "vec4<f32>";
                    break;
                case 12:
                    n = "vec4<u32>";
                    break;
                case 6:
                    n = "vec4<i32>";
                    break;
                case 9:
                    n = "vec4<bool>";
                    break;
                default:
                    throw new RangeError(`not supported type (specified in attribute 'to' from 'Cast' operator): ${t.to}`);
            }
            e1.compute(ee(e1.inputs[0], "Cast", n, void 0, t.cacheKey, t.to));
        }, Zd = (e1)=>{
            let t, n, r = e1.length >= 2 && e1[1].data !== 0, o = e1.length >= 3 && e1[2].data !== 0;
            switch(e1[0].dataType){
                case 1:
                    t = r ? e1[1].getFloat32Array()[0] : -340282346638528860000000000000000000000, n = o ? e1[2].getFloat32Array()[0] : 34028234663852886e22;
                    break;
                case 10:
                    t = r ? e1[1].getUint16Array()[0] : 64511, n = o ? e1[2].getUint16Array()[0] : 31743;
                    break;
                default:
                    throw new Error("Unsupport data type");
            }
            return G({
                min: t,
                max: n
            });
        }, hi = (e1, t)=>{
            let n = t || Zd(e1.inputs), r = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "Clip", (o)=>`clamp(${o}, vec4<${r}>(uniforms.min), vec4<${r}>(uniforms.max))`, void 0, n.cacheKey, void 0, [
                {
                    type: e1.inputs[0].dataType,
                    data: n.min
                },
                {
                    type: e1.inputs[0].dataType,
                    data: n.max
                }
            ], [
                {
                    name: "min",
                    type: r
                },
                {
                    name: "max",
                    type: r
                }
            ]), {
                inputs: [
                    0
                ]
            });
        }, gi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Ceil", "ceil"));
        }, yi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Cos", "cos"));
        }, bi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Cosh", "cosh"));
        }, yt = (e1)=>G(e1), _i = (e1, t)=>{
            let n = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "Elu", (r)=>`elu_vf32(${r})`, `
  const elu_alpha_ = ${n}(${t.alpha});

  fn elu_f32(a: ${n}) -> ${n} {
  return select((exp(a) - 1.0) * elu_alpha_, a, a >= 0.0);
  }

  fn elu_vf32(v: vec4<${n}>) -> vec4<${n}> {
  return vec4(elu_f32(v.x), elu_f32(v.y), elu_f32(v.z), elu_f32(v.w));
  }`, t.cacheKey));
        }, nn = (e1 = "f32")=>`
const r0: ${e1} = 0.3275911;
const r1: ${e1} = 0.254829592;
const r2: ${e1} = -0.284496736;
const r3: ${e1} = 1.421413741;
const r4: ${e1} = -1.453152027;
const r5: ${e1} = 1.061405429;

fn erf_vf32(v: vec4<${e1}>) -> vec4<${e1}> {
  let absv = abs(v);
  let x = 1.0 / (1.0 + r0 * absv);
  return sign(v) * (1.0 - ((((r5 * x + r4) * x + r3) * x + r2) * x + r1) * x * exp(-absv * absv));
}`, wi = (e1)=>{
            let t = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "Erf", (n)=>`erf_vf32(${n})`, nn(t)));
        }, $i = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Exp", "exp"));
        }, vi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Floor", "floor"));
        }, xi = (e1)=>{
            let t = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "Gelu", (n)=>`0.5 * ${n} * (1.0 + erf_vf32(${n} * 0.7071067811865475))`, nn(t)));
        }, Si = (e1, t)=>{
            let n = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "LeakyRelu", (r)=>`select(leaky_relu_alpha_ * ${r}, ${r}, ${r} >= vec4<${n}>(0.0))`, `const leaky_relu_alpha_ = ${n}(${t.alpha});`, t.cacheKey));
        }, Ti = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Not", (t)=>`!${t}`));
        }, Ii = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Neg", (t)=>`-${t}`));
        }, Ci = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Reciprocal", (t)=>`1.0/${t}`));
        }, Ai = (e1)=>{
            let t = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "Relu", (n)=>`select(vec4<${t}>(0.0), ${n}, ${n} > vec4<${t}>(0.0))`));
        }, Ei = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Sigmoid", (t)=>`(1.0 / (1.0 + exp(-${t})))`));
        }, ki = (e1)=>G(e1), Pi = (e1, t)=>{
            let n = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "HardSigmoid", (r)=>`max(vec4<${n}>(0.0), min(vec4<${n}>(1.0), ${t.alpha} * ${r} + vec4<${n}>(${t.beta})))`, void 0, t.cacheKey));
        }, zi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Sin", "sin"));
        }, Bi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Sinh", "sinh"));
        }, Di = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Sqrt", "sqrt"));
        }, Oi = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Tan", "tan"));
        }, Mi = (e1)=>`sign(${e1}) * (1 - exp(-2 * abs(${e1}))) / (1 + exp(-2 * abs(${e1})))`, Ui = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Tanh", Mi));
        }, Qn = (e1 = "f32")=>`
const fast_gelu_a: ${e1} = 0.5;
const fast_gelu_b: ${e1} = 0.7978845608028654;
const fast_gelu_c: ${e1} = 0.035677408136300125;

fn tanh_v(v: vec4<${e1}>) -> vec4<${e1}> {
  return ${Mi("v")};
}
`, Xn = (e1)=>`(fast_gelu_a + fast_gelu_a * tanh_v(${e1} * (fast_gelu_c * ${e1} * ${e1} + fast_gelu_b))) * ${e1}`, Ri = (e1)=>{
            let t = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "FastGelu", Xn, Qn(t), void 0, e1.inputs[0].dataType));
        }, Vi = (e1, t)=>{
            let n = ce(e1.inputs[0].dataType);
            return e1.compute(ee(e1.inputs[0], "ThresholdedRelu", (r)=>`select(vec4<${n}>(0.0), ${r}, ${r} > thresholded_relu_alpha_)`, `const thresholded_relu_alpha_ = vec4<${n}>(${t.alpha});`, t.cacheKey)), 0;
        }, Ni = (e1)=>{
            e1.compute(ee(e1.inputs[0], "Log", "log"));
        }, Qd = (e1, t)=>`
const alpha = vec4<${e1}>(${t});
const one = ${e1}(1.0);
const zero = ${e1}(0.0);

fn quick_gelu_impl(x: vec4<${e1}>) -> vec4<${e1}> {
  let v = x *alpha;
  var x1 : vec4<${e1}>;
  for (var i = 0; i < 4; i = i + 1) {
    if (v[i] >= zero) {
      x1[i] = one / (one + exp(-v[i]));
    } else {
      x1[i] = one - one / (one + exp(v[i]));
    }
  }
  return x * x1;
}
`, Xd = (e1)=>`quick_gelu_impl(${e1})`, Li = (e1, t)=>{
            let n = ce(e1.inputs[0].dataType);
            e1.compute(ee(e1.inputs[0], "QuickGelu", Xd, Qd(n, t.alpha), t.cacheKey, e1.inputs[0].dataType));
        };
    });
    var Yd, Jd, Wi, Hi = k(()=>{
        "use strict";
        F();
        j();
        rn();
        Yd = (e1)=>{
            if (e1[0].dims.length !== 3) throw new Error("input should have 3 dimensions");
            if (![
                2560,
                5120,
                10240
            ].includes(e1[0].dims[2])) throw new Error("hidden state should be 2560, 5120 or 10240");
            if (e1[1].dims.length !== 1) throw new Error("bias is expected to have 1 dimensions");
            if (e1[0].dims[2] !== e1[1].dims[0]) throw new Error("last dimension of input and bias are not the same");
        }, Jd = (e1)=>{
            let t = e1[0].dims.slice();
            t[2] = t[2] / 2;
            let n = S("input", e1[0].dataType, e1[0].dims, 4), r = S("bias", e1[0].dataType, [
                e1[0].dims[2]
            ], 4), o = C("output", e1[0].dataType, t, 4), i = x.size(t) / 4, s = re(e1[0].dataType);
            return {
                name: "BiasSplitGelu",
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: t,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(i / 64)
                        }
                    }),
                getShaderSource: (u)=>`
  const M_SQRT2 = sqrt(2.0);
  const halfChannels = ${e1[0].dims[2] / 4 / 2}u;

  ${u.declareVariables(n, r, o)}

  ${nn(s)}

  ${u.mainStart()}
    ${u.guardAgainstOutOfBoundsWorkgroupSizes(i)}
    let biasIdx = global_idx % halfChannels;
    let batchIndex = global_idx / halfChannels;
    let inputOffset = biasIdx + batchIndex * halfChannels * 2;
    let valueLeft = input[inputOffset] + bias[biasIdx];
    let valueRight = input[inputOffset + halfChannels] + bias[biasIdx + halfChannels];
    let geluRight = valueRight * 0.5 * (erf_vf32(valueRight / M_SQRT2) + 1);

    ${o.setByOffset("global_idx", "valueLeft * geluRight")}
  }`
            };
        }, Wi = (e1)=>{
            Yd(e1.inputs), e1.compute(Jd(e1.inputs));
        };
    });
    var el, tl, Me, qi, Fi, Ki, ji, Zi, Qi, Xi, Yi, Ji, es, ts = k(()=>{
        "use strict";
        L();
        F();
        j();
        el = (e1, t, n, r, o, i, s, a, u, d, l, c)=>{
            let p, f;
            typeof a == "string" ? p = f = (g, _)=>`${a}((${g}),(${_}))` : typeof a == "function" ? p = f = a : (p = a.scalar, f = a.vector);
            let m = C("outputData", l, r.length, 4), h = S("aData", u, t.length, 4), b = S("bData", d, n.length, 4), y;
            if (o) {
                if (i) {
                    let g = x.size(t) === 1, _ = x.size(n) === 1, w = t.length > 0 && t[t.length - 1] % 4 === 0, v = n.length > 0 && n[n.length - 1] % 4 === 0;
                    g || _ ? y = m.setByOffset("global_idx", f(g ? `${h.type.value}(${h.getByOffset("0")}.x)` : h.getByOffset("global_idx"), _ ? `${b.type.value}(${b.getByOffset("0")}.x)` : b.getByOffset("global_idx"))) : y = `
            let outputIndices = ${m.offsetToIndices("global_idx * 4u")};
            let offsetA = ${h.broadcastedIndicesToOffset("outputIndices", m)};
            let offsetB = ${b.broadcastedIndicesToOffset("outputIndices", m)};
            ${m.setByOffset("global_idx", f(s || w ? h.getByOffset("offsetA / 4u") : `${h.type.value}(${h.getByOffset("offsetA / 4u")}[offsetA % 4u])`, s || v ? b.getByOffset("offsetB / 4u") : `${b.type.value}(${b.getByOffset("offsetB / 4u")}[offsetB % 4u])`))}
          `;
                } else y = m.setByOffset("global_idx", f(h.getByOffset("global_idx"), b.getByOffset("global_idx")));
            } else {
                if (!i) throw new Error("no necessary to use scalar implementation for element-wise binary op implementation.");
                let g = (_, w, v = "")=>{
                    let $ = `aData[indexA${w}][componentA${w}]`, T = `bData[indexB${w}][componentB${w}]`;
                    return `
            let outputIndices${w} = ${m.offsetToIndices(`global_idx * 4u + ${w}u`)};
            let offsetA${w} = ${h.broadcastedIndicesToOffset(`outputIndices${w}`, m)};
            let offsetB${w} = ${b.broadcastedIndicesToOffset(`outputIndices${w}`, m)};
            let indexA${w} = offsetA${w} / 4u;
            let indexB${w} = offsetB${w} / 4u;
            let componentA${w} = offsetA${w} % 4u;
            let componentB${w} = offsetB${w} % 4u;
            ${_}[${w}] = ${v}(${p($, T)});
          `;
                };
                l === 9 ? y = `
            var data = vec4<u32>(0);
            ${g("data", 0, "u32")}
            ${g("data", 1, "u32")}
            ${g("data", 2, "u32")}
            ${g("data", 3, "u32")}
            outputData[global_idx] = dot(vec4<u32>(0x1, 0x100, 0x10000, 0x1000000), vec4<u32>(data));` : y = `
            ${g("outputData[global_idx]", 0)}
            ${g("outputData[global_idx]", 1)}
            ${g("outputData[global_idx]", 2)}
            ${g("outputData[global_idx]", 3)}
          `;
            }
            return `
        ${e1.registerUniform("vec_size", "u32").declareVariables(h, b, m)}

        ${c ?? ""}

        ${e1.mainStart()}
        ${e1.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.vec_size")}
        ${y}
      }`;
        }, tl = (e1, t, n, r, o, i, s = n.dataType)=>{
            let a = n.dims.map(Number), u = r.dims.map(Number), d = !x.areEqual(a, u), l = a, c = x.size(a), p = !1, f = !1, m = [
                d
            ];
            if (d) {
                let h = Pe.calcShape(a, u, !1);
                if (!h) throw new Error("Can't perform binary op on the given tensors");
                l = h.slice(), c = x.size(l);
                let b = x.size(a) === 1, y = x.size(u) === 1, g = a.length > 0 && a[a.length - 1] % 4 === 0, _ = u.length > 0 && u[u.length - 1] % 4 === 0;
                m.push(b), m.push(y), m.push(g), m.push(_);
                let w = 1;
                for(let v = 1; v < l.length; v++){
                    let $ = a[a.length - v], T = u[u.length - v];
                    if ($ === T) w *= $;
                    else break;
                }
                w % 4 === 0 ? (f = !0, p = !0) : (b || y || g || _) && (p = !0);
            } else p = !0;
            return m.push(p), {
                name: e1,
                shaderCache: {
                    hint: t + m.map((h)=>h.toString()).join("_"),
                    inputDependencies: [
                        "rank",
                        "rank"
                    ]
                },
                getShaderSource: (h)=>el(h, a, u, l, p, d, f, o, n.dataType, r.dataType, s, i),
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: l,
                                dataType: s
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(c / 64 / 4)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: Math.ceil(x.size(l) / 4)
                            },
                            ...P(a, u, l)
                        ]
                    })
            };
        }, Me = (e1, t, n, r, o, i)=>{
            e1.compute(tl(t, o ?? "", e1.inputs[0], e1.inputs[1], n, r, i));
        }, qi = (e1)=>{
            Me(e1, "Add", (t, n)=>`${t}+${n}`);
        }, Fi = (e1)=>{
            Me(e1, "Div", (t, n)=>`${t}/${n}`);
        }, Ki = (e1)=>{
            Me(e1, "Equal", {
                scalar: (t, n)=>`u32(${t}==${n})`,
                vector: (t, n)=>`vec4<u32>(${t}==${n})`
            }, void 0, void 0, 9);
        }, ji = (e1)=>{
            Me(e1, "Mul", (t, n)=>`${t}*${n}`);
        }, Zi = (e1)=>{
            let t = S("input", e1.inputs[0].dataType, e1.inputs[0].dims).type.value;
            Me(e1, "Pow", {
                scalar: (r, o)=>`pow_custom(${r},${o})`,
                vector: (r, o)=>`pow_vector_custom(${r},${o})`
            }, `
    fn pow_custom(a : ${t}, b : ${t}) -> ${t} {
      if (b == ${t}(0.0)) {
        return ${t}(1.0);
      } else if (a < ${t}(0.0) && f32(b) != floor(f32(b))) {
        return ${t}(pow(f32(a), f32(b))); // NaN
      }
      return select(sign(a), ${t}(1.0), round(f32(abs(b) % ${t}(2.0))) != 1.0) * ${t}(${t === "i32" ? "round" : ""}(pow(f32(abs(a)), f32(b))));
    }
    fn pow_vector_custom(a : vec4<${t}>, b : vec4<${t}>) -> vec4<${t}> {
      // TODO: implement vectorized pow
      return vec4<${t}>(pow_custom(a.x, b.x), pow_custom(a.y, b.y), pow_custom(a.z, b.z), pow_custom(a.w, b.w));
    }
      `);
        }, Qi = (e1)=>{
            Me(e1, "Sub", (t, n)=>`${t}-${n}`);
        }, Xi = (e1)=>{
            Me(e1, "Greater", {
                scalar: (t, n)=>`u32(${t}>${n})`,
                vector: (t, n)=>`vec4<u32>(${t}>${n})`
            }, void 0, void 0, 9);
        }, Yi = (e1)=>{
            Me(e1, "Less", {
                scalar: (t, n)=>`u32(${t}<${n})`,
                vector: (t, n)=>`vec4<u32>(${t}<${n})`
            }, void 0, void 0, 9);
        }, Ji = (e1)=>{
            Me(e1, "GreaterOrEqual", {
                scalar: (t, n)=>`u32(${t}>=${n})`,
                vector: (t, n)=>`vec4<u32>(${t}>=${n})`
            }, void 0, void 0, 9);
        }, es = (e1)=>{
            Me(e1, "LessOrEqual", {
                scalar: (t, n)=>`u32(${t}<=${n})`,
                vector: (t, n)=>`vec4<u32>(${t}<=${n})`
            }, void 0, void 0, 9);
        };
    });
    var rl, ol, il, sl, ns, rs, os = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        rl = (e1, t)=>{
            if (!e1 || e1.length < 1) throw new Error("too few inputs");
            let n = 0, r = e1[n], o = r.dataType, i = r.dims.length;
            e1.forEach((s, a)=>{
                if (a !== n) {
                    if (s.dataType !== o) throw new Error("input tensors should be one type");
                    if (s.dims.length !== i) throw new Error("input tensors should have the same shape");
                    s.dims.forEach((u, d)=>{
                        if (d !== t && u !== r.dims[d]) throw new Error("non concat dimensions must match");
                    });
                }
            });
        }, ol = (e1, t)=>`
  fn calculateInputIndex(index: u32) -> u32 {
    let sizeInConcatAxis = array<u32, ${e1}u>(${t});
    for (var i: u32 = 0u; i < ${e1}; i += 1u ) {
      if (index < sizeInConcatAxis[i]) {
        return i;
      }
    }
    return ${e1}u;
  }`, il = (e1, t)=>{
            let n = e1.length, r = [];
            for(let o = 0; o < n; ++o){
                let i = t.setByOffset("global_idx", e1[o].getByIndices("indices"));
                n === 1 ? r.push(i) : o === 0 ? r.push(`if (inputIndex == ${o}u) { ${i} }`) : o === n - 1 ? r.push(`else { ${i} }`) : r.push(`else if (inputIndex == ${o}) { ${i} }`);
            }
            return r.join(`
`);
        }, sl = (e1, t, n, r)=>{
            let o = x.size(n), i = new Array(e1.length), s = new Array(e1.length), a = 0, u = [], d = [], l = [
                {
                    type: 12,
                    data: o
                }
            ];
            for(let h = 0; h < e1.length; ++h)a += e1[h].dims[t], i[h] = a, d.push(e1[h].dims.length), s[h] = S(`input${h}`, r, d[h]), u.push("rank"), l.push({
                type: 12,
                data: i[h]
            });
            for(let h = 0; h < e1.length; ++h)l.push(...P(e1[h].dims));
            l.push(...P(n));
            let c = C("output", r, n.length), p = c.indicesGet("indices", t), f = Array.from(Array(i.length).keys()).map((h)=>`uniforms.sizeInConcatAxis${h}`).join(","), m = (h)=>`

  ${(()=>{
                    h.registerUniform("outputSize", "u32");
                    for(let b = 0; b < e1.length; b++)h.registerUniform(`sizeInConcatAxis${b}`, "u32");
                    return h.declareVariables(...s, c);
                })()}

  ${ol(i.length, f)}

  ${h.mainStart()}
    ${h.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}

    var indices = ${c.offsetToIndices("global_idx")};

    let inputIndex = calculateInputIndex(${p});
    if (inputIndex != 0u) {
      let sizeInConcatAxis = array<u32, ${i.length}u>(${f});
      ${p} -= sizeInConcatAxis[inputIndex - 1u];
    }

    ${il(s, c)}
  }`;
            return {
                name: "Concat",
                shaderCache: {
                    hint: `${t}`,
                    inputDependencies: u
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: n,
                                dataType: r
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(o / 64)
                        },
                        programUniforms: l
                    }),
                getShaderSource: m
            };
        }, ns = (e1, t)=>{
            let n = e1.inputs, r = n[0].dims, o = x.normalizeAxis(t.axis, r.length);
            rl(n, o);
            let i = r.slice();
            i[o] = n.reduce((a, u)=>a + (u.dims.length > o ? u.dims[o] : 0), 0);
            let s = n.filter((a)=>x.size(a.dims) > 0);
            e1.compute(sl(s, o, i, n[0].dataType), {
                inputs: s
            });
        }, rs = (e1)=>G({
                axis: e1.axis
            });
    });
    var Ie, Ce, Ae, on, Fe = k(()=>{
        "use strict";
        L();
        F();
        Ie = (e1, t, n = "f32")=>{
            switch(e1.activation){
                case "Relu":
                    return `value = max(value, ${t}(0.0));`;
                case "Sigmoid":
                    return `value = (${t}(1.0) / (${t}(1.0) + exp(-value)));`;
                case "Clip":
                    return `value = clamp(value, ${t}(${n}(uniforms.clip_min)), ${t}(${n}(uniforms.clip_max)));`;
                case "HardSigmoid":
                    return `value = max(${t}(0.0), min(${t}(1.0), ${n}(uniforms.alpha) * value + ${n}(uniforms.beta)));`;
                case "LeakyRelu":
                    return `value = select(${n}(uniforms.alpha) * value, value, value >= ${t}(0.0));`;
                case "Tanh":
                    return `let e2x = exp(-2.0 * abs(value));
              value = sign(value) * (1.0 - e2x) / (1.0 + e2x);
        `;
                case "":
                    return "";
                default:
                    throw new Error(`Unsupported activation ${e1.activation}`);
            }
        }, Ce = (e1, t)=>{
            e1.activation === "Clip" ? t.push({
                type: 1,
                data: e1.clipMax
            }, {
                type: 1,
                data: e1.clipMin
            }) : e1.activation === "HardSigmoid" ? t.push({
                type: 1,
                data: e1.alpha
            }, {
                type: 1,
                data: e1.beta
            }) : e1.activation === "LeakyRelu" && t.push({
                type: 1,
                data: e1.alpha
            });
        }, Ae = (e1, t)=>{
            e1.activation === "Clip" ? t.push({
                name: "clip_max",
                type: "f32"
            }, {
                name: "clip_min",
                type: "f32"
            }) : e1.activation === "HardSigmoid" ? t.push({
                name: "alpha",
                type: "f32"
            }, {
                name: "beta",
                type: "f32"
            }) : e1.activation === "LeakyRelu" && t.push({
                name: "alpha",
                type: "f32"
            });
        }, on = (e1)=>{
            let t = e1?.activation || "";
            if (t === "HardSigmoid") {
                let [n, r] = e1?.activation_params || [
                    .2,
                    .5
                ];
                return {
                    activation: t,
                    alpha: n,
                    beta: r
                };
            } else if (t === "Clip") {
                let [n, r] = e1?.activation_params || [
                    co,
                    po
                ];
                return {
                    activation: t,
                    clipMax: r,
                    clipMin: n
                };
            } else if (t === "LeakyRelu") {
                let [n] = e1?.activation_params || [
                    .01
                ];
                return {
                    activation: t,
                    alpha: n
                };
            }
            return {
                activation: t
            };
        };
    });
    var ue, is, sn = k(()=>{
        "use strict";
        ue = (e1, t)=>{
            switch(e1){
                case 1:
                    return t;
                case 2:
                    return `vec2<${t}>`;
                case 3:
                    return `vec3<${t}>`;
                case 4:
                    return `vec4<${t}>`;
                default:
                    throw new Error(`${e1}-component is not supported.`);
            }
        }, is = (e1)=>`
      ${e1 ? "value = value + getBiasByOutputCoords(coords);" : ""}
      `;
    });
    var ss, as = k(()=>{
        "use strict";
        ss = (e1)=>`
fn getIndexFromCoords4D(coords : vec4<i32>, shape : vec4<i32>) -> i32 {
  return dot(coords, vec4<i32>(
      shape.y * shape.z * shape.w, shape.z * shape.w, shape.w, 1));
}
fn getOutputIndexFromCoords(coords : vec4<i32>) -> i32 {
  return dot(coords, vec4<i32>(
    i32(${e1}.x), i32(${e1}.y), i32(${e1}.z), 1));
}
`;
    });
    var bt, an, un = k(()=>{
        "use strict";
        L();
        F();
        j();
        Fe();
        bt = (e1, t, n, r, o)=>{
            let i = r - n;
            return `
      ${Array.from({
                length: n
            }).map((s, a)=>`
      if (${B(t.shape, a, t.rank)} != 1) {
        ${t.indicesSet(e1, a, B(o, a + i, r))}
      } else {
        ${t.indicesSet(e1, a, 0)}
      }`).join("")}
`;
        }, an = (e1, t, n, r, o = !1, i)=>{
            let s = e1[0].dims, a = e1[1].dims, u = s[s.length - 2], d = a[a.length - 1], l = s[s.length - 1], c = J(d), p = J(l), f = J(u), m = x.size(n) / c / f, h = e1.length > 2, b = r ? r.slice(0, -2) : n.slice(0, -2), g = [
                x.size(b),
                u,
                d
            ], _ = [
                {
                    type: 12,
                    data: m
                },
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: d
                },
                {
                    type: 12,
                    data: l
                }
            ];
            Ce(t, _), _.push(...P(b, s, a)), h && _.push(...P(e1[2].dims)), _.push(...P(g));
            let w = (v)=>{
                let $ = Yt("batch_dims", e1[0].dataType, b.length), T = S("a", e1[0].dataType, s.length, p), I = S("b", e1[1].dataType, a.length, c), A = C("output", e1[0].dataType, g.length, c), z = re(A.type.tensor), R = Ie(t, A.type.value, z), D = [
                    T,
                    I
                ], U = "";
                if (h) {
                    let M = o ? c : 1;
                    D.push(S("bias", e1[2].dataType, e1[2].dims.length, M)), U = `${o ? `value += bias[col / ${M}];` : `value += ${A.type.value}(bias[row + i]);`}`;
                }
                let Q = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    }
                ];
                Ae(t, Q);
                let O = ()=>{
                    let M = `var a_data: ${T.type.value};`;
                    for(let V = 0; V < p; V++)M += `
              let b_data${V} = b[(b_offset + (k + ${V}) * uniforms.N + col) / ${c}];`;
                    for(let V = 0; V < f; V++){
                        M += `a_data = a[(a_offset + (row + ${V}) * uniforms.K + k) / ${p}];`;
                        for(let W = 0; W < p; W++)M += `
            values[${V}] = fma(${I.type.value}(a_data${p === 1 ? "" : `[${W}]`}), b_data${W}, values[${V}]);
`;
                    }
                    return M;
                };
                return `
  ${v.registerUniforms(Q).registerInternalVariables($).declareVariables(...D, A)}
  ${v.mainStart()}
    ${v.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    let col = (global_idx % (uniforms.N / ${c})) * ${c};
    var index1 = global_idx / (uniforms.N / ${c});
    let stride1 = uniforms.M / ${f};
    let row = (index1 % stride1) * ${f};
    let batch = index1 / stride1;

    ${n.length === 2 ? "" : `let batch_indices = ${$.offsetToIndices("batch")};`}

    var a_indices: ${T.type.indices};
    ${bt("a_indices", T, T.rank - 2, $.rank, "batch_indices")}
    ${T.indicesSet("a_indices", T.rank - 2, 0)}
    ${T.indicesSet("a_indices", T.rank - 1, 0)}
    let a_offset = ${T.indicesToOffset("a_indices")};

    var b_indices: ${I.type.indices};
    ${bt("b_indices", I, I.rank - 2, $.rank, "batch_indices")}
    ${I.indicesSet("b_indices", I.rank - 2, 0)}
    ${I.indicesSet("b_indices", I.rank - 1, 0)}
    let b_offset = ${I.indicesToOffset("b_indices")};
    var values: array<${A.type.value}, ${f}>;
    for (var k: u32 = 0u; k < uniforms.K; k = k + ${p}) {
      ${O()}
    }
    for (var i = 0u; i < ${f}u; i++) {
      var value = values[i];
      ${U}
      ${R}
      let cur_indices = ${A.type.indices}(batch, row + i, col);
      let offset = ${A.indicesToOffset("cur_indices")};
      ${A.setByOffset(`offset / ${c}`, "value")};
    }
  }
  `;
            };
            return {
                name: "MatMulNaive",
                shaderCache: {
                    hint: `${t.activation};${c};${p};${f};${o}`,
                    inputDependencies: h ? [
                        "rank",
                        "rank",
                        "rank"
                    ] : [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i ? i(n) : n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(m / 64)
                        },
                        programUniforms: _
                    }),
                getShaderSource: w
            };
        };
    });
    var al, ul, Yn, us, dl, Jn, ll, _t, dn = k(()=>{
        "use strict";
        L();
        F();
        j();
        Fe();
        un();
        sn();
        al = (e1, t)=>e1 ? `
        mm_Asub[inputRow][inputCol] = mm_readA(batch,
          kStart + inputRow,
          globalRowStart / innerElementSize + inputCol${t ? ", batchIndices" : ""});
        ` : `
        mm_Asub[inputRow][inputCol] = mm_readA(batch,
          globalRow + innerRow,
          kStart / innerElementSize + inputCol${t ? ", batchIndices" : ""});
        `, ul = (e1, t)=>e1 ? `
        let ACached0 = mm_Asub[k * innerElementSize][localRow];
        let ACached1 = mm_Asub[k * innerElementSize + 1][localRow];
        let ACached2 = mm_Asub[k * innerElementSize + 2][localRow];
        ${t === 3 ? "" : "let ACached3 = mm_Asub[k * innerElementSize + 3][localRow];"}
        for (var i = 0; i < rowPerThread; i = i + 1) {
          acc[i] = BCached0 * ACached0[i] + acc[i];
          acc[i] = BCached1 * ACached1[i] + acc[i];
          acc[i] = BCached2 * ACached2[i] + acc[i];
          ${t === 3 ? "" : "acc[i] = BCached3 * ACached3[i] + acc[i];"}
        }` : `
        for (var i = 0; i < rowPerThread; i = i + 1) {
          let ACached = mm_Asub[tileRow + i][k];
          acc[i] = BCached0 * ACached.x + acc[i];
          acc[i] = BCached1 * ACached.y + acc[i];
          acc[i] = BCached2 * ACached.z + acc[i];
          ${t === 3 ? "" : "acc[i] = BCached3 * ACached.w + acc[i];"}
        }`, Yn = (e1, t, n = "f32", r, o = !1, i = 32, s = !1, a = 32)=>{
            let u = t[1] * e1[1], d = t[0] * e1[0], l = o ? u : i, c = o ? i : u, p = l / t[0], f = i / t[1];
            if (!((o && p === 4 && e1[1] === 4 || !o && (p === 3 || p === 4)) && l % t[0] === 0 && i % t[1] === 0 && e1[0] === 4)) throw new Error(`If transposeA ${o} is true, innerElementSize ${p} and workPerThread[1] ${e1[1]} must be 4.
      Otherwise, innerElementSize ${p} must be 3 or 4.
  tileAWidth ${l} must be divisible by workgroupSize[0]${t[0]}. tileInner ${i} must be divisible by workgroupSize[1] ${t[1]}. colPerThread ${e1[0]} must be 4.`);
            return `
var<workgroup> mm_Asub: array<array<vec${p}<${n}>, ${l / p}>, ${c}>;
var<workgroup> mm_Bsub: array<array<vec4<${n}>, ${d / e1[0]}>, ${i}>;

const rowPerThread = ${e1[1]};
const colPerThread = ${e1[0]};
const innerElementSize = ${p};
const tileInner = ${i};

@compute @workgroup_size(${t[0]}, ${t[1]}, ${t[2]})
fn main(@builtin(local_invocation_id) localId : vec3<u32>,
        @builtin(global_invocation_id) globalId : vec3<u32>,
        @builtin(workgroup_id) workgroupId : vec3<u32>) {
  let localRow = i32(localId.y);
  let tileRow = localRow * rowPerThread;
  let tileCol = i32(localId.x);

  let globalRow =i32(globalId.y) * rowPerThread;
  let globalCol = i32(globalId.x);
  let batch = ${s ? "0" : "i32(globalId.z)"};
  ${r ? `let batchIndices = ${r.offsetToIndices("u32(batch)")};` : ""}
  let globalRowStart = i32(workgroupId.y) * ${u};

  let num_tiles = ${s ? `${Math.ceil(a / i)}` : "(uniforms.dim_inner - 1) / tileInner + 1"};
  var kStart = ${s ? `i32(globalId.z) * ${a}` : "0"};

  var acc: array<vec4<${n}>, rowPerThread>;

  // Loop over shared dimension.
  let tileRowB = localRow * ${f};
  for (var t = 0; t < num_tiles; t = t + 1) {
      // Load one tile of A into local memory.
      for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
          let inputRow = tileRow + innerRow;
          let inputCol = tileCol;
          ${al(o, r)}
      }

      // Load one tile of B into local memory.
      for (var innerRow = 0; innerRow < ${f}; innerRow = innerRow + 1) {
          let inputRow = tileRowB + innerRow;
          let inputCol = tileCol;
          mm_Bsub[inputRow][inputCol] = mm_readB(batch, kStart + inputRow, globalCol${r ? ", batchIndices" : ""});
      }
      kStart = kStart + tileInner;
      workgroupBarrier();

      // Compute acc values for a single thread.
      for (var k = 0; k < tileInner / innerElementSize; k = k + 1) {
          let BCached0 = mm_Bsub[k * innerElementSize][tileCol];
          let BCached1 = mm_Bsub[k * innerElementSize + 1][tileCol];
          let BCached2 = mm_Bsub[k * innerElementSize + 2][tileCol];
          ${p === 3 ? "" : "let BCached3 = mm_Bsub[k * innerElementSize + 3][tileCol];"}

          ${ul(o, p)}
      }

      workgroupBarrier();
  }

  for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
      mm_write(batch, globalRow + innerRow, globalCol, acc[innerRow]);
  }
}`;
        }, us = (e1, t)=>e1 ? `
            mm_Asub[inputRow][inputCol] = mm_readA(batch,
              kStart + inputRow,
              globalRowStart + inputCol${t ? ", batchIndices" : ""});
            ` : `
            mm_Asub[inputRow][inputCol] = mm_readA(batch,
              globalRowStart + inputRow,
              kStart + inputCol${t ? ", batchIndices" : ""});
            `, dl = (e1)=>e1 ? "let ACached = mm_Asub[k][tileRow + innerRow];" : "let ACached = mm_Asub[tileRow + innerRow][k];", Jn = (e1, t, n = "f32", r, o = !1, i = 32, s = !1, a = 32, u = !1)=>{
            let d = e1[1] * t[1], l = e1[0] * t[0], c = o ? d : i, p = o ? i : d;
            if (!(p % t[1] === 0 && c % t[0] === 0 && i % t[1] === 0)) throw new Error(`tileAHight ${p} must be divisible by workgroupSize[1]${t[1]}, tileAWidth ${c} must be divisible by workgroupSize[0]${t[0]}, tileInner ${i} must be divisible by workgroupSize[1]${t[1]}`);
            let f = p / t[1], m = c / t[0], h = i / t[1], b = u ? `
    let localRow = i32(localId.y);
    let localCol = i32(localId.x);
    let globalRowStart = i32(workgroupId.y) * ${d};
    let globalColStart = i32(workgroupId.x) * ${l};

    // Loop over shared dimension.
    for (var t = 0; t < num_tiles; t = t + 1) {
      // Load one tile of A into local memory.
      for (var inputRow = localRow; inputRow < ${p}; inputRow = inputRow + ${t[1]}) {
        for (var inputCol = localCol; inputCol < ${c}; inputCol = inputCol + ${t[0]}) {
          ${us(o, r)}
        }
      }
      // Load one tile of B into local memory.
      for (var inputRow = localRow; inputRow < ${i}; inputRow = inputRow + ${t[1]}) {
            for (var inputCol = localCol; inputCol < ${l}; inputCol = inputCol + ${t[0]}) {
          mm_Bsub[inputRow][inputCol] = mm_readB(batch,
            kStart + inputRow,
            globalColStart + inputCol${r ? ", batchIndices" : ""});
        }
      }
      kStart = kStart + tileInner;
      workgroupBarrier();

      // Compute acc values for a single thread.
      var BCached : array<${n}, colPerThread>;
      for (var k = 0; k < tileInner; k = k + 1) {
        for (var inner = 0; inner < colPerThread; inner = inner + 1) {
          BCached[inner] = mm_Bsub[k][localCol + inner * ${t[0]}];
        }
        for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
          let ACached = ${o ? `mm_Asub[k][localRow + innerRow * ${t[1]}];` : `mm_Asub[localRow + innerRow * ${t[1]}][k];`}
          for (var innerCol = 0; innerCol < colPerThread; innerCol = innerCol + 1) {
            acc[innerRow][innerCol] = acc[innerRow][innerCol] +
                ACached * BCached[innerCol];
          }
        }
      }
      workgroupBarrier();
    }
    for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
      let gRow = globalRowStart + localRow + innerRow * ${t[1]};
      for (var innerCol = 0; innerCol < colPerThread; innerCol = innerCol + 1) {
        let gCol = globalColStart + localCol + innerCol * ${t[0]};
        mm_write(batch, gRow, gCol, acc[innerRow][innerCol]);
      }
    }
    ` : `
let tileRow = i32(localId.y) * rowPerThread;
let tileCol = i32(localId.x) * colPerThread;

let globalRow = i32(globalId.y) * rowPerThread;
let globalCol = i32(globalId.x) * colPerThread;
let globalRowStart = i32(workgroupId.y) * ${d};

let tileRowA = i32(localId.y) * ${f};
let tileColA = i32(localId.x) * ${m};
let tileRowB = i32(localId.y) * ${h};
// Loop over shared dimension.
for (var t = 0; t < num_tiles; t = t + 1) {
  // Load one tile of A into local memory.
  for (var innerRow = 0; innerRow < ${f}; innerRow = innerRow + 1) {
    for (var innerCol = 0; innerCol < ${m}; innerCol = innerCol + 1) {
      let inputRow = tileRowA + innerRow;
      let inputCol = tileColA + innerCol;
      ${us(o, r)}
    }
  }

  // Load one tile of B into local memory.
  for (var innerRow = 0; innerRow < ${h}; innerRow = innerRow + 1) {
    for (var innerCol = 0; innerCol < colPerThread; innerCol = innerCol + 1) {
      let inputRow = tileRowB + innerRow;
      let inputCol = tileCol + innerCol;
      mm_Bsub[inputRow][inputCol] = mm_readB(batch,
        kStart + inputRow,
        globalCol + innerCol${r ? ", batchIndices" : ""});
    }
  }
  kStart = kStart + tileInner;
  workgroupBarrier();

  // Compute acc values for a single thread.
  var BCached : array<${n}, colPerThread>;
  for (var k = 0; k < tileInner; k = k + 1) {
    for (var inner = 0; inner < colPerThread; inner = inner + 1) {
      BCached[inner] = mm_Bsub[k][tileCol + inner];
    }

    for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
      ${dl(o)}
      for (var innerCol = 0; innerCol < colPerThread; innerCol = innerCol + 1) {
        acc[innerRow][innerCol] = acc[innerRow][innerCol] + ACached * BCached[innerCol];
      }
    }
  }

  workgroupBarrier();
}

for (var innerRow = 0; innerRow < rowPerThread; innerRow = innerRow + 1) {
  for (var innerCol = 0; innerCol < colPerThread; innerCol = innerCol + 1) {
    mm_write(batch, globalRow + innerRow, globalCol + innerCol,
        acc[innerRow][innerCol]);
  }
}
`;
            return `
  var<workgroup> mm_Asub : array<array<${n}, ${c}>, ${p}>;
  var<workgroup> mm_Bsub : array<array<${n}, ${l}>, ${i}>;
  const rowPerThread = ${e1[1]};
  const colPerThread = ${e1[0]};
  const tileInner = ${i};

@compute @workgroup_size(${t[0]}, ${t[1]}, ${t[2]})
fn main(@builtin(local_invocation_id) localId : vec3<u32>,
        @builtin(global_invocation_id) globalId : vec3<u32>,
        @builtin(workgroup_id) workgroupId : vec3<u32>) {
    let batch = ${s ? "0" : "i32(globalId.z)"};
    ${r ? `let batchIndices = ${r.offsetToIndices("u32(batch)")};` : ""}
    let num_tiles = ${s ? `${Math.ceil(a / i)}` : "(uniforms.dim_inner - 1) / tileInner + 1"};
    var kStart = ${s ? `i32(globalId.z) * ${a}` : "0"};

    var acc : array<array<${n}, colPerThread>, rowPerThread>;
    ${b}
  }
`;
        }, ll = (e1, t, n, r, o = !1)=>{
            let [i, s, a, u] = r, d = re(r[0].type.tensor);
            return `
    fn mm_readA(batch: i32, row: i32, colIn: i32, batchIndices: ${i.type.indices}) -> ${ue(e1, d)} {
      var value = ${ue(e1, d)}(0.0);
      let col = colIn * ${e1};
      if(row < uniforms.dim_a_outer && col < uniforms.dim_inner)
      {
        var aIndices: ${s.type.indices};
        ${bt("aIndices", s, s.rank - 2, i.rank, "batchIndices")}
        ${s.indicesSet("aIndices", s.rank - 2, "u32(row)")}
        ${s.indicesSet("aIndices", s.rank - 1, "u32(colIn)")}
        value = ${s.getByIndices("aIndices")};
      }
      return value;
    }

    fn mm_readB(batch: i32, row: i32, colIn: i32, batchIndices: ${i.type.indices}) -> ${ue(e1, d)} {
      var value = ${ue(e1, d)}(0.0);
      let col = colIn * ${e1};
      if(row < uniforms.dim_inner && col < uniforms.dim_b_outer)
      {
        var bIndices: ${a.type.indices};
        ${bt("bIndices", a, a.rank - 2, i.rank, "batchIndices")}
        ${a.indicesSet("bIndices", a.rank - 2, "u32(row)")}
        ${a.indicesSet("bIndices", a.rank - 1, "u32(colIn)")}
        value = ${a.getByIndices("bIndices")};
      }
      return value;
    }

    fn mm_write(batch: i32, row: i32, colIn: i32, valueIn: ${ue(e1, d)}) {
      let col = colIn * ${e1};
      if (row < uniforms.dim_a_outer && col < uniforms.dim_b_outer) {
        var value = valueIn;
        let coords = vec3<i32>(batch, row, colIn);
        ${t ? `value = value + ${o ? "bias[colIn]" : `${ue(e1, d)}(bias[row])`};` : ""}
        ${n}
        ${u.setByIndices("vec3<u32>(coords)", "value")}
      }
    }
    `;
        }, _t = (e1, t, n, r, o = !1, i)=>{
            let s = e1[0].dims, a = e1[1].dims, u = s.slice(0, -2), d = a.slice(0, -2), l = r ? r.slice(0, -2) : n.slice(0, -2), c = x.size(l), p = s[s.length - 2], f = s[s.length - 1], m = a[a.length - 1], h = f % 4 === 0 && m % 4 === 0, b = p <= 8 ? [
                4,
                1,
                1
            ] : [
                4,
                4,
                1
            ], y = [
                8,
                8,
                1
            ], g = [
                Math.ceil(m / y[0] / b[0]),
                Math.ceil(p / y[1] / b[1]),
                Math.ceil(c / y[2] / b[2])
            ], _ = h ? 4 : 1, w = [
                ...u,
                p,
                f / _
            ], v = w.length, $ = [
                ...d,
                f,
                m / _
            ], T = $.length, I = [
                c,
                p,
                m / _
            ], A = [
                {
                    type: 6,
                    data: p
                },
                {
                    type: 6,
                    data: m
                },
                {
                    type: 6,
                    data: f
                }
            ];
            Ce(t, A), A.push(...P(l, w, $));
            let z = [
                "rank",
                "rank"
            ], R = e1.length > 2;
            R && (A.push(...P(e1[2].dims)), z.push("rank")), A.push(...P(I));
            let D = (U)=>{
                let Q = l.length, O = Yt("batchDims", e1[0].dataType, Q, 1), M = re(e1[0].dataType), V = S("a", e1[0].dataType, v, _), W = S("b", e1[1].dataType, T, _), H = C("result", e1[0].dataType, I.length, _), X = [
                    V,
                    W
                ];
                if (R) {
                    let N = o ? _ : 1;
                    X.push(S("bias", e1[2].dataType, e1[2].dims.length, N));
                }
                let oe = [
                    {
                        name: "dim_a_outer",
                        type: "i32"
                    },
                    {
                        name: "dim_b_outer",
                        type: "i32"
                    },
                    {
                        name: "dim_inner",
                        type: "i32"
                    }
                ];
                Ae(t, oe);
                let de = re(H.type.tensor), q = Ie(t, H.type.value, de), E = ll(_, R, q, [
                    O,
                    V,
                    W,
                    H
                ], o);
                return `
  ${U.registerUniforms(oe).registerInternalVariables(O).declareVariables(...X, H)}
  ${E}
  ${h ? Yn(b, y, M, O) : Jn(b, y, M, O)}
                   `;
            };
            return {
                name: "MatMul",
                shaderCache: {
                    hint: `${b};${t.activation};${h};${o}`,
                    inputDependencies: z
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i ? i(n) : n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: g[0],
                            y: g[1],
                            z: g[2]
                        },
                        programUniforms: A
                    }),
                getShaderSource: D
            };
        };
    });
    var cl, ds, ls = k(()=>{
        "use strict";
        L();
        ke();
        j();
        Fe();
        sn();
        as();
        dn();
        cl = (e1, t, n, r, o = !1, i, s = 4, a = 4, u = 4, d = "f32")=>{
            let l = (z)=>{
                switch(z){
                    case 1:
                        return "resData = x[xIndex];";
                    case 3:
                        return `resData = vec3<${d}>(x[xIndex], x[xIndex + 1], x[xIndex + 2]);`;
                    case 4:
                        return "resData = x[xIndex / 4];";
                    default:
                        throw new Error(`innerElementSize ${z} is not supported.`);
                }
            }, c = (z)=>{
                switch(z){
                    case 1:
                        return "return w[row * i32(uniforms.w_shape[3]) + colIn];";
                    case 4:
                        return "return w[row * i32(uniforms.w_shape[3]) / 4 + colIn];";
                    default:
                        throw new Error(`innerElementSize ${z} is not supported.`);
                }
            }, p = e1 ? `
    let coord = vec4<i32>(batch, xRow, xCol, xCh);
    ` : `
    let coord = vec4<i32>(batch, xCh, xRow, xCol);
    `, f = e1 ? `
    let coords = vec4<i32>(
      batch,
      row / outWidth,
      row % outWidth,
      col);
    ` : `
    let coords = vec4<i32>(
      batch,
      row,
      col / outWidth,
      col % outWidth);
    `, m = e1 ? "i32(uniforms.x_shape[1])" : "i32(uniforms.x_shape[2])", h = e1 ? "i32(uniforms.x_shape[2])" : "i32(uniforms.x_shape[3])", b = e1 ? "row" : "col", y = e1 ? "col" : "row", g = `
    let inChannels = i32(uniforms.w_shape[2]);
    let outWidth = ${e1 ? "i32(uniforms.result_shape[2])" : "i32(uniforms.result_shape[3])"};
    let outRow = ${b} / outWidth;
    let outCol = ${b} % outWidth;

    let WRow = ${y} / (i32(uniforms.w_shape[1]) * inChannels);
    let WCol = ${y} / inChannels % i32(uniforms.w_shape[1]);
    let xRow = outRow * uniforms.stride[0] + uniforms.dilation[0] * WRow - uniforms.pad[0];
    let xCol = outCol * uniforms.stride[1] + uniforms.dilation[1] * WCol - uniforms.pad[1];
    let xCh = ${y} % inChannels;
    var resData = ${ue(s, d)}(0.0);
    // The bounds checking is always needed since we use it to pad zero for
    // the 'same' padding type.
    if (xRow >= 0 && xRow < ${m} && xCol >= 0 && xCol < ${h}) {
      ${p}
      let xIndex = getIndexFromCoords4D(coord, vec4<i32>(uniforms.x_shape));
      ${l(s)}
    }
    return resData;`, _ = e1 ? t && r ? `
    let col = colIn * ${s};
    ${g}` : `
    let col = colIn * ${s};
    if (row < uniforms.dim_a_outer && col < uniforms.dim_inner) {
      ${g}
    }
    return ${ue(s, d)}(0.0);` : r && n ? `
    let col = colIn * ${s};
    ${g}` : `
    let col = colIn * ${s};
    if (row < uniforms.dim_inner && col < uniforms.dim_b_outer) {
      ${g}
    }
    return ${ue(s, d)}(0.0);`, w = e1 ? r && n ? c(a) : `
    let col = colIn * ${a};
    if (row < uniforms.dim_inner && col < uniforms.dim_b_outer) {
      ${c(a)}
    }
    return ${ue(a, d)}(0.0);` : `
    let col = colIn * ${a};
    if (row < uniforms.dim_inner && col < uniforms.dim_a_outer) {
      ${c(a)}
    }
    return ${ue(a, d)}(0.0);`, v = ue(u, d), $ = e1 ? ue(s, d) : ue(a, d), T = e1 ? ue(a, d) : ue(s, d), I = Ie(i, v, d);
            return `
    fn mm_readA(batch: i32, row : i32, colIn : i32) -> ${$} {
      ${e1 ? _ : w}
    }

    fn mm_readB(batch: i32, row : i32, colIn : i32) -> ${T} {
      ${e1 ? w : _}
    }

    fn mm_write(batch: i32, row : i32, colIn : i32, valueIn : ${v}) {
      let col = colIn * ${u};
      if (row < uniforms.dim_a_outer && col < uniforms.dim_b_outer)
      {
      var value = valueIn;
      let outWidth = ${e1 ? "i32(uniforms.result_shape[2])" : "i32(uniforms.result_shape[3])"};
      ${f}
      ${is(o)}
      ${I}
      setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
      }
    }`;
        }, ds = (e1, t, n, r, o, i, s, a, u)=>{
            let d = t.format === "NHWC", l = d ? e1[0].dims[3] : e1[0].dims[1], c = n[0], p = d ? n[2] : n[3], f = d ? n[1] : n[2], m = d ? n[3] : n[1], h = d && (l % 4 === 0 || l % 3 === 0) && m % 4 === 0, b = d ? m : p * f, y = d ? p * f : m, g = [
                8,
                8,
                1
            ], _ = r <= 8 ? [
                4,
                1,
                1
            ] : [
                4,
                4,
                1
            ], w = [
                Math.ceil(b / g[0] / _[0]),
                Math.ceil(y / g[1] / _[1]),
                Math.ceil(c / g[2] / _[2])
            ];
            Z("verbose", ()=>`[conv2d_mm_webgpu] dispatch = ${w}`);
            let v = h ? d && l % 4 !== 0 ? 3 : 4 : 1, $ = g[1] * _[1], T = g[0] * _[0], I = Math.max(g[0] * v, g[1]), A = r % $ === 0, z = o % T === 0, R = i % I === 0, D = h ? [
                v,
                4,
                4
            ] : [
                1,
                1,
                1
            ], U = [
                {
                    type: 6,
                    data: r
                },
                {
                    type: 6,
                    data: o
                },
                {
                    type: 6,
                    data: i
                },
                {
                    type: 6,
                    data: [
                        t.pads[0],
                        t.pads[1]
                    ]
                },
                {
                    type: 6,
                    data: t.strides
                },
                {
                    type: 6,
                    data: t.dilations
                }
            ];
            Ce(t, U), U.push(...P(e1[0].dims, e1[1].dims));
            let Q = [
                "rank",
                "rank"
            ];
            s && (U.push(...P(e1[2].dims)), Q.push("rank")), U.push(...P(n));
            let O = (M)=>{
                let V = [
                    {
                        name: "dim_a_outer",
                        type: "i32"
                    },
                    {
                        name: "dim_b_outer",
                        type: "i32"
                    },
                    {
                        name: "dim_inner",
                        type: "i32"
                    },
                    {
                        name: "pad",
                        type: "i32",
                        length: 2
                    },
                    {
                        name: "stride",
                        type: "i32",
                        length: 2
                    },
                    {
                        name: "dilation",
                        type: "i32",
                        length: 2
                    }
                ];
                Ae(t, V);
                let W = h ? 4 : 1, H = re(e1[0].dataType), X = `
      fn setOutputAtIndex(flatIndex : i32, value : ${h ? `vec4<${H}>` : H}) {
        result[flatIndex] = ${h ? `vec4<${H}>` : H}(value);
      }
      fn setOutputAtCoords(d0 : i32, d1 : i32, d2 : i32, d3 : i32, value : ${h ? `vec4<${H}>` : H}) {
        let flatIndex = getOutputIndexFromCoords(vec4<i32>(d0, d1, d2, d3));
        setOutputAtIndex(flatIndex ${h ? "/ 4" : ""}, value);
      }`, oe = S("x", e1[0].dataType, e1[0].dims.length, v === 3 ? 1 : v), de = S("w", e1[1].dataType, e1[1].dims.length, W), q = [
                    oe,
                    de
                ], E = C("result", e1[0].dataType, n.length, W);
                if (s) {
                    let N = S("bias", e1[2].dataType, e1[2].dims.length, W);
                    q.push(N), X += `
        fn getBiasByOutputCoords(coords : vec4<i32>) -> ${h ? `vec4<${H}>` : H} {
          return bias[coords.${d ? "w" : "y"}${h ? "/ 4" : ""}];
        }`;
                }
                return `
        ${ss("uniforms.result_strides")}
        //struct Uniforms { xShape : vec4<i32>, wShape : vec4<i32>, outShape : vec4<i32>,
        //  outShapeStrides: vec3<i32>, filterDims : vec2<i32>, pad : vec2<i32>, stride : vec2<i32>,
        //  dilation : vec2<i32>, dimAOuter : i32, dimBOuter : i32, dimInner : i32 };
        ${M.registerUniforms(V).declareVariables(...q, E)}
        ${X}
        ${cl(d, A, z, R, s, t, D[0], D[1], D[2], H)}
        ${h ? Yn(_, g, H, void 0, !d, I) : Jn(_, g, H, void 0, !d, I, !1, void 0, a)}`;
            };
            return {
                name: "Conv2DMatMul",
                shaderCache: {
                    hint: `${t.cacheKey};${v};${h};${A};${z};${R};${$};${T};${I}`,
                    inputDependencies: Q
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: u ? u(n) : n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: w[0],
                            y: w[1],
                            z: w[2]
                        },
                        programUniforms: U
                    }),
                getShaderSource: O
            };
        };
    });
    var pl, cs, ln, ml, ps, fl, ms, fs, hs = k(()=>{
        "use strict";
        L();
        ke();
        F();
        j();
        Fe();
        sn();
        pl = (e1)=>{
            let t = 1;
            for(let n = 0; n < e1.length; n++)t *= e1[n];
            return t;
        }, cs = (e1)=>typeof e1 == "number" ? [
                e1,
                e1,
                e1
            ] : e1, ln = (e1, t)=>t <= 1 ? e1 : e1 + (e1 - 1) * (t - 1), ml = (e1, t, n, r = 1)=>{
            let o = ln(t, r);
            return Math.floor((e1[0] * (n - 1) - n + o) / 2);
        }, ps = (e1, t, n, r, o)=>{
            o == null && (o = ml(e1, t[0], r[0]));
            let i = [
                0,
                0,
                0,
                n
            ];
            for(let s = 0; s < 3; s++)e1[s] + 2 * o >= t[s] && (i[s] = Math.trunc((e1[s] - t[s] + 2 * o) / r[s] + 1));
            return i;
        }, fl = (e1, t, n, r, o, i, s, a, u, d)=>{
            let l, c, p, f;
            if (e1 === "VALID" && (e1 = 0), typeof e1 == "number") {
                l = {
                    top: e1,
                    bottom: e1,
                    left: e1,
                    right: e1,
                    front: e1,
                    back: e1
                };
                let m = ps([
                    t,
                    n,
                    r,
                    1
                ], [
                    a,
                    u,
                    d
                ], 1, [
                    o,
                    i,
                    s
                ], e1);
                c = m[0], p = m[1], f = m[2];
            } else if (Array.isArray(e1)) {
                if (!e1.every((h, b, y)=>h === y[0])) throw Error(`Unsupported padding parameter: ${e1}`);
                l = {
                    top: e1[0],
                    bottom: e1[1],
                    left: e1[2],
                    right: e1[3],
                    front: e1[4],
                    back: e1[5]
                };
                let m = ps([
                    t,
                    n,
                    r,
                    1
                ], [
                    a,
                    u,
                    d
                ], 1, [
                    o,
                    i,
                    s
                ], e1[0]);
                c = m[0], p = m[1], f = m[2];
            } else if (e1 === "SAME_UPPER") {
                c = Math.ceil(t / o), p = Math.ceil(n / i), f = Math.ceil(r / s);
                let m = (c - 1) * o + a - t, h = (p - 1) * i + u - n, b = (f - 1) * s + d - r, y = Math.floor(m / 2), g = m - y, _ = Math.floor(h / 2), w = h - _, v = Math.floor(b / 2), $ = b - v;
                l = {
                    top: _,
                    bottom: w,
                    left: v,
                    right: $,
                    front: y,
                    back: g
                };
            } else throw Error(`Unknown padding parameter: ${e1}`);
            return {
                padInfo: l,
                outDepth: c,
                outHeight: p,
                outWidth: f
            };
        }, ms = (e1, t, n, r, o, i = !1, s = "channelsLast")=>{
            let a, u, d, l, c;
            if (s === "channelsLast") [a, u, d, l, c] = e1;
            else if (s === "channelsFirst") [a, c, u, d, l] = e1;
            else throw new Error(`Unknown dataFormat ${s}`);
            let [p, , f, m, h] = t, [b, y, g] = cs(n), [_, w, v] = cs(r), $ = ln(f, _), T = ln(m, w), I = ln(h, v), { padInfo: A, outDepth: z, outHeight: R, outWidth: D } = fl(o, u, d, l, b, y, g, $, T, I), U = i ? p * c : p, Q = [
                0,
                0,
                0,
                0,
                0
            ];
            return s === "channelsFirst" ? Q = [
                a,
                U,
                z,
                R,
                D
            ] : s === "channelsLast" && (Q = [
                a,
                z,
                R,
                D,
                U
            ]), {
                batchSize: a,
                dataFormat: s,
                inDepth: u,
                inHeight: d,
                inWidth: l,
                inChannels: c,
                outDepth: z,
                outHeight: R,
                outWidth: D,
                outChannels: U,
                padInfo: A,
                strideDepth: b,
                strideHeight: y,
                strideWidth: g,
                filterDepth: f,
                filterHeight: m,
                filterWidth: h,
                effectiveFilterDepth: $,
                effectiveFilterHeight: T,
                effectiveFilterWidth: I,
                dilationDepth: _,
                dilationHeight: w,
                dilationWidth: v,
                inShape: e1,
                outShape: Q,
                filterShape: t
            };
        }, fs = (e1, t, n, r, o, i)=>{
            let s = i === "channelsLast", a = s ? e1[0].dims[3] : e1[0].dims[1], u = !1, d = [
                64,
                1,
                1
            ], l = {
                x: n.map((g, _)=>_)
            }, c = [
                Math.ceil(pl(l.x.map((g)=>n[g])) / d[0]),
                1,
                1
            ];
            Z("verbose", ()=>`[conv3d_naive_webgpu] dispatch = ${c}`);
            let p = u ? s && a % 4 !== 0 ? 3 : 4 : 1, f = x.size(n), m = [
                {
                    type: 12,
                    data: f
                },
                {
                    type: 12,
                    data: r
                },
                {
                    type: 12,
                    data: o
                },
                {
                    type: 12,
                    data: t.strides
                },
                {
                    type: 12,
                    data: t.dilations
                }
            ];
            Ce(t, m), m.push(...P(e1[0].dims, e1[1].dims));
            let h = [
                "rank",
                "rank"
            ], b = e1.length === 3;
            b && (m.push(...P(e1[2].dims)), h.push("rank")), m.push(...P(n));
            let y = (g)=>{
                let _ = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "filter_dims",
                        type: "u32",
                        length: r.length
                    },
                    {
                        name: "pads",
                        type: "u32",
                        length: o.length
                    },
                    {
                        name: "strides",
                        type: "u32",
                        length: t.strides.length
                    },
                    {
                        name: "dilations",
                        type: "u32",
                        length: t.dilations.length
                    }
                ];
                Ae(t, _);
                let w = u ? 4 : 1, v = re(e1[0].dataType), $ = S("x", e1[0].dataType, e1[0].dims.length, p === 3 ? 1 : p), T = S("W", e1[1].dataType, e1[1].dims.length, w), I = [
                    $,
                    T
                ], A = C("result", e1[0].dataType, n.length, w), z = "";
                if (b) {
                    let U = S("bias", e1[2].dataType, e1[2].dims.length, w);
                    I.push(U), z += `
        fn getBiasByOutputCoords(coords : array<u32, 5>) -> ${u ? `vec4<${v}>` : v} {
          return bias[${s ? B("coords", 4, 5) : B("coords", 1, 5)}${u ? "/ 4" : ""}];
        }`;
                }
                let R = ue(p, v), D = Ie(t, R, v);
                return `
            ${z}
            fn getX(d0 : u32, d1 : u32, d2 : u32, d3 : u32, d4 : u32) -> f32 {
              let aIndices = array<u32, 5>(d0, d1, d2, d3, d4);
              return ${$.getByIndices("aIndices")};
            }
            fn getW(d0 : u32, d1 : u32, d2 : u32, d3 : u32, d4 : u32) -> f32 {
              let aIndices = array<u32, 5>(d0, d1, d2, d3, d4);
              return ${T.getByIndices("aIndices")};
            }
          ${g.registerUniforms(_).declareVariables(...I, A)}
          ${g.mainStart()}
          ${g.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
              let coords = ${A.offsetToIndices("global_idx")};
              let batch = ${B("coords", 0, $.rank)};
              let d2 = ${s ? B("coords", $.rank - 1, $.rank) : B("coords", 1, $.rank)};
              let xFRCCorner = vec3<u32>(${s ? B("coords", 1, $.rank) : B("coords", 2, $.rank)},
              ${s ? B("coords", 2, $.rank) : B("coords", 3, $.rank)},
              ${s ? B("coords", 3, $.rank) : B("coords", 4, $.rank)}) * uniforms.strides - uniforms.pads;
              let xFCorner = xFRCCorner.x;
              let xRCorner = xFRCCorner.y;
              let xCCorner = xFRCCorner.z;
              let xShapeY = ${s ? B("uniforms.x_shape", 1, $.rank) : B("uniforms.x_shape", 2, $.rank)};
              let xShapeZ = ${s ? B("uniforms.x_shape", 2, $.rank) : B("uniforms.x_shape", 3, $.rank)};
              let xShapeW = ${s ? B("uniforms.x_shape", 3, $.rank) : B("uniforms.x_shape", 4, $.rank)};
              let xShapeU = ${s ? B("uniforms.x_shape", 4, $.rank) : B("uniforms.x_shape", 1, $.rank)};
              let inputDepthNearestVec4 = (xShapeU / 4) * 4;
              let inputDepthVec4Remainder = xShapeU % 4;

              var value = 0.0;
              for (var wF = 0u; wF < uniforms.filter_dims[0]; wF++) {
                let xF = xFCorner + wF * uniforms.dilations[0];
                if (xF < 0 || xF >= xShapeY) {
                  continue;
                }

                for (var wR = 0u; wR < uniforms.filter_dims[1]; wR++) {
                  let xR = xRCorner + wR * uniforms.dilations[1];
                  if (xR < 0 || xR >= xShapeZ) {
                    continue;
                  }

                  for (var wC = 0u; wC < uniforms.filter_dims[2]; wC++) {
                    let xC = xCCorner + wC * uniforms.dilations[2];
                    if (xC < 0 || xC >= xShapeW) {
                      continue;
                    }

                    for (var d1 = 0u; d1 < inputDepthNearestVec4; d1 += 4) {
                      ${s ? `let xValues = vec4<f32>(
                               getX(batch, xF, xR, xC, d1),
                               getX(batch, xF, xR, xC, d1 + 1),
                               getX(batch, xF, xR, xC, d1 + 2),
                               getX(batch, xF, xR, xC, d1 + 3));
                            ` : `let xValues = vec4<f32>(
                               getX(batch, d1, xF, xR, xC),
                               getX(batch, d1 + 1, xF, xR, xC),
                               getX(batch, d1 + 2, xF, xR, xC),
                               getX(batch, d1 + 3, xF, xR, xC));
                            `}
                            let wValues = vec4<f32>(
                              getW(d2, d1, wF, wR, wC),
                              getW(d2, d1 + 1, wF, wR, wC),
                              getW(d2, d1 + 2, wF, wR, wC),
                              getW(d2, d1 + 3, wF, wR, wC));
                      value += dot(xValues, wValues);
                    }
                    if (inputDepthVec4Remainder == 1) {
                        ${s ? `value += getX(batch, xF, xR, xC, inputDepthNearestVec4)
                          * getW(d2, inputDepthNearestVec4, wF, wR, wC);` : `value += getX(batch, inputDepthNearestVec4, xF, xR, xC)
                          * getW(d2, inputDepthNearestVec4, wF, wR, wC);`}
                    } else if (inputDepthVec4Remainder == 2) {
                      ${s ? `let xValues = vec2<f32>(
                        getX(batch, xF, xR, xC, inputDepthNearestVec4),
                        getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1));
                      ` : `let xValues = vec2<f32>(
                        getX(batch, inputDepthNearestVec4, xF, xR, xC),
                        getX(batch, inputDepthNearestVec4 + 1, xF, xR, xC));
                    `}
                    let wValues = vec2<f32>(
                      getW(d2, inputDepthNearestVec4, wF, wR, wC),
                      getW(d2, inputDepthNearestVec4 + 1, wF, wR, wC));
                      value += dot(xValues, wValues);
                    } else if (inputDepthVec4Remainder == 3) {
                      ${s ? `let xValues = vec3<f32>(
                        getX(batch, xF, xR, xC, inputDepthNearestVec4),
                        getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1),
                        getX(batch, xF, xR, xC, inputDepthNearestVec4 + 2));
                      ` : `let xValues = vec3<f32>(
                        getX(batch, inputDepthNearestVec4, xF, xR, xC),
                        getX(batch, inputDepthNearestVec4 + 1, xF, xR, xC),
                        getX(batch, inputDepthNearestVec4 + 2, xF, xR, xC));
                    `}
                    let wValues = vec3<f32>(
                      getW(d2, inputDepthNearestVec4, wF, wR, wC),
                      getW(d2, inputDepthNearestVec4 + 1, wF, wR, wC),
                      getW(d2, inputDepthNearestVec4 + 2, wF, wR, wC));
                      value += dot(xValues, wValues);
                    }
                  }
                }
              }
              ${b ? "value = value + getBiasByOutputCoords(coords)" : ""};
              ${D}
              result[global_idx] = f32(value);
          }`;
            };
            return {
                name: "Conv3DNaive",
                shaderCache: {
                    hint: `${t.cacheKey};${s};${p};${b}`,
                    inputDependencies: h
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: c[0],
                            y: c[1],
                            z: c[2]
                        },
                        programUniforms: m
                    }),
                getShaderSource: y
            };
        };
    });
    var gs, ys, bs = k(()=>{
        "use strict";
        L();
        F();
        j();
        Fe();
        gs = (e1, t, n, r)=>{
            let o = e1.length > 2, i = o ? "value += b[output_channel];" : "", s = e1[0].dims, a = e1[1].dims, u = t.format === "NHWC", d = u ? n[3] : n[1], l = d / t.group, c = u && l >= 4 ? J(d) : 1, p = x.size(n) / c, f = [
                {
                    type: 12,
                    data: p
                },
                {
                    type: 12,
                    data: t.dilations
                },
                {
                    type: 12,
                    data: [
                        t.strides[0],
                        t.strides[1]
                    ]
                },
                {
                    type: 12,
                    data: [
                        t.pads[0],
                        t.pads[1]
                    ]
                },
                {
                    type: 12,
                    data: l
                }
            ];
            Ce(t, f), f.push(...P(s, [
                a[0],
                a[1],
                a[2],
                a[3] / c
            ]));
            let m = o ? [
                "rank",
                "rank",
                "rank"
            ] : [
                "rank",
                "rank"
            ];
            f.push(...P([
                n[0],
                n[1],
                n[2],
                n[3] / c
            ]));
            let h = (b)=>{
                let y = C("output", e1[0].dataType, n.length, c), g = re(y.type.tensor), _ = Ie(t, y.type.value, g), w = S("x", e1[0].dataType, s.length), v = S("w", e1[1].dataType, a.length, c), $ = [
                    w,
                    v
                ];
                o && $.push(S("b", e1[2].dataType, e1[2].dims, c));
                let T = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "dilations",
                        type: "u32",
                        length: t.dilations.length
                    },
                    {
                        name: "strides",
                        type: "u32",
                        length: 2
                    },
                    {
                        name: "pads",
                        type: "u32",
                        length: 2
                    },
                    {
                        name: "output_channels_per_group",
                        type: "u32"
                    }
                ];
                Ae(t, T);
                let I = u ? `
      for (var wHeight: u32 = 0u; wHeight < uniforms.w_shape[0]; wHeight++) {
        let xHeight = xRCCorner.x + wHeight * uniforms.dilations[0];

        if (xHeight < 0u || xHeight >= uniforms.x_shape[1]) {
          continue;
        }

        for (var wWidth: u32 = 0u; wWidth < uniforms.w_shape[1]; wWidth++) {
          let xWidth = xRCCorner.y + wWidth * uniforms.dilations[1];
          if (xWidth < 0u || xWidth >= uniforms.x_shape[2]) {
            continue;
          }

          for (var wInChannel: u32 = 0u; wInChannel < uniforms.w_shape[2]; wInChannel++) {
            let input_channel = in_channel_offset + wInChannel;
            let xVal = ${w.get("batch", "xHeight", "xWidth", "input_channel")};
            let wVal = ${v.get("wHeight", "wWidth", "wInChannel", "output_channel")};
            value += xVal * wVal;
          }
        }
      }
      ` : `
      for (var wInChannel: u32 = 0u; wInChannel < uniforms.w_shape[1]; wInChannel++) {
        let input_channel = in_channel_offset + wInChannel;
        for (var wHeight: u32 = 0u; wHeight < uniforms.w_shape[2]; wHeight++) {
          let xHeight = xRCCorner.x + wHeight * uniforms.dilations[0];

          if (xHeight < 0u || xHeight >= uniforms.x_shape[2]) {
            continue;
          }

          for (var wWidth: u32 = 0u; wWidth < uniforms.w_shape[3]; wWidth++) {
            let xWidth = xRCCorner.y + wWidth * uniforms.dilations[1];
            if (xWidth < 0u || xWidth >= uniforms.x_shape[3]) {
              continue;
            }

            let xVal = ${w.get("batch", "input_channel", "xHeight", "xWidth")};
            let wVal = ${v.get("output_channel", "wInChannel", "wHeight", "wWidth")};
            value += xVal * wVal;
          }
        }
      }
      `;
                return `
  ${b.registerUniforms(T).declareVariables(...$, y)}

  ${b.mainStart()}
    ${b.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}

    let outputIndices = ${y.offsetToIndices("global_idx")};
    let batch: u32 = outputIndices[0];
    let output_channel: u32 = outputIndices[${u ? 3 : 1}];
    let xRCCorner: vec2<u32> = vec2<u32>(outputIndices[${u ? 1 : 2}], outputIndices[${u ? 2 : 3}]) * uniforms.strides - uniforms.pads;
    let group_id: u32 = output_channel * ${c} / uniforms.output_channels_per_group;
    var in_channel_offset = group_id * uniforms.w_shape[${u ? 2 : 1}];

    var value: ${y.type.value} = ${y.type.value}(0);
    ${I}
    ${i}
    ${_}
    ${y.setByOffset("global_idx", "value")}
  }`;
            };
            return {
                name: "GroupedConv",
                shaderCache: {
                    hint: `${t.cacheKey}_${c}`,
                    inputDependencies: m
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: r ? r(n) : n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(p / 64)
                        },
                        programUniforms: f
                    }),
                getShaderSource: h
            };
        }, ys = (e1, t, n, r)=>{
            let o = e1.length > 2, i = J(n[3]), s = J(n[2]), a = x.size(n) / i / s, u = [
                e1[0].dims[0],
                e1[0].dims[1],
                e1[0].dims[2],
                e1[0].dims[3] / i
            ], d = [
                e1[1].dims[0],
                e1[1].dims[1],
                e1[1].dims[2],
                e1[1].dims[3] / i
            ], l = [
                n[0],
                n[1],
                n[2],
                n[3] / i
            ], c = [
                {
                    type: 12,
                    data: a
                },
                {
                    type: 6,
                    data: [
                        t.strides[0],
                        t.strides[1]
                    ]
                },
                {
                    type: 6,
                    data: [
                        t.pads[0],
                        t.pads[1]
                    ]
                }
            ];
            Ce(t, c), c.push(...P(u, d, l));
            let p = (s - 1) * t.strides[1] + d[1], f = (m)=>{
                let h = C("output", e1[0].dataType, l.length, i), b = re(h.type.tensor), y = Ie(t, h.type.value, b), g = S("x", e1[0].dataType, u.length, i), _ = S("w", e1[1].dataType, d.length, i), w = [
                    g,
                    _
                ];
                o && w.push(S("b", e1[2].dataType, e1[2].dims, i));
                let v = o ? "value += b[output_channel];" : "", $ = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "strides",
                        type: "i32",
                        length: 2
                    },
                    {
                        name: "pads",
                        type: "i32",
                        length: 2
                    }
                ];
                return Ae(t, $), `
  ${m.registerUniforms($).declareVariables(...w, h)}
  ${m.mainStart()}
    ${m.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    let width0 = uniforms.output_shape[3];
    let output_channel = global_idx % width0;
    var index1 = global_idx / width0;
    let width1 = uniforms.output_shape[2] / ${s}u;
    let col = (index1 % width1) * ${s}u;
    index1 = index1 / width1;
    let row = index1 % uniforms.output_shape[1];
    let batch = index1 / uniforms.output_shape[1];

    let x_corner = vec2<i32>(i32(row), i32(col)) * uniforms.strides - uniforms.pads;

    var x_vals: array<${g.type.value}, ${p}>;
    var values: array<${h.type.value}, ${s}>;
    let input_channel = output_channel;
    // Use constant instead of uniform can give better performance for w's height/width.
    for (var w_height: u32 = 0u; w_height < ${d[0]}; w_height++) {
      let x_height = x_corner.x + i32(w_height);
      if (x_height >= 0 && u32(x_height) < uniforms.x_shape[1]) {
        for (var i = 0; i < ${p}; i++) {
          let x_width = x_corner.y + i;
          if (x_width >= 0 && u32(x_width) < uniforms.x_shape[2]) {
            x_vals[i] = ${g.get("batch", "u32(x_height)", "u32(x_width)", "input_channel")};
          } else {
            x_vals[i] = ${g.type.value}(0);
          }
        }
        for (var w_width: u32 = 0u; w_width < ${d[1]}; w_width++) {
          let w_val = ${_.get("w_height", "w_width", "0", "output_channel")};
          for (var i = 0u; i < ${s}u; i++) {
            values[i] = fma(x_vals[i * u32(uniforms.strides[1]) + w_width], w_val, values[i]);
          }
        }
      }
    }

    for (var i = 0u; i < ${s}u; i++) {
      var value = values[i];
      ${v}
      ${y}
      ${h.set("batch", "row", "col + i", "output_channel", "value")};
    }
  }`;
            };
            return {
                name: "GroupedConv-Vectorize",
                shaderCache: {
                    hint: `${t.cacheKey};${i};${s};${p};${d[0]};${d[1]}`,
                    inputDependencies: o ? [
                        "rank",
                        "rank",
                        "type"
                    ] : [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: r ? r(n) : n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(a / 64)
                        },
                        programUniforms: c
                    }),
                getShaderSource: f
            };
        };
    });
    var hl, er, gl, tr, nr, _s, yl, bl, rr, ws = k(()=>{
        "use strict";
        F();
        ls();
        hs();
        dn();
        bs();
        Fe();
        un();
        Ve();
        hl = (e1, t, n, r, o, i)=>{
            let s = e1[0], a = e1.slice(i ? 1 : 2, i ? 3 : 4), u = a.length, d = t[0], c = t.slice(2).map((m, h)=>m + (m - 1) * (n[h] - 1)), f = a.map((m, h)=>m + r[h] + r[h + u]).map((m, h)=>Math.floor((m - c[h] + o[h]) / o[h]));
            return f.splice(0, 0, s), f.splice(i ? 3 : 1, 0, d), f;
        }, er = [
            2,
            3,
            1,
            0
        ], gl = (e1, t)=>{
            if (!e1 || e1.length !== 2 && e1.length !== 3) throw new Error("Conv requires 2 or 3 inputs");
            if (e1[0].dims.length > 5) throw new Error("greater than 5D is not supported");
            if (e1[0].dims.length !== e1[1].dims.length) throw new Error("filter does not have same dimension as input");
            let n = e1[0].dims[t.format === "NHWC" ? e1[0].dims.length - 1 : 1], r = e1[1].dims[1] * t.group;
            if (n !== r) throw new Error("FILTER_IN_CHANNEL should be equal to DATA_CHANNEL");
            if (e1.length === 3 && (e1[2].dims.length !== 1 || e1[1].dims[0] !== e1[2].dims[0])) throw new Error("invalid bias");
            let o = e1[0].dims.length - 2;
            if (t.dilations.length !== o) throw new Error(`dilations should be ${o}D`);
            if (t.strides.length !== o) throw new Error(`strides should be ${o}D`);
            if (t.pads.length !== o * 2) throw new Error(`pads should be ${o * 2}D`);
            if (t.kernelShape.length !== 0 && t.kernelShape.length !== e1[1].dims.length - 2) throw new Error("invalid kernel shape");
        }, tr = (e1, t)=>{
            let n = e1.kernelShape.slice();
            n.length < t[1].dims.length - 2 && n.push(...Array(t[1].dims.length - 2 - n.length).fill(0));
            for(let i = 2; i < t[1].dims.length; ++i)n[i - 2] === 0 && (n[i - 2] = t[1].dims[i]);
            let r = e1.pads.slice();
            Ye.adjustPadsBasedOnAutoPad(t[0].dims, e1.strides, e1.dilations, n, r, e1.format === "NHWC", e1.autoPad);
            let o = Object.assign({}, e1);
            return Object.assign(o, {
                kernelShape: n,
                pads: r
            }), o;
        }, nr = (e1)=>{
            let t = on(e1), n = e1.format, r = [
                "NOTSET",
                "VALID",
                "SAME_UPPER",
                "SAME_LOWER"
            ][e1.auto_pad], o = e1.dilations, i = e1.group, s = e1.kernel_shape, a = e1.pads, u = e1.strides, d = e1.w_is_const();
            return {
                autoPad: r,
                format: n,
                dilations: o,
                group: i,
                kernelShape: s,
                pads: a,
                strides: u,
                wIsConst: d,
                ...t,
                cacheKey: `${e1.format};${t.activation};`
            };
        }, _s = (e1, t, n, r)=>{
            let o = n.format === "NHWC", i = hl(t[0].dims, t[1].dims, n.dilations, n.pads, n.strides, o);
            if (n.group !== 1) {
                let $ = [
                    t[0]
                ];
                if (o) {
                    let I = e1.kernelCustomData.wT ?? e1.compute(pe(t[1], er), {
                        inputs: [
                            1
                        ],
                        outputs: [
                            n.wIsConst ? -2 : -1
                        ]
                    })[0];
                    n.wIsConst && !e1.kernelCustomData.wT && (e1.kernelCustomData.wT = I), $.push(I);
                } else $.push(t[1]);
                t.length === 3 && $.push(t[2]), !e1.adapterInfo.isArchitecture("ampere") && o && t[1].dims[0] === n.group && t[1].dims[1] === 1 && n.dilations[0] === 1 && n.dilations[1] === 1 ? e1.compute(ys($, n, i, r), {
                    inputs: $
                }) : e1.compute(gs($, n, i, r), {
                    inputs: $
                });
                return;
            }
            let s = t.length === 3, a = t[0].dims[o ? 1 : 2], u = t[0].dims[o ? 2 : 3], d = t[0].dims[o ? 3 : 1], l = t[1].dims[2], c = t[1].dims[3], p = i[o ? 1 : 2], f = i[o ? 2 : 3], m = i[o ? 3 : 1], h = o && l === a && c === u && n.pads[0] === 0 && n.pads[1] === 0;
            if (h || l === 1 && c === 1 && n.dilations[0] === 1 && n.dilations[1] === 1 && n.strides[0] === 1 && n.strides[1] === 1 && n.pads[0] === 0 && n.pads[1] === 0) {
                let $ = i[0], T, I, A, z = [];
                if (o) {
                    let U = e1.kernelCustomData.wT ?? e1.compute(pe(t[1], er), {
                        inputs: [
                            1
                        ],
                        outputs: [
                            n.wIsConst ? -2 : -1
                        ]
                    })[0];
                    if (n.wIsConst && !e1.kernelCustomData.wT && (e1.kernelCustomData.wT = U), h) {
                        let Q = a * u * d;
                        T = t[0].reshape([
                            1,
                            $,
                            Q
                        ]), I = U.reshape([
                            1,
                            Q,
                            m
                        ]), A = [
                            1,
                            $,
                            m
                        ];
                    } else T = t[0].reshape([
                        $,
                        a * u,
                        d
                    ]), I = U.reshape([
                        1,
                        d,
                        m
                    ]), A = [
                        $,
                        p * f,
                        m
                    ];
                    z.push(T), z.push(I);
                } else T = t[0].reshape([
                    $,
                    d,
                    a * u
                ]), I = t[1].reshape([
                    1,
                    m,
                    d
                ]), A = [
                    $,
                    m,
                    p * f
                ], z.push(I), z.push(T);
                s && z.push(t[2]);
                let R = A[2], D = z[0].dims[z[0].dims.length - 1];
                R < 8 && D < 8 ? e1.compute(an(z, n, i, A, o, r), {
                    inputs: z
                }) : e1.compute(_t(z, n, i, A, o, r), {
                    inputs: z
                });
                return;
            }
            let b = !0, y = e1.kernelCustomData.wT ?? e1.compute(pe(t[1], er), {
                inputs: [
                    1
                ],
                outputs: [
                    n.wIsConst ? -2 : -1
                ]
            })[0];
            n.wIsConst && !e1.kernelCustomData.wT && (e1.kernelCustomData.wT = y);
            let g = [
                t[0],
                y
            ];
            s && g.push(t[2]);
            let _ = o ? p * f : m, w = o ? m : p * f, v = l * c * d;
            e1.compute(ds(g, n, i, _, w, v, s, b, r), {
                inputs: g
            });
        }, yl = (e1, t)=>{
            let n = t.format === "NHWC", r = [
                e1.inputs[0].reshape(n ? [
                    e1.inputs[0].dims[0],
                    1,
                    e1.inputs[0].dims[1],
                    e1.inputs[0].dims[2]
                ] : [
                    e1.inputs[0].dims[0],
                    e1.inputs[0].dims[1],
                    1,
                    e1.inputs[0].dims[2]
                ]),
                e1.inputs[1].reshape([
                    e1.inputs[1].dims[0],
                    e1.inputs[1].dims[1],
                    1,
                    e1.inputs[1].dims[2]
                ])
            ];
            e1.inputs.length === 3 && r.push(e1.inputs[2]);
            let o = [
                0,
                t.pads[0],
                0,
                t.pads[1]
            ], i = [
                1
            ].concat(t.strides), s = [
                1
            ].concat(t.dilations), a = [
                1
            ].concat(t.kernelShape), u = tr({
                ...t,
                pads: o,
                strides: i,
                dilations: s,
                kernelShape: a
            }, r);
            _s(e1, r, u, (d)=>n ? [
                    d[0],
                    d[2],
                    d[3]
                ] : [
                    d[0],
                    d[1],
                    d[3]
                ]);
        }, bl = (e1, t, n)=>{
            let r = n.format === "NHWC" ? "channelsLast" : "channelsFirst", o = tr(n, t), i = n.autoPad === "NOTSET" ? n.pads : n.autoPad, s = ms(t[0].dims, t[1].dims, n.strides, n.dilations, i, !1, r);
            e1.compute(fs(t, o, s.outShape, [
                s.filterDepth,
                s.filterHeight,
                s.filterWidth
            ], [
                s.padInfo.front,
                s.padInfo.top,
                s.padInfo.left
            ], r));
        }, rr = (e1, t)=>{
            if (gl(e1.inputs, t), e1.inputs[0].dims.length === 3) yl(e1, t);
            else if (e1.inputs[0].dims.length === 5) bl(e1, e1.inputs, t);
            else {
                let n = tr(t, e1.inputs);
                _s(e1, e1.inputs, n);
            }
        };
    });
    var $s, vs = k(()=>{
        "use strict";
        L();
        ke();
        F();
        j();
        $s = (e1, t, n)=>{
            let r = e1.length > 2, o = t.outputShape, i = t.format === "NHWC", s = t.group, a = e1[1].dims, u = a[2] / s, d = a[3], l = i ? J(u) : 1, c = i && d === 1 && u >= 4, p = c ? Math.floor(u / 4) * 4 : Math.floor(u / l) * l, f = u - p, m = i ? J(d) : 1, h = i ? d === 1 ? l : m : 1, b = x.size(o) / m, y = [
                Math.ceil(b / 64),
                1,
                1
            ];
            Z("verbose", ()=>`[conv2d_backprop_webgpu] dispatch = ${y}`);
            let g = [
                "rank",
                "rank"
            ], _ = [
                t.strides[0],
                t.strides[1]
            ], w = [
                t.kernelShape[i ? 1 : 2],
                t.kernelShape[i ? 2 : 3]
            ], v = [
                t.dilations[0],
                t.dilations[1]
            ], $ = [
                w[0] + (t.dilations[0] <= 1 ? 0 : (t.kernelShape[i ? 1 : 2] - 1) * (t.dilations[0] - 1)),
                w[1] + (t.dilations[1] <= 1 ? 0 : (t.kernelShape[i ? 2 : 3] - 1) * (t.dilations[1] - 1))
            ], T = [
                $[0] - 1 - Math.floor((t.pads[0] + t.pads[2]) / 2),
                $[1] - 1 - Math.floor((t.pads[1] + t.pads[3]) / 2)
            ], I = [
                {
                    type: 12,
                    data: b
                },
                {
                    type: 12,
                    data: _
                },
                {
                    type: 12,
                    data: w
                },
                {
                    type: 12,
                    data: v
                },
                {
                    type: 12,
                    data: $
                },
                {
                    type: 6,
                    data: T
                },
                {
                    type: 12,
                    data: p
                },
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: d
                },
                ...P(e1[0].dims, e1[1].dims)
            ];
            r && (I.push(...P(e1[2].dims)), g.push("rank")), I.push(...P(o));
            let A = (z)=>{
                let R = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "strides",
                        type: "u32",
                        length: _.length
                    },
                    {
                        name: "filter_dims",
                        type: "u32",
                        length: w.length
                    },
                    {
                        name: "dilations",
                        type: "u32",
                        length: w.length
                    },
                    {
                        name: "effective_filter_dims",
                        type: "u32",
                        length: $.length
                    },
                    {
                        name: "pads",
                        type: "i32",
                        length: T.length
                    },
                    {
                        name: "input_channels_per_group_int",
                        type: "u32"
                    },
                    {
                        name: "input_channels_per_group",
                        type: "u32"
                    },
                    {
                        name: "output_channels_per_group",
                        type: "u32"
                    }
                ], D = re(e1[0].dataType), U = i ? 1 : 2, Q = i ? 2 : 3, O = i ? 3 : 1, M = S("W", e1[1].dataType, e1[1].dims.length, h), V = S("Dy", e1[0].dataType, e1[0].dims.length, l), W = [
                    V,
                    M
                ];
                r && W.push(S("bias", e1[2].dataType, [
                    o[O]
                ].length, m));
                let H = C("result", e1[0].dataType, o.length, m), X = ()=>{
                    let q = "";
                    if (c) l === 4 ? q += `
        let xValue = ${V.getByOffset("x_offset")};
        let wValue = ${M.getByOffset("w_offset")};
        dotProd = dotProd + dot(xValue, wValue);
        x_offset += 1u;
        w_offset += 1u;` : l === 2 ? q += `
          dotProd = dotProd + dot(vec4<${D}>(${V.getByOffset("x_offset")}, ${V.getByOffset("x_offset + 1u")}), vec4<${D}>(${M.getByOffset("w_offset")}, ${M.getByOffset("w_offset + 1u")}));
          x_offset += 2u;
          w_offset += 2u;` : l === 1 && (q += `
          dotProd = dotProd + dot(vec4<${D}>(${V.getByOffset("x_offset")}, ${V.getByOffset("x_offset + 1u")}, ${V.getByOffset("x_offset + 2u")}, ${V.getByOffset("x_offset + 3u")}), vec4<${D}>(${M.getByOffset("w_offset")}, ${M.getByOffset("w_offset + 1u")}, ${M.getByOffset("w_offset + 2u")}, ${M.getByOffset("w_offset + 3u")}));
          x_offset += 4u;
          w_offset += 4u;`);
                    else if (q += `
                  let xValue = ${i ? V.getByOffset(`${V.indicesToOffset(`${V.type.indices}(batch, idyR, idyC, inputChannel)`)} / ${l}`) : V.get("batch", "inputChannel", "idyR", "idyC")};
        `, l === 1) q += `
          let w_offset = ${M.indicesToOffset(`${M.type.indices}(u32(wRPerm), u32(wCPerm), inputChannel, wOutChannel)`)};
          let wValue = ${M.getByOffset(`w_offset / ${h}`)};
          dotProd = dotProd + xValue * wValue;`;
                    else for(let E = 0; E < l; E++)q += `
            let wValue${E} = ${M.getByOffset(`${M.indicesToOffset(`${M.type.indices}(u32(wRPerm), u32(wCPerm), inputChannel + ${E}, wOutChannel)`)} / ${h}`)};
            dotProd = dotProd + xValue[${E}] * wValue${E};`;
                    return q;
                }, oe = ()=>{
                    if (f === 0) return "";
                    if (!c) throw new Error(`packInputAs4 ${c} is not true.`);
                    let q = "";
                    if (l === 1) {
                        q += "dotProd = dotProd";
                        for(let E = 0; E < f; E++)q += `
            + ${V.getByOffset(`x_offset + ${E}`)} * ${M.getByOffset(`w_offset + ${E}`)}`;
                        q += ";";
                    } else if (l === 2) {
                        if (f !== 2) throw new Error(`Invalid inputChannelsRemainder ${f}.`);
                        q += `
          let xValue = ${V.getByOffset("x_offset")};
          let wValue = ${M.getByOffset("w_offset")};
          dotProd = dotProd + dot(xValue, wValue);`;
                    }
                    return q;
                }, de = `
            let outputIndices = ${H.offsetToIndices(`global_idx * ${m}`)};
            let batch = ${H.indicesGet("outputIndices", 0)};
            let d1 = ${H.indicesGet("outputIndices", O)};
            let r = ${H.indicesGet("outputIndices", U)};
            let c = ${H.indicesGet("outputIndices", Q)};
            let dyCorner = vec2<i32>(i32(r), i32(c)) - uniforms.pads;
            let dyRCorner = dyCorner.x;
            let dyCCorner = dyCorner.y;
            let groupId = d1 / uniforms.output_channels_per_group;
            let wOutChannel = d1 - groupId * uniforms.output_channels_per_group;
            // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
            // ? = to be determined. : = across all values in that axis.
            var dotProd = ${H.type.value}(0.0);
            var wR: u32 = 0;
            if (uniforms.dilations.x == 1) {
              // Minimum wR >= 0 that satisfies (dyRCorner + wR) % (uniforms.strides.x) == 0
              wR = u32(((dyRCorner + i32(uniforms.strides.x) - 1) / i32(uniforms.strides.x)) * i32(uniforms.strides.x) - dyRCorner);
            }
            for (; wR < uniforms.effective_filter_dims.x; wR = wR + 1) {
              if (wR % uniforms.dilations.x != 0) {
                continue;
              }
              let dyR = (${D}(dyRCorner) + ${D}(wR)) / ${D}(uniforms.strides[0]);
              let wRPerm = uniforms.filter_dims.x - 1 - wR / uniforms.dilations.x;
              if (dyR < 0.0 || dyR >= ${D}(uniforms.Dy_shape[${U}]) || fract(dyR) > 0.0 ||
                  wRPerm < 0) {
                continue;
              }
              let idyR: u32 = u32(dyR);
              var wC: u32 = 0;
              if (uniforms.dilations.y == 1) {
                // Minimum wC >= 0 that satisfies (dyCCorner + wC) % (uniforms.strides.y) == 0
                wC = u32(((dyCCorner + i32(uniforms.strides.y) - 1) / i32(uniforms.strides.y)) * i32(uniforms.strides.y) - dyCCorner);
              }
              for (; wC < uniforms.effective_filter_dims.y; wC = wC + 1) {
                if (wC % uniforms.dilations.y != 0) {
                  continue;
                }
                let dyC = (${D}(dyCCorner) + ${D}(wC)) / ${D}(uniforms.strides.y);
                let wCPerm = uniforms.filter_dims.y - 1 - wC / uniforms.dilations.y;
                if (dyC < 0.0 || dyC >= ${D}(uniforms.Dy_shape[${Q}]) ||
                    fract(dyC) > 0.0 || wCPerm < 0) {
                  continue;
                }
                let idyC: u32 = u32(dyC);
                var inputChannel = groupId * uniforms.input_channels_per_group;
                ${c ? `
                var x_offset = ${V.indicesToOffset(`${V.type.indices}(batch, idyR, idyC, inputChannel)`)} / ${l};
                var w_offset = ${M.indicesToOffset(`${M.type.indices}(wRPerm, wCPerm, inputChannel, wOutChannel)`)} / ${h};
                  ` : ""}
                for (var d2: u32 = 0; d2 < uniforms.input_channels_per_group_int; d2 = d2 + ${c ? 4 : l}) {
                  ${X()}
                  inputChannel = inputChannel + ${c ? 4 : l};
                }
                ${oe()}
                wC = wC + uniforms.strides.y - 1;
              }
              wR = wR + uniforms.strides[0] - 1;
            }
            let value = dotProd${r ? ` + bias[d1 / ${m}]` : ""};
            ${H.setByOffset("global_idx", "value")};
          `;
                return `
    ${z.registerUniforms(R).declareVariables(...W, H)}
      ${z.mainStart()}
      ${z.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")};
    ${de}}`;
            };
            return {
                name: "ConvTranspose2D",
                shaderCache: {
                    hint: `${t.cacheKey};${l}${h}${m}${c}${f}`,
                    inputDependencies: g
                },
                getRunData: ()=>({
                        dispatchGroup: {
                            x: y[0],
                            y: y[1],
                            z: y[2]
                        },
                        outputs: [
                            {
                                dims: n ? n(o) : o,
                                dataType: e1[0].dataType
                            }
                        ],
                        programUniforms: I
                    }),
                getShaderSource: A
            };
        };
    });
    var _l, wl, $l, xs, Ss, vl, Ts, xl, Is, Cs = k(()=>{
        "use strict";
        vs();
        Fe();
        Ve();
        _l = (e1, t, n, r, o, i)=>(e1 - 1) * t + n + (r - 1) * o + 1 - i, wl = (e1, t, n, r, o)=>{
            let i = Math.floor(e1 / 2);
            t === "SAME_UPPER" ? (n[r] = i, n[o] = e1 - i) : t === "SAME_LOWER" && (n[r] = e1 - i, n[o] = i);
        }, $l = (e1, t, n, r, o, i, s, a, u, d)=>{
            let l = e1.length - 2, c = d.length === 0;
            u.length < l && u.push(...Array(l - u.length).fill(0));
            let p = e1[0], f = t[a ? 3 : 1] * o;
            for(let m = 0, h = e1.length - l - (a ? 1 : 0); m < l; ++m, ++h){
                let b = e1[h], y = c ? b * s[m] : d[m], g = _l(b, s[m], i[m], t[h], n[m], y);
                wl(g, r, i, m, m + l), c && d.push(s[m] * (b - 1) + u[m] + (t[h] - 1) * n[m] + 1 - i[m] - i[m + l]);
            }
            d.splice(0, 0, p), d.splice(a ? 3 : 1, 0, f);
        }, xs = (e1, t)=>{
            let n = e1.kernelShape.slice();
            if (e1.kernelShape.length === 0 || e1.kernelShape.reduce((c, p)=>c * p, 1) === 0) {
                n.length = 0;
                for(let c = 2; c < t[1].dims.length; ++c)n.push(t[1].dims[c]);
            }
            let r = e1.format === "NHWC";
            n.splice(0, 0, t[1].dims[0]), n.splice(r ? 3 : 1, 0, t[1].dims[1]);
            let o = e1.pads.slice(), i = e1.outputShape.slice(), s = e1.outputPadding.slice(), a = t[0].dims, u = e1.dilations.slice();
            if (u.reduce((c, p)=>c + p, 0) === 0) {
                let c = t[0].dims.length - 2;
                u = new Array(c).fill(1);
            }
            let d = e1.strides.slice();
            if (d.reduce((c, p)=>c + p, 0) === 0) {
                let c = t[0].dims.length - 2;
                d = new Array(c).fill(1);
            }
            $l(a, n, u, e1.autoPad, e1.group, o, d, r, s, i);
            let l = Object.assign({}, e1);
            return Object.assign(l, {
                kernelShape: n,
                pads: o,
                outputPadding: s,
                outputShape: i,
                dilations: u,
                strides: d
            }), l;
        }, Ss = (e1)=>{
            let t = on(e1), n = e1.format, r = [
                "NOTSET",
                "VALID",
                "SAME_UPPER",
                "SAME_LOWER"
            ][typeof e1.autoPad > "u" ? 0 : e1.autoPad], o = e1.dilations, i = e1.group ?? 1, s = e1.kernelShape, a = e1.pads, u = e1.strides, d = e1.wIsConst(), l = e1.outputPadding, c = e1.outputShape;
            return {
                autoPad: r,
                format: n,
                dilations: o,
                group: i,
                kernelShape: s,
                outputPadding: l,
                outputShape: c,
                pads: a,
                strides: u,
                wIsConst: d,
                ...t,
                cacheKey: `${e1.format};${t.activation};`
            };
        }, vl = (e1, t)=>{
            if (!e1 || e1.length !== 2 && e1.length !== 3) throw new Error("Conv requires 2 or 3 inputs");
            if (e1[0].dims.length !== 4 && e1[0].dims.length !== 3) throw new Error("currently only support 2-dimensional conv");
            if (e1[0].dims.length !== e1[1].dims.length) throw new Error("filter does not have same dimension as input");
            let n = e1[0].dims[t.format === "NHWC" ? e1[0].dims.length - 1 : 1], r = e1[1].dims[0];
            if (n !== r) throw new Error("FILTER_IN_CHANNEL should be equal to DATA_CHANNEL");
            let o = e1[1].dims[1] * t.group;
            if (e1.length === 3 && (e1[2].dims.length !== 1 || e1[2].dims[0] !== o)) throw new Error("invalid bias");
            let i = e1[0].dims.length - 2;
            if (t.dilations.reduce((l, c)=>l + c, 0) > 0 && t.dilations.length !== i) throw new Error(`dilations should be ${i}D`);
            if (t.strides.reduce((l, c)=>l + c, 0) > 0 && t.strides.length !== i) throw new Error(`strides should be ${i}D`);
            if (t.pads.reduce((l, c)=>l + c, 0) > 0 && t.pads.length !== i * 2) throw new Error(`pads should be ${i * 2}D`);
            if (t.outputPadding.length !== i && t.outputPadding.length !== 0) throw new Error(`output_padding should be ${i}D`);
            if (t.kernelShape.reduce((l, c)=>l + c, 0) > 0 && t.kernelShape.length !== 0 && t.kernelShape.length !== e1[1].dims.length - 2) throw new Error("invalid kernel shape");
            if (t.outputShape.length !== 0 && t.outputShape.length !== e1[0].dims.length - 2) throw new Error("invalid output shape");
        }, Ts = (e1, t, n, r)=>{
            let o = e1.kernelCustomData.wT ?? e1.compute(pe(t[1], [
                2,
                3,
                0,
                1
            ]), {
                inputs: [
                    1
                ],
                outputs: [
                    n.wIsConst ? -2 : -1
                ]
            })[0];
            n.wIsConst && !e1.kernelCustomData.wT && (e1.kernelCustomData.wT = o);
            let i = [
                t[0],
                o
            ];
            t.length === 3 && i.push(t[2]), e1.compute($s(i, n, r), {
                inputs: i
            });
        }, xl = (e1, t)=>{
            let n = t.format === "NHWC", r = [
                e1.inputs[0].reshape(n ? [
                    e1.inputs[0].dims[0],
                    1,
                    e1.inputs[0].dims[1],
                    e1.inputs[0].dims[2]
                ] : [
                    e1.inputs[0].dims[0],
                    e1.inputs[0].dims[1],
                    1,
                    e1.inputs[0].dims[2]
                ]),
                e1.inputs[1].reshape([
                    e1.inputs[1].dims[0],
                    e1.inputs[1].dims[1],
                    1,
                    e1.inputs[1].dims[2]
                ])
            ];
            e1.inputs.length === 3 && r.push(e1.inputs[2]);
            let o = t.kernelShape;
            (o.length === 0 || o[0] === 0) && (o = [
                e1.inputs[1].dims[2]
            ]);
            let i = t.dilations;
            (i.length === 0 || i[0] === 0) && (i = [
                1
            ]);
            let s = t.strides;
            (s.length === 0 || s[0] === 0) && (s = [
                1
            ]);
            let a = t.pads;
            a.length === 0 && (a = [
                0,
                0
            ]), a = [
                0,
                a[0],
                0,
                a[1]
            ], s = [
                1
            ].concat(s), i = [
                1
            ].concat(i), o = [
                1
            ].concat(o);
            let u = t.outputPadding;
            u = [
                0
            ].concat(u);
            let d = xs({
                ...t,
                pads: a,
                strides: s,
                dilations: i,
                kernelShape: o,
                outputPadding: u
            }, r);
            Ts(e1, r, d, (l)=>n ? [
                    l[0],
                    l[2],
                    l[3]
                ] : [
                    l[0],
                    l[1],
                    l[3]
                ]);
        }, Is = (e1, t)=>{
            if (vl(e1.inputs, t), e1.inputs[0].dims.length === 3) xl(e1, t);
            else {
                let n = xs(t, e1.inputs);
                Ts(e1, e1.inputs, n);
            }
        };
    });
    var Sl, As, Es, ks = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Sl = (e1, t, n, r)=>{
            let o = x.size(t), i = t.length, s = S("input", e1, i), a = C("output", e1, i), u = n.dataType === 6 ? n.getInt32Array()[0] : Number(n.getBigInt64Array()[0]), d = x.normalizeAxis(u, i), l = (c)=>{
                let p = ` i32(${s.indicesGet("inputIndices", "uniforms.axis")}) `, f = B("uniforms.input_shape", "uniforms.axis", i), m = r.reverse ? p + (r.exclusive ? " + 1" : "") : "0", h = r.reverse ? f : p + (r.exclusive ? "" : " + 1");
                return `
                ${c.registerUniform("outputSize", "u32").registerUniform("axis", "u32").declareVariables(s, a)}
                ${c.mainStart()}
                  ${c.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
                  var inputIndices = ${a.offsetToIndices("global_idx")};
                  var sum = ${a.type.value}(0);
                  let first : i32 = ${m};
                  let last : i32 = ${h};
                  for (var i : i32 = first; i < last; i++) {
                    ${s.indicesSet("inputIndices", "uniforms.axis", "u32(i)")};
                    sum = sum + ${s.getByIndices("inputIndices")};
                  }
                  ${a.setByOffset("global_idx", "sum")};
                }`;
            };
            return {
                name: "CumSum",
                shaderCache: {
                    hint: r.cacheKey,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: t,
                                dataType: e1
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(o / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: o
                            },
                            {
                                type: 12,
                                data: d
                            },
                            ...P(t, t)
                        ]
                    }),
                getShaderSource: l
            };
        }, As = (e1, t)=>{
            let n = e1.inputs[0].dims, r = e1.inputs[0].dataType, o = e1.inputs[1];
            e1.compute(Sl(r, n, o, t), {
                inputs: [
                    0
                ]
            });
        }, Es = (e1)=>{
            let t = e1.exclusive === 1, n = e1.reverse === 1;
            return G({
                exclusive: t,
                reverse: n
            });
        };
    });
    var Tl, Il, Cl, Ps, zs, Bs = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Tl = (e1)=>{
            if (!e1 || e1.length !== 1) throw new Error("DepthToSpace requires 1 input.");
            if (e1[0].dims.length !== 4) throw new Error("DepthToSpace requires 4D input.");
        }, Il = (e1, t, n, r)=>{
            let o = [];
            o.push(`fn perm(i: ${r.type.indices}) -> ${n.type.indices} {
    var a: ${n.type.indices};`);
            for(let i = 0; i < t; ++i)o.push(n.indicesSet("a", e1[i], `i[${i}]`));
            return o.push("return a;}"), o.join(`
`);
        }, Cl = (e1, t)=>{
            let n, r, o, i, s, a, u = t.format === "NHWC", d = t.blocksize, l = t.mode === "DCR";
            u ? ([n, r, o, i] = e1.dims, s = l ? [
                n,
                r,
                o,
                d,
                d,
                i / d ** 2
            ] : [
                n,
                r,
                o,
                i / d ** 2,
                d,
                d
            ], a = l ? [
                0,
                1,
                3,
                2,
                4,
                5
            ] : [
                0,
                1,
                4,
                2,
                5,
                3
            ]) : ([n, r, o, i] = [
                e1.dims[0],
                e1.dims[2],
                e1.dims[3],
                e1.dims[1]
            ], s = l ? [
                n,
                d,
                d,
                i / d ** 2,
                r,
                o
            ] : [
                n,
                i / d ** 2,
                d,
                d,
                r,
                o
            ], a = l ? [
                0,
                3,
                4,
                1,
                5,
                2
            ] : [
                0,
                1,
                4,
                2,
                5,
                3
            ]);
            let c = e1.reshape(s), p = c.dims.length, f = e1.dataType, m = S("a", f, p), h = C("output", f, p), b = (y)=>`
  ${y.registerUniform("output_size", "u32").declareVariables(m, h)}

  ${Il(a, p, m, h)}

  ${y.mainStart()}
    ${y.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}

    let indices = ${h.offsetToIndices("global_idx")};
    let aIndices = perm(indices);

    ${h.setByOffset("global_idx", m.getByIndices("aIndices"))}
  }`;
            return {
                name: "DepthToSpace",
                shaderCache: {
                    hint: `${e1.dims};${t.blocksize};${t.mode}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getRunData: (y)=>{
                    let g = u ? [
                        n,
                        r * d,
                        o * d,
                        i / d ** 2
                    ] : [
                        n,
                        i / d ** 2,
                        r * d,
                        o * d
                    ], _ = x.size(g), w = c.dims, v = x.sortBasedOnPerm(w, a);
                    return {
                        outputs: [
                            {
                                dims: g,
                                dataType: y[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(_ / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: _
                            },
                            ...P(w, v)
                        ]
                    };
                },
                getShaderSource: b
            };
        }, Ps = (e1, t)=>{
            Tl(e1.inputs), e1.compute(Cl(e1.inputs[0], t));
        }, zs = (e1)=>G({
                blocksize: e1.blocksize,
                mode: e1.mode,
                format: e1.format
            });
    });
    var or, cn, Ds, Al, El, ir, sr, Os, kl, Ms, Us, Rs = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        or = "[a-zA-Z]|\\.\\.\\.", cn = "(" + or + ")+", Ds = "^" + cn + "$", Al = "(" + cn + ",)*" + cn, El = "^" + Al + "$", ir = class {
            constructor(t = -1){
                this.symbolToIndices = new Map, this.inputIndex = t;
            }
            addSymbol(t, n) {
                let r = this.symbolToIndices.get(t);
                r === void 0 ? r = [
                    n
                ] : r.push(n), this.symbolToIndices.set(t, r);
            }
        }, sr = class {
            constructor(t, n){
                this.equation = n;
                this.hasEllipsis = !1, this.symbolToInfo = new Map, this.lhs = new Array, this.outputDims = [];
                let [r, o] = n.includes("->") ? n.split("->", 2) : [
                    n,
                    ""
                ];
                if (!r.match(RegExp(El))) throw new Error("Invalid LHS term");
                if (r.split(",").forEach((a, u)=>{
                    let d = t[u].dims.slice();
                    if (!a.match(RegExp(Ds))) throw new Error("Invalid LHS term");
                    let l = this.processTerm(a, !0, d, u);
                    this.lhs.push(l);
                }), o === "") o += [
                    ...this.symbolToInfo.entries()
                ].filter(([a, u])=>u.count === 1 || a === "...").map(([a])=>a).join("");
                else if (!o.match(RegExp(cn))) throw new Error("Invalid RHS");
                o.match(RegExp(or, "g"))?.forEach((a)=>{
                    if (a === "...") this.outputDims = this.outputDims.concat(this.ellipsisDims);
                    else {
                        let u = this.symbolToInfo.get(a);
                        if (u === void 0) throw new Error("Invalid RHS symbol");
                        this.outputDims.push(u.dimValue);
                    }
                }), this.rhs = this.processTerm(o, !1, this.outputDims);
            }
            addSymbol(t, n, r) {
                let o = this.symbolToInfo.get(t);
                if (o !== void 0) {
                    if (o.dimValue !== n && o.count !== 1) throw new Error("Dimension mismatch");
                    o.count++, o.inputIndices.push(r);
                } else o = {
                    count: 1,
                    dimValue: n,
                    inputIndices: [
                        r
                    ]
                };
                this.symbolToInfo.set(t, o);
            }
            processTerm(t, n, r, o = -1) {
                let i = r.length, s = !1, a = [], u = 0;
                if (!t.match(RegExp(Ds)) && !n && t !== "") throw new Error("Invalid LHS term");
                let d = t.match(RegExp(or, "g")), l = new ir(o);
                return d?.forEach((c, p)=>{
                    if (c === "...") {
                        if (s) throw new Error("Only one ellipsis is allowed per input term");
                        s = !0;
                        let f = i - d.length + 1;
                        if (f < 0) throw new Error("Ellipsis out of bounds");
                        if (a = r.slice(u, u + f), this.hasEllipsis) {
                            if (this.ellipsisDims.length !== a.length || this.ellipsisDims.toString() !== a.toString()) throw new Error("Ellipsis dimensions mismatch");
                        } else if (n) this.hasEllipsis = !0, this.ellipsisDims = a;
                        else throw new Error("Ellipsis must be specified in the LHS");
                        for(let m = 0; m < a.length; m++){
                            let h = String.fromCharCode(48 + m);
                            l.addSymbol(h, p + m), this.addSymbol(h, r[u++], o);
                        }
                    } else l.addSymbol(c, p + (this.hasEllipsis ? this.ellipsisDims.length - 1 : 0)), this.addSymbol(c, r[u++], o);
                }), l;
            }
        }, Os = (e1)=>e1 + "_max", kl = (e1, t, n, r)=>{
            let i = e1.map((l)=>l.length).map((l, c)=>S(`input${c}`, t, l)), s = x.size(r), a = C("output", t, r.length), u = [
                ...n.symbolToInfo.keys()
            ].filter((l)=>!n.rhs.symbolToIndices.has(l)), d = (l)=>{
                let c = [], p = "var prod = 1.0;", f = "var sum = 0.0;", m = "sum += prod;", h = [], b = [], y = [], g = [], _ = n.symbolToInfo.size === n.rhs.symbolToIndices.size;
                n.symbolToInfo.forEach((v, $)=>{
                    if (n.rhs.symbolToIndices.has($)) {
                        let T = n.rhs.symbolToIndices.get($)?.[0];
                        T !== void 0 && n.lhs.forEach((I, A)=>{
                            if (v.inputIndices.includes(A)) {
                                let z = I.symbolToIndices.get($);
                                if (z === void 0) throw new Error("Invalid symbol error");
                                z.forEach((R)=>{
                                    c.push(`${i[A].indicesSet(`input${A}Indices`, R, a.indicesGet("outputIndices", T))}`);
                                });
                            }
                        });
                    } else n.lhs.forEach((T, I)=>{
                        if (v.inputIndices.includes(I)) {
                            let A = T.symbolToIndices.get($);
                            if (A === void 0) throw new Error("Invalid symbol error");
                            A.forEach((z)=>{
                                h.push(`${i[I].indicesSet(`input${I}Indices`, z, `${$}`)}`);
                            }), g.push(`prod *= ${i[I].getByIndices(`input${I}Indices`)};`);
                        }
                    }), b.push(`for(var ${$}: u32 = 0; ${$} < uniforms.${Os($)}; ${$}++) {`), y.push("}");
                });
                let w = _ ? [
                    ...c,
                    `let sum = ${i.map((v, $)=>v.getByIndices(`input${$}Indices`)).join(" * ")};`
                ] : [
                    ...c,
                    f,
                    ...b,
                    ...h,
                    p,
                    ...g,
                    m,
                    ...y
                ];
                return `
            ${l.registerUniforms(u.map((v)=>({
                        name: `${Os(v)}`,
                        type: "u32"
                    }))).registerUniform("outputSize", "u32").declareVariables(...i, a)}

            ${l.mainStart()}
            ${l.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
            var outputIndices = ${a.offsetToIndices("global_idx")};
            ${i.map((v, $)=>`var input${$}Indices: ${i[$].type.indices};`).join(`
`)}
            ${w.join(`
`)};
            ${a.setByOffset("global_idx", "sum")};
          }`;
            };
            return {
                name: "Einsum",
                shaderCache: {
                    hint: n.equation,
                    inputDependencies: e1.map(()=>"rank")
                },
                getRunData: ()=>{
                    let l = u.filter((p)=>n.symbolToInfo.has(p)).map((p)=>({
                            type: 12,
                            data: n.symbolToInfo.get(p)?.dimValue || 0
                        }));
                    l.push({
                        type: 12,
                        data: s
                    });
                    let c = e1.map((p, f)=>[
                            ...P(p)
                        ]).reduce((p, f)=>p.concat(f), l);
                    return c.push(...P(r)), {
                        outputs: [
                            {
                                dims: r,
                                dataType: t
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(s / 64)
                        },
                        programUniforms: c
                    };
                },
                getShaderSource: d
            };
        }, Ms = (e1, t)=>{
            let n = new sr(e1.inputs, t.equation), r = n.outputDims, o = e1.inputs.map((i, s)=>i.dims);
            e1.compute(kl(o, e1.inputs[0].dataType, n, r));
        }, Us = (e1)=>{
            let t = e1.equation.replace(/\s+/g, "");
            return G({
                equation: t
            });
        };
    });
    var Pl, Vs, zl, Bl, Ns, Ls = k(()=>{
        "use strict";
        L();
        F();
        j();
        Pl = (e1)=>{
            if (!e1 || e1.length !== 2) throw new Error("Expand requires 2 input.");
            let t = e1[0].dims, n = Array.from(e1[1].getBigInt64Array(), Number), r = n.length < t.length ? 0 : n.length - t.length, o = t.length < n.length ? 0 : t.length - n.length;
            for(; r < n.length && o < t.length; ++r, ++o)if (n[r] !== t[o] && n[r] !== 1 && t[o] !== 1) throw new Error("Expand requires shape to be broadcastable to input");
        }, Vs = (e1, t)=>{
            let n = e1.length - t.length, r = [];
            for(let o = 0; o < n; ++o)r.push(e1[o]);
            for(let o = 0; o < t.length; ++o)r.push(t[o] === 1 ? e1[o + n] : t[o]);
            return r;
        }, zl = (e1, t)=>e1.length > t.length ? Vs(e1, t) : Vs(t, e1), Bl = (e1)=>{
            let t = e1[0].dims, n = Array.from(e1[1].getBigInt64Array(), Number), r = zl(t, n), o = e1[0].dataType, i = o === 9 || x.size(t) === 1, s = o === 9 || t.length > 0 && t[t.length - 1] % 4 === 0 ? 4 : 1, a = i || r.length > 0 && r[r.length - 1] % 4 === 0 ? 4 : 1, u = Math.ceil(x.size(r) / a), d = (c)=>{
                let p = S("input", o, t.length, s), f = C("output", o, r.length, a), m;
                if (o === 9) {
                    let h = (b, y, g = "")=>`
          let outputIndices${y} = ${f.offsetToIndices(`outputOffset + ${y}u`)};
          let offset${y} = ${p.broadcastedIndicesToOffset(`outputIndices${y}`, f)};
          let index${y} = offset${y} / 4u;
          let component${y} = offset${y} % 4u;
          ${b}[${y}] = ${g}(${p.getByOffset(`index${y}`)}[component${y}]);
        `;
                    m = `
        let outputOffset = global_idx * ${a};
        var data = vec4<u32>(0);
        ${h("data", 0, "u32")}
        ${h("data", 1, "u32")}
        ${h("data", 2, "u32")}
        ${h("data", 3, "u32")}
        ${f.setByOffset("global_idx", "data")}
      }`;
                } else m = `
        let outputIndices = ${f.offsetToIndices(`global_idx * ${a}`)};
        let inputOffset = ${p.broadcastedIndicesToOffset("outputIndices", f)};
        let data = ${f.type.value}(${p.getByOffset(`inputOffset / ${s}`)});
        ${f.setByOffset("global_idx", "data")}
      }`;
                return `
    ${c.registerUniform("vec_size", "u32").declareVariables(p, f)}
    ${c.mainStart()}
    ${c.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.vec_size")}
    ${m}`;
            }, l = [
                {
                    type: 12,
                    data: u
                },
                ...P(t, r)
            ];
            return {
                name: "Expand",
                shaderCache: {
                    hint: `${r.length};${s}${a}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getShaderSource: d,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: r,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(u / 64)
                        },
                        programUniforms: l
                    })
            };
        }, Ns = (e1)=>{
            Pl(e1.inputs), e1.compute(Bl(e1.inputs), {
                inputs: [
                    0
                ]
            });
        };
    });
    var Dl, Gs, Ws = k(()=>{
        "use strict";
        L();
        F();
        j();
        rn();
        Dl = (e1)=>{
            let t = e1[0].dataType, n = x.size(e1[0].dims), r = x.size(e1[1].dims), o = r % 4 === 0, i = (s)=>{
                let a = S("x", t, [
                    1
                ], 4), u = S("bias", t, [
                    1
                ], 4), d = C("y", t, [
                    1
                ], 4), l = [
                    {
                        name: "output_vec_size",
                        type: "u32"
                    },
                    {
                        name: "bias_size",
                        type: "u32"
                    }
                ], c = (f)=>`
      let bias${f}_offset: u32 = (global_idx * 4 + ${f}) % uniforms.bias_size;
      let bias${f} = ${u.getByOffset(`bias${f}_offset / 4`)}[bias${f}_offset % 4];`, p = o ? `
      let bias = ${u.getByOffset("global_idx % (uniforms.bias_size / 4)")};` : `${c(0)}${c(1)}${c(2)}${c(3)}
      let bias = ${a.type.value}(bias0, bias1, bias2, bias3);`;
                return `${s.registerUniforms(l).declareVariables(a, u, d)}

    ${Qn(ce(t))}

    ${s.mainStart(Je)}
      ${s.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_vec_size")}

      let x = ${a.getByOffset("global_idx")};
      ${p}
      let x_in = x + bias;
      ${d.setByOffset("global_idx", Xn("x_in"))}
    }`;
            };
            return {
                name: "FastGeluWithBias",
                shaderCache: {
                    hint: `${o}`,
                    inputDependencies: [
                        "type",
                        "type"
                    ]
                },
                getShaderSource: i,
                getRunData: (s)=>({
                        outputs: [
                            {
                                dims: s[0].dims,
                                dataType: s[0].dataType
                            }
                        ],
                        programUniforms: [
                            {
                                type: 12,
                                data: Math.ceil(n / 4)
                            },
                            {
                                type: 12,
                                data: r
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(n / Je / 4)
                        }
                    })
            };
        }, Gs = (e1)=>{
            e1.inputs.length < 2 || x.size(e1.inputs[1].dims) === 0 ? Ri(e1) : e1.compute(Dl(e1.inputs));
        };
    });
    var Ol, Ml, Hs, qs, Fs = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Ol = (e1)=>{
            if (!e1 || e1.length !== 2) throw new Error("Gather requires 2 inputs.");
        }, Ml = (e1, t)=>{
            let n = e1[0].dims, r = e1[1].dims, o = n.length, i = x.normalizeAxis(t.axis, o), s = n.slice(0);
            s.splice(i, 1, ...r);
            let a = n[i], u = e1[0].dataType === 9 ? 4 : 1, d = Math.ceil(x.size(s) / u), l = [
                {
                    type: 12,
                    data: d
                },
                {
                    type: 6,
                    data: a
                },
                {
                    type: 12,
                    data: i
                },
                ...P(e1[0].dims, e1[1].dims, s)
            ], c = (p)=>{
                let f = S("data", e1[0].dataType, e1[0].dims.length, u), m = S("inputIndices", e1[1].dataType, e1[1].dims.length), h = C("output", e1[0].dataType, s.length, u), b = (g)=>{
                    let _ = r.length, w = `var indicesIndices${g}  = ${m.type.indices}(0);`;
                    for(let v = 0; v < _; v++)w += `${_ > 1 ? `indicesIndices${g}[${v}]` : `indicesIndices${g}`} = ${s.length > 1 ? `outputIndices${g}[uniforms.axis + ${v}]` : `outputIndices${g}`};`;
                    w += `
          var idx${g} = ${m.getByIndices(`indicesIndices${g}`)};
          if (idx${g} < 0) {
            idx${g} = idx${g} + uniforms.axisDimLimit;
          }
          var dataIndices${g} : ${f.type.indices};
        `;
                    for(let v = 0, $ = 0; v < o; v++)v === i ? (w += `${o > 1 ? `dataIndices${g}[${v}]` : `dataIndices${g}`} = u32(idx${g});`, $ += _) : (w += `${o > 1 ? `dataIndices${g}[${v}]` : `dataIndices${g}`} = ${s.length > 1 ? `outputIndices${g}[${$}]` : `outputIndices${g}`};`, $++);
                    return w;
                }, y;
                if (e1[0].dataType === 9) {
                    let g = (_, w, v = "")=>`
          let outputIndices${w} = ${h.offsetToIndices(`outputOffset + ${w}u`)};
          ${b(w)};
          let offset${w} = ${f.indicesToOffset(`dataIndices${w}`)};
          let index${w} = offset${w} / 4u;
          let component${w} = offset${w} % 4u;
          ${_}[${w}] = ${v}(${f.getByOffset(`index${w}`)}[component${w}]);
        `;
                    y = `
        let outputOffset = global_idx * ${u};
        var value = vec4<u32>(0);
        ${g("value", 0, "u32")}
        ${g("value", 1, "u32")}
        ${g("value", 2, "u32")}
        ${g("value", 3, "u32")}
        ${h.setByOffset("global_idx", "value")}
      `;
                } else y = `
      let outputIndices = ${h.offsetToIndices("global_idx")};
      ${b("")};
      let value = ${f.getByIndices("dataIndices")};
      ${h.setByOffset("global_idx", "value")};
      `;
                return `
      ${p.registerUniform("outputSize", "u32").registerUniform("axisDimLimit", "i32").registerUniform("axis", "u32").declareVariables(f, m, h)}
      ${p.mainStart()}
        ${p.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
        ${y}
      }`;
            };
            return {
                name: "Gather",
                shaderCache: {
                    hint: t.cacheKey,
                    inputDependencies: [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: s,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(d / 64)
                        },
                        programUniforms: l
                    }),
                getShaderSource: c
            };
        }, Hs = (e1)=>G({
                axis: e1.axis
            }), qs = (e1, t)=>{
            let n = e1.inputs;
            Ol(n), e1.compute(Ml(e1.inputs, t));
        };
    });
    var Ul, Ks, js, Zs = k(()=>{
        "use strict";
        L();
        F();
        j();
        Ul = (e1, t, n, r, o, i, s, a, u)=>{
            let d = [
                {
                    type: 12,
                    data: i
                },
                {
                    type: 12,
                    data: r
                },
                {
                    type: 12,
                    data: o
                },
                {
                    type: 12,
                    data: n
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 12,
                    data: a
                },
                {
                    type: 12,
                    data: u
                }
            ], l = [
                i
            ];
            d.push(...P(t.dims, l));
            let c = (p)=>{
                let f = S("indices_data", t.dataType, t.dims.length), m = C("input_slice_offsets_data", 12, 1, 1), h = [
                    f,
                    m
                ], b = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "batch_dims",
                        type: "u32"
                    },
                    {
                        name: "input_dims",
                        type: "u32",
                        length: o.length
                    },
                    {
                        name: "sizes_from_slice_dims_data",
                        type: "u32",
                        length: n.length
                    },
                    {
                        name: "num_slices_per_batch",
                        type: "u32"
                    },
                    {
                        name: "input_batch_stride",
                        type: "u32"
                    },
                    {
                        name: "num_slice_dims",
                        type: "u32"
                    }
                ];
                return `
  ${p.registerUniforms(b).declareVariables(...h)}
  ${p.mainStart()}
    ${p.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    let batch_idx = global_idx / uniforms.num_slices_per_batch;
    let base_offset = batch_idx * uniforms.input_batch_stride;

    let slice_indices_base_offset = global_idx * uniforms.num_slice_dims;
    var relative_slice_offset = 0;
    for (var dim_idx = 0u; dim_idx < uniforms.num_slice_dims; dim_idx ++) {
      var index = i32(indices_data[dim_idx + slice_indices_base_offset].x);
      let input_dim_idx = uniforms.batch_dims + dim_idx;
      if (index < 0) {
        ${o.length === 1 ? "index += i32(uniforms.input_dims);" : "index += i32(uniforms.input_dims[input_dim_idx]);"}
      }
      ${n.length === 1 ? "relative_slice_offset += index * i32(uniforms.sizes_from_slice_dims_data);" : "relative_slice_offset += index * i32(uniforms.sizes_from_slice_dims_data[dim_idx]);"}
    }

    input_slice_offsets_data[global_idx] =  base_offset + u32(relative_slice_offset);
  }`;
            };
            return e1.compute({
                name: "computeSliceOffsets",
                shaderCache: {
                    hint: `${o.length}_${n.length}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: l,
                                dataType: e1.inputs[1].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(i / 64)
                        },
                        programUniforms: d
                    }),
                getShaderSource: c
            }, {
                inputs: [
                    t
                ],
                outputs: [
                    -1
                ]
            })[0];
        }, Ks = (e1, t)=>{
            let n = e1.inputs, r = n[0].dims, o = n[0].dataType, i = n[1].dims, s = i[i.length - 1], a = x.sizeToDimension(i, i.length - 1), u = x.sizeFromDimension(r, t.batchDims + s), d = x.sizeToDimension(r, t.batchDims), l = x.sizeFromDimension(r, t.batchDims), c = a / d, p = new Array(s), f = u;
            for(let w = 0; w < s; ++w)p[s - 1 - w] = f, f *= r[t.batchDims + s - 1 - w];
            let m = Ul(e1, n[1], p, t.batchDims, r, a, c, l, s), h = t.batchDims + s;
            if (h > r.length) throw new Error("last dimension of indices must not be larger than rank of input tensor");
            let b = i.slice(0, -1).concat(r.slice(h)), y = x.size(b), g = [
                {
                    type: 12,
                    data: y
                },
                {
                    type: 12,
                    data: u
                },
                ...P(n[0].dims, m.dims, b)
            ], _ = (w)=>{
                let v = S("data", n[0].dataType, n[0].dims.length), $ = S("slice_offsets", 12, m.dims.length), T = C("output", n[0].dataType, b.length);
                return `
          ${w.registerUniform("output_size", "u32").registerUniform("slice_size", "u32").declareVariables(v, $, T)}
            ${w.mainStart()}
            ${w.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
          let slice_offset = slice_offsets[global_idx / uniforms.slice_size];
          output[global_idx] = data[u32(slice_offset) + global_idx % uniforms.slice_size];
        }`;
            };
            e1.compute({
                name: "GatherND",
                shaderCache: {
                    hint: t.cacheKey,
                    inputDependencies: [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: b,
                                dataType: o
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(y / 64)
                        },
                        programUniforms: g
                    }),
                getShaderSource: _
            }, {
                inputs: [
                    n[0],
                    m
                ]
            });
        }, js = (e1)=>({
                batchDims: e1.batch_dims,
                cacheKey: ""
            });
    });
    var Rl, Vl, Qs, Xs, Ys = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Rl = (e1, t)=>{
            if (e1.length < 3 || e1.length > 4) throw new Error("GatherBlockQuantized requires 3 or 4 inputs.");
            let n = x.normalizeAxis(t.quantizeAxis, e1[0].dims.length), r = t.blockSize, o = e1[0], i = e1[2], s = e1.length === 4 ? e1[3] : void 0;
            if (i.dims.length !== o.dims.length || !o.dims.map((a, u)=>u === n ? Math.ceil(a / r) === i.dims[u] : a === i.dims[u]).reduce((a, u)=>a && u, !0)) throw new Error("Scales must have the same rank as the input tensor and the dims should match except on gatherAxis.");
            if (s) {
                if (s.dataType !== o.dataType) throw new Error("Zero point must have the same data type as the input tensor.");
                if (s.dims.length !== i.dims.length || !s.dims.map((a, u)=>a === i.dims[u]).reduce((a, u)=>a && u, !0)) throw new Error("Zero point must have the same rank as the input tensor and the dims should match except on quantizeAxis.");
            }
        }, Vl = (e1, t)=>{
            let n = e1[0].dims, r = e1[1].dims, o = n.length, i = x.normalizeAxis(t.gatherAxis, o), s = x.normalizeAxis(t.quantizeAxis, o), a = n.slice(0);
            a.splice(i, 1, ...r);
            let u = x.size(a), d = e1[2].dataType, c = e1[0].dataType === 22, p = [
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 12,
                    data: i
                },
                {
                    type: 12,
                    data: t.blockSize
                },
                ...P(...e1.map((m, h)=>m.dims), a)
            ], f = (m)=>{
                let h = S("data", e1[0].dataType, e1[0].dims.length), b = S("inputIndices", e1[1].dataType, e1[1].dims.length), y = S("scales", e1[2].dataType, e1[2].dims.length), g = e1.length > 3 ? S("zeroPoint", e1[3].dataType, e1[3].dims.length) : void 0, _ = C("output", d, a.length), w = [
                    h,
                    b,
                    y
                ];
                g && w.push(g);
                let v = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "quantize_axis",
                        type: "u32"
                    },
                    {
                        name: "gather_axis",
                        type: "u32"
                    },
                    {
                        name: "block_size",
                        type: "u32"
                    }
                ];
                return `
        ${m.registerUniforms(v).declareVariables(...w, _)}
        ${m.mainStart()}
        let output_indices = ${_.offsetToIndices("global_idx")};
        var indices_indices = ${b.type.indices}(0);
        ${r.length > 1 ? `
          for (var i: u32 = 0; i < ${r.length}; i++) {
            let index = ${_.indicesGet("output_indices", "uniforms.gather_axis + i")};
            ${b.indicesSet("indices_indices", "i", "index")};
          }` : `indices_indices = ${_.indicesGet("output_indices", "uniforms.gather_axis")};`};
        var data_indices = ${h.type.indices}(0);
        for (var i: u32 = 0; i < uniforms.gather_axis; i++) {
          let index = ${_.indicesGet("output_indices", "i")};
          ${h.indicesSet("data_indices", "i", "index")};
        }
        var index_from_indices = ${b.getByIndices("indices_indices")};
        if (index_from_indices < 0) {
          index_from_indices += ${n[i]};
        }
        ${h.indicesSet("data_indices", "uniforms.gather_axis", "u32(index_from_indices)")};
        for (var i = uniforms.gather_axis + 1; i < ${a.length}; i++) {
          let index = ${_.indicesGet("output_indices", `i + ${r.length} - 1`)};
          ${h.indicesSet("data_indices", "i", "index")};
        }
        let data_offset = ${h.indicesToOffset("data_indices")};
        let data_index = data_offset % 8;
        // Convert 4-bit packed data to 8-bit packed data.
        let packed_4bit_quantized_data = ${h.getByOffset("data_offset / 8")};
        let packed_8bit_quantized_data = (packed_4bit_quantized_data >> (4 * (data_index % 2))) & 0x0f0f0f0f;
        let quantized_data_vec = ${c ? "unpack4xI8" : "unpack4xU8"}(u32(packed_8bit_quantized_data));
        let quantized_data = quantized_data_vec[data_index / 2];
        var scale_indices = data_indices;
        let quantize_axis_index = ${y.indicesGet("data_indices", "uniforms.quantize_axis")} / uniforms.block_size;
        ${y.indicesSet("scale_indices", "uniforms.quantize_axis", "quantize_axis_index")};
        var scale = ${y.getByIndices("scale_indices")};
        ${g ? `
              let zero_point_indices = scale_indices;
              let zero_point_offset = ${g.indicesToOffset("zero_point_indices")};
              let zero_point_index = zero_point_offset % 8;
              let packed_4bit_zero_points = ${g.getByOffset("zero_point_offset / 8")};
              let packed_8bit_zero_points = (packed_4bit_zero_points >> (4 * (zero_point_index % 2))) & 0x0f0f0f0f;
              let zero_point_vec = ${c ? "unpack4xI8" : "unpack4xU8"}(u32(packed_8bit_zero_points));
              let zero_point = zero_point_vec[zero_point_index / 2];` : "var zero_point = 0"};
        let dequantized_data = ${ce(d)}(quantized_data - zero_point) * scale;
        ${_.setByOffset("global_idx", "dequantized_data")};
    }`;
            };
            return {
                name: "GatherBlockQuantized",
                shaderCache: {
                    hint: `${t.cacheKey};${e1.filter((m, h)=>h !== 1).map((m)=>m.dims.join("_")).join(";")}`,
                    inputDependencies: Array.from({
                        length: e1.length
                    }, (m, h)=>"rank")
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: a,
                                dataType: d
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(u / 64)
                        },
                        programUniforms: p
                    }),
                getShaderSource: f
            };
        }, Qs = (e1, t)=>{
            let n = e1.inputs;
            Rl(n, t), e1.compute(Vl(e1.inputs, t));
        }, Xs = (e1)=>G({
                blockSize: e1.blockSize,
                gatherAxis: e1.gatherAxis,
                quantizeAxis: e1.quantizeAxis
            });
    });
    var Nl, Ll, Js, ea, ta = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Nl = (e1)=>{
            if (!e1 || e1.length !== 2) throw new Error("GatherElements requires 2 inputs.");
            if (e1[0].dims.length < 1) throw new Error("GatherElements requires that the data input be rank >= 1.");
            if (e1[0].dims.length !== e1[1].dims.length) throw new Error(`GatherElements requires that the data input and
                     indices input tensors be of same rank.`);
        }, Ll = (e1, t)=>{
            let n = e1[0].dims, r = e1[0].dataType, o = n.length, i = e1[1].dims, s = e1[1].dataType, a = x.normalizeAxis(t.axis, o), u = n[a], d = i.slice(0), l = x.size(d), c = S("input", r, o), p = S("indicesInput", s, i.length), f = C("output", r, d.length), m = [
                {
                    type: 12,
                    data: l
                },
                {
                    type: 6,
                    data: u
                },
                {
                    type: 12,
                    data: a
                }
            ];
            return m.push(...P(n, i, d)), {
                name: "GatherElements",
                shaderCache: {
                    inputDependencies: [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: d,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(l / 64)
                        },
                        programUniforms: m
                    }),
                getShaderSource: (y)=>`
      ${y.registerUniform("outputSize", "u32").registerUniform("axisDimLimit", "i32").registerUniform("axis", "u32").declareVariables(c, p, f)}
      ${y.mainStart()}
      ${y.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}

      let outputIndices = ${f.offsetToIndices("global_idx")};

      var idx = ${p.getByOffset("global_idx")};
      if (idx < 0) {
        idx = idx + uniforms.axisDimLimit;
      }
      var inputIndices = ${c.type.indices}(outputIndices);
      ${c.indicesSet("inputIndices", "uniforms.axis", "u32(idx)")};
      let value = ${c.getByIndices("inputIndices")};

      ${f.setByOffset("global_idx", "value")};
  }`
            };
        }, Js = (e1)=>G({
                axis: e1.axis
            }), ea = (e1, t)=>{
            let n = e1.inputs;
            Nl(n), e1.compute(Ll(e1.inputs, t));
        };
    });
    var Gl, Wl, na, ra, oa = k(()=>{
        "use strict";
        L();
        F();
        j();
        Gl = (e1)=>{
            if (!e1) throw new Error("Input is missing");
            if (e1.length < 2 || e1.length > 3) throw new Error("Invaid input number.");
            if (e1.length === 3 && e1[2].dims.length > 2) throw new Error("Invalid input shape of C");
            if (e1[0].dataType !== e1[1].dataType || e1.length === 3 && e1[0].dataType !== e1[2].dataType) throw new Error("Input types are mismatched");
        }, Wl = (e1, t)=>{
            let n = e1[0].dims.slice(), r = e1[1].dims.slice(), [o, i, s] = Ht.getShapeOfGemmResult(n, t.transA, r, t.transB, e1.length === 3 ? e1[2].dims : void 0), a = [
                o,
                i
            ];
            if (!a) throw new Error("Can't use gemm on the given tensors");
            let u = 16, d = Math.ceil(i / u), l = Math.ceil(o / u), c = !0, p = x.size(a), f = [
                {
                    type: 12,
                    data: c ? d : p
                },
                {
                    type: 12,
                    data: o
                },
                {
                    type: 12,
                    data: i
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 1,
                    data: t.alpha
                },
                {
                    type: 1,
                    data: t.beta
                }
            ], m = [
                "type",
                "type"
            ];
            e1.length === 3 && (f.push(...P(e1[2].dims)), m.push("rank")), f.push(...P(a));
            let h = (y)=>{
                let g = "";
                t.transA && t.transB ? g = "value += a[k * uniforms.M + m] * b[n * uniforms.K + k];" : t.transA && !t.transB ? g = "value += a[k * uniforms.M + m] * b[k * uniforms.N + n];" : !t.transA && t.transB ? g = "value += a[m * uniforms.K + k] * b[n * uniforms.K + k];" : !t.transA && !t.transB && (g = "value += a[m * uniforms.K + k] * b[k * uniforms.N + n];");
                let _ = t.alpha === 1 ? "" : "value *= uniforms.alpha;", w = S("a", e1[0].dataType, e1[0].dims), v = S("b", e1[1].dataType, e1[1].dims), $ = w.type.value, T = null, I = [
                    w,
                    v
                ];
                e1.length === 3 && (T = S("c", e1[2].dataType, e1[2].dims.length), I.push(T));
                let A = C("output", e1[0].dataType, a.length);
                I.push(A);
                let z = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    },
                    {
                        name: "alpha",
                        type: "f32"
                    },
                    {
                        name: "beta",
                        type: "f32"
                    }
                ];
                return `
  ${y.registerUniforms(z).declareVariables(...I)}

  ${y.mainStart()}
    ${y.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}

    let m = global_idx / uniforms.N;
    let n = global_idx % uniforms.N;

    var value = ${$}(0);
    for (var k: u32 = 0u; k < uniforms.K; k++) {
      ${g}
    }

    ${_}
    ${T != null ? `let cOffset = ${T.broadcastedIndicesToOffset("vec2(m, n)", A)}; value += ${$}(uniforms.beta) * ${T.getByOffset("cOffset")};` : ""}
    output[global_idx] = value;
  }`;
            }, b = (y)=>{
                let g = S("a", e1[0].dataType, e1[0].dims), _ = S("b", e1[1].dataType, e1[1].dims), w = null, v = [
                    g,
                    _
                ];
                e1.length === 3 && (w = S("c", e1[2].dataType, e1[2].dims.length), v.push(w));
                let $ = C("output", e1[0].dataType, a.length);
                v.push($);
                let T = [
                    {
                        name: "num_tile_n",
                        type: "u32"
                    },
                    {
                        name: "M",
                        type: "u32"
                    },
                    {
                        name: "N",
                        type: "u32"
                    },
                    {
                        name: "K",
                        type: "u32"
                    },
                    {
                        name: "alpha",
                        type: "f32"
                    },
                    {
                        name: "beta",
                        type: "f32"
                    }
                ], I = "", A = "";
                t.transA && t.transB ? (A = `
      var col = tile_row_start + local_id.x;
      var row = k_start + local_id.y;
      if (col < uniforms.M && row < uniforms.K) {
        tile_a[local_id.y][local_id.x] = a[row * uniforms.M + col];
      } else {
        tile_a[local_id.y][local_id.x] = ${g.type.value}(0);
      }

      col = k_start + local_id.x;
      row = tile_col_start + local_id.y;
      if (col < uniforms.K && row < uniforms.N) {
        tile_b[local_id.y][local_id.x] = b[row * uniforms.K + col];
      } else {
        tile_b[local_id.y][local_id.x] = ${_.type.value}(0);
      }
      `, I = "value += tile_a[k][local_id.y] * tile_b[local_id.x][k];") : t.transA && !t.transB ? (A = `
      var col = tile_row_start + local_id.x;
      var row = k_start + local_id.y;
      if (col < uniforms.M && row < uniforms.K) {
        tile_a[local_id.y][local_id.x] = a[row * uniforms.M + col];
      } else {
        tile_a[local_id.y][local_id.x] = ${g.type.value}(0);
      }

      col = tile_col_start + local_id.x;
      row = k_start + local_id.y;
      if (col < uniforms.N && row < uniforms.K) {
        tile_b[local_id.y][local_id.x] = b[row * uniforms.N + col];
      } else {
        tile_b[local_id.y][local_id.x] = ${_.type.value}(0);
      }
      `, I = "value += tile_a[k][local_id.y] * tile_b[k][local_id.x];") : !t.transA && t.transB ? (A = `
      var col = k_start + local_id.x;
      var row = tile_row_start + local_id.y;
      if (col < uniforms.K && row < uniforms.M) {
        tile_a[local_id.y][local_id.x] = a[row * uniforms.K + col];
      } else {
        tile_a[local_id.y][local_id.x] = ${g.type.value}(0);
      }

      col = k_start + local_id.x;
      row = tile_col_start + local_id.y;
      if (col < uniforms.K && row < uniforms.N) {
        tile_b[local_id.y][local_id.x] = b[row * uniforms.K + col];
      } else {
        tile_b[local_id.y][local_id.x] = ${_.type.value}(0);
      }
      `, I = "value += tile_a[local_id.y][k] * tile_b[local_id.x][k];") : !t.transA && !t.transB && (A = `
      var col = k_start + local_id.x;
      var row = tile_row_start + local_id.y;
      if (col < uniforms.K && row < uniforms.M) {
        tile_a[local_id.y][local_id.x] = a[row * uniforms.K + col];
      } else {
        tile_a[local_id.y][local_id.x] = ${g.type.value}(0);
      }

      col = tile_col_start + local_id.x;
      row = k_start + local_id.y;
      if (col < uniforms.N && row < uniforms.K) {
        tile_b[local_id.y][local_id.x] = b[row * uniforms.N + col];
      } else {
        tile_b[local_id.y][local_id.x] = ${_.type.value}(0);
      }
      `, I = "value += tile_a[local_id.y][k] * tile_b[k][local_id.x];");
                let z = t.alpha === 1 ? "" : "value *= uniforms.alpha;";
                return `
  ${y.registerUniforms(T).declareVariables(...v)}
  var<workgroup> tile_a: array<array<${g.type.storage}, ${u}>, ${u}>;
  var<workgroup> tile_b: array<array<${_.type.storage}, ${u}>, ${u}>;
  ${y.mainStart([
                    u,
                    u,
                    1
                ])}
    let tile_col_start = (workgroup_index % uniforms.num_tile_n) * ${u};
    let tile_row_start = (workgroup_index / uniforms.num_tile_n) * ${u};
    let num_tiles = (uniforms.K - 1) / ${u} + 1;
    var k_start = 0u;
    var value = ${$.type.value}(0);
    for (var t: u32 = 0u; t < num_tiles; t++) {
      ${A}
      k_start = k_start + ${u};
      workgroupBarrier();

      for (var k: u32 = 0u; k < ${u}; k++) {
        ${I}
      }
      workgroupBarrier();
    }

    ${z}
    let m = tile_row_start + local_id.y;
    let n = tile_col_start + local_id.x;
    ${w != null ? `let cOffset = ${w.broadcastedIndicesToOffset("vec2(m, n)", $)}; value += ${$.type.value}(uniforms.beta) * ${w.getByOffset("cOffset")};` : ""}
    if (m < uniforms.M && n < uniforms.N) {
      output[m * uniforms.N + n] = value;
    }
  }`;
            };
            return c ? {
                name: "GemmShared",
                shaderCache: {
                    hint: `${t.cacheKey}`,
                    inputDependencies: m
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: a,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: d * l
                        },
                        programUniforms: f
                    }),
                getShaderSource: b
            } : {
                name: "Gemm",
                shaderCache: {
                    hint: `${t.cacheKey}`,
                    inputDependencies: m
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: a,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(p / 64)
                        },
                        programUniforms: f
                    }),
                getShaderSource: h
            };
        }, na = (e1)=>{
            let t = e1.transA, n = e1.transB, r = e1.alpha, o = e1.beta;
            return {
                transA: t,
                transB: n,
                alpha: r,
                beta: o,
                cacheKey: `${e1.transA};${e1.transB};${e1.alpha === 1}`
            };
        }, ra = (e1, t)=>{
            Gl(e1.inputs), e1.compute(Wl(e1.inputs, t));
        };
    });
    var Ne, Ke, st, at, Hl, ql, Fl, Kl, jl, Zl, Ql, Xl, ia, sa, aa = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        [Ne, Ke, st, at] = [
            0,
            1,
            2,
            3
        ], Hl = (e1)=>{
            if (e1[0].dims.length !== 4) throw new Error("only 4-D tensor is supported.");
            if (e1[0].dims.length !== e1[1].dims.length) throw new Error("input dimensions must be equal to grid dimensions");
            if (e1[0].dims.length - 2 !== e1[1].dims[e1[1].dims.length - 1]) throw new Error(`last dimension of grid must be equal to ${e1[0].dims.length - 2}`);
            if (e1[0].dims[0] !== e1[1].dims[0]) throw new Error("grid batch size must match input batch size");
        }, ql = `
  fn gs_get_cubic_coeffs(x: f32) -> vec4<f32> {
    let cubic_alpha = -0.75f;
    let x_abs = abs(x);
    var coeffs: vec4<f32>;
    coeffs[0] = (((cubic_alpha * (x_abs + 1) - 5 * cubic_alpha) * (x_abs + 1) + 8 * cubic_alpha) * (x_abs + 1) - 4 * cubic_alpha);
    coeffs[1] = (((cubic_alpha + 2) * x_abs - (cubic_alpha + 3)) * x_abs * x_abs + 1);
    coeffs[2] = (((cubic_alpha + 2) * (1 - x_abs) - (cubic_alpha + 3)) * (1 - x_abs) * (1 - x_abs) + 1);
    coeffs[3] = (((cubic_alpha * (2 - x_abs) - 5 * cubic_alpha) * (2 - x_abs) + 8 * cubic_alpha) * (2 - x_abs) - 4 * cubic_alpha);
    return coeffs;
  }
`, Fl = (e1)=>`
  fn gs_bicubic_interpolate(p: mat4x4<${e1}>, x: f32, y: f32) -> ${e1} {
    var v: vec4<f32>;
    var coeffs = gs_get_cubic_coeffs(x);
    for (var i = 0; i < 4; i++) {
      v[i] = coeffs[0] * p[i][0] + coeffs[1] * p[i][1] + coeffs[2] * p[i][2] + coeffs[3] * p[i][3];
    }
    coeffs = gs_get_cubic_coeffs(y);
    let pixel = ${e1}(coeffs[0] * v[0] + coeffs[1] * v[1] + coeffs[2] * v[2] + coeffs[3] * v[3]);
    return pixel;
  }
`, Kl = (e1)=>`
  fn gs_denormalize(n: f32, length: i32) -> f32 {
    ${e1.alignCorners === 0 ? `
    // alignCorners: false => [-1, 1] to [-0.5, length - 0.5]
    return ((n + 1.0) * f32(length) - 1.0) / 2.0;
    ` : `
    // alignCorners: true => [-1, 1] to [0, length - 1]
    return (n + 1.0) / 2.0 * (f32(length - 1));
    `}
  }
`, jl = (e1)=>`
  ${e1.paddingMode === "reflection" ? `
      fn gs_reflect(x: i32, x_min: f32, x_max: f32) -> u32 {
        var dx = 0.0;
        var fx = f32(x);
        let range = x_max - x_min;
        if (fx < x_min) {
          dx = x_min - fx;
          let n = u32(dx / range);
          let r = dx - f32(n) * range;
          if (n % 2 == 0) {
            fx = x_min + r;
          } else {
            fx = x_max - r;
          }
        } else if (fx > x_max) {
          dx = fx - x_max;
          let n = u32(dx / range);
          let r = dx - f32(n) * range;
          if (n % 2 == 0) {
            fx = x_max - r;
          } else {
            fx = x_min + r;
          }
        }
        return u32(fx);
      }` : ""}
`, Zl = (e1, t, n)=>`
  fn pixel_at_grid(r: i32, c: i32, H: i32, W: i32, batch: u32, channel: u32, border: vec4<f32>) -> ${t} {
     var pixel = ${t}(0);
     var indices = vec4<u32>(0);
     indices[${Ne}] = batch;
     indices[${Ke}] = channel;` + (()=>{
                switch(n.paddingMode){
                    case "zeros":
                        return `
          if (r >= 0 && r < H && c >=0 && c < W) {
            indices[${st}] = u32(r);
            indices[${at}] = u32(c);
          } else {
            return ${t}(0);
          }
        `;
                    case "border":
                        return `
          indices[${st}] = u32(clamp(r, 0, H - 1));
          indices[${at}] = u32(clamp(c, 0, W - 1));
        `;
                    case "reflection":
                        return `
          indices[${st}] = gs_reflect(r, border[1], border[3]);
          indices[${at}] = gs_reflect(c, border[0], border[2]);
        `;
                    default:
                        throw new Error(`padding mode ${n.paddingMode} is not supported`);
                }
            })() + `
    return ${e1.getByIndices("indices")};
  }
`, Ql = (e1, t, n)=>(()=>{
                switch(n.mode){
                    case "nearest":
                        return `
          let result = pixel_at_grid(i32(round(y)), i32(round(x)), H_in, W_in, indices[${Ne}], indices[${Ke}], border);
        `;
                    case "bilinear":
                        return `
          let x1 = i32(floor(x));
          let y1 = i32(floor(y));
          let x2 = x1 + 1;
          let y2 = y1 + 1;

          let p11 = pixel_at_grid(y1, x1, H_in, W_in, indices[${Ne}], indices[${Ke}], border);
          let p12 = pixel_at_grid(y1, x2, H_in, W_in, indices[${Ne}], indices[${Ke}], border);
          let p21 = pixel_at_grid(y2, x1, H_in, W_in, indices[${Ne}], indices[${Ke}], border);
          let p22 = pixel_at_grid(y2, x2, H_in, W_in, indices[${Ne}], indices[${Ke}], border);

          let dx2 = ${t}(f32(x2) - x);
          let dx1 = ${t}(x - f32(x1));
          let dy2 = ${t}(f32(y2) - y);
          let dy1 = ${t}(y - f32(y1));
          let result = dy2 * (dx2 * p11 + dx1 * p12) + dy1 * (dx2 * p21 + dx1 * p22);
        `;
                    case "bicubic":
                        return `
          let x0 = i32(floor(x)) - 1;
          let y0 = i32(floor(y)) - 1;
          var p: mat4x4<${t}>;
          for (var h = 0; h < 4; h++) {
            for (var w = 0; w < 4; w++) {
              p[h][w] = pixel_at_grid(h + y0, w + x0, H_in, W_in, indices[${Ne}], indices[${Ke}], border);
            }
          }

          let dx = x - f32(x0 + 1);
          let dy = y - f32(y0 + 1);
          let result = gs_bicubic_interpolate(p, dx, dy);
        `;
                    default:
                        throw new Error(`mode ${n.mode} is not supported`);
                }
            })() + `${e1.setByOffset("global_idx", "result")}`, Xl = (e1, t)=>{
            let n = S("x", e1[0].dataType, e1[0].dims.length), r = [
                e1[1].dims[0],
                e1[1].dims[1],
                e1[1].dims[2]
            ], o = S("grid", e1[1].dataType, r.length, 2), i = [
                e1[0].dims[0],
                e1[0].dims[1],
                e1[1].dims[1],
                e1[1].dims[2]
            ];
            t.format === "NHWC" && (i = [
                e1[0].dims[0],
                e1[1].dims[1],
                e1[1].dims[2],
                e1[0].dims[3]
            ], [Ne, Ke, st, at] = [
                0,
                3,
                1,
                2
            ]);
            let s = C("output", e1[0].dataType, i.length), a = n.type.value, u = x.size(i), d = [
                {
                    type: 12,
                    data: u
                },
                ...P(e1[0].dims, r, i)
            ], l = (c)=>`
  ${c.registerUniform("output_size", "u32").declareVariables(n, o, s)}
  ${ql}
  ${Fl(a)}
  ${Kl(t)}
  ${jl(t)}
  ${Zl(n, a, t)}

  ${c.mainStart()}
    ${c.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
      let H_in = i32(uniforms.x_shape[${st}]);
      let W_in = i32(uniforms.x_shape[${at}]);

      ${t.alignCorners === 0 ? `
      let x_min = -0.5;
      let x_max = f32(W_in) - 0.5;
      let y_min = -0.5;
      let y_max = f32(H_in) - 0.5;
      ` : `
      let x_min = 0.0;
      let x_max = f32(W_in) - 1.0;
      let y_min = 0.0;
      let y_max = f32(H_in) - 1.0;
      `};
      let border = vec4<f32>(x_min, y_min, x_max, y_max);

      let indices = ${s.offsetToIndices("global_idx")};
      var grid_indices = vec3<u32>(indices[${Ne}], indices[${st}], indices[${at}]);
      let nxy = ${o.getByIndices("grid_indices")};
      var x = gs_denormalize(f32(nxy[0]), W_in);
      var y = gs_denormalize(f32(nxy[1]), H_in);

      ${Ql(s, a, t)}
  }`;
            return {
                name: "GridSample",
                shaderCache: {
                    hint: `${t.cacheKey}`,
                    inputDependencies: [
                        "type",
                        "type"
                    ]
                },
                getRunData: (c)=>{
                    let p = x.size(i);
                    return {
                        outputs: [
                            {
                                dims: i,
                                dataType: c[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(p / 64)
                        },
                        programUniforms: d
                    };
                },
                getShaderSource: l
            };
        }, ia = (e1, t)=>{
            Hl(e1.inputs), e1.compute(Xl(e1.inputs, t));
        }, sa = (e1)=>G({
                alignCorners: e1.align_corners,
                mode: e1.mode,
                paddingMode: e1.padding_mode,
                format: e1.format
            });
    });
    var be, ec, da, ua, tc, wt, la, ar = k(()=>{
        "use strict";
        L();
        F();
        ie();
        Qt();
        tn();
        j();
        Ve();
        be = (e1, t)=>e1.length > t && e1[t].dims.length > 0 ? e1[t] : void 0, ec = (e1, t)=>{
            let n = e1[0], r = be(e1, 1), o = be(e1, 2), i = be(e1, 3), s = be(e1, 4), a = be(e1, 5), u = be(e1, 6), d = be(e1, 7);
            if (n.dims.length !== 3 && n.dims.length !== 5) throw new Error("Input query is expected to have 3 or 5 dimensions");
            let l = n.dims[0], c = n.dims[1], p = n.dims.length === 3 ? n.dims[2] : t.numHeads * n.dims[4], f = c, m = 0, h = 0, b = Math.floor(p / t.numHeads);
            if (u && d && x.size(u.dims) && x.size(d.dims)) {
                if (u.dims.length !== 4) throw new Error('Input "past_key" is expected to have 4 dimensions');
                if (u.dims[0] !== l || u.dims[1] !== t.numHeads || u.dims[3] !== b) throw new Error('Input "past_key" shape (batch_size, num_heads, past_sequence_length, head_size)');
                if (d.dims[0] !== l || d.dims[1] !== t.numHeads || d.dims[3] !== b) throw new Error('Input "past_value" shape (batch_size, num_heads, past_sequence_length, head_size)');
                if (u.dims[2] !== d.dims[2]) throw new Error('Input "past_key" and "past_value" shall have same dim 2 (past_sequence_length)');
                if (d.dims.length !== 4) throw new Error('Input "past_value" is expected to have 4 dimensions');
                m = u.dims[2], h = u.dims[2];
            } else if (u && x.size(u.dims) || d && x.size(d.dims)) throw new Error('Input "past_key" and "past_value" shall be both present or both absent');
            let y;
            if (r && x.size(r.dims) > 0) {
                if (n.dims.length !== 3) throw new Error('Input "query" is expected to have 3 dimensions when key is given');
                if (r.dims.length < 3 || r.dims.length > 5) throw new Error('Input "key" is expected to have 3, 4, or 5 dimensions');
                if (n.dims[0] !== r.dims[0]) throw new Error('Input "query" and "key" shall have same dim 0 (batch size)');
                if (r.dims.length === 3) {
                    if (r.dims[2] !== n.dims[2]) throw new Error('Input "query" and "key" shall have same dim 2 (hidden_size)');
                    y = 2, f = r.dims[1];
                } else if (r.dims.length === 5) {
                    if (r.dims[2] !== t.numHeads || r.dims[3] !== 2 || r.dims[4] !== b) throw new Error('Expect "key" shape (batch_size, kv_sequence_length, num_heads, 2, head_size) for packed kv');
                    if (o) throw new Error('Expect "value" be none when "key" has packed kv format.');
                    y = 5, f = r.dims[1];
                } else {
                    if (r.dims[1] !== t.numHeads || r.dims[3] !== b) throw new Error('Expect "key" shape (batch_size, num_heads, kv_sequence_length, head_size) for past_key');
                    y = 0, f = r.dims[2];
                }
            } else {
                if (n.dims.length !== 5) throw new Error('Input "query" is expected to have 5 dimensions when key is empty');
                if (n.dims[2] !== t.numHeads || n.dims[3] !== 3) throw new Error('Expect "query" shape (batch_size, kv_sequence_length, num_heads, 3, head_size) for packed kv');
                y = 3;
            }
            if (i && x.size(i.dims) > 0) {
                if (i.dims.length !== 1) throw new Error('Input "bias" is expected to have 1 dimension');
                if (r && r.dims.length === 5 && r.dims[3] === 2) throw new Error("bias is not allowed for packed kv.");
            }
            let g = m + f, _ = 0;
            if (s && x.size(s.dims) > 0) {
                _ = 8;
                let T = s.dims;
                throw T.length === 1 ? T[0] === l ? _ = 1 : T[0] === 3 * l + 2 && (_ = 3) : T.length === 2 && T[0] === l && T[1] === g && (_ = 5), _ === 8 ? new Error('Input "key_padding_mask" shape shall be (batch_size) or (batch_size, total_sequence_length)') : new Error("Mask not supported");
            }
            let w = !1, v = p;
            if (o && x.size(o.dims) > 0) {
                if (o.dims.length !== 3 && o.dims.length !== 4) throw new Error('Input "value" is expected to have 3 or 4 dimensions');
                if (n.dims[0] !== o.dims[0]) throw new Error('Input "query" and "value" shall have same dim 0 (batch_size)');
                if (o.dims.length === 3) {
                    if (f !== o.dims[1]) throw new Error('Input "key" and "value" shall have the same dim 1 (kv_sequence_length)');
                    v = o.dims[2];
                } else {
                    if (f !== o.dims[2]) throw new Error('Input "key" and "value" shall have the same dim 2 (kv_sequence_length)');
                    v = o.dims[1] * o.dims[3], w = !0;
                }
            }
            let $ = !1;
            if (s && x.size(s.dims) > 0) throw new Error("Key padding mask is not supported");
            if (a && x.size(a.dims) > 0) {
                if (a.dims.length !== 4) throw new Error('Input "attention_bias" is expected to have 4 dimensions');
                if (a.dims[0] !== l || a.dims[1] !== t.numHeads || a.dims[2] !== c || a.dims[3] !== g) throw new Error('Expect "attention_bias" shape (batch_size, num_heads, sequence_length, total_sequence_length)');
            }
            return {
                batchSize: l,
                sequenceLength: c,
                pastSequenceLength: m,
                kvSequenceLength: f,
                totalSequenceLength: g,
                maxSequenceLength: h,
                inputHiddenSize: 0,
                hiddenSize: p,
                vHiddenSize: v,
                headSize: b,
                vHeadSize: Math.floor(v / t.numHeads),
                numHeads: t.numHeads,
                isUnidirectional: !1,
                pastPresentShareBuffer: !1,
                maskFilterValue: t.maskFilterValue,
                maskType: _,
                scale: t.scale,
                broadcastResPosBias: $,
                passPastInKv: w,
                qkvFormat: y
            };
        }, da = (e1)=>G({
                ...e1
            }), ua = G({
            perm: [
                0,
                2,
                1,
                3
            ]
        }), tc = (e1, t, n, r, o, i, s)=>{
            let a = [
                r,
                o,
                i
            ], u = x.size(a), d = [
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 12,
                    data: i
                }
            ], l = (c)=>{
                let p = C("qkv_with_bias", t.dataType, a), f = S("qkv", t.dataType, a), m = S("bias", n.dataType, a), h = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "bias_offset",
                        type: "u32"
                    },
                    {
                        name: "hidden_size",
                        type: "u32"
                    }
                ];
                return `
  ${c.registerUniforms(h).declareVariables(f, m, p)}
  ${c.mainStart()}
    ${c.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    let bias_offset_idx = (global_idx % uniforms.hidden_size) + uniforms.bias_offset;

    qkv_with_bias[global_idx] = qkv[global_idx] + bias[bias_offset_idx];
  }`;
            };
            return e1.compute({
                name: "MultiHeadAttentionAddBias",
                shaderCache: {
                    inputDependencies: [
                        "type",
                        "type"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: a,
                                dataType: t.dataType,
                                gpuDataType: 0
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(u / 64)
                        },
                        programUniforms: d
                    }),
                getShaderSource: l
            }, {
                inputs: [
                    t,
                    n
                ],
                outputs: [
                    -1
                ]
            })[0];
        }, wt = (e1, t, n, r, o, i, s, a)=>{
            let u = i;
            if (s && x.size(s.dims) > 0) {
                if (r === 1) throw new Error("AddBiasReshape is not implemented. Please export your model with packed QKV or KV");
                return u = tc(e1, i, s, t, r, n * o, a), u = u.reshape([
                    t,
                    r,
                    n,
                    o
                ]), n === 1 || r === 1 ? u : e1.compute(pe(u, ua.perm), {
                    inputs: [
                        u
                    ],
                    outputs: [
                        -1
                    ]
                })[0];
            } else return i.dims.length === 3 && (u = i.reshape([
                t,
                r,
                n,
                o
            ])), n === 1 || r === 1 ? u : e1.compute(pe(u, ua.perm), {
                inputs: [
                    u
                ],
                outputs: [
                    -1
                ]
            })[0];
        }, la = (e1, t)=>{
            let n = ec(e1.inputs, t), r = e1.inputs[0], o = be(e1.inputs, 1), i = be(e1.inputs, 2), s = be(e1.inputs, 3), a = be(e1.inputs, 4), u = be(e1.inputs, 5), d = be(e1.inputs, 6), l = be(e1.inputs, 7);
            if (r.dims.length === 5) throw new Error("Packed QKV is not implemented");
            if (o?.dims.length === 5) throw new Error("Packed KV is not implemented");
            let c = o && i && o.dims.length === 4 && i.dims.length === 4, p = wt(e1, n.batchSize, n.numHeads, n.sequenceLength, n.headSize, r, s, 0);
            if (c) return it(e1, p, o, i, a, void 0, d, l, u, n);
            if (!o || !i) throw new Error("key and value must be provided");
            let f = wt(e1, n.batchSize, n.numHeads, n.kvSequenceLength, n.headSize, o, s, n.hiddenSize), m = wt(e1, n.batchSize, n.numHeads, n.kvSequenceLength, n.vHeadSize, i, s, 2 * n.hiddenSize);
            it(e1, p, f, m, a, void 0, d, l, u, n);
        };
    });
    var nc, rc, oc, ic, ur, ca, pa, dr = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        nc = (e1)=>{
            if (!e1 || e1.length < 1) throw new Error("too few inputs");
        }, rc = (e1, t)=>{
            let n = [], r = t.numOutputs;
            return e1[1].dims[0] > 0 && (e1[1].getBigInt64Array().forEach((o)=>n.push(Number(o))), r = n.length), G({
                numOutputs: r,
                axis: t.axis,
                splitSizes: n
            });
        }, oc = (e1)=>`
fn calculateOutputIndex(index: u32) -> u32 {
    for (var i: u32 = 0u; i < ${e1}u; i += 1u ) {
    if (index < ${B("uniforms.size_in_split_axis", "i", e1)}) {
        return i;
    }
    }
    return ${e1}u;
}`, ic = (e1)=>{
            let t = e1.length, n = [];
            for(let r = 0; r < t; ++r){
                let o = e1[r].setByIndices("indices", "input[global_idx]");
                t === 1 ? n.push(o) : r === 0 ? n.push(`if (output_number == ${r}u) { ${o} }`) : r === t - 1 ? n.push(`else { ${o} }`) : n.push(`else if (output_number == ${r}) { ${o} }`);
            }
            return `
      fn writeBufferData(output_number: u32, indices: ${e1[0].type.indices}, global_idx: u32) {
        ${n.join(`
`)}
      }`;
        }, ur = (e1, t)=>{
            let n = e1[0].dims, r = x.size(n), o = e1[0].dataType, i = x.normalizeAxis(t.axis, n.length), s = new Array(t.numOutputs), a = S("input", o, n.length), u = new Array(t.numOutputs), d = [], l = [], c = 0, p = [
                {
                    type: 12,
                    data: r
                }
            ];
            for(let m = 0; m < t.numOutputs; m++){
                c += t.splitSizes[m], u[m] = c;
                let h = n.slice();
                h[i] = t.splitSizes[m], l.push(h), s[m] = C(`output${m}`, o, h.length), d.push({
                    dims: l[m],
                    dataType: e1[0].dataType
                });
            }
            p.push({
                type: 12,
                data: u
            }, ...P(n, ...l));
            let f = (m)=>`
  ${m.registerUniform("input_size", "u32").registerUniform("size_in_split_axis", "u32", u.length).declareVariables(a, ...s)}
  ${oc(u.length)}
  ${ic(s)}

  ${m.mainStart()}
    ${m.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.input_size")}

    var indices = ${a.offsetToIndices("global_idx")};
    var index = ${a.indicesGet("indices", i)};
    let output_number = calculateOutputIndex(index);
    if (output_number != 0) {
      index -= ${B("uniforms.size_in_split_axis", "output_number - 1u", u.length)};
      ${a.indicesSet("indices", i, "index")};
    }
    writeBufferData(output_number, indices, global_idx);
  }`;
            return {
                name: "Split",
                shaderCache: {
                    hint: t.cacheKey,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getShaderSource: f,
                getRunData: ()=>({
                        outputs: d,
                        dispatchGroup: {
                            x: Math.ceil(r / 64)
                        },
                        programUniforms: p
                    })
            };
        }, ca = (e1, t)=>{
            nc(e1.inputs);
            let n = e1.inputs.length === 1 ? t : rc(e1.inputs, t);
            e1.compute(ur(e1.inputs, n), {
                inputs: [
                    0
                ]
            });
        }, pa = (e1)=>{
            let t = e1.axis, n = e1.splitSizes, r = e1.numOutputs < 0 ? n.length : e1.numOutputs;
            if (r !== n.length) throw new Error("numOutputs and splitSizes length must be equal");
            return G({
                axis: t,
                numOutputs: r,
                splitSizes: n
            });
        };
    });
    var sc, pn, ma, lr = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        sc = (e1, t)=>{
            let [n, r, o, i] = e1, { numHeads: s, rotaryEmbeddingDim: a } = t;
            if (n.dims.length !== 3 && n.dims.length !== 4) throw new Error(`Input 'x' is expected to have 3 or 4 dimensions, got ${n.dims.length}`);
            if (!x.areEqual(r.dims, []) && !x.areEqual(r.dims, [
                1
            ]) && r.dims.length !== 2) throw new Error(`Input 'position_ids' is expected to have 0, 1, or 2 dimensions, got ${r.dims.length}`);
            if (o.dims.length !== 2) throw new Error(`Input 'cos_cache' is expected to have 2 dimensions, got ${o.dims.length}`);
            if (i.dims.length !== 2) throw new Error(`Input 'sin_cache' is expected to have 2 dimensions, got ${i.dims.length}`);
            if (!x.areEqual(o.dims, i.dims)) throw new Error("Inputs 'cos_cache' and 'sin_cache' are expected to have the same shape");
            if (a > 0 && s === 0) throw new Error("num_heads must be provided if rotary_embedding_dim is specified");
            let u = n.dims[0], d = n.dims[n.dims.length - 2], l = o.dims[0], c = x.sizeFromDimension(n.dims, 1) / d, p = a === 0 ? o.dims[1] * 2 : c / s;
            if (a > p) throw new Error("rotary_embedding_dim must be less than or equal to head_size");
            if (r.dims.length === 2) {
                if (u !== r.dims[0]) throw new Error(`Input 'position_ids' dimension 0 should be of size batch_size, got ${r.dims[0]}`);
                if (d !== r.dims[1]) throw new Error(`Input 'position_ids' dimension 1 should be of size sequence_length, got ${r.dims[1]}`);
            }
            if (p / 2 !== o.dims[1] && a / 2 !== o.dims[1]) throw new Error(`Input 'cos_cache' dimension 1 should be same as head_size / 2 or rotary_embedding_dim / 2, got ${o.dims[1]}`);
            if (d > l) throw new Error("Updating cos_cache and sin_cache in RotaryEmbedding is not currently supported");
        }, pn = (e1, t)=>{
            let { interleaved: n, numHeads: r, rotaryEmbeddingDim: o, scale: i } = t, s = e1[0].dims[0], a = x.sizeFromDimension(e1[0].dims, 1), u = e1[0].dims[e1[0].dims.length - 2], d = a / u, l = e1[2].dims[1], c = o === 0 ? l * 2 : d / r, p = new Array(s, u, d / c, c - l), f = x.computeStrides(p), m = [
                {
                    type: 1,
                    data: i
                },
                {
                    type: 12,
                    data: p
                },
                {
                    type: 12,
                    data: f
                },
                ...e1[0].dims.length === 3 ? new Array({
                    type: 12,
                    data: [
                        a,
                        d,
                        c,
                        1
                    ]
                }) : [],
                ...e1[0].dims.length === 4 ? new Array({
                    type: 12,
                    data: [
                        a,
                        c,
                        u * c,
                        1
                    ]
                }) : [],
                ...P(e1[0].dims, e1[1].dims, e1[2].dims, e1[3].dims, e1[0].dims)
            ], h = (b)=>{
                let y = S("input", e1[0].dataType, e1[0].dims.length), g = S("position_ids", e1[1].dataType, e1[1].dims.length), _ = S("cos_cache", e1[2].dataType, e1[2].dims.length), w = S("sin_cache", e1[3].dataType, e1[3].dims.length), v = C("output", e1[0].dataType, e1[0].dims.length);
                return b.registerUniforms([
                    {
                        name: "scale",
                        type: "f32"
                    },
                    {
                        name: "global_shape",
                        type: "u32",
                        length: p.length
                    },
                    {
                        name: "global_strides",
                        type: "u32",
                        length: f.length
                    },
                    {
                        name: "input_output_strides",
                        type: "u32",
                        length: f.length
                    }
                ]), `
        ${b.declareVariables(y, g, _, w, v)}

        ${b.mainStart(Je)}
          let half_rotary_emb_dim = uniforms.${_.name}_shape[1];
          let bsnh = global_idx / uniforms.global_strides % uniforms.global_shape;
          let size = uniforms.global_shape[0] * uniforms.global_strides[0];
          ${b.guardAgainstOutOfBoundsWorkgroupSizes("size")}

          if (bsnh[3] < half_rotary_emb_dim) {
            let position_ids_idx =
                ${g.broadcastedIndicesToOffset("bsnh.xy", C("", g.type.tensor, 2))};
            let position_id =
                u32(${g.getByOffset("position_ids_idx")}) + select(0, bsnh[1], position_ids_idx == 0);
            let i = dot(bsnh, uniforms.input_output_strides) + select(0, bsnh[3], ${n});
            let j = i + select(half_rotary_emb_dim, 1, ${n});
            let re = ${y.getByOffset("i")} * ${_.get("position_id", "bsnh[3]")} -
                ${y.getByOffset("j")} * ${w.get("position_id", "bsnh[3]")};
            ${v.setByOffset("i", "re")}
            let im = ${y.getByOffset("i")} * ${w.get("position_id", "bsnh[3]")} +
                ${y.getByOffset("j")} * ${_.get("position_id", "bsnh[3]")};
            ${v.setByOffset("j", "im")}
          } else {
            let k = dot(bsnh, uniforms.input_output_strides) + half_rotary_emb_dim;
            ${v.setByOffset("k", y.getByOffset("k"))}
          }
        }`;
            };
            return {
                name: "RotaryEmbedding",
                shaderCache: {
                    hint: G({
                        interleaved: n
                    }).cacheKey,
                    inputDependencies: [
                        "rank",
                        "rank",
                        "rank",
                        "rank"
                    ]
                },
                getShaderSource: h,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: e1[0].dims,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(x.size(p) / Je)
                        },
                        programUniforms: m
                    })
            };
        }, ma = (e1, t)=>{
            sc(e1.inputs, t), e1.compute(pn(e1.inputs, t));
        };
    });
    var ac, uc, fa, dc, ha, ga = k(()=>{
        "use strict";
        ie();
        L();
        tn();
        ar();
        dr();
        Ve();
        lr();
        j();
        ac = (e1, t)=>{
            if (t.doRotary && e1.length <= 7) throw new Error("cos_cache and sin_cache inputs are required if do_rotary is specified");
            let n = e1[0], r = e1[1], o = e1[2], i = e1[3], s = e1[4];
            if (t.doRotary !== 0 && e1.length <= 7) throw new Error("cos_cast and sin_cache are expected if do_rotary attribute is non-zero");
            if (t.localWindowSize !== -1) throw new Error("Local attention is not supported");
            if (t.softcap !== 0) throw new Error("Softcap is not supported");
            if (t.rotaryInterleaved !== 0) throw new Error("Rotary interleaved is not supported");
            if (t.smoothSoftmax) throw new Error("Smooth softmax is not supported");
            if (n.dims.length !== 3 && n.dims.length !== 5) throw new Error("Input query is expected to have 3 or 5 dimensions");
            let a = !1, u = n.dims[0], d = n.dims[1], l = n.dims.length === 3 ? a ? n.dims[2] / 3 : n.dims[2] : t.numHeads * n.dims[4], c = d, p = 0, f = !r || r.dims.length === 0, m = Math.floor(f ? l / (t.numHeads + 2 * t.kvNumHeads) : l / t.numHeads);
            f && (l = m * t.numHeads);
            let h = i && i.dims.length !== 0, b = s && s.dims.length !== 0;
            if (h && i.dims.length === 4 && i.dims[0] === u && i.dims[1] !== t.kvNumHeads && i.dims[2] === t.kvNumHeads && i.dims[3] === m) throw new Error("BSNH pastKey/pastValue is not supported");
            if (h && b) {
                if (i.dims.length !== 4) throw new Error('Input "past_key" is expected to have 4 dimensions');
                if (s.dims.length !== 4) throw new Error('Input "past_value" is expected to have 4 dimensions');
                p = i.dims[2];
            } else if (h || b) throw new Error('Input "past_key" and "past_value" shall be both present or both absent');
            let g = 1;
            if (r && r.dims.length > 0) {
                if (n.dims.length !== 3) throw new Error('Input "query" is expected to have 3 dimensions when key is given');
                if (r.dims.length < 3 || r.dims.length > 5) throw new Error('Input "key" is expected to have 3, 4, or 5 dimensions');
                if (n.dims[0] !== r.dims[0]) throw new Error('Input "query" and "key" shall have same dim 0 (batch size)');
                if (r.dims.length === 3) {
                    if (n.dims[2] % r.dims[2] !== 0) throw new Error('Dimension 2 of "query" should be a multiple of "key"');
                    c = r.dims[1];
                } else if (r.dims.length === 5) {
                    if (r.dims[2] !== t.numHeads || r.dims[3] !== 2 || r.dims[4] !== m) throw new Error('Expect "key" shape (batch_size, kv_sequence_length, num_heads, 2, head_size) for packed kv');
                    if (o) throw new Error('Expect "value" be none when "key" has packed kv format.');
                    c = r.dims[1];
                } else {
                    if (r.dims[1] !== t.numHeads || r.dims[3] !== m) throw new Error('Expect "key" shape (batch_size, num_heads, kv_sequence_length, head_size) for past_key');
                    c = r.dims[2];
                }
            } else {
                if (n.dims.length !== 3 && n.dims.length !== 5) throw new Error('Input "query" is expected to have 3 or 5 dimensions when key is empty');
                if (n.dims.length === 5 && (n.dims[2] !== t.numHeads || n.dims[3] !== 3)) throw new Error('Expect "query" shape (batch_size, kv_sequence_length, num_heads, 3, head_size) for packed kv');
                g = 3;
            }
            let _ = 0, w = !1, v = t.kvNumHeads ? m * t.kvNumHeads : l;
            if (o && o.dims.length > 0) {
                if (o.dims.length !== 3 && o.dims.length !== 4) throw new Error('Input "value" is expected to have 3 or 4 dimensions');
                if (n.dims[0] !== o.dims[0]) throw new Error('Input "query" and "value" shall have same dim 0 (batch_size)');
                if (o.dims.length === 3) {
                    if (c !== o.dims[1]) throw new Error('Input "key" and "value" shall have the same dim 1 (kv_sequence_length)');
                    v = o.dims[2];
                } else {
                    if (c !== o.dims[2]) throw new Error('Input "past_key" and "past_value" shall have the same dim 2 (kv_sequence_length)');
                    v = o.dims[1] * o.dims[3], w = !0;
                }
            }
            let $ = e1.length > 4 ? e1[5] : void 0;
            if ($ && $.dims.length !== 1 && $.dims[0] !== u) throw new Error('Input "seqlens" is expected to have 1 dimension and the same dim 0 as batch_size');
            return {
                batchSize: u,
                sequenceLength: d,
                pastSequenceLength: p,
                kvSequenceLength: c,
                totalSequenceLength: -1,
                maxSequenceLength: -1,
                inputHiddenSize: 0,
                hiddenSize: l,
                vHiddenSize: v,
                headSize: m,
                vHeadSize: Math.floor(v / t.kvNumHeads),
                numHeads: t.numHeads,
                kvNumHeads: t.kvNumHeads,
                nReps: t.numHeads / t.kvNumHeads,
                pastPresentShareBuffer: !1,
                maskType: _,
                scale: t.scale,
                broadcastResPosBias: !1,
                passPastInKv: w,
                qkvFormat: g
            };
        }, uc = G({
            perm: [
                0,
                2,
                1,
                3
            ]
        }), fa = (e1, t, n)=>{
            let r = t, o = n.kvNumHeads;
            return t.dims.length === 3 && n.kvSequenceLength !== 0 && (r = t.reshape([
                n.batchSize,
                n.kvSequenceLength,
                o,
                n.headSize
            ]), r = e1.compute(pe(r, uc.perm), {
                inputs: [
                    r
                ],
                outputs: [
                    -1
                ]
            })[0]), r;
        }, dc = (e1, t, n, r)=>{
            let o = 7, i = [
                "type",
                "type"
            ], s = [
                e1 * t
            ], a = e1 * t, u = [
                {
                    type: 12,
                    data: a
                },
                {
                    type: 12,
                    data: t
                },
                {
                    type: 12,
                    data: e1
                }
            ], d = (l)=>{
                let c = S("seq_lens", n.dataType, n.dims), p = S("total_seq_lens", r.dataType, r.dims), f = C("pos_ids", o, s), m = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "sequence_length",
                        type: "u32"
                    },
                    {
                        name: "batch_size",
                        type: "u32"
                    }
                ];
                return `
  ${l.registerUniforms(m).declareVariables(c, p, f)}
  ${l.mainStart()}
    ${l.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
    let total_sequence_length = u32(${p.getByOffset("0")});
    let is_subsequent_prompt = uniforms.sequence_length > 1 && uniforms.sequence_length != total_sequence_length;
    let is_first_prompt = !is_subsequent_prompt && uniforms.sequence_length == total_sequence_length;
    let batch_idx = global_idx / uniforms.sequence_length;
    let sequence_idx = i32(global_idx % uniforms.sequence_length);
    var pos_id: i32 = 0;
    let seqlen = ${c.getByOffset("batch_idx")};
    let total_seqlen = seqlen + 1;
    if (is_first_prompt) {
      if (sequence_idx < total_seqlen) {
        pos_id = sequence_idx;
      } else {
        pos_id = 1;
      }
      ${f.setByOffset("global_idx", "pos_id")}
    } else if (is_subsequent_prompt) {
      let past_seqlen = total_seqlen - i32(uniforms.sequence_length);
      if (past_seqlen + sequence_idx < total_seqlen) {
        pos_id = past_seqlen + sequence_idx;
      } else {
        pos_id = 1;
      }
      ${f.setByOffset("global_idx", "pos_id")}
    } else if (global_idx < uniforms.batch_size) {
      ${f.setByOffset("global_idx", "seqlen")}
    };
  }
  `;
            };
            return {
                name: "GeneratePositionIds",
                shaderCache: {
                    hint: `${e1};${t}`,
                    inputDependencies: i
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: s,
                                dataType: o
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(a / 64)
                        },
                        programUniforms: u
                    }),
                getShaderSource: d
            };
        }, ha = (e1, t)=>{
            let n = ac(e1.inputs, t);
            if (e1.inputs[0].dims.length === 5) throw new Error("Packed QKV is not implemented");
            if (e1.inputs[1]?.dims.length === 5) throw new Error("Packed KV is not implemented");
            let r = e1.inputs[0], o = e1.inputs[1] && e1.inputs[1].dims.length > 0 ? e1.inputs[1] : void 0, i = e1.inputs[2] && e1.inputs[2].dims.length > 0 ? e1.inputs[2] : void 0, s = e1.inputs[3] && e1.inputs[3].dims.length !== 0 ? e1.inputs[3] : void 0, a = e1.inputs[4] && e1.inputs[4].dims.length !== 0 ? e1.inputs[4] : void 0, u = e1.inputs.length > 4 ? e1.inputs[5] : void 0, d = e1.inputs.length > 5 ? e1.inputs[6] : void 0, l = n.kvNumHeads ? n.kvNumHeads : n.numHeads, c = G({
                axis: 2,
                numOutputs: 3,
                splitSizes: [
                    n.numHeads * n.headSize,
                    l * n.headSize,
                    l * n.headSize
                ]
            }), [p, f, m] = !o && !i ? e1.compute(ur([
                r
            ], c), {
                inputs: [
                    r
                ],
                outputs: [
                    -1,
                    -1,
                    -1
                ]
            }) : [
                r,
                o,
                i
            ], h, b;
            if (t.doRotary) {
                let w = e1.compute(dc(n.batchSize, n.sequenceLength, u, d), {
                    inputs: [
                        u,
                        d
                    ],
                    outputs: [
                        -1
                    ]
                })[0], v = e1.inputs[7], $ = e1.inputs[8], T = G({
                    interleaved: t.rotaryInterleaved !== 0,
                    numHeads: n.numHeads,
                    rotaryEmbeddingDim: 0,
                    scale: t.scale
                }), I = [
                    p,
                    w,
                    v,
                    $
                ], A = [
                    -1
                ];
                h = e1.compute(pn(I, T), {
                    inputs: I,
                    outputs: A
                })[0], I.splice(0, 1, f);
                let z = G({
                    interleaved: t.rotaryInterleaved !== 0,
                    numHeads: n.kvNumHeads,
                    rotaryEmbeddingDim: 0,
                    scale: t.scale
                });
                b = e1.compute(pn(I, z), {
                    inputs: I,
                    outputs: A
                })[0];
            }
            let y = wt(e1, n.batchSize, n.numHeads, n.sequenceLength, n.headSize, t.doRotary ? h : p, void 0, 0), g = fa(e1, t.doRotary ? b : f, n), _ = fa(e1, m, n);
            it(e1, y, g, _, void 0, void 0, s, a, void 0, n, u, d);
        };
    });
    var ya, lc, cc, ba, _a = k(()=>{
        "use strict";
        L();
        F();
        Ve();
        j();
        ya = (e1, t, n, r, o, i, s, a)=>{
            let u = J(i), d = u === 1 ? "f32" : `vec${u}f`, l = u === 1 ? "vec2f" : `mat2x${u}f`, c = o * s, p = 64;
            c === 1 && (p = 256);
            let f = [
                o,
                s,
                i / u
            ], m = [
                o,
                s,
                2
            ], h = [
                "rank",
                "type",
                "type"
            ], b = [];
            b.push(...P(f, m));
            let y = (g)=>{
                let _ = S("x", t.dataType, 3, u), w = S("scale", n.dataType, n.dims), v = S("bias", r.dataType, r.dims), $ = C("output", 1, 3, 2), T = [
                    _,
                    w,
                    v,
                    $
                ];
                return `
  var<workgroup> workgroup_shared : array<${l}, ${p}>;
  const workgroup_size = ${p}u;
  ${g.declareVariables(...T)}
  ${g.mainStart(p)}
    let batch = workgroup_index / uniforms.x_shape[1];
    let channel = workgroup_index % uniforms.x_shape[1];
    let hight = uniforms.x_shape[2];
    // initialize workgroup memory
    var sum = ${d}(0);
    var squared_sum = ${d}(0);
    for (var h = local_idx; h < hight; h += workgroup_size) {
      let value = ${d}(${_.get("batch", "channel", "h")});
      sum += value;
      squared_sum += value * value;
    }
    workgroup_shared[local_idx] = ${l}(sum, squared_sum);
    workgroupBarrier();

    for (var currSize = workgroup_size >> 1;  currSize > 0; currSize = currSize >> 1) {
      if (local_idx < currSize) {
        workgroup_shared[local_idx] = workgroup_shared[local_idx] + workgroup_shared[local_idx + currSize];
      }
      workgroupBarrier();
    }
    if (local_idx == 0) {
      let sum_final = ${Te("workgroup_shared[0][0]", u)} / f32(hight * ${u});
      let squared_sum_final = ${Te("workgroup_shared[0][1]", u)} / f32(hight * ${u});

      let inv_std_dev = inverseSqrt(squared_sum_final - sum_final * sum_final + f32(${a}));
      let channel_scale = inv_std_dev * f32(scale[channel]);
      let channel_shift = f32(bias[channel]) - sum_final * channel_scale;
      output[workgroup_index] = vec2f(channel_scale, channel_shift);
    }
  }`;
            };
            return e1.compute({
                name: "InstanceNormComputeChannelScaleShift",
                shaderCache: {
                    hint: `${u};${a};${p}`,
                    inputDependencies: h
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: m,
                                dataType: 1
                            }
                        ],
                        dispatchGroup: {
                            x: c
                        },
                        programUniforms: b
                    }),
                getShaderSource: y
            }, {
                inputs: [
                    t,
                    n,
                    r
                ],
                outputs: [
                    -1
                ]
            })[0];
        }, lc = (e1, t, n)=>{
            let r = t[0].dims, o = r, i = 2, s = r[0], a = r[1], u = x.sizeFromDimension(r, i), d = J(u), l = x.size(o) / d, c = ya(e1, t[0], t[1], t[2], s, u, a, n.epsilon), p = [
                s,
                a,
                u / d
            ], f = [
                s,
                a
            ], m = [
                "type",
                "none"
            ], h = (b)=>{
                let y = S("x", t[0].dataType, p.length, d), g = S("scale_shift", 1, f.length, 2), _ = C("output", t[0].dataType, p.length, d), w = [
                    y,
                    g,
                    _
                ];
                return `
  ${b.registerUniform("output_size", "u32").declareVariables(...w)}
  ${b.mainStart()}
  ${b.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
      let outputIndices = ${_.offsetToIndices("global_idx")};
      let batch = outputIndices[0];
      let channel = outputIndices[1];
      let scale_shift = ${g.getByIndices("vec2<u32>(batch, channel)")};
      let value = ${y.getByOffset("global_idx")} * ${_.type.value}(scale_shift.x) + ${_.type.value}(scale_shift.y);
      ${_.setByOffset("global_idx", "value")};
  }`;
            };
            e1.compute({
                name: "InstanceNormalization",
                shaderCache: {
                    hint: `${d}`,
                    inputDependencies: m
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: o,
                                dataType: t[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(l / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: l
                            },
                            ...P(p, f, p)
                        ]
                    }),
                getShaderSource: h
            }, {
                inputs: [
                    t[0],
                    c
                ]
            });
        }, cc = (e1, t, n)=>{
            let r = t[0].dims, o = r, i = r[0], s = r[r.length - 1], a = x.sizeFromDimension(r, 1) / s, u = J(s), d = x.size(o) / u, l = [
                {
                    type: 12,
                    data: a
                },
                {
                    type: 12,
                    data: Math.floor(s / u)
                }
            ], c = [
                "type",
                "type"
            ], p = !1, f = [
                0,
                r.length - 1
            ];
            for(let y = 0; y < r.length - 2; y++)p = p || r[y + 1] !== 1, f.push(y + 1);
            p = p && r[r.length - 1] !== 1;
            let m = p ? e1.compute(pe(e1.inputs[0], f), {
                inputs: [
                    e1.inputs[0]
                ],
                outputs: [
                    -1
                ]
            })[0] : e1.inputs[0].reshape(Array.from({
                length: r.length
            }, (y, g)=>r[f[g]])), h = ya(e1, m, t[1], t[2], i, a, s, n.epsilon), b = (y)=>{
                let g = re(t[0].dataType), _ = u === 1 ? "vec2f" : `mat${u}x2f`, w = (T)=>{
                    let I = T === 0 ? "x" : "y", A = u === 1 ? "f32" : `vec${u}f`;
                    switch(u){
                        case 1:
                            return `${g}(${A}(scale.${I}))`;
                        case 2:
                            return `vec2<${g}>(${A}(scale[0].${I}, scale[1].${I}))`;
                        case 4:
                            return `vec4<${g}>(${A}(scale[0].${I}, scale[1].${I}, scale[2].${I}, scale[3].${I}))`;
                        default:
                            throw new Error(`Not supported compoents ${u}`);
                    }
                }, v = S("input", t[0].dataType, t[0].dims, u), $ = C("output", t[0].dataType, o, u);
                return `
  @group(0) @binding(0) var<storage, read> input : array<${v.type.storage}>;
  @group(0) @binding(1) var<storage, read> scale_input : array<${_}>;
  @group(0) @binding(2) var<storage, read_write> output : array<${$.type.storage}>;
  struct Uniforms {H: u32, C : u32};
  @group(0) @binding(3) var<uniform> uniforms: Uniforms;

  ${y.mainStart()}
    let current_image_number = global_idx / (uniforms.C * uniforms.H);
    let current_channel_number = global_idx % uniforms.C;

    let scale_offset = current_image_number * uniforms.C + current_channel_number;
    let scale = scale_input[scale_offset];
    output[global_idx] = fma(input[global_idx], ${w(0)}, ${w(1)});
  }`;
            };
            e1.compute({
                name: "InstanceNormalizationNHWC",
                shaderCache: {
                    hint: `${u}`,
                    inputDependencies: c
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: o,
                                dataType: t[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(d / 64)
                        },
                        programUniforms: l
                    }),
                getShaderSource: b
            }, {
                inputs: [
                    t[0],
                    h
                ]
            });
        }, ba = (e1, t)=>{
            t.format === "NHWC" ? cc(e1, e1.inputs, t) : lc(e1, e1.inputs, t);
        };
    });
    var pc, mc, wa, $a = k(()=>{
        "use strict";
        L();
        F();
        j();
        pc = (e1)=>{
            if (!e1 || e1.length < 2) throw new Error("layerNorm requires at least 2 inputs.");
        }, mc = (e1, t, n)=>{
            let r = t.simplified, o = e1[0].dims, i = e1[1], s = !r && e1[2], a = o, u = x.normalizeAxis(t.axis, o.length), d = x.sizeToDimension(o, u), l = x.sizeFromDimension(o, u), c = x.size(i.dims), p = s ? x.size(s.dims) : 0;
            if (c !== l || s && p !== l) throw new Error(`Size of X.shape()[axis:] == ${l}.
       Size of scale and bias (if provided) must match this.
       Got scale size of ${c} and bias size of ${p}`);
            let f = [];
            for(let v = 0; v < o.length; ++v)v < u ? f.push(o[v]) : f.push(1);
            let m = J(l), h = [
                "type",
                "type"
            ], b = [
                {
                    type: 12,
                    data: d
                },
                {
                    type: 1,
                    data: l
                },
                {
                    type: 12,
                    data: Math.floor(l / m)
                },
                {
                    type: 1,
                    data: t.epsilon
                }
            ];
            s && h.push("type");
            let y = n > 1, g = n > 2, _ = (v)=>{
                let $ = re(e1[0].dataType), T = [
                    S("x", e1[0].dataType, e1[0].dims, m),
                    S("scale", i.dataType, i.dims, m)
                ];
                s && T.push(S("bias", s.dataType, s.dims, m)), T.push(C("output", e1[0].dataType, a, m)), y && T.push(C("mean_data_output", 1, f)), g && T.push(C("inv_std_output", 1, f));
                let I = [
                    {
                        name: "norm_count",
                        type: "u32"
                    },
                    {
                        name: "norm_size",
                        type: "f32"
                    },
                    {
                        name: "norm_size_vectorized",
                        type: "u32"
                    },
                    {
                        name: "epsilon",
                        type: "f32"
                    }
                ];
                return `
  ${v.registerUniforms(I).declareVariables(...T)}
  ${v.mainStart()}
    ${v.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.norm_count")}
    let offset = global_idx * uniforms.norm_size_vectorized;
    var mean_vector = ${Fn("f32", m)};
    var mean_square_vector = ${Fn("f32", m)};

    for (var h: u32 = 0u; h < uniforms.norm_size_vectorized; h++) {
      let value = ${et($, m, "x[h + offset]")};
      mean_vector += value;
      mean_square_vector += value * value;
    }
    let mean = ${Te("mean_vector", m)} / uniforms.norm_size;
    let inv_std_dev = inverseSqrt(${Te("mean_square_vector", m)} / uniforms.norm_size ${r ? "" : "- mean * mean"} + uniforms.epsilon);

    for (var j: u32 = 0; j < uniforms.norm_size_vectorized; j++) {
      let f32input = ${et($, m, "x[j + offset]")};
      let f32scale = ${et($, m, "scale[j]")};
      output[j + offset] = ${T[0].type.value}((f32input ${r ? "" : "- mean"}) * inv_std_dev * f32scale
        ${s ? `+ ${et($, m, "bias[j]")}` : ""}
      );
    }

    ${y ? "mean_data_output[global_idx] = mean" : ""};
    ${g ? "inv_std_output[global_idx] = inv_std_dev" : ""};
  }`;
            }, w = [
                {
                    dims: a,
                    dataType: e1[0].dataType
                }
            ];
            return y && w.push({
                dims: f,
                dataType: 1
            }), g && w.push({
                dims: f,
                dataType: 1
            }), {
                name: "LayerNormalization",
                shaderCache: {
                    hint: `${m};${n};${r}`,
                    inputDependencies: h
                },
                getRunData: ()=>({
                        outputs: w,
                        dispatchGroup: {
                            x: Math.ceil(d / 64)
                        },
                        programUniforms: b
                    }),
                getShaderSource: _
            };
        }, wa = (e1, t)=>{
            pc(e1.inputs), e1.compute(mc(e1.inputs, t, e1.outputCount));
        };
    });
    var fc, va, xa = k(()=>{
        "use strict";
        F();
        un();
        dn();
        fc = (e1)=>{
            if (!e1 || e1.length !== 2) throw new Error("MatMul requires 2 inputs.");
            if (e1[0].dims[e1[0].dims.length - 1] !== e1[1].dims[e1[1].dims.length - 2]) throw new Error("shared dimension does not match.");
        }, va = (e1)=>{
            fc(e1.inputs);
            let t = Pe.calcShape(e1.inputs[0].dims, e1.inputs[1].dims, !0);
            if (!t) throw new Error("Can't use matmul on the given tensors");
            let n = t[t.length - 1], r = e1.inputs[0].dims[e1.inputs[0].dims.length - 1];
            if (n < 8 && r < 8) e1.compute(an(e1.inputs, {
                activation: ""
            }, t));
            else {
                let o = t[t.length - 2], i = x.size(e1.inputs[0].dims.slice(0, -2)), s = x.size(e1.inputs[1].dims.slice(0, -2));
                if (i !== 1 && o === 1 && s === 1) {
                    let a = e1.inputs[0].reshape([
                        1,
                        i,
                        r
                    ]), u = e1.inputs[1].reshape([
                        1,
                        r,
                        n
                    ]), d = [
                        1,
                        i,
                        n
                    ], l = [
                        a,
                        u
                    ];
                    e1.compute(_t(l, {
                        activation: ""
                    }, t, d), {
                        inputs: l
                    });
                } else e1.compute(_t(e1.inputs, {
                    activation: ""
                }, t));
            }
        };
    });
    var hc, gc, yc, Sa, Ta, Ia = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        hc = (e1, t)=>{
            if (e1.length < 3 || e1.length > 4) throw new Error("MatMulNBits requires 3 or 4 inputs");
            let n = e1[0], r = n.dims.length;
            if (n.dims[r - 1] !== t.k) throw new Error("The last dim of input shape does not match the k value");
            let o = Math.floor((t.k + t.blockSize - 1) / t.blockSize), i = t.blockSize / 8 * t.bits, s = e1[1];
            if (!x.areEqual(s.dims, [
                t.n,
                o,
                i
            ])) throw new Error("The second inputs must be 3D tensor with shape N X nBlocksPerCol X blobSize");
            let u = e1[2].dims;
            if (x.size(u) !== t.n * o) throw new Error("scales input size error.");
            if (e1.length === 4) {
                let l = e1[3].dims, c = t.n * (t.bits === 8 ? o : Math.floor((o * t.bits + 7) / 8));
                if (x.size(l) !== c) throw new Error("zeroPoints input size error.");
            }
        }, gc = (e1, t)=>{
            let n = e1[0].dims, r = n.length, o = n[r - 2], i = t.k, s = t.n, a = n.slice(0, r - 2), u = x.size(a), l = e1[1].dims[2] / 4, c = e1[0].dataType, p = J(t.k), f = J(l), m = J(s), h = a.concat([
                o,
                s
            ]), b = o > 1 && s / m % 2 === 0 ? 2 : 1, y = x.size(h) / m / b, g = 64, _ = [], w = [
                u,
                o,
                i / p
            ], v = x.convertShape(e1[1].dims).slice();
            v.splice(-1, 1, l / f), _.push(...P(w)), _.push(...P(v)), _.push(...P(e1[2].dims)), e1.length === 4 && _.push(...P(x.convertShape(e1[3].dims)));
            let $ = [
                u,
                o,
                s / m
            ];
            _.push(...P($));
            let T = (I)=>{
                let A = w.length, z = S("a", e1[0].dataType, A, p), R = S("b", 12, v.length, f), D = S("scales", e1[2].dataType, e1[2].dims.length), U = [
                    z,
                    R,
                    D
                ], Q = e1.length === 4 ? S("zero_points", 12, e1[3].dims.length) : void 0;
                Q && U.push(Q);
                let O = $.length, M = C("output", e1[0].dataType, O, m), V = re(e1[0].dataType), W = (()=>{
                    switch(p){
                        case 1:
                            return `array<${V}, 8>`;
                        case 2:
                            return `mat4x2<${V}>`;
                        case 4:
                            return `mat2x4<${V}>`;
                        default:
                            throw new Error(`${p}-component is not supported.`);
                    }
                })(), H = ()=>{
                    let de = `
          // reuse a data
            var input_offset = ${z.indicesToOffset(`${z.type.indices}(batch, row, word_offset)`)};
            var a_data: ${W};
            for (var j: u32 = 0; j < ${8 / p}; j++) {
              a_data[j] = ${z.getByOffset("input_offset")};
              input_offset++;
            }
          `;
                    for(let q = 0; q < m * b; q++)de += `
            b_value = ${f === 1 ? `b${q}_data` : `b${q}_data[i]`};
            b_value_lower = unpack4xU8(b_value & b_mask);
            b_value_upper = unpack4xU8((b_value >> 4) & b_mask);
            b_quantized_values = ${W}(${Array.from({
                        length: 4
                    }, (E, N)=>`${V}(b_value_lower[${N}]), ${V}(b_value_upper[${N}])`).join(", ")});
            b_dequantized_values = ${p === 1 ? `${W}(${Array.from({
                        length: 8
                    }, (E, N)=>`(b_quantized_values[${N}] - ${Q ? `zero_point${q}` : "zero_point"}) * scale${q}`).join(", ")});` : `(b_quantized_values - ${W}(${Array(8).fill(`${Q ? `zero_point${q}` : "zero_point"}`).join(",")})) * scale${q};`};
            workgroup_shared[local_id.x * ${b} + ${Math.floor(q / m)}]${m > 1 ? `[${q % m}]` : ""} += ${Array.from({
                        length: 8 / p
                    }, (E, N)=>`${p === 1 ? `a_data[${N}] * b_dequantized_values[${N}]` : `dot(a_data[${N}], b_dequantized_values[${N}])`}`).join(" + ")};
          `;
                    return de;
                }, X = ()=>{
                    let de = `
            var col_index = col * ${m};
            ${Q ? `
            let zero_point_bytes_per_col = (nBlocksPerCol + 1) / 2;
            var zero_point_byte_count: u32;
            var zero_point_word_index: u32;
            var zero_point_byte_offset: u32;
            let zero_point_nibble_offset: u32 = block & 0x1u;
            var zero_point_bits_offset: u32;
            var zero_point_word: u32;` : `
            // The default zero point is 8 for unsigned 4-bit quantization.
            let zero_point = ${V}(8);`}
            `;
                    for(let q = 0; q < m * b; q++)de += `
            let scale${q} = ${D.getByOffset("col_index * nBlocksPerCol + block")};
            ${Q ? `
            zero_point_byte_count = col_index * zero_point_bytes_per_col + (block >> 0x1u);
            zero_point_word_index = zero_point_byte_count >> 0x2u;
            zero_point_byte_offset = zero_point_byte_count & 0x3u;
            zero_point_bits_offset = (zero_point_byte_offset << 3) + (zero_point_nibble_offset << 2);
            zero_point_word = ${Q.getByOffset("zero_point_word_index")} >> zero_point_bits_offset;
            let zero_point${q} = ${V}((zero_point_word) & 0xFu);` : ""}
            col_index += 1;`;
                    return de;
                }, oe = ()=>{
                    let de = `col_index = col * ${m};`;
                    for(let q = 0; q < m * b; q++)de += `
            let b${q}_data = ${R.getByIndices(`${R.type.indices}(col_index, block, word)`)};
            col_index += 1;`;
                    return de += `
            var b_value: u32;
            let b_mask: u32 = 0x0F0F0F0Fu;
            var b_value_lower: vec4<u32>;
            var b_value_upper: vec4<u32>;
            var b_quantized_values: ${W};
            var b_dequantized_values: ${W};`, de;
                };
                return `
        var<workgroup> workgroup_shared: array<${M.type.value}, ${b * g}>;
        ${I.declareVariables(...U, M)}
        ${I.mainStart([
                    g,
                    1,
                    1
                ])}
          let output_indices = ${M.offsetToIndices(`(global_idx / ${g}) * ${b}`)};
          let col = output_indices[2];
          let row = output_indices[1];
          let batch = output_indices[0];
          let nBlocksPerCol = uniforms.b_shape[1];

          for (var block = local_id.x; block < nBlocksPerCol; block += ${g}) {
            //process one block
            var word_offset: u32 = block * ${t.blockSize / p};
            ${X()}
            for (var word: u32 = 0; word < ${l}; word += ${f}) {
              ${oe()}
              for (var i: u32 = 0; i < ${f}; i++) {
                ${H()}
                word_offset += ${8 / p};
              }
            }
          }
          workgroupBarrier();

          if (local_id.x < ${b}) {
            var output_value: ${M.type.value} = ${M.type.value}(0);
            var workgroup_shared_offset: u32 = local_id.x;
            for (var b: u32 = 0u; b < ${g}u; b++) {
              output_value += workgroup_shared[workgroup_shared_offset];
              workgroup_shared_offset += ${b};
            }
            ${M.setByIndices(`${M.type.indices}(batch, row, col + local_id.x)`, "output_value")};
          }
        }`;
            };
            return {
                name: "MatMulNBits",
                shaderCache: {
                    hint: `${t.blockSize};${t.bits};${p};${f};${m};${b};${g}`,
                    inputDependencies: Array(e1.length).fill("rank")
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: h,
                                dataType: c
                            }
                        ],
                        dispatchGroup: {
                            x: y
                        },
                        programUniforms: _
                    }),
                getShaderSource: T
            };
        }, yc = (e1, t)=>{
            let n = e1[0].dims, r = n.length, o = n[r - 2], i = t.k, s = t.n, a = n.slice(0, r - 2), u = x.size(a), l = e1[1].dims[2] / 4, c = e1[0].dataType, p = J(t.k), f = J(l), m = a.concat([
                o,
                s
            ]), h = 128, b = s % 8 === 0 ? 8 : s % 4 === 0 ? 4 : 1, y = h / b, g = y * f * 8, _ = g / p, w = g / t.blockSize, v = x.size(m) / b, $ = [], T = [
                u,
                o,
                i / p
            ], I = x.convertShape(e1[1].dims).slice();
            I.splice(-1, 1, l / f), $.push(...P(T)), $.push(...P(I)), $.push(...P(e1[2].dims)), e1.length === 4 && $.push(...P(x.convertShape(e1[3].dims)));
            let A = [
                u,
                o,
                s
            ];
            $.push(...P(A));
            let z = (R)=>{
                let D = T.length, U = S("a", e1[0].dataType, D, p), Q = S("b", 12, I.length, f), O = S("scales", e1[2].dataType, e1[2].dims.length), M = [
                    U,
                    Q,
                    O
                ], V = e1.length === 4 ? S("zero_points", 12, e1[3].dims.length) : void 0;
                V && M.push(V);
                let W = A.length, H = C("output", e1[0].dataType, W), X = re(e1[0].dataType), oe = ()=>{
                    switch(p){
                        case 1:
                            return `
          let a_data0 = vec4<${X}>(sub_a[word_offset], sub_a[word_offset + 1], sub_a[word_offset + 2], sub_a[word_offset + 3]);
          let a_data1 = vec4<${X}>(sub_a[word_offset + 4], sub_a[word_offset + 5], sub_a[word_offset + 6], sub_a[word_offset + 7]);`;
                        case 2:
                            return `
          let a_data0 = vec4<${X}>(sub_a[word_offset], sub_a[word_offset + 1]);
          let a_data1 = vec4<${X}>(sub_a[word_offset + 2], sub_a[word_offset + 3]);`;
                        case 4:
                            return `
          let a_data0 = sub_a[word_offset];
          let a_data1 = sub_a[word_offset + 1];`;
                        default:
                            throw new Error(`${p}-component is not supported.`);
                    }
                };
                return `
        var<workgroup> sub_a: array<${U.type.value}, ${_}>;
        var<workgroup> inter_results: array<array<${H.type.value}, ${y}>, ${b}>;
        ${R.declareVariables(...M, H)}
        ${R.mainStart([
                    y,
                    b,
                    1
                ])}
          let output_indices = ${H.offsetToIndices(`workgroup_index * ${b}`)};
          let col = output_indices[2];
          let row = output_indices[1];
          let batch = output_indices[0];
          let n_blocks_per_col = uniforms.b_shape[1];
          let num_tiles =  (n_blocks_per_col - 1) / ${w} + 1;

          // Loop over shared dimension.
          for (var tile: u32 = 0; tile < num_tiles; tile += 1) {
            let a_col_start = tile * ${_};
            // load one tile A data into shared memory.
            for (var a_offset = local_idx; a_offset < ${_}; a_offset += ${h})
            {
              let a_col = a_col_start + a_offset;
              if (a_col < uniforms.a_shape[2])
              {
                sub_a[a_offset] = ${U.getByIndices(`${U.type.indices}(batch, row, a_col)`)};
              } else {
                sub_a[a_offset] = ${U.type.value}(0);
              }
            }
            workgroupBarrier();

            // each thread process one block
            let b_row = col + local_id.y;
            let block = tile * ${w} + local_id.x;
            ${V ? `
            let zero_point_bytes_per_col = (n_blocks_per_col + 1) / 2;
            let zero_point_byte_count = b_row * zero_point_bytes_per_col + (block >> 0x1u);
            let zero_point_word_index = zero_point_byte_count >> 0x2u;
            let zero_point_byte_offset = zero_point_byte_count & 0x3u;
            let zero_point_nibble_offset: u32 = block & 0x1u;
            let zero_point_bits_offset = (zero_point_byte_offset << 3) + (zero_point_nibble_offset << 2);
            let zero_point_word = ${V.getByOffset("zero_point_word_index")} >> zero_point_bits_offset;
            let zero_point = ${X}((zero_point_word) & 0xFu);` : `
            // The default zero point is 8 for unsigned 4-bit quantization.
            let zero_point = ${X}(8);`}
            let scale = ${O.getByOffset("b_row * n_blocks_per_col + block")};
            let b_data = ${Q.getByIndices(`${Q.type.indices}(b_row, block, 0)`)};
            var word_offset = local_id.x * ${t.blockSize / p};
            for (var i: u32 = 0; i < ${f}; i++) {
              ${oe()}
              let b_value = ${f === 1 ? "b_data" : "b_data[i]"};
              let b_value_lower = unpack4xU8(b_value & 0x0F0F0F0Fu);
              let b_value_upper = unpack4xU8((b_value >> 4) & 0x0F0F0F0Fu);
              let b_quantized_values = mat2x4<${X}>(${Array.from({
                    length: 4
                }, (de, q)=>`${X}(b_value_lower[${q}]), ${X}(b_value_upper[${q}])`).join(", ")});
              let b_dequantized_values = (b_quantized_values - mat2x4<${X}>(${Array(8).fill("zero_point").join(",")})) * scale;
              inter_results[local_id.y][local_id.x] += ${Array.from({
                    length: 2
                }, (de, q)=>`${`dot(a_data${q}, b_dequantized_values[${q}])`}`).join(" + ")};
              word_offset += ${8 / p};
            }
            workgroupBarrier();
          }

          if (local_idx < ${b}) {
            var output_value: ${H.type.value} = ${H.type.value}(0);
            for (var b = 0u; b < ${y}; b++) {
              output_value += inter_results[local_idx][b];
            }
            if (col + local_idx < uniforms.output_shape[2])
            {
              ${H.setByIndices(`${H.type.indices}(batch, row, col + local_idx)`, "output_value")}
            }
          }
        }`;
            };
            return {
                name: "BlockwiseMatMulNBits32",
                shaderCache: {
                    hint: `${t.blockSize};${p};${f};${y};${b}`,
                    inputDependencies: Array(e1.length).fill("rank")
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: m,
                                dataType: c
                            }
                        ],
                        dispatchGroup: {
                            x: v
                        },
                        programUniforms: $
                    }),
                getShaderSource: z
            };
        }, Sa = (e1, t)=>{
            hc(e1.inputs, t), t.blockSize === 32 && e1.adapterInfo.isVendor("intel") && e1.adapterInfo.isArchitecture("gen-12lp") ? e1.compute(yc(e1.inputs, t)) : e1.compute(gc(e1.inputs, t));
        }, Ta = (e1)=>G(e1);
    });
    var bc, _c, wc, $c, vc, xc, Sc, Tc, Ca, Aa = k(()=>{
        "use strict";
        L();
        F();
        j();
        bc = (e1)=>{
            if (!e1 || e1.length < 1) throw new Error("Too few inputs");
            if (e1[0].dataType !== 1 && e1[0].dataType !== 10) throw new Error("Input type must be float or float16.");
            if (e1.length >= 2) {
                let t = e1[0].dims.length * 2 === e1[1].dims[0];
                if (e1.length === 4 && (t = e1[3].dims[0] * 2 === e1[1].dims[0]), !t) throw new Error("The pads should be a 1D tensor of shape [2 * input_rank] or [2 * num_axes].");
            }
        }, _c = (e1, t, n)=>{
            let r = "";
            for(let o = t - 1; o >= 0; --o)r += `
            k = i32(${e1.indicesGet("indices", o)}) - ${B("uniforms.pads", o, n)};
            if (k < 0) {
              break;
            }
            if (k >= i32(${B("uniforms.x_shape", o, t)})) {
              break;
            }
            offset += k * i32(${B("uniforms.x_strides", o, t)});
        `;
            return `
          value = ${e1.type.value}(uniforms.constant_value);
          for (var i = 0; i < 1; i++) {
            var offset = 0;
            var k = 0;
            ${r}
            value = x[offset];
          }
      `;
        }, wc = (e1, t, n)=>{
            let r = "";
            for(let o = t - 1; o >= 0; --o)r += `
                k = i32(${e1.indicesGet("indices", o)}) - ${B("uniforms.pads", o, n)};
                if (k < 0) {
                  k = -k;
                }
                {
                  let _2n_1 = 2 * (i32(${B("uniforms.x_shape", o, t)}) - 1);
                  k = k % _2n_1;
                  if(k >= i32(${B("uniforms.x_shape", o, t)})) {
                    k = _2n_1 - k;
                  }
                }
                offset += k * i32(${B("uniforms.x_strides", o, t)});
            `;
            return `
              var offset = 0;
              var k = 0;
              ${r}
              value = x[offset];
          `;
        }, $c = (e1, t, n)=>{
            let r = "";
            for(let o = t - 1; o >= 0; --o)r += `
                k = i32(${e1.indicesGet("indices", o)}) - ${B("uniforms.pads", o, n)};
                if (k < 0) {
                  k = 0;
                }
                if (k >= i32(${B("uniforms.x_shape", o, t)})) {
                  k = i32(${B("uniforms.x_shape", o, t)}) - 1;
                }
                offset += k * i32(${B("uniforms.x_strides", o, t)});
            `;
            return `
              var offset = 0;
              var k = 0;
              ${r}
              value = x[offset];
          `;
        }, vc = (e1, t, n)=>{
            let r = "";
            for(let o = t - 1; o >= 0; --o)r += `
                k = i32(${e1.indicesGet("indices", o)}) - ${B("uniforms.pads", o, n)};
                if (k < 0)  {
                  k += i32(${B("uniforms.x_shape", o, t)}]);
                }
                if (k >= i32(${B("uniforms.x_shape", o, t)})) {
                  k -= i32(${B("uniforms.x_shape", o, t)});
                }
                offset += k * i32(${B("uniforms.x_strides", o, t)});
            `;
            return `
              var offset = 0;
              var k = 0;
              ${r}
              value = x[offset];
          `;
        }, xc = (e1, t, n)=>{
            switch(n.mode){
                case 0:
                    return _c(e1, t, n.pads.length);
                case 1:
                    return wc(e1, t, n.pads.length);
                case 2:
                    return $c(e1, t, n.pads.length);
                case 3:
                    return vc(e1, t, n.pads.length);
                default:
                    throw new Error("Invalid mode");
            }
        }, Sc = (e1, t)=>{
            let n = x.padShape(e1[0].dims.slice(), t.pads), r = e1[0].dims, o = x.size(n), i = [
                {
                    type: 12,
                    data: o
                },
                {
                    type: 6,
                    data: t.pads
                }
            ], s = e1.length >= 3 && e1[2].data;
            t.mode === 0 && i.push({
                type: s ? e1[2].dataType : 1,
                data: t.value
            }), i.push(...P(e1[0].dims, n));
            let a = [
                "rank"
            ], u = (d)=>{
                let l = C("output", e1[0].dataType, n.length), c = S("x", e1[0].dataType, r.length), p = c.type.value, f = xc(l, r.length, t), m = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "pads",
                        type: "i32",
                        length: t.pads.length
                    }
                ];
                return t.mode === 0 && m.push({
                    name: "constant_value",
                    type: s ? p : "f32"
                }), `
            ${d.registerUniforms(m).declareVariables(c, l)}
            ${d.mainStart()}
            ${d.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}

            let indices = ${l.offsetToIndices("global_idx")};

            var value = ${p}(0);
            ${f}
            output[global_idx] = value;
        }`;
            };
            return {
                name: "Pad",
                shaderCache: {
                    hint: `${t.mode}${s}`,
                    inputDependencies: a
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: n,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(x.size(n) / 64)
                        },
                        programUniforms: i
                    }),
                getShaderSource: u
            };
        }, Tc = (e1, t)=>{
            if (e1.length > 1) {
                let n = e1[1].getBigInt64Array(), r = e1.length >= 3 && e1[2].data ? e1[2].dataType === 10 ? e1[2].getUint16Array()[0] : e1[2].getFloat32Array()[0] : 0, o = e1[0].dims.length, i = new Int32Array(2 * o).fill(0);
                if (e1.length >= 4) {
                    let a = e1[3].getBigInt64Array();
                    for(let u = 0; u < a.length; u++)i[Number(a[u])] = Number(n[u]), i[Number(a[u]) + o] = Number(n[u + a.length]);
                } else n.forEach((a, u)=>i[Number(u)] = Number(a));
                let s = [];
                return i.forEach((a)=>s.push(a)), {
                    mode: t.mode,
                    value: r,
                    pads: s
                };
            } else return t;
        }, Ca = (e1, t)=>{
            bc(e1.inputs);
            let n = Tc(e1.inputs, t);
            e1.compute(Sc(e1.inputs, n), {
                inputs: [
                    0
                ]
            });
        };
    });
    var mn, Ea, ka, Pa, za, Ic, Cc, Ba, Da, Oa, Ma, Ua, Ra, Va, Na, La, Ga, Wa, Ha, qa = k(()=>{
        "use strict";
        _e();
        L();
        F();
        j();
        mn = (e1)=>{
            if (te.webgpu.validateInputContent && (!e1 || e1.length !== 1)) throw new Error("Pool ops requires 1 input.");
        }, Ea = (e1, t, n)=>{
            let r = t.format === "NHWC", o = e1.dims.slice();
            r && o.splice(1, 0, o.pop());
            let i = Object.hasOwnProperty.call(t, "dilations"), s = t.kernelShape.slice(), a = t.strides.slice(), u = i ? t.dilations.slice() : [], d = t.pads.slice();
            Ye.adjustPoolAttributes(n, o, s, a, u, d);
            let l = Ye.computePoolOutputShape(n, o, a, u, s, d, t.autoPad), c = Object.assign({}, t);
            i ? Object.assign(c, {
                kernelShape: s,
                strides: a,
                pads: d,
                dilations: u,
                cacheKey: t.cacheKey
            }) : Object.assign(c, {
                kernelShape: s,
                strides: a,
                pads: d,
                cacheKey: t.cacheKey
            });
            let p = l.slice();
            return p.push(p.splice(1, 1)[0]), [
                c,
                r ? p : l
            ];
        }, ka = (e1, t)=>{
            let n = t.format === "NHWC", r = x.size(e1), o = x.size(t.kernelShape), i = [
                {
                    type: 12,
                    data: r
                },
                {
                    type: 12,
                    data: o
                }
            ], s = [
                {
                    name: "outputSize",
                    type: "u32"
                },
                {
                    name: "kernelSize",
                    type: "u32"
                }
            ];
            if (t.kernelShape.length <= 2) {
                let a = t.kernelShape[t.kernelShape.length - 1], u = t.strides[t.strides.length - 1], d = t.pads[t.pads.length / 2 - 1], l = t.pads[t.pads.length - 1], c = !!(d + l);
                i.push({
                    type: 12,
                    data: a
                }, {
                    type: 12,
                    data: u
                }, {
                    type: 12,
                    data: d
                }, {
                    type: 12,
                    data: l
                }), s.push({
                    name: "kw",
                    type: "u32"
                }, {
                    name: "sw",
                    type: "u32"
                }, {
                    name: "pwStart",
                    type: "u32"
                }, {
                    name: "pwEnd",
                    type: "u32"
                });
                let p = !1;
                if (t.kernelShape.length === 2) {
                    let f = t.kernelShape[t.kernelShape.length - 2], m = t.strides[t.strides.length - 2], h = t.pads[t.pads.length / 2 - 2], b = t.pads[t.pads.length - 2];
                    p = !!(h + b), i.push({
                        type: 12,
                        data: f
                    }, {
                        type: 12,
                        data: m
                    }, {
                        type: 12,
                        data: h
                    }, {
                        type: 12,
                        data: b
                    }), s.push({
                        name: "kh",
                        type: "u32"
                    }, {
                        name: "sh",
                        type: "u32"
                    }, {
                        name: "phStart",
                        type: "u32"
                    }, {
                        name: "phEnd",
                        type: "u32"
                    });
                }
                return [
                    i,
                    s,
                    !0,
                    c,
                    p
                ];
            } else {
                if (n) throw new Error("Pooling with kernelShape.length > 2 is not supported for NHWC format.");
                let a = x.computeStrides(t.kernelShape);
                i.push({
                    type: 12,
                    data: a
                }, {
                    type: 12,
                    data: t.pads
                }, {
                    type: 12,
                    data: t.strides
                }), s.push({
                    name: "kernelStrides",
                    type: "u32",
                    length: a.length
                }, {
                    name: "pads",
                    type: "u32",
                    length: t.pads.length
                }, {
                    name: "strides",
                    type: "u32",
                    length: t.strides.length
                });
                let u = t.pads.reduce((d, l)=>d + l);
                return [
                    i,
                    s,
                    !!u,
                    !1,
                    !1
                ];
            }
        }, Pa = (e1, t, n, r, o, i, s, a, u, d, l, c)=>{
            let p = o.format === "NHWC", f = t.type.value, m = C("output", t.type.tensor, r);
            if (o.kernelShape.length <= 2) {
                let h = "", b = "", y = "", g = n - (p ? 2 : 1);
                if (l ? h = `
                for (var i: u32 = 0u; i < uniforms.kw; i++) {
                  xIndices[${g}] = indices[${g}] * uniforms.sw - uniforms.pwStart + i;
                  if (xIndices[${g}] < 0 || xIndices[${g}]
                      >= uniforms.x_shape[${g}]) {
                    pad++;
                    continue;
                  }
                  let x_val = x[${t.indicesToOffset("xIndices")}];
                  ${i}
                }` : h = `
                for (var i: u32 = 0u; i < uniforms.kw; i++) {
                  xIndices[${g}] = indices[${g}] * uniforms.sw - uniforms.pwStart + i;
                  let x_val = x[${t.indicesToOffset("xIndices")}];
                  ${i}
                }`, o.kernelShape.length === 2) {
                    let w = n - (p ? 3 : 2);
                    c ? b = `
                for (var j: u32 = 0u; j < uniforms.kh; j++) {
                  xIndices[${w}] = indices[${w}] * uniforms.sh - uniforms.phStart + j;
                  if (xIndices[${w}] < 0 || xIndices[${w}] >= uniforms.x_shape[${w}]) {
                    pad += i32(uniforms.kw);
                    continue;
                  }
              ` : b = `
                for (var j: u32 = 0u; j < uniforms.kh; j++) {
                  xIndices[${w}] = indices[${w}] * uniforms.sh - uniforms.phStart + j;
                `, y = `
              }
            `;
                }
                return `
            ${e1.registerUniforms(u).declareVariables(t, m)}

            ${e1.mainStart()}
              ${e1.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}

              let indices = ${m.offsetToIndices("global_idx")};
              var xIndices = ${m.offsetToIndices("global_idx")};

              var value = ${f}(${a});
              var pad = 0;
              ${b}
              ${h}
              ${y}
              ${s}

              output[global_idx] = value;
            }`;
            } else {
                if (p) throw new Error("Pooling with kernelShape.length > 2 is not supported for NHWC format.");
                let h = o.kernelShape.length, b = o.pads.length, y = "";
                return d ? y = `
                if (xIndices[j] >= uniforms.x_shape[j]) {
                  pad++;
                  isPad = true;
                  break;
                }
              }
              if (!isPad) {
                let x_val = x[${t.indicesToOffset("xIndices")}];
                ${i}
              }` : y = `
              }
              let x_val = x[${t.indicesToOffset("xIndices")}];
              ${i}
            `, `
            ${e1.registerUniforms(u).declareVariables(t, m)}

            ${e1.mainStart()}
              ${e1.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
              let indices = ${m.offsetToIndices("global_idx")};
              var xIndices = ${m.offsetToIndices("global_idx")};

              var offsets: array<u32, ${h}>;

              var value = ${f}(${a});
              var pad = 0;
              var isPad = false;

              for (var i: u32 = 0u; i < uniforms.kernelSize; i++) {
                var offset = i;
                for (var j = 0u; j < ${h - 1}u; j++) {
                  offsets[j] = offset / ${B("uniforms.kernelStrides", "j", h)};
                  offset -= offsets[j] * ${B("uniforms.kernelStrides", "j", h)};
                }
                offsets[${h - 1}] = offset;

                isPad = false;
                for (var j = ${n - h}u; j < ${n}u; j++) {
                  xIndices[j] = indices[j] * ${B("uniforms.strides", `j - ${n - h}u`, h)}
                    + offsets[j - ${n - h}u] - ${B("uniforms.pads", "j - 2u", b)};
                  ${y}
              }
              ${s}

              output[global_idx] = value;
            }`;
            }
        }, za = (e1)=>`${e1.format};${e1.ceilMode};${e1.autoPad};${e1.kernelShape.length}`, Ic = (e1)=>`${za(e1)};${e1.countIncludePad}`, Cc = (e1)=>`${za(e1)};${e1.storageOrder};${e1.dilations}`, Ba = (e1)=>({
                format: e1.format,
                autoPad: [
                    "NOTSET",
                    "VALID",
                    "SAME_UPPER",
                    "SAME_LOWER"
                ][e1.auto_pad],
                ceilMode: e1.ceil_mode,
                kernelShape: e1.kernel_shape,
                strides: e1.strides,
                pads: e1.pads
            }), Da = (e1, t, n, r)=>{
            let [o, i] = Ea(t, r, n), s = S("x", t.dataType, t.dims.length), a = s.type.value, u = "value += x_val;", d = "";
            o.countIncludePad ? d += `value /= ${a}(uniforms.kernelSize);` : d += `value /= ${a}(i32(uniforms.kernelSize) - pad);`;
            let [l, c, p, f, m] = ka(i, o);
            l.push(...P(t.dims, i));
            let h = [
                "rank"
            ];
            return {
                name: e1,
                shaderCache: {
                    hint: `${r.cacheKey};${p};${f};${m}`,
                    inputDependencies: h
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i,
                                dataType: t.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(x.size(i) / 64)
                        },
                        programUniforms: l
                    }),
                getShaderSource: (b)=>Pa(b, s, t.dims.length, i.length, o, u, d, 0, c, p, f, m)
            };
        }, Oa = (e1)=>{
            let t = e1.count_include_pad !== 0, n = Ba(e1);
            if (n.ceilMode !== 0) throw new Error("using ceil() in shape computation is not yet supported for AveragePool");
            let r = {
                countIncludePad: t,
                ...n,
                cacheKey: ""
            };
            return {
                ...r,
                cacheKey: Ic(r)
            };
        }, Ma = (e1, t)=>{
            mn(e1.inputs), e1.compute(Da("AveragePool", e1.inputs[0], !1, t));
        }, Ua = {
            autoPad: "",
            ceilMode: 0,
            countIncludePad: !1,
            kernelShape: [],
            strides: [],
            pads: [],
            storageOrder: 0,
            dilations: []
        }, Ra = (e1)=>{
            let t = e1.format;
            return {
                format: t,
                ...Ua,
                cacheKey: t
            };
        }, Va = (e1, t)=>{
            mn(e1.inputs), e1.compute(Da("GlobalAveragePool", e1.inputs[0], !0, t));
        }, Na = (e1, t, n, r)=>{
            let [o, i] = Ea(t, r, n), s = `
      value = max(x_val, value);
    `, a = "", u = S("x", t.dataType, t.dims.length), d = [
                "rank"
            ], [l, c, p, f, m] = ka(i, o);
            return l.push(...P(t.dims, i)), {
                name: e1,
                shaderCache: {
                    hint: `${r.cacheKey};${p};${f};${m}`,
                    inputDependencies: d
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i,
                                dataType: t.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(x.size(i) / 64)
                        },
                        programUniforms: l
                    }),
                getShaderSource: (h)=>Pa(h, u, t.dims.length, i.length, o, s, a, t.dataType === 10 ? -65504 : -100000, c, p, f, m)
            };
        }, La = (e1, t)=>{
            mn(e1.inputs), e1.compute(Na("MaxPool", e1.inputs[0], !1, t));
        }, Ga = (e1)=>{
            let t = e1.storage_order, n = e1.dilations, r = Ba(e1);
            if (t !== 0) throw new Error("column major storage order is not yet supported for MaxPool");
            if (r.ceilMode !== 0) throw new Error("using ceil() in shape computation is not yet supported for MaxPool");
            let o = {
                storageOrder: t,
                dilations: n,
                ...r,
                cacheKey: ""
            };
            return {
                ...o,
                cacheKey: Cc(o)
            };
        }, Wa = (e1)=>{
            let t = e1.format;
            return {
                format: t,
                ...Ua,
                cacheKey: t
            };
        }, Ha = (e1, t)=>{
            mn(e1.inputs), e1.compute(Na("GlobalMaxPool", e1.inputs[0], !0, t));
        };
    });
    var Ec, kc, Fa, Ka, ja = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Ec = (e1, t)=>{
            if (e1.length < 2 || e1.length > 3) throw new Error("DequantizeLinear requires 2 or 3 inputs.");
            if (e1.length === 3 && e1[1].dims === e1[2].dims) throw new Error("x-scale and x-zero-point must have the same shape.");
            if (e1.length === 3 && e1[0].dataType !== e1[2].dataType) throw new Error("x and x-zero-point must have the same data type.");
            if (e1[0].dataType === 6 && e1.length > 2) throw new Error("In the case of dequantizing int32 there is no zero point.");
            if (e1[1].dims.length !== 0 && e1[1].dims.length !== 1 && e1[1].dims.length !== e1[0].dims.length) throw new Error("scale input must be a scalar, a 1D tensor, or have the same rank as the input tensor.");
            if (e1.length > 2) {
                if (e1[0].dataType !== e1[2].dataType) throw new Error("x and x-zero-point must have the same data type.");
                if (e1[1].dims.length !== e1[2].dims.length) throw new Error("scale and zero-point inputs must have the same rank.");
                if (!e1[1].dims.map((n, r)=>n === e1[2].dims[r]).reduce((n, r)=>n && r, !0)) throw new Error("scale and zero-point inputs must have the same shape.");
            }
            if (t.blockSize > 0) {
                if (e1[1].dims.length === 0 || e1[1].dims.length === 1 && e1[1].dims[0] === 1) throw new Error("blockSize must be set only for block quantization.");
                if (!e1[1].dims.map((o, i)=>i === t.axis || o === e1[0].dims[i]).reduce((o, i)=>o && i, !0)) throw new Error("For block qunatization, scale input shape to match the input shape except for the axis");
                if (e1[1].dims.length !== e1[0].dims.length) throw new Error("For block qunatization the scale input rank must be the same as the x rank.");
                let n = e1[0].dims[t.axis], r = e1[1].dims[t.axis];
                if (t.blockSize < Math.ceil(n / r) || t.blockSize > Math.ceil(n / (r - 1) - 1)) throw new Error("blockSize must be with in the range [ceil(dI / Si), ceil(dI / (Si - 1) - 1)].");
            }
        }, kc = (e1, t)=>{
            let n = x.normalizeAxis(t.axis, e1[0].dims.length), r = e1[0].dataType, o = r === 3, i = e1[0].dims, s = e1[1].dataType, a = x.size(i), u = r === 3 || r === 2, d = u ? [
                Math.ceil(x.size(e1[0].dims) / 4)
            ] : e1[0].dims, l = e1[1].dims, c = e1.length > 2 ? e1[2] : void 0, p = c ? u ? [
                Math.ceil(x.size(c.dims) / 4)
            ] : c.dims : void 0, f = l.length === 0 || l.length === 1 && l[0] === 1, m = f === !1 && l.length === 1, h = J(a), b = f && (!u || h === 4), y = b ? h : 1, g = b && !u ? h : 1, _ = S("input", u ? 12 : r, d.length, g), w = S("scale", s, l.length), v = c ? S("zero_point", u ? 12 : r, p.length) : void 0, $ = C("output", s, i.length, y), T = [
                _,
                w
            ];
            v && T.push(v);
            let I = [
                d,
                l
            ];
            c && I.push(p);
            let A = [
                {
                    type: 12,
                    data: a / y
                },
                {
                    type: 12,
                    data: n
                },
                {
                    type: 12,
                    data: t.blockSize
                },
                ...P(...I, i)
            ], z = (R)=>{
                let D = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "axis",
                        type: "u32"
                    },
                    {
                        name: "block_size",
                        type: "u32"
                    }
                ];
                return `
      ${R.registerUniforms(D).declareVariables(...T, $)}
      ${R.mainStart()}
          ${R.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
          let output_indices = ${$.offsetToIndices("global_idx")};

          // Set input x
          ${u ? `
            let input = ${_.getByOffset("global_idx / 4")};
            let x_vec = ${o ? "unpack4xI8(input)" : "unpack4xU8(input)"};
            let x_value = ${y === 1 ? "x_vec[global_idx % 4]" : "x_vec"};` : `let x_value = ${_.getByOffset("global_idx")};`};

          // Set scale input
          ${f ? `let scale_value= ${w.getByOffset("0")}` : m ? `
            let scale_index = ${$.indicesGet("output_indices", "uniforms.axis")};
            let scale_value= ${w.getByOffset("scale_index")};` : `
            var scale_indices: ${w.type.indices} = output_indices;
            let index = ${w.indicesGet("scale_indices", "uniforms.axis")} / uniforms.block_size;
            ${w.indicesSet("scale_indices", "uniforms.axis", "index")};
            let scale_value= ${w.getByIndices("scale_indices")};`};

          // Set zero-point input
          ${v ? f ? u ? `
                let zero_point_input = ${v.getByOffset("0")};
                let zero_point_vec =  ${o ? "unpack4xI8(zero_point_input)" : "unpack4xU8(zero_point_input)"};
                let zero_point_value= zero_point_vec[0]` : `let zero_point_value = ${v.getByOffset("0")}` : m ? u ? `
                let zero_point_index = ${$.indicesGet("output_indices", "uniforms.axis")};
                let zero_point_input = ${v.getByOffset("zero_point_index / 4")};
                let zero_point_vec =  ${o ? "unpack4xI8(zero_point_input)" : "unpack4xU8(zero_point_input)"};
                let zero_point_value = zero_point_vec[zero_point_index % 4]` : `
                let zero_point_index = ${$.indicesGet("output_indices", "uniforms.axis")};
                let zero_point_value = ${v.getByOffset("zero_point_index")};` : u ? `
                let zero_point_offset = ${w.indicesToOffset("scale_indices")};
                let zero_point_input = ${v.getByOffset("zero_point_offset / 4")};
                let zero_point_vec = ${o ? "unpack4xI8(zero_point_input)" : "unpack4xU8(zero_point_input)"};
                let zero_point_value = zero_point_vec[zero_point_offset % 4];` : `let zero_point_value = ${v.getByIndices("scale_indices")};` : `let zero_point_value = ${u ? o ? "i32" : "u32" : _.type.value}(0);`};
      // Compute and write output
      ${$.setByOffset("global_idx", `${$.type.value}(x_value - zero_point_value) * scale_value`)};
      }`;
            };
            return {
                name: "DequantizeLinear",
                shaderCache: {
                    hint: t.cacheKey,
                    inputDependencies: v ? [
                        "rank",
                        "rank",
                        "rank"
                    ] : [
                        "rank",
                        "rank"
                    ]
                },
                getShaderSource: z,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i,
                                dataType: s
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(a / y / 64),
                            y: 1,
                            z: 1
                        },
                        programUniforms: A
                    })
            };
        }, Fa = (e1, t)=>{
            Ec(e1.inputs, t), e1.compute(kc(e1.inputs, t));
        }, Ka = (e1)=>G({
                axis: e1.axis,
                blockSize: e1.blockSize
            });
    });
    var Pc, zc, Za, Qa = k(()=>{
        "use strict";
        _e();
        L();
        j();
        Pc = (e1, t, n)=>{
            let r = e1 === t, o = e1 < t && n < 0, i = e1 > t && n > 0;
            if (r || o || i) throw new Error("Range these inputs' contents are invalid.");
        }, zc = (e1, t, n, r)=>{
            let o = Math.abs(Math.ceil((t - e1) / n)), i = [
                o
            ], s = o, a = [
                {
                    type: 12,
                    data: s
                },
                {
                    type: r,
                    data: e1
                },
                {
                    type: r,
                    data: n
                },
                ...P(i)
            ], u = (d)=>{
                let l = C("output", r, i.length), c = l.type.value, p = [
                    {
                        name: "outputSize",
                        type: "u32"
                    },
                    {
                        name: "start",
                        type: c
                    },
                    {
                        name: "delta",
                        type: c
                    }
                ];
                return `
        ${d.registerUniforms(p).declareVariables(l)}
        ${d.mainStart()}
        ${d.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
        output[global_idx] = uniforms.start + ${c}(global_idx) * uniforms.delta;
      }`;
            };
            return {
                name: "Range",
                shaderCache: {
                    hint: `${r}`
                },
                getShaderSource: u,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: i,
                                dataType: r
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(s / 64)
                        },
                        programUniforms: a
                    })
            };
        }, Za = (e1)=>{
            let t = 0, n = 0, r = 0;
            e1.inputs[0].dataType === 6 ? (t = e1.inputs[0].getInt32Array()[0], n = e1.inputs[1].getInt32Array()[0], r = e1.inputs[2].getInt32Array()[0]) : e1.inputs[0].dataType === 1 && (t = e1.inputs[0].getFloat32Array()[0], n = e1.inputs[1].getFloat32Array()[0], r = e1.inputs[2].getFloat32Array()[0]), te.webgpu.validateInputContent && Pc(t, n, r), e1.compute(zc(t, n, r, e1.inputs[0].dataType), {
                inputs: []
            });
        };
    });
    var Bc, Dc, Xa, Ya, Ja = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Bc = (e1, t, n, r)=>{
            if (e1 !== "none" && r !== "i32" && r !== "u32" && r !== "f32") throw new Error(`Input ${r} is not supported with reduction ${e1}.`);
            let o = `{
                var oldValue = 0;
                loop {
                  let newValueF32 =`, i = `;
                  let newValue = bitcast<i32>(newValueF32);
                  let res = atomicCompareExchangeWeak(&${t}, oldValue, newValue);
                  if res.exchanged {
                    break;
                  }
                  oldValue = res.old_value;
                }
              }`;
            switch(e1){
                case "none":
                    return `${t}=${n};`;
                case "add":
                    return r === "i32" || r === "u32" ? `atomicAdd(&${t}, bitcast<${r}>(${n}));` : `
              ${o}bitcast<${r}>(oldValue) + (${n})${i}`;
                case "max":
                    return r === "i32" || r === "u32" ? `atomicMax(&${t}, bitcast<${r}>(${n}));` : `
                ${o}max(bitcast<f32>(oldValue), (${n}))${i}`;
                case "min":
                    return r === "i32" || r === "u32" ? `atomicMin(&${t}, bitcast<${r}>(${n}));` : `${o}min(bitcast<${r}>(oldValue), (${n}))${i}`;
                case "mul":
                    return `${o}(bitcast<${r}>(oldValue) * (${n}))${i}`;
                default:
                    throw new Error(`Reduction ${e1} is not supported.`);
            }
        }, Dc = (e1, t)=>{
            let n = e1[0].dims, r = e1[1].dims, o = n, i = 1, s = Math.ceil(x.sizeToDimension(r, r.length - 1) / i), a = r[r.length - 1], u = x.sizeFromDimension(n, a), d = [
                {
                    type: 12,
                    data: s
                },
                {
                    type: 12,
                    data: a
                },
                {
                    type: 12,
                    data: u
                },
                ...P(e1[1].dims, e1[2].dims, o)
            ], l = (c)=>{
                let p = S("indices", e1[1].dataType, e1[1].dims.length), f = S("updates", e1[2].dataType, e1[2].dims.length, i), m = t.reduction !== "none" && t.reduction !== "" ? To("output", e1[0].dataType, o.length) : C("output", e1[0].dataType, o.length, i);
                return `
      ${c.registerUniform("output_size", "u32").registerUniform("last_index_dimension", "u32").registerUniform("num_updates_elements", "u32").declareVariables(p, f, m)}
      ${c.mainStart()}
        ${c.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
  var data_offset = 0u;
  let indices_start = uniforms.last_index_dimension * global_idx;
  let indices_end = indices_start + uniforms.last_index_dimension;
  for (var i = indices_start; i < indices_end; i++) {
    var index = i32(indices[i].x);
    ${e1[0].dims.length === 1 ? `
    let element_count_dim = uniforms.output_strides;
    let dim_value = uniforms.output_shape;` : `
    let element_count_dim = uniforms.output_strides[i - indices_start];
    let dim_value = uniforms.output_shape[i - indices_start];`}
    if (index >= 0) {
      if (index >= i32(dim_value)) {
        index = i32(dim_value - 1);
      }
    } else {
      if (index < -i32(dim_value)) {
        index = 0;
      } else {
        index += i32(dim_value);
      }
    }
    data_offset += u32((u32(index) * element_count_dim));
  }

  for (var i = 0u; i < uniforms.num_updates_elements; i++) {
    let value = updates[uniforms.num_updates_elements * global_idx + i];
    ${Bc(t.reduction, "output[data_offset + i]", "value", m.type.value)}
  }

      }`;
            };
            return {
                name: "ScatterND",
                shaderCache: {
                    hint: `${t.cacheKey}_${t.reduction}`,
                    inputDependencies: [
                        "rank",
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: o,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(s / 64)
                        },
                        programUniforms: d
                    }),
                getShaderSource: l
            };
        }, Xa = (e1)=>G({
                reduction: e1.reduction
            }), Ya = (e1, t)=>{
            e1.compute(Dc(e1.inputs, t), {
                inputs: [
                    e1.inputs[1],
                    e1.inputs[2]
                ],
                outputs: []
            });
        };
    });
    var Oc, Mc, Uc, eu, Rc, Vc, Nc, Lc, Gc, Wc, Hc, qc, tu, Fc, Kc, jc, Zc, Qc, nu, ru, ou = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Oc = (e1, t)=>{
            if (e1.every((n)=>n > 0 || (()=>{
                    throw new Error("Resize requires scales input values to be positive");
                })), e1.length > 0) {
                if (t.mode === "linear") {
                    if (!(e1.length === 2 || e1.length === 3 || e1.length === 4 && e1[0] === 1 && e1[1] === 1 || e1.length === 4 && e1[0] === 1 && e1[3] === 1 || e1.length === 5 && e1[0] === 1 && e1[1] === 1)) throw new Error(`For linear mode, Resize requires scales to be 2D, 3D, 4D with either two outermost or one innermost and
            one outermost scale values equal to 1, or 5D with two outermost scale values equal to 1`);
                } else if (t.mode === "cubic" && !(e1.length === 2 || e1.length === 4 && e1[0] === 1 && e1[1] === 1 || e1.length === 4 && e1[0] === 1 && e1[3] === 1)) throw new Error("Resize requires scales input size to be 2 or 4 for cubic mode");
            }
        }, Mc = (e1, t, n)=>{
            t.every((o)=>o >= 0 && o < n || (()=>{
                    throw new Error("Resize requires axes input values to be positive and less than rank");
                }));
            let r = new Array(n).fill(1);
            return t.forEach((o, i)=>r[o] = e1[i]), r;
        }, Uc = (e1, t, n, r, o, i)=>{
            let [s, a, u] = n > 10 ? [
                1,
                2,
                3
            ] : [
                -1,
                e1.length > 1 ? 1 : -1,
                -1
            ], d = e1[0].dims.length;
            if (s > 0 && e1.length > s && e1[s].dims.length > 0) e1[s].getFloat32Array().forEach((l)=>i.push(l));
            else if (t.coordinateTransformMode === "tf_crop_and_resize") throw new Error("Resize requires RoI input to be specified when coordinateTransformMode is tfCropAndResize");
            if (a > 0 && e1.length > a && e1[a].dims.length === 1 && e1[a].dims[0] > 0) {
                if (e1[a].getFloat32Array().forEach((l)=>r.push(l)), r.length !== 0 && r.length !== d && n >= 18 && r.length !== t.axes.length) throw new Error("Resize requires scales input size to be same as input rank or axes size for opset 18 and up");
                Oc(r, t), t.axes.length > 0 && Mc(r, t.axes, d).forEach((l, c)=>r[c] = l);
            }
            if (u > 0 && e1.length > u && e1[u].dims.length === 1 && e1[u].dims[0] > 0 && (e1[u].getBigInt64Array().forEach((l)=>o.push(Number(l))), o.length !== 0 && o.length !== d && n >= 18 && o.length !== t.axes.length)) throw new Error("Resize requires sizes input size to be same as input rank or axes size for opset 18 and up");
            if (t.axes.length > 0) {
                if (r.length !== 0 && r.length !== t.axes.length) throw new Error('Resize requires "scales" input size to be of axes rank when axes attributes is specified');
                if (o.length !== 0 && o.length !== t.axes.length) throw new Error('Resize requires "sizes" input size to be of rank axes rank when axes attributes is specified');
            }
            if (typeof r < "u" && typeof o < "u" && r.length > 0 && o.length > d) throw new Error("Resize requires only of scales or sizes to be specified");
        }, eu = (e1, t, n, r)=>`
  // The whole part and the fractional part are calculated separately due to inaccuracy of floating
  // point division. As an example, f32(21) / f32(7) may evaluate to 2.99... instead of 3, causing an
  // offset-by-one error later in floor().
  let big = (${e1}) * (${t});
  let whole = ${r}(big / (${n}));
  let fract = ${r}(big % (${n})) / ${r}(${n});
  return whole + fract;
`, Rc = (e1, t)=>`fn getOriginalCoordinateFromResizedCoordinate(xResized: u32, xScale: f32, lengthResized: u32,
     lengthOriginal: u32, roiStart: f32, roiEnd: f32) -> ${t} { ` + (()=>{
                switch(e1){
                    case "asymmetric":
                        return `
          if (xScale < 1.0 || floor(xScale) != xScale) {
            return ${t}(xResized) / ${t}(xScale);
          } else {
            ${eu("xResized", "lengthOriginal", "lengthResized", t)}
          }
        `;
                    case "pytorch_half_pixel":
                        return `if (lengthResized > 1) {
                    return (${t}(xResized) + 0.5) / ${t}(xScale) - 0.5;
                  } else {
                    return 0.0;
                  }`;
                    case "tf_half_pixel_for_nn":
                        return `return (${t}(xResized) + 0.5) / ${t}(xScale);`;
                    case "align_corners":
                        return `if (lengthResized == 1) {
                    return 0.0;
                  } else {
                    ${eu("xResized", "lengthOriginal - 1", "lengthResized - 1", t)}
                  }`;
                    case "tf_crop_and_resize":
                        return `if (lengthResized > 1) {
                    return ${t}(roiStart) * ${t}(lengthOriginal - 1) +
                        (${t}(xResized) * ${t}(roiEnd - roiStart) * ${t}(lengthOriginal - 1)) /
                        ${t}(lengthResized - 1);
                  } else {
                    return 0.5 * ${t}(roiStart + roiEnd) * ${t}(lengthOriginal - 1);
                  }`;
                    case "half_pixel_symmetric":
                        return `const outputWidth = ${t}xScale * ${t}(lengthResized);
                  const adjustment = ${t}(lengthResized) / outputWidth;
                  const center = ${t}(lengthOriginal) / 2;
                  const offset = center * (1 - adjustment);
                  return offset + ((${t}(xResized) + 0.5) / ${t}(xScale)) - 0.5;`;
                    case "half_pixel":
                        return `return ((${t}(xResized) + 0.5) / ${t}(xScale)) - 0.5;`;
                    default:
                        throw new Error(`Coordinate transform mode ${e1} is not supported`);
                }
            })() + "}", Vc = (e1, t, n)=>`fn getNearestPixelFromOriginal(xOriginal: ${n}, isDownSample: bool) -> ${n} {` + (()=>{
                switch(e1){
                    case "round_prefer_ceil":
                        return "if (fract(xOriginal) == 0.5) {             return ceil(xOriginal);           } else {             return round(xOriginal);           }";
                    case "floor":
                        return "return floor(xOriginal);";
                    case "ceil":
                        return "return ceil(xOriginal);";
                    case "round_prefer_floor":
                        return "if (fract(xOriginal) == 0.5) {                     return floor(xOriginal);                   } else {                     return round(xOriginal);                   }";
                    case "simple":
                    default:
                        if (t < 11) return "if (isDownSample)                     {                       return ceil(xOriginal);                     } else {                       return xOriginal;                     }";
                        throw new Error(`Nearest mode ${e1} is not supported`);
                }
            })() + "}", Nc = (e1, t, n)=>{
            let r = new Array(n).fill(0).concat(new Array(n).fill(1)), o = e1.length === 0 ? r : e1.slice();
            return t.length > 0 ? (t.forEach((i, s)=>{
                r[i] = o[s], r[s + n] = o[t.length + s];
            }), r) : o;
        }, Lc = (e1, t, n, r)=>{
            let o = [];
            if (n.length > 0) {
                if (r.length > 0) {
                    if (e1.forEach((i)=>o.push(i)), Math.max(...r) > e1.length) throw new Error("axes is out of bound");
                    r.forEach((i, s)=>o[i] = n[s]);
                } else n.forEach((i)=>o.push(i));
            } else {
                if (t.length === 0) throw new Error("Resize requires either scales or sizes.");
                o = e1.map((i, s)=>Math.round(i * t[s]));
            }
            return o;
        }, Gc = (e1, t, n)=>{
            let r = (()=>{
                switch(n.keepAspectRatioPolicy){
                    case "not_larger":
                        return n.axes.length > 0 ? Math.min(...n.axes.map((i)=>t[i]), Number.MAX_VALUE) : Math.min(...t, Number.MAX_VALUE);
                    case "not_smaller":
                        return n.axes.length > 0 ? Math.max(...n.axes.map((i)=>t[i]), Number.MIN_VALUE) : Math.max(...t, Number.MIN_VALUE);
                    default:
                        throw new Error(`Keep aspect ratio policy ${n.keepAspectRatioPolicy} is not supported`);
                }
            })();
            t.fill(1, 0, t.length);
            let o = e1.slice();
            return n.axes.length > 0 ? (n.axes.forEach((i)=>t[i] = r), n.axes.forEach((i)=>o[i] = Math.round(e1[i] * t[i]))) : (t.fill(r, 0, t.length), o.forEach((i, s)=>o[s] = Math.round(i * t[s]))), o;
        }, Wc = (e1, t, n, r, o)=>`
    fn calculateOriginalIndicesFromOutputIndices(output_indices: ${e1.type.indices}) -> array<${e1.type.value}, ${n.length}> {
      var original_indices: array<${e1.type.value}, ${n.length}>;
      for (var i:u32 = 0; i < ${n.length}; i++) {
        var output_index = ${e1.indicesGet("output_indices", "i")};
        var scale = ${B("uniforms.scales", "i", r)};
        var roi_low = ${B("uniforms.roi", "i", o)};
        var roi_hi = ${B("uniforms.roi", `i + ${t.length}`, o)};
        if (scale == 1.0) {
          original_indices[i] = ${e1.type.value}(output_index);
        } else {
          var input_shape_i = ${B("uniforms.input_shape", "i", t.length)};
          var output_shape_i = ${B("uniforms.output_shape", "i", n.length)};
          original_indices[i] = getOriginalCoordinateFromResizedCoordinate(output_index, scale, output_shape_i,
                                                                           input_shape_i, roi_low, roi_hi);
        }
      }
      return original_indices;
    }`, Hc = (e1, t, n, r, o, i, s)=>`
    fn calculateInputIndicesFromOutputIndices(output_indices: ${t.type.indices}) -> ${e1.type.indices} {
      var input_indices: ${e1.type.indices};
      for (var i:u32 = 0; i < ${r.length}; i++) {
        var output_index = ${t.indicesGet("output_indices", "i")};
        var input_index: u32;
        var scale = ${B("uniforms.scales", "i", o)};
        if (scale == 1.0) {
          input_index = output_index;
        } else {
          var roi_low = ${B("uniforms.roi", "i", i)};
          var roi_hi = ${B("uniforms.roi", `i + ${n.length}`, i)};
          var input_shape_i = ${B("uniforms.input_shape", "i", n.length)};
          var output_shape_i = ${B("uniforms.output_shape", "i", r.length)};
          var original_idx = getOriginalCoordinateFromResizedCoordinate(output_index, scale, output_shape_i,
                                                                        input_shape_i, roi_low, roi_hi);
          if (!${s} || (original_idx >= 0 && original_idx < ${t.type.value}(input_shape_i))) {
            if (original_idx < 0) {
              input_index = 0;
            } else if (original_idx > ${t.type.value}(input_shape_i - 1)) {
              input_index = input_shape_i - 1;
            } else {
              input_index = u32(getNearestPixelFromOriginal(original_idx, scale < 1));
            }
          } else {
            input_index = u32(original_idx);
          }
        }
        ${e1.indicesSet("input_indices", "i", "input_index")}
      }
      return input_indices;
    }`, qc = (e1, t)=>`
    fn checkInputIndices(input_indices: ${e1.type.indices}) -> bool {
      for (var i:u32 = 0; i < ${t.length}; i++) {
        var input_index = ${e1.indicesGet("input_indices", "i")};
        if (input_index < 0 || input_index >= ${B("uniforms.input_shape", "i", t.length)}) {
          return false;
        }
      }
      return true;
    }`, tu = (e1, t, n, r)=>e1.rank > r ? `
    ${e1.indicesSet("input_indices", t, "channel")};
    ${e1.indicesSet("input_indices", n, "batch")};
` : "", Fc = (e1, t, n, r, o)=>{
            let [s, a, u, d] = n.length === 2 ? [
                -1,
                0,
                1,
                -1
            ] : [
                0,
                2,
                3,
                1
            ], l = e1.type.value;
            return `
    fn getInputValue(batch: u32, channel: u32, row: u32, col: u32) -> ${l} {
      var input_indices: ${e1.type.indices};
      ${e1.indicesSet("input_indices", a, `max(0, min(row, ${n[a]} - 1))`)};
      ${e1.indicesSet("input_indices", u, `max(0, min(col, ${n[u]} - 1))`)};
      ${tu(e1, d, s, 2)}
      return ${e1.getByIndices("input_indices")};
    }

    fn bilinearInterpolation(output_indices: ${t.type.indices}) -> ${l} {
      var originalIndices = calculateOriginalIndicesFromOutputIndices(output_indices);
      var row:${l} = originalIndices[${a}];
      var col:${l} = originalIndices[${u}];
      ${r ? `if (row < 0 || row > (${n[a]} - 1) || col < 0 || col > (${n[u]} - 1)) {
        return ${o};
      }` : ""};
      row = max(0, min(row, ${n[a]} - 1));
      col = max(0, min(col, ${n[u]} - 1));
      var row1: u32 = u32(row);
      var col1: u32 = u32(col);
      var row2: u32 = u32(row + 1);
      var col2: u32 = u32(col + 1);
      var channel: u32 = ${n.length > 2 ? `u32(originalIndices[${d}])` : "0"};
      var batch: u32 =  ${n.length > 2 ? `u32(originalIndices[${s}])` : "0"};
      var x11: ${l} = getInputValue(batch, channel, row1, col1);
      var x12: ${l} = getInputValue(batch, channel, row1, col2);
      var x21: ${l} = getInputValue(batch, channel, row2, col1);
      var x22: ${l} = getInputValue(batch, channel, row2, col2);
      var dx1: ${l} = abs(row - ${l}(row1));
      var dx2: ${l} = abs(${l}(row2) - row);
      var dy1: ${l} = abs(col - ${l}(col1));
      var dy2: ${l} = abs(${l}(col2) - col);
      if (row1 == row2) {
        dx1 = 0.5;
        dx2 = 0.5;
      }
      if (col1 == col2) {
        dy1 = 0.5;
        dy2 = 0.5;
      }
      return (x11 * dx2 * dy2 + x12 * dx2 * dy1 + x21 * dx1 * dy2 + x22 * dx1 * dy1);
    }`;
        }, Kc = (e1, t, n, r, o, i, s, a, u, d)=>{
            let l = n.length === 2, c = !0, [p, f] = l ? [
                0,
                1
            ] : c ? [
                2,
                3
            ] : [
                1,
                2
            ], m = e1.type.value, h = (b)=>{
                let y = b === p ? "row" : "col";
                return `
      fn ${y}CubicInterpolation(input_indices: ${e1.type.indices}, output_indices: ${t.type.indices}) -> ${m} {
        var output_index = ${t.indicesGet("output_indices", b)};
        var originalIdx: ${m} = getOriginalCoordinateFromResizedCoordinate(output_index, ${o[b]},
        ${r[b]}, ${n[b]}, ${i[b]}, ${i[b]} + ${n.length});
        var fractOriginalIdx: ${m} = originalIdx - floor(originalIdx);
        var coefs = getCubicInterpolationCoefs(fractOriginalIdx);

        if (${a} && (originalIdx < 0 || originalIdx > (${n[b]} - 1))) {
          return ${u};
        }
        var data: array<${m}, 4> = array<${m}, 4>(0.0, 0.0, 0.0, 0.0);
        for (var i: i32 = -1; i < 3; i++) {
          var ${y}: ${m} = originalIdx + ${m}(i);
          if (${y} < 0 || ${y} >= ${n[b]}) {
            ${d ? `coefs[i + 1] = 0.0;
                        continue;` : a ? `return ${u};` : `${y} = max(0, min(${y}, ${n[b]} - 1));`};
          }
        var input_indices_copy: ${e1.type.indices} = input_indices;
          ${e1.indicesSet("input_indices_copy", b, `u32(${y})`)};
          data[i + 1] = ${b === p ? e1.getByIndices("input_indices_copy") : "rowCubicInterpolation(input_indices_copy, output_indices)"};
        }
        return cubicInterpolation1D(data, coefs);
      }`;
            };
            return `
    ${h(p)};
    ${h(f)};
  fn getCubicInterpolationCoefs(s: ${m}) -> array<${m}, 4> {
    var absS = abs(s);
    var coeffs: array<${m}, 4> = array<${m}, 4>(0.0, 0.0, 0.0, 0.0);
    var oneMinusAbsS: ${m} = 1.0 - absS;
    var twoMinusAbsS: ${m} = 2.0 - absS;
    var onePlusAbsS: ${m} = 1.0 + absS;
    coeffs[0] = ((${s} * onePlusAbsS - 5 * ${s}) * onePlusAbsS + 8 * ${s}) * onePlusAbsS - 4 * ${s};
    coeffs[1] = ((${s} + 2) * absS - (${s} + 3)) * absS * absS + 1;
    coeffs[2] = ((${s} + 2) * oneMinusAbsS - (${s} + 3)) * oneMinusAbsS * oneMinusAbsS + 1;
    coeffs[3] = ((${s} * twoMinusAbsS - 5 * ${s}) * twoMinusAbsS + 8 * ${s}) * twoMinusAbsS - 4 * ${s};
    return coeffs;
  }

  fn cubicInterpolation1D(x: array<${m}, 4>, coefs: array<${m}, 4>) -> ${m} {
    var coefsSum: ${m} = coefs[0] + coefs[1] + coefs[2] + coefs[3];
    return (x[0] * coefs[0] + x[1] * coefs[1]+ x[2] * coefs[2]+ x[3] * coefs[3]) / coefsSum;
  }

  fn bicubicInterpolation(output_indices: ${t.type.indices}) -> ${m} {
    var input_indices: ${e1.type.indices} = output_indices;
    return colCubicInterpolation(input_indices, output_indices);
  }
    `;
        }, jc = (e1, t, n, r, o)=>{
            let [s, a, u, d, l] = n.length === 3 ? [
                -1,
                0,
                1,
                2,
                -1
            ] : [
                0,
                2,
                3,
                4,
                1
            ], c = e1.type.value;
            return `
    fn getInputValue(batch: u32, channel: u32, depth:u32, height: u32, width: u32) -> ${c} {
      var input_indices: ${e1.type.indices};
      ${e1.indicesSet("input_indices", a, `max(0, min(depth, ${n[a]} - 1))`)};
      ${e1.indicesSet("input_indices", u, `max(0, min(height, ${n[u]} - 1))`)};
      ${e1.indicesSet("input_indices", d, `max(0, min(width, ${n[d]} - 1))`)};
      ${tu(e1, l, s, 3)}
      return ${e1.getByIndices("input_indices")};
    }

    fn trilinearInterpolation(output_indices: ${t.type.indices}) -> ${c} {
      var originalIndices = calculateOriginalIndicesFromOutputIndices(output_indices);
      var depth:${c} = originalIndices[${a}];
      var height:${c} = originalIndices[${u}];
      var width:${c} = originalIndices[${d}];
      ${r ? `if (depth < 0 || depth > (${n[a]} - 1) || height < 0 || height > (${n[u]} - 1) || width < 0 || (width > ${n[d]} - 1)) {
      return ${o};
        }` : ""};

    depth = max(0, min(depth, ${n[a]} - 1));
      height = max(0, min(height, ${n[u]} - 1));
      width = max(0, min(width, ${n[d]} - 1));
      var depth1: u32 = u32(depth);
      var height1: u32 = u32(height);
      var width1: u32 = u32(width);
      var depth2: u32 = u32(depth + 1);
      var height2: u32 = u32(height + 1);
      var width2: u32 = u32(width + 1);
      var channel: u32 = ${n.length > 3 ? `u32(originalIndices[${l}])` : "0"};
      var batch: u32 =  ${n.length > 3 ? `u32(originalIndices[${s}])` : "0"};

      var x111: ${c} = getInputValue(batch, channel, depth1, height1, width1);
      var x112: ${c} = getInputValue(batch, channel, depth1, height1, width2);
      var x121: ${c} = getInputValue(batch, channel, depth1, height2, width1);
      var x122: ${c} = getInputValue(batch, channel, depth1, height2, width2);
      var x211: ${c} = getInputValue(batch, channel, depth2, height1, width1);
      var x212: ${c} = getInputValue(batch, channel, depth2, height1, width2);
      var x221: ${c} = getInputValue(batch, channel, depth2, height2, width1);
      var x222: ${c} = getInputValue(batch, channel, depth2, height2, width2);
      var dx1: ${c} = abs(depth - ${c}(depth1));
      var dx2: ${c} = abs(${c}(depth2) - depth);
      var dy1: ${c} = abs(height - ${c}(height1));
      var dy2: ${c} = abs(${c}(height2) - height);
      var dz1: ${c} = abs(width - ${c}(width1));
      var dz2: ${c} = abs(${c}(width2) - width);
      if (depth1 == depth2) {
        dx1 = 0.5;
        dx2 = 0.5;
      }
      if (height1 == height2) {
        dy1 = 0.5;
        dy2 = 0.5;
      }
      if (width1 == width2) {
        dz1 = 0.5;
        dz2 = 0.5;
      }
      return (x111 * dx2 * dy2 * dz2 + x112 * dx2 * dy2 * dz1 + x121 * dx2 * dy1 *dz2 + x122 * dx2 * dy1 * dz1 +
              x211 * dx1 * dy2 * dz2 + x212 * dx1 * dy2 * dz1 + x221 * dx1 * dy1 *dz2 + x222 * dx1 * dy1 * dz1);
    }`;
        }, Zc = (e1, t, n, r, o, i)=>{
            let s = e1.dims, a = Nc(i, t.axes, s.length), u = Lc(s, r, o, t.axes), d = r.slice();
            r.length === 0 && (d = s.map((g, _)=>g === 0 ? 1 : u[_] / g), t.keepAspectRatioPolicy !== "stretch" && (u = Gc(s, d, t)));
            let l = C("output", e1.dataType, u.length), c = S("input", e1.dataType, s.length), p = x.size(u), f = s.length === u.length && s.every((g, _)=>g === u[_]), m = t.coordinateTransformMode === "tf_crop_and_resize", h = t.extrapolationValue, b = c.type.value, y = (g)=>`
      ${f ? "" : `
      ${Rc(t.coordinateTransformMode, b)};
      ${(()=>{
                    switch(t.mode){
                        case "nearest":
                            return `
              ${qc(c, s)};
              ${Vc(t.nearestMode, n, b)};
              ${Hc(c, l, s, u, d.length, a.length, m)};
              `;
                        case "linear":
                            return `
              ${Wc(l, s, u, d.length, a.length)};
              ${(()=>{
                                if (s.length === 2 || s.length === 4) return `${Fc(c, l, s, m, h)}`;
                                if (s.length === 3 || s.length === 5) return `${jc(c, l, s, m, h)}`;
                                throw Error("Linear mode only supports input dims 2, 3, 4 and 5 are supported in linear mode.");
                            })()};
            `;
                        case "cubic":
                            return `
            ${(()=>{
                                if (s.length === 2 || s.length === 4) return `${Kc(c, l, s, u, d, a, t.cubicCoeffA, m, t.extrapolationValue, t.excludeOutside)}`;
                                throw Error("Cubic mode only supports input dims 2 and 4 are supported in linear mode.");
                            })()};
            `;
                        default:
                            throw Error("Invalid resize mode");
                    }
                })()};
      `}
      ${g.registerUniform("output_size", "u32").registerUniform("scales", "f32", d.length).registerUniform("roi", "f32", a.length).declareVariables(c, l)}
      ${g.mainStart()}
        ${g.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
        ${f ? "output[global_idx] = input[global_idx];" : `
        let output_indices = ${l.offsetToIndices("global_idx")};
        var input_indices: ${c.type.indices};
        ${(()=>{
                    switch(t.mode){
                        case "nearest":
                            return `input_indices = calculateInputIndicesFromOutputIndices(output_indices);
                if (checkInputIndices(input_indices)) {
                  output[global_idx] = ${c.getByIndices("input_indices")};
                } else {
                  output[global_idx] = ${t.extrapolationValue};
                }`;
                        case "linear":
                            return `output[global_idx] = ${s.length === 2 || s.length === 4 ? "bilinearInterpolation" : "trilinearInterpolation"}(output_indices);`;
                        case "cubic":
                            return "output[global_idx] = bicubicInterpolation(output_indices);";
                        default:
                            throw Error(`Unsupported resize mode: ${t.mode}`);
                    }
                })()};
`}
      }`;
            return {
                name: "Resize",
                shaderCache: {
                    hint: `${t.cacheKey}|${n}|${d.length > 0 ? t.mode === "cubic" ? d : d.length : ""}|${o.length > 0 ? o : ""}|${a.length > 0 ? a : ""}|${f}|${t.mode === "nearest" ? s.length : s}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getShaderSource: y,
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: u,
                                dataType: e1.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(p / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: p
                            },
                            {
                                type: 1,
                                data: d
                            },
                            {
                                type: 1,
                                data: a
                            },
                            ...P(s, u)
                        ]
                    })
            };
        }, Qc = (e1)=>{
            let t = e1.customDataBuffer;
            return new Uint32Array(t, t.byteOffset, 1)[0];
        }, nu = (e1, t)=>{
            let n = [], r = [], o = [], i = Qc(e1);
            if (t.antialias !== 0) throw Error("Only default value (0) for Antialias attribute is supported");
            Uc(e1.inputs, t, i, n, r, o), e1.compute(Zc(e1.inputs[0], t, i, n, r, o), {
                inputs: [
                    0
                ]
            });
        }, ru = (e1)=>{
            let t = e1.antialias, n = e1.axes, r = e1.coordinateTransformMode, o = e1.cubicCoeffA, i = e1.excludeOutside !== 0, s = e1.extrapolationValue, a = e1.keepAspectRatioPolicy, u = e1.mode, d = e1.nearestMode === "" ? "simple" : e1.nearestMode;
            return G({
                antialias: t,
                axes: n,
                coordinateTransformMode: r,
                cubicCoeffA: o,
                excludeOutside: i,
                extrapolationValue: s,
                keepAspectRatioPolicy: a,
                mode: u,
                nearestMode: d
            });
        };
    });
    var Xc, Yc, iu, su = k(()=>{
        "use strict";
        L();
        F();
        j();
        Xc = (e1)=>{
            if (!e1 || e1.length < 3) throw new Error("layerNorm requires at least 3 inputs.");
            let t = e1[0], n = e1[1], r = e1[2];
            if (t.dataType !== n.dataType || t.dataType !== r.dataType) throw new Error("All inputs must have the same data type");
            if (t.dims.length !== 3 && t.dims.length !== 2) throw new Error("Input must be 2D or 3D");
            if (n.dims.length !== 3 && n.dims.length !== 2) throw new Error("Skip must be 2D or 3D");
            let o = t.dims[t.dims.length - 1], i = t.dims[t.dims.length - 2];
            if (n.dims[n.dims.length - 1] !== o) throw new Error("Skip must have the same hidden size as input");
            if (n.dims[n.dims.length - 2] !== i) throw new Error("Skip must have the same sequence length as input");
            if (r.dims.length !== 1) throw new Error("Gamma must be 1D");
            if (r.dims[r.dims.length - 1] !== o) throw new Error("Gamma must have the same hidden size as input");
            if (e1.length > 3) {
                let s = e1[3];
                if (s.dims.length !== 1) throw new Error("Beta must be 1D");
                if (s.dims[s.dims.length - 1] !== o) throw new Error("Beta must have the same hidden size as input");
            }
            if (e1.length > 4) {
                let s = e1[4];
                if (s.dims.length !== 1) throw new Error("Bias must be 1D");
                if (s.dims[s.dims.length - 1] !== o) throw new Error("Bias must have the same hidden size as input");
            }
        }, Yc = (e1, t, n, r)=>{
            let o = t.simplified, i = e1[0].dims, s = x.size(i), a = i, u = s, d = i.slice(-1)[0], l = r ? i.slice(0, -1).concat(1) : [], c = !o && e1.length > 3, p = e1.length > 4, f = r && n > 1, m = r && n > 2, h = n > 3, b = 64, y = J(d), g = [
                {
                    type: 12,
                    data: u
                },
                {
                    type: 12,
                    data: y
                },
                {
                    type: 12,
                    data: d
                },
                {
                    type: 1,
                    data: t.epsilon
                }
            ], _ = (v)=>{
                let $ = [
                    {
                        name: "output_size",
                        type: "u32"
                    },
                    {
                        name: "components",
                        type: "u32"
                    },
                    {
                        name: "hidden_size",
                        type: "u32"
                    },
                    {
                        name: "epsilon",
                        type: "f32"
                    }
                ], T = [
                    S("x", e1[0].dataType, e1[0].dims, y),
                    S("skip", e1[1].dataType, e1[1].dims, y),
                    S("gamma", e1[2].dataType, e1[2].dims, y)
                ];
                c && T.push(S("beta", e1[3].dataType, e1[3].dims, y)), p && T.push(S("bias", e1[4].dataType, e1[4].dims, y)), T.push(C("output", e1[0].dataType, a, y)), f && T.push(C("mean_output", 1, l)), m && T.push(C("inv_std_output", 1, l)), h && T.push(C("input_skip_bias_sum", e1[0].dataType, a, y));
                let I = re(e1[0].dataType), A = re(1, y);
                return `

      ${v.registerUniforms($).declareVariables(...T)}
      var<workgroup> sum_shared : array<${A}, ${b}>;
      var<workgroup> sum_squared_shared : array<${A}, ${b}>;

      ${v.mainStart([
                    b,
                    1,
                    1
                ])}
        let ix = local_id.x;
        let iy = global_id.x / ${b};

        let hidden_size_vectorized: u32 = uniforms.hidden_size / uniforms.components;
        var stride = hidden_size_vectorized / ${b};
        let offset = ix * stride + iy * hidden_size_vectorized;
        let offset1d = stride * ix;
        if (ix == ${b - 1}) {
          stride = hidden_size_vectorized - stride * ix;
        }
        for (var i: u32 = 0; i < stride; i++) {
          let skip_value = skip[offset + i];
          let bias_value = ${p ? "bias[offset1d + i]" : I + "(0.0)"};
          let input_value = x[offset + i];
          let value = input_value + skip_value + bias_value;
          ${h ? "input_skip_bias_sum[offset + i] = value;" : ""}
          output[offset + i] = value;
          let f32_value = ${et(I, y, "value")};
          sum_shared[ix] += f32_value;
          sum_squared_shared[ix] += f32_value * f32_value;
        }
        workgroupBarrier();

        var reduce_size : u32 = ${b};
        for (var curr_size = reduce_size >> 1;  curr_size > 0; curr_size = reduce_size >> 1) {
          reduce_size = curr_size + (reduce_size & 1);
          if (ix < curr_size) {
            sum_shared[ix] += sum_shared[ix + reduce_size];
            sum_squared_shared[ix] += sum_squared_shared[ix + reduce_size];
          }
          workgroupBarrier();
        }

        let sum = sum_shared[0];
        let square_sum = sum_squared_shared[0];
        let mean = ${Te("sum", y)} / f32(uniforms.hidden_size);
        let inv_std_dev = inverseSqrt(${Te("square_sum", y)} / f32(uniforms.hidden_size) ${o ? "" : "- mean * mean"} + uniforms.epsilon);
        ${f ? "mean_output[global_idx] = mean;" : ""}
        ${m ? "inv_std_output[global_idx] = inv_std_dev;" : ""}

        for (var i: u32 = 0; i < stride; i++) {
          output[offset + i] = (output[offset + i] ${o ? "" : `- ${I}(mean)`}) *
            ${I}(inv_std_dev) * gamma[offset1d + i]
            ${c ? "+ beta[offset1d + i]" : ""};
        }
      }`;
            }, w = [
                {
                    dims: a,
                    dataType: e1[0].dataType
                }
            ];
            return n > 1 && w.push({
                dims: l,
                dataType: 1
            }), n > 2 && w.push({
                dims: l,
                dataType: 1
            }), n > 3 && w.push({
                dims: i,
                dataType: e1[0].dataType
            }), {
                name: "SkipLayerNormalization",
                shaderCache: {
                    hint: `${y};${f};${m};${h}`,
                    inputDependencies: e1.map((v, $)=>"type")
                },
                getShaderSource: _,
                getRunData: ()=>({
                        outputs: w,
                        dispatchGroup: {
                            x: Math.ceil(u / d)
                        },
                        programUniforms: g
                    })
            };
        }, iu = (e1, t)=>{
            Xc(e1.inputs);
            let r = [
                0
            ];
            e1.outputCount > 1 && r.push(-3), e1.outputCount > 2 && r.push(-3), e1.outputCount > 3 && r.push(3), e1.compute(Yc(e1.inputs, t, e1.outputCount, !1), {
                outputs: r
            });
        };
    });
    var Jc, fn, ep, au, tp, np, uu, du, lu = k(()=>{
        "use strict";
        L();
        F();
        ie();
        j();
        Jc = (e1, t)=>{
            if (!e1 || e1.length < 1) throw new Error("too few inputs");
            if (t.axes.length !== 0) {
                if (t.axes.length !== t.starts.length || t.axes.length !== t.ends.length) throw new Error("axes, starts and ends must have the same length");
            } else if (t.starts.length !== t.ends.length) throw new Error("starts and ends must have the same length");
            e1.slice(1).forEach((n, r)=>{
                if (e1[r + 1].dataType !== 6 && e1[r + 1].dataType !== 7) throw new Error(`Input ${r} must be an array of int32 or int64`);
            });
        }, fn = (e1, t)=>{
            let n = [];
            if (e1.length > t) {
                if (e1[t].dataType === 7) e1[t].getBigInt64Array().forEach((r)=>n.push(Number(r)));
                else if (e1[t].dataType === 6) e1[t].getInt32Array().forEach((r)=>n.push(Number(r)));
                else throw new Error(`Input ${t} must be an array of int32 or int64`);
            }
            return n;
        }, ep = (e1, t)=>{
            if (e1.length > 1) {
                let n = fn(e1, 1), r = fn(e1, 2), o = fn(e1, 3);
                return o.length === 0 && (o = [
                    ...Array(e1[0].dims.length).keys()
                ]), G({
                    starts: n,
                    ends: r,
                    axes: o
                });
            } else return t;
        }, au = (e1, t, n, r, o)=>{
            let i = e1;
            return e1 < 0 && (i += n[r[t]]), o[t] < 0 ? Math.max(0, Math.min(i, n[r[t]] - 1)) : Math.max(0, Math.min(i, n[r[t]]));
        }, tp = (e1, t, n)=>`fn calculateInputIndices(output_indices: ${t.type.indices}) -> ${e1.type.indices} {
          var input_indices: ${e1.type.indices};
          var carry = 0u;
          for (var i = ${n.length - 1}; i >= 0; i--) {
            let input_shape_i = ${B("uniforms.input_shape", "i", n.length)};
            let steps_i = ${B("uniforms.steps", "i", n.length)};
            let signs_i = ${B("uniforms.signs", "i", n.length)};
            let starts_i = ${B("uniforms.starts", "i", n.length)};
            var output_index = ${t.indicesGet("output_indices", "i")};
            var input_index = output_index * steps_i + starts_i + carry;
            carry = input_index / input_shape_i;
            input_index = input_index % input_shape_i;
            if (signs_i < 0) {
              input_index = input_shape_i - input_index - 1u + starts_i;
            }
            ${e1.indicesSet("input_indices", "i", "input_index")};
          }
          return input_indices;
      }`, np = (e1, t)=>{
            let n = e1[0].dims, r = x.size(n), o = t.axes.length > 0 ? x.normalizeAxes(t.axes, n.length) : [
                ...Array(n.length).keys()
            ], i = fn(e1, 4);
            i.forEach((y)=>y !== 0 || (()=>{
                    throw new Error("step cannot be 0");
                })), i.length === 0 && (i = Array(o.length).fill(1));
            let s = t.starts.map((y, g)=>au(y, g, n, o, i)), a = t.ends.map((y, g)=>au(y, g, n, o, i));
            if (o.length !== s.length || o.length !== a.length) throw new Error("start, ends and axes should have the same number of elements");
            if (o.length !== n.length) for(let y = 0; y < n.length; ++y)o.includes(y) || (s.splice(y, 0, 0), a.splice(y, 0, n[y]), i.splice(y, 0, 1));
            let u = i.map((y)=>Math.sign(y));
            i.forEach((y, g, _)=>{
                if (y < 0) {
                    let w = (a[g] - s[g]) / y, v = s[g], $ = v + w * i[g];
                    s[g] = $, a[g] = v, _[g] = -y;
                }
            });
            let d = n.slice(0);
            o.forEach((y, g)=>{
                d[y] = Math.ceil((a[y] - s[y]) / i[y]);
            });
            let l = {
                dims: d,
                dataType: e1[0].dataType
            }, c = C("output", e1[0].dataType, d.length), p = S("input", e1[0].dataType, e1[0].dims.length), f = x.size(d), m = [
                {
                    name: "outputSize",
                    type: "u32"
                },
                {
                    name: "starts",
                    type: "u32",
                    length: s.length
                },
                {
                    name: "signs",
                    type: "i32",
                    length: u.length
                },
                {
                    name: "steps",
                    type: "u32",
                    length: i.length
                }
            ], h = [
                {
                    type: 12,
                    data: f
                },
                {
                    type: 12,
                    data: s
                },
                {
                    type: 6,
                    data: u
                },
                {
                    type: 12,
                    data: i
                },
                ...P(e1[0].dims, d)
            ], b = (y)=>`
      ${y.registerUniforms(m).declareVariables(p, c)}
        ${tp(p, c, n)}
        ${y.mainStart()}
          ${y.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.outputSize")}
          let output_indices = ${c.offsetToIndices("global_idx")};
          let input_indices = calculateInputIndices(output_indices);
          ${c.setByOffset("global_idx", p.getByIndices("input_indices"))}
      }`;
            return {
                name: "Slice",
                shaderCache: {
                    hint: `${u.length}_${s.length}_${i.length}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getShaderSource: b,
                getRunData: ()=>({
                        outputs: [
                            l
                        ],
                        dispatchGroup: {
                            x: Math.ceil(r / 64)
                        },
                        programUniforms: h
                    })
            };
        }, uu = (e1, t)=>{
            Jc(e1.inputs, t);
            let n = ep(e1.inputs, t);
            e1.compute(np(e1.inputs, n), {
                inputs: [
                    0
                ]
            });
        }, du = (e1)=>{
            let t = e1.starts, n = e1.ends, r = e1.axes;
            return G({
                starts: t,
                ends: n,
                axes: r
            });
        };
    });
    var rp, op, cu, pu, mu = k(()=>{
        "use strict";
        L();
        F();
        ie();
        Ve();
        j();
        rp = (e1)=>{
            if (!e1 || e1.length !== 1) throw new Error("Softmax op requires 1 input.");
        }, op = (e1, t)=>{
            let n = e1.inputs[0], r = n.dims, o = x.size(r), i = r.length, s = x.normalizeAxis(t.axis, i), a = s < r.length - 1, u, d = [];
            a ? (d = Array.from({
                length: i
            }, (T, I)=>I), d[s] = i - 1, d[i - 1] = s, u = e1.compute(pe(n, d), {
                inputs: [
                    n
                ],
                outputs: [
                    -1
                ]
            })[0]) : u = n;
            let l = u.dims, c = l[i - 1], p = o / c, f = J(c), m = c / f, h = 64;
            p === 1 && (h = 256);
            let b = (T, I)=>I === 4 ? `max(max(${T}.x, ${T}.y), max(${T}.z, ${T}.w))` : I === 2 ? `max(${T}.x, ${T}.y)` : I === 3 ? `max(max(${T}.x, ${T}.y), ${T}.z)` : T, y = S("x", u.dataType, u.dims, f), g = C("result", u.dataType, u.dims, f), _ = y.type.value, w = re(u.dataType) === "f32" ? `var threadMax = ${_}(-3.4028234663852886e+38f);` : `var threadMax = ${_}(-65504.0h);`, v = (T)=>`
      var<workgroup> rowMaxShared : ${_};
      var<workgroup> rowSumShared : ${_};
      var<workgroup> threadShared : array<${_}, ${h}>;

      fn getValue(row: i32, col: i32, row_stride: i32) -> ${_} {
        let index = row * row_stride + col;
        return x[index];
      }

      fn setValue(row: i32, col: i32, row_stride: i32, value: ${_}) {
        let index = row * row_stride + col;
        result[index] = value;
      }
      ${T.registerUniform("packedCols", "i32").declareVariables(y, g)}
      ${T.mainStart(h)}
        let gindex = i32(global_idx);
        let lindex = i32(local_idx);
        const wg = ${h};
        let row = gindex / wg;
        let cols = uniforms.packedCols;
        let row_stride : i32 = uniforms.packedCols;

        // find the rows max
        ${w}
        for (var col = lindex; col < cols; col += wg) {
          let value = getValue(row, col, row_stride);
          threadMax = max(threadMax, value);
        }
        if (lindex < cols) {
          threadShared[lindex] = threadMax;
        }
        workgroupBarrier();

        var reduceSize = min(cols, wg);
        for (var currSize = reduceSize >> 1;  currSize > 0; currSize = reduceSize >> 1) {
          reduceSize = currSize + (reduceSize & 1);
          if (lindex < currSize) {
            threadShared[lindex] = max(threadShared[lindex], threadShared[lindex + reduceSize]);
          }
          workgroupBarrier();
        }
        if (lindex == 0) {
          rowMaxShared = ${_}(${b("threadShared[0]", f)});
        }
        workgroupBarrier();

        // find the rows sum
        var threadSum = ${_}(0.0);
        for (var col = lindex; col < cols; col += wg) {
          let subExp = exp(getValue(row, col, row_stride) - rowMaxShared);
          threadSum += subExp;
        }
        threadShared[lindex] = threadSum;
        workgroupBarrier();

        for (var currSize = wg >> 1;  currSize > 0; currSize = currSize >> 1) {
          if (lindex < currSize) {
            threadShared[lindex] = threadShared[lindex] + threadShared[lindex + currSize];
          }
          workgroupBarrier();
        }
        if (lindex == 0) {
          rowSumShared = ${_}(${Te("threadShared[0]", f)});
        }
        workgroupBarrier();

        // calculate final value for each element in the row
        for (var col = lindex; col < cols; col += wg) {
          var value = exp(getValue(row, col, row_stride) - rowMaxShared) / rowSumShared;
          // max operation protects against NaN since all values should be >=0
          value = max(value, ${_}(0.0));
          setValue(row, col, row_stride, value);
        }
      }`, $ = e1.compute({
                name: "Softmax",
                shaderCache: {
                    hint: `${f};${h}`,
                    inputDependencies: [
                        "type"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: l,
                                dataType: u.dataType
                            }
                        ],
                        dispatchGroup: {
                            x: p
                        },
                        programUniforms: [
                            {
                                type: 6,
                                data: m
                            }
                        ]
                    }),
                getShaderSource: v
            }, {
                inputs: [
                    u
                ],
                outputs: [
                    a ? -1 : 0
                ]
            })[0];
            a && e1.compute(pe($, d), {
                inputs: [
                    $
                ]
            });
        }, cu = (e1, t)=>{
            rp(e1.inputs), op(e1, t);
        }, pu = (e1)=>G({
                axis: e1.axis
            });
    });
    var fu, ip, sp, ap, hu, gu = k(()=>{
        "use strict";
        L();
        F();
        j();
        fu = (e1)=>Array.from(e1.getBigInt64Array(), Number), ip = (e1)=>{
            if (!e1 || e1.length !== 2) throw new Error("Tile requires 2 inputs.");
            if (e1[0].dataType !== 1 && e1[0].dataType !== 10 && e1[0].dataType !== 6 && e1[0].dataType !== 12) throw new Error("Tile only support float, float16, int32, and uint32 data types");
            if (e1[1].dataType !== 7) throw new Error("Tile `repeats` input should be of int64 data type");
            if (e1[1].dims.length !== 1) throw new Error("Tile `repeats` input should be 1-D");
            if (fu(e1[1]).length !== e1[0].dims.length) throw new Error("Tile `repeats` input should have same number of elements as rank of input data tensor");
        }, sp = (e1, t)=>{
            let n = [];
            for(let r = 0; r < e1.length; ++r)n.push(e1[r] * t[r]);
            return n;
        }, ap = (e1, t)=>{
            let n = e1[0].dims, r = t ?? fu(e1[1]), o = sp(n, r), i = x.size(o), s = e1[0].dataType, a = S("input", s, n.length), u = C("output", s, o.length), d = (l)=>`
      const inputShape = ${a.indices(...n)};
      ${l.registerUniform("output_size", "u32").declareVariables(a, u)}
      ${l.mainStart()}
      ${l.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.output_size")}
      let output_indices = ${u.offsetToIndices("global_idx")};
      var input_indices: ${a.type.indices};
      for (var i = 0; i < ${n.length}; i++) {
        let input_dim_i = ${a.indicesGet("uniforms.input_shape", "i")};
        let input_dim_value = ${u.indicesGet("output_indices", "i")}  % input_dim_i;

        ${a.indicesSet("input_indices", "i", "input_dim_value")}
      }
      ${u.setByOffset("global_idx", a.getByIndices("input_indices"))}
    }`;
            return {
                name: "Tile",
                shaderCache: {
                    hint: `${r}`,
                    inputDependencies: [
                        "rank"
                    ]
                },
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: o,
                                dataType: e1[0].dataType
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(i / 64)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: i
                            },
                            ...P(e1[0].dims, o)
                        ]
                    }),
                getShaderSource: d
            };
        }, hu = (e1)=>{
            ip(e1.inputs), e1.compute(ap(e1.inputs), {
                inputs: [
                    0
                ]
            });
        };
    });
    var up, dp, yu, bu = k(()=>{
        "use strict";
        L();
        F();
        j();
        up = (e1, t, n, r, o)=>{
            let i = C("output_data", o, n.length, 4), s = S("a_data", t[1].dataType, t[1].dims.length, 4), a = S("b_data", t[2].dataType, t[2].dims.length, 4), u = S("c_data", t[0].dataType, t[0].dims.length, 4), d, l = (c, p, f)=>`select(${p}, ${c}, ${f})`;
            if (!r) d = i.setByOffset("global_idx", l(s.getByOffset("global_idx"), a.getByOffset("global_idx"), u.getByOffset("global_idx")));
            else {
                let c = (p, f, m = "")=>{
                    let h = `a_data[index_a${f}][component_a${f}]`, b = `b_data[index_b${f}][component_b${f}]`, y = `bool(c_data[index_c${f}] & (0xffu << (component_c${f} * 8)))`;
                    return `
            let output_indices${f} = ${i.offsetToIndices(`global_idx * 4u + ${f}u`)};
            let offset_a${f} = ${s.broadcastedIndicesToOffset(`output_indices${f}`, i)};
            let offset_b${f} = ${a.broadcastedIndicesToOffset(`output_indices${f}`, i)};
            let offset_c${f} = ${u.broadcastedIndicesToOffset(`output_indices${f}`, i)};
            let index_a${f} = offset_a${f} / 4u;
            let index_b${f} = offset_b${f} / 4u;
            let index_c${f} = offset_c${f} / 4u;
            let component_a${f} = offset_a${f} % 4u;
            let component_b${f} = offset_b${f} % 4u;
            let component_c${f} = offset_c${f} % 4u;
            ${p}[${f}] = ${m}(${l(h, b, y)});
          `;
                };
                o === 9 ? d = `
            var data = vec4<u32>(0);
            ${c("data", 0, "u32")}
            ${c("data", 1, "u32")}
            ${c("data", 2, "u32")}
            ${c("data", 3, "u32")}
            output_data[global_idx] = dot(vec4<u32>(0x1, 0x100, 0x10000, 0x1000000), vec4<u32>(data));` : d = `
            ${c("output_data[global_idx]", 0)}
            ${c("output_data[global_idx]", 1)}
            ${c("output_data[global_idx]", 2)}
            ${c("output_data[global_idx]", 3)}
          `;
            }
            return `
        ${e1.registerUniform("vec_size", "u32").declareVariables(u, s, a, i)}
        ${e1.mainStart()}
        ${e1.guardAgainstOutOfBoundsWorkgroupSizes("uniforms.vec_size")}
        ${d}
      }`;
        }, dp = (e1)=>{
            let t = e1[1].dims, n = e1[2].dims, r = e1[0].dims, o = e1[1].dataType, i = !(x.areEqual(t, n) && x.areEqual(n, r)), s = t, a = x.size(t);
            if (i) {
                let d = Pe.calcShape(Pe.calcShape(t, n, !1), r, !1);
                if (!d) throw new Error("Can't perform where op on the given tensors");
                s = d, a = x.size(s);
            }
            let u = Math.ceil(a / 4);
            return {
                name: "Where",
                shaderCache: {
                    inputDependencies: [
                        "rank",
                        "rank",
                        "rank"
                    ]
                },
                getShaderSource: (d)=>up(d, e1, s, i, o),
                getRunData: ()=>({
                        outputs: [
                            {
                                dims: s,
                                dataType: o
                            }
                        ],
                        dispatchGroup: {
                            x: Math.ceil(a / 64 / 4)
                        },
                        programUniforms: [
                            {
                                type: 12,
                                data: u
                            },
                            ...P(r, t, n, s)
                        ]
                    })
            };
        }, yu = (e1)=>{
            e1.compute(dp(e1.inputs));
        };
    });
    var _u, wu = k(()=>{
        "use strict";
        ei();
        tn();
        ri();
        ii();
        Hi();
        ts();
        os();
        ws();
        Cs();
        ks();
        Bs();
        Rs();
        Ls();
        Ws();
        Fs();
        Zs();
        Ys();
        ta();
        oa();
        aa();
        ga();
        _a();
        $a();
        xa();
        Ia();
        ar();
        Aa();
        qa();
        ja();
        Qa();
        Ja();
        Jt();
        ou();
        lr();
        su();
        lu();
        mu();
        dr();
        gu();
        Ve();
        rn();
        bu();
        _u = new Map([
            [
                "Abs",
                [
                    si
                ]
            ],
            [
                "Acos",
                [
                    ai
                ]
            ],
            [
                "Acosh",
                [
                    ui
                ]
            ],
            [
                "Add",
                [
                    qi
                ]
            ],
            [
                "ArgMax",
                [
                    Jo,
                    jn
                ]
            ],
            [
                "ArgMin",
                [
                    Yo,
                    jn
                ]
            ],
            [
                "Asin",
                [
                    di
                ]
            ],
            [
                "Asinh",
                [
                    li
                ]
            ],
            [
                "Atan",
                [
                    ci
                ]
            ],
            [
                "Atanh",
                [
                    pi
                ]
            ],
            [
                "Attention",
                [
                    ti
                ]
            ],
            [
                "AveragePool",
                [
                    Ma,
                    Oa
                ]
            ],
            [
                "BatchNormalization",
                [
                    ni
                ]
            ],
            [
                "BiasAdd",
                [
                    oi
                ]
            ],
            [
                "BiasSplitGelu",
                [
                    Wi
                ]
            ],
            [
                "Cast",
                [
                    fi,
                    mi
                ]
            ],
            [
                "Ceil",
                [
                    gi
                ]
            ],
            [
                "Clip",
                [
                    hi
                ]
            ],
            [
                "Concat",
                [
                    ns,
                    rs
                ]
            ],
            [
                "Conv",
                [
                    rr,
                    nr
                ]
            ],
            [
                "ConvTranspose",
                [
                    Is,
                    Ss
                ]
            ],
            [
                "Cos",
                [
                    yi
                ]
            ],
            [
                "Cosh",
                [
                    bi
                ]
            ],
            [
                "CumSum",
                [
                    As,
                    Es
                ]
            ],
            [
                "DepthToSpace",
                [
                    Ps,
                    zs
                ]
            ],
            [
                "DequantizeLinear",
                [
                    Fa,
                    Ka
                ]
            ],
            [
                "Div",
                [
                    Fi
                ]
            ],
            [
                "Einsum",
                [
                    Ms,
                    Us
                ]
            ],
            [
                "Elu",
                [
                    _i,
                    yt
                ]
            ],
            [
                "Equal",
                [
                    Ki
                ]
            ],
            [
                "Erf",
                [
                    wi
                ]
            ],
            [
                "Exp",
                [
                    $i
                ]
            ],
            [
                "Expand",
                [
                    Ns
                ]
            ],
            [
                "FastGelu",
                [
                    Gs
                ]
            ],
            [
                "Floor",
                [
                    vi
                ]
            ],
            [
                "FusedConv",
                [
                    rr,
                    nr
                ]
            ],
            [
                "Gather",
                [
                    qs,
                    Hs
                ]
            ],
            [
                "GatherElements",
                [
                    ea,
                    Js
                ]
            ],
            [
                "GatherBlockQuantized",
                [
                    Qs,
                    Xs
                ]
            ],
            [
                "GatherND",
                [
                    Ks,
                    js
                ]
            ],
            [
                "Gelu",
                [
                    xi
                ]
            ],
            [
                "Gemm",
                [
                    ra,
                    na
                ]
            ],
            [
                "GlobalAveragePool",
                [
                    Va,
                    Ra
                ]
            ],
            [
                "GlobalMaxPool",
                [
                    Ha,
                    Wa
                ]
            ],
            [
                "Greater",
                [
                    Xi
                ]
            ],
            [
                "GreaterOrEqual",
                [
                    Ji
                ]
            ],
            [
                "GridSample",
                [
                    ia,
                    sa
                ]
            ],
            [
                "GroupQueryAttention",
                [
                    ha
                ]
            ],
            [
                "HardSigmoid",
                [
                    Pi,
                    ki
                ]
            ],
            [
                "InstanceNormalization",
                [
                    ba
                ]
            ],
            [
                "LayerNormalization",
                [
                    wa
                ]
            ],
            [
                "LeakyRelu",
                [
                    Si,
                    yt
                ]
            ],
            [
                "Less",
                [
                    Yi
                ]
            ],
            [
                "LessOrEqual",
                [
                    es
                ]
            ],
            [
                "Log",
                [
                    Ni
                ]
            ],
            [
                "MatMul",
                [
                    va
                ]
            ],
            [
                "MatMulNBits",
                [
                    Sa,
                    Ta
                ]
            ],
            [
                "MaxPool",
                [
                    La,
                    Ga
                ]
            ],
            [
                "Mul",
                [
                    ji
                ]
            ],
            [
                "MultiHeadAttention",
                [
                    la,
                    da
                ]
            ],
            [
                "Neg",
                [
                    Ii
                ]
            ],
            [
                "Not",
                [
                    Ti
                ]
            ],
            [
                "Pad",
                [
                    Ca
                ]
            ],
            [
                "Pow",
                [
                    Zi
                ]
            ],
            [
                "QuickGelu",
                [
                    Li,
                    yt
                ]
            ],
            [
                "Range",
                [
                    Za
                ]
            ],
            [
                "Reciprocal",
                [
                    Ci
                ]
            ],
            [
                "ReduceMin",
                [
                    Fo
                ]
            ],
            [
                "ReduceMean",
                [
                    Lo
                ]
            ],
            [
                "ReduceMax",
                [
                    qo
                ]
            ],
            [
                "ReduceSum",
                [
                    jo
                ]
            ],
            [
                "ReduceProd",
                [
                    Ko
                ]
            ],
            [
                "ReduceL1",
                [
                    Go
                ]
            ],
            [
                "ReduceL2",
                [
                    Wo
                ]
            ],
            [
                "ReduceLogSum",
                [
                    Qo
                ]
            ],
            [
                "ReduceLogSumExp",
                [
                    Ho
                ]
            ],
            [
                "ReduceSumSquare",
                [
                    Zo
                ]
            ],
            [
                "Relu",
                [
                    Ai
                ]
            ],
            [
                "Resize",
                [
                    nu,
                    ru
                ]
            ],
            [
                "RotaryEmbedding",
                [
                    ma
                ]
            ],
            [
                "ScatterND",
                [
                    Ya,
                    Xa
                ]
            ],
            [
                "Sigmoid",
                [
                    Ei
                ]
            ],
            [
                "Sin",
                [
                    zi
                ]
            ],
            [
                "Sinh",
                [
                    Bi
                ]
            ],
            [
                "Slice",
                [
                    uu,
                    du
                ]
            ],
            [
                "SkipLayerNormalization",
                [
                    iu
                ]
            ],
            [
                "Split",
                [
                    ca,
                    pa
                ]
            ],
            [
                "Sqrt",
                [
                    Di
                ]
            ],
            [
                "Softmax",
                [
                    cu,
                    pu
                ]
            ],
            [
                "Sub",
                [
                    Qi
                ]
            ],
            [
                "Tan",
                [
                    Oi
                ]
            ],
            [
                "Tanh",
                [
                    Ui
                ]
            ],
            [
                "ThresholdedRelu",
                [
                    Vi,
                    yt
                ]
            ],
            [
                "Tile",
                [
                    hu
                ]
            ],
            [
                "Transpose",
                [
                    Ao,
                    Eo
                ]
            ],
            [
                "Where",
                [
                    yu
                ]
            ]
        ]);
    });
    var hn, $u = k(()=>{
        "use strict";
        _e();
        ke();
        j();
        hn = class {
            constructor(t){
                this.backend = t;
                this.repo = new Map, this.attributesBound = !1;
            }
            getArtifact(t) {
                return this.repo.get(t);
            }
            setArtifact(t, n) {
                this.repo.set(t, n);
            }
            run(t, n, r, o, i) {
                ye(t.programInfo.name);
                let s = this.backend.device, a = this.backend.getComputePassEncoder();
                this.backend.writeTimestamp(this.backend.pendingDispatchNumber * 2);
                let u = [];
                for (let l of n)u.push({
                    binding: u.length,
                    resource: {
                        buffer: l.buffer
                    }
                });
                for (let l of r)u.push({
                    binding: u.length,
                    resource: {
                        buffer: l.buffer
                    }
                });
                i && u.push({
                    binding: u.length,
                    resource: i
                });
                let d = s.createBindGroup({
                    layout: t.computePipeline.getBindGroupLayout(0),
                    entries: u,
                    label: t.programInfo.name
                });
                if (this.backend.sessionStatus === "capturing") {
                    let l = {
                        kernelId: this.backend.currentKernelId,
                        computePipeline: t.computePipeline,
                        bindGroup: d,
                        dispatchGroup: o
                    };
                    this.backend.capturedCommandList.get(this.backend.currentSessionId).push(l);
                }
                a.setPipeline(t.computePipeline), a.setBindGroup(0, d), a.dispatchWorkgroups(...o), this.backend.writeTimestamp(this.backend.pendingDispatchNumber * 2 + 1), this.backend.pendingDispatchNumber++, (this.backend.pendingDispatchNumber >= this.backend.maxDispatchNumber || this.backend.queryType === "at-passes") && this.backend.endComputePass(), this.backend.pendingDispatchNumber >= this.backend.maxDispatchNumber && this.backend.flush(), he(t.programInfo.name);
            }
            dispose() {}
            build(t, n) {
                ye(t.name);
                let r = this.backend.device, o = [];
                [
                    {
                        feature: "shader-f16",
                        extension: "f16"
                    },
                    {
                        feature: "subgroups",
                        extension: "subgroups"
                    }
                ].forEach((c)=>{
                    r.features.has(c.feature) && o.push(`enable ${c.extension};`);
                });
                let s = Io(n, this.backend.device.limits), a = t.getShaderSource(s), u = `${o.join(`
`)}
${s.additionalImplementations}
${a}`, d = r.createShaderModule({
                    code: u,
                    label: t.name
                });
                Z("verbose", ()=>`[WebGPU] ${t.name} shader code: ${u}`);
                let l = r.createComputePipeline({
                    compute: {
                        module: d,
                        entryPoint: "main"
                    },
                    layout: "auto",
                    label: t.name
                });
                return he(t.name), {
                    programInfo: t,
                    computePipeline: l,
                    uniformVariablesInfo: s.variablesInfo
                };
            }
            normalizeDispatchGroupSize(t) {
                let n = typeof t == "number" ? t : t.x, r = typeof t == "number" ? 1 : t.y || 1, o = typeof t == "number" ? 1 : t.z || 1, i = this.backend.device.limits.maxComputeWorkgroupsPerDimension;
                if (n <= i && r <= i && o <= i) return [
                    n,
                    r,
                    o
                ];
                let s = n * r * o, a = Math.ceil(Math.sqrt(s));
                if (a > i) {
                    if (a = Math.ceil(Math.cbrt(s)), a > i) throw new Error("Total dispatch size exceeds WebGPU maximum.");
                    return [
                        a,
                        a,
                        a
                    ];
                } else return [
                    a,
                    a,
                    1
                ];
            }
        };
    });
    var vu = {};
    rt(vu, {
        WebGpuBackend: ()=>pr
    });
    var lp, cp, cr, pr, xu = k(()=>{
        "use strict";
        _e();
        L();
        ke();
        Mn();
        So();
        wu();
        $u();
        lp = (e1, t)=>{
            if (t.length !== e1.length) throw new Error(`inputDependencies length ${t.length} is not equal to inputTensors length ${e1.length}.`);
            let n = [];
            for(let r = 0; r < e1.length; ++r){
                let o = e1[r].dataType;
                switch(t[r]){
                    case "none":
                        n.push("");
                        break;
                    case "type":
                        n.push(`${o}`);
                        break;
                    case "rank":
                        {
                            let i = e1[r].dims.length;
                            n.push(`${o};${i}`);
                            break;
                        }
                    case "dims":
                        {
                            let i = e1[r].dims.join(",");
                            n.push(`${o};${i}`);
                            break;
                        }
                    default:
                        throw new Error(`unsupported input dependency: ${t[r]}`);
                }
            }
            return n.join("|");
        }, cp = (e1, t, n)=>{
            let r = e1.name;
            return e1.shaderCache?.hint && (r += "[" + e1.shaderCache.hint + "]"), r += ":" + n + `:${lp(t, e1.shaderCache?.inputDependencies ?? new Array(t.length).fill("dims"))}`, r;
        }, cr = class {
            constructor(t){
                t && (this.architecture = t.architecture, this.vendor = t.vendor);
            }
            isArchitecture(t) {
                return this.architecture === t;
            }
            isVendor(t) {
                return this.vendor === t;
            }
        }, pr = class {
            constructor(){
                this.currentSessionId = null;
                this.currentKernelId = null;
                this.commandEncoder = null;
                this.computePassEncoder = null;
                this.maxDispatchNumber = 16;
                this.pendingDispatchNumber = 0;
                this.pendingKernels = [];
                this.pendingQueries = new Map;
                this.sessionStatus = "default";
                this.capturedCommandList = new Map;
                this.capturedPendingKernels = new Map;
                this.sessionExternalDataMapping = new Map;
            }
            get currentKernelCustomData() {
                if (this.currentKernelId === null) throw new Error("currentKernelCustomData(): currentKernelId is null. (should not happen)");
                let t = this.kernelCustomData.get(this.currentKernelId);
                return t || (t = {}, this.kernelCustomData.set(this.currentKernelId, t)), t;
            }
            async initialize(t, n) {
                this.env = t;
                let r = [], o = {
                    requiredLimits: {
                        maxComputeWorkgroupStorageSize: n.limits.maxComputeWorkgroupStorageSize,
                        maxComputeWorkgroupsPerDimension: n.limits.maxComputeWorkgroupsPerDimension,
                        maxStorageBufferBindingSize: n.limits.maxStorageBufferBindingSize,
                        maxBufferSize: n.limits.maxBufferSize,
                        maxComputeInvocationsPerWorkgroup: n.limits.maxComputeInvocationsPerWorkgroup,
                        maxComputeWorkgroupSizeX: n.limits.maxComputeWorkgroupSizeX,
                        maxComputeWorkgroupSizeY: n.limits.maxComputeWorkgroupSizeY,
                        maxComputeWorkgroupSizeZ: n.limits.maxComputeWorkgroupSizeZ
                    },
                    requiredFeatures: r
                }, i = (s)=>n.features.has(s) && r.push(s) && !0;
                i("chromium-experimental-timestamp-query-inside-passes") || i("timestamp-query"), i("shader-f16"), i("subgroups"), this.device = await n.requestDevice(o), this.adapterInfo = new cr(n.info || await n.requestAdapterInfo()), this.gpuDataManager = xo(this), this.programManager = new hn(this), this.kernels = new Map, this.kernelPersistentData = new Map, this.kernelCustomData = new Map, Wt(t.logLevel, !!t.debug), this.device.onuncapturederror = (s)=>{
                    s.error instanceof GPUValidationError && console.error(`An uncaught WebGPU validation error was raised: ${s.error.message}`);
                }, Object.defineProperty(this.env.webgpu, "device", {
                    value: this.device,
                    writable: !1,
                    enumerable: !0,
                    configurable: !1
                }), Object.defineProperty(this.env.webgpu, "adapter", {
                    value: n,
                    writable: !1,
                    enumerable: !0,
                    configurable: !1
                }), this.setQueryType();
            }
            dispose() {
                typeof this.querySet < "u" && this.querySet.destroy(), this.gpuDataManager.dispose();
            }
            getCommandEncoder() {
                return this.commandEncoder || (this.commandEncoder = this.device.createCommandEncoder()), this.commandEncoder;
            }
            getComputePassEncoder() {
                if (!this.computePassEncoder) {
                    let t = this.getCommandEncoder(), n = {};
                    this.queryType === "at-passes" && (n.timestampWrites = {
                        querySet: this.querySet,
                        beginningOfPassWriteIndex: this.pendingDispatchNumber * 2,
                        endOfPassWriteIndex: this.pendingDispatchNumber * 2 + 1
                    }), this.computePassEncoder = t.beginComputePass(n);
                }
                return this.computePassEncoder;
            }
            endComputePass() {
                this.computePassEncoder && (this.computePassEncoder.end(), this.computePassEncoder = null);
            }
            flush() {
                if (!this.commandEncoder) return;
                ye(), this.endComputePass();
                let t;
                this.queryType !== "none" && (this.commandEncoder.resolveQuerySet(this.querySet, 0, this.pendingDispatchNumber * 2, this.queryResolveBuffer, 0), t = this.device.createBuffer({
                    size: this.pendingDispatchNumber * 16,
                    usage: GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST
                }), this.pendingQueries.set(t, this.pendingKernels), this.pendingKernels = [], this.commandEncoder.copyBufferToBuffer(this.queryResolveBuffer, 0, t, 0, this.pendingDispatchNumber * 16)), this.device.queue.submit([
                    this.commandEncoder.finish()
                ]), this.gpuDataManager.refreshPendingBuffers(), this.commandEncoder = null, this.pendingDispatchNumber = 0, this.queryType !== "none" && t.mapAsync(GPUMapMode.READ).then(()=>{
                    let n = new BigUint64Array(t.getMappedRange()), r = this.pendingQueries.get(t);
                    for(let o = 0; o < n.length / 2; o++){
                        let i = r[o], s = i.kernelId, a = this.kernels.get(s), u = a.kernelType, d = a.kernelName, l = i.programName, c = i.inputTensorViews, p = i.outputTensorViews, f = n[o * 2], m = n[o * 2 + 1];
                        typeof this.queryTimeBase > "u" && (this.queryTimeBase = f);
                        let h = Number(f - this.queryTimeBase), b = Number(m - this.queryTimeBase);
                        if (!Number.isSafeInteger(h) || !Number.isSafeInteger(b)) throw new RangeError("incorrect timestamp range");
                        if (this.env.webgpu.profiling?.ondata) this.env.webgpu.profiling.ondata({
                            version: 1,
                            inputsMetadata: c.map((y)=>({
                                    dims: y.dims,
                                    dataType: Ee(y.dataType)
                                })),
                            outputsMetadata: p.map((y)=>({
                                    dims: y.dims,
                                    dataType: Ee(y.dataType)
                                })),
                            kernelId: s,
                            kernelType: u,
                            kernelName: d,
                            programName: l,
                            startTime: h,
                            endTime: b
                        });
                        else {
                            let y = "";
                            c.forEach((_, w)=>{
                                y += `input[${w}]: [${_.dims}] | ${Ee(_.dataType)}, `;
                            });
                            let g = "";
                            p.forEach((_, w)=>{
                                g += `output[${w}]: [${_.dims}] | ${Ee(_.dataType)}, `;
                            }), console.log(`[profiling] kernel "${s}|${u}|${d}|${l}" ${y}${g}start time: ${h} ns, execution time: ${b - h} ns`);
                        }
                        pt("GPU", `${l}::${f}::${m}`);
                    }
                    t.unmap(), this.pendingQueries.delete(t);
                }), he();
            }
            run(t, n, r, o, i, s) {
                ye(t.name);
                let a = [];
                for(let _ = 0; _ < n.length; ++_){
                    let w = n[_].data;
                    if (w === 0) continue;
                    let v = this.gpuDataManager.get(w);
                    if (!v) throw new Error(`no GPU data for input: ${w}`);
                    a.push(v);
                }
                let { outputs: u, dispatchGroup: d, programUniforms: l } = t.getRunData(n), c = r.length === 0 ? u.map((_, w)=>w) : r;
                if (c.length !== u.length) throw new Error(`Output size ${c.length} must be equal to ${u.length}.`);
                let p = [], f = [];
                for(let _ = 0; _ < u.length; ++_){
                    if (!Number.isInteger(c[_]) || c[_] < -3 || c[_] >= s) throw new Error(`Invalid output index: ${c[_]}`);
                    if (c[_] === -3) continue;
                    let w = c[_] === -1, v = c[_] === -2, $ = w || v ? i(u[_].dataType, u[_].dims) : o(c[_], u[_].dataType, u[_].dims);
                    if (p.push($), $.data === 0) continue;
                    let T = this.gpuDataManager.get($.data);
                    if (!T) throw new Error(`no GPU data for output: ${$.data}`);
                    if (w && this.temporaryData.push(T), v) {
                        let I = this.kernelPersistentData.get(this.currentKernelId);
                        I || (I = [], this.kernelPersistentData.set(this.currentKernelId, I)), I.push(T);
                    }
                    f.push(T);
                }
                if (a.length !== n.length || f.length !== p.length) {
                    if (f.length === 0) return he(t.name), p;
                    throw new Error(`Program ${t.name} has zero-sized tensor(s) in inputs or outputs. This is not supported now.`);
                }
                let m;
                if (l) {
                    let _ = 0, w = [];
                    l.forEach((I)=>{
                        let A = typeof I.data == "number" ? [
                            I.data
                        ] : I.data;
                        if (A.length === 0) return;
                        let z = I.type === 10 ? 2 : 4, R, D;
                        I.type === 10 ? (D = A.length > 4 ? 16 : A.length > 2 ? 8 : A.length * z, R = A.length > 4 ? 16 : z * A.length) : (D = A.length <= 2 ? A.length * z : 16, R = 16), _ = Math.ceil(_ / D) * D, w.push(_);
                        let U = I.type === 10 ? 8 : 4;
                        _ += A.length > 4 ? Math.ceil(A.length / U) * R : A.length * z;
                    });
                    let v = 16;
                    _ = Math.ceil(_ / v) * v;
                    let $ = new ArrayBuffer(_);
                    l.forEach((I, A)=>{
                        let z = w[A], R = typeof I.data == "number" ? [
                            I.data
                        ] : I.data;
                        if (I.type === 6) new Int32Array($, z, R.length).set(R);
                        else if (I.type === 12) new Uint32Array($, z, R.length).set(R);
                        else if (I.type === 10) new Uint16Array($, z, R.length).set(R);
                        else if (I.type === 1) new Float32Array($, z, R.length).set(R);
                        else throw new Error(`Unsupported uniform type: ${Ee(I.type)}`);
                    });
                    let T = this.gpuDataManager.create(_, GPUBufferUsage.COPY_DST | GPUBufferUsage.UNIFORM);
                    this.device.queue.writeBuffer(T.buffer, 0, $, 0, _), this.gpuDataManager.release(T.id), m = {
                        offset: 0,
                        size: _,
                        buffer: T.buffer
                    };
                }
                let h = this.programManager.normalizeDispatchGroupSize(d), b = h[1] === 1 && h[2] === 1, y = cp(t, n, b), g = this.programManager.getArtifact(y);
                if (g || (g = this.programManager.build(t, h), this.programManager.setArtifact(y, g), Z("info", ()=>`[artifact] key: ${y}, programName: ${t.name}`)), l && g.uniformVariablesInfo) {
                    if (l.length !== g.uniformVariablesInfo.length) throw new Error(`Uniform variables count mismatch: expect ${g.uniformVariablesInfo.length}, got ${l.length} in program "${g.programInfo.name}".`);
                    for(let _ = 0; _ < l.length; _++){
                        let w = l[_], v = w.type, $ = typeof w.data == "number" ? 1 : w.data.length, [T, I] = g.uniformVariablesInfo[_];
                        if (v !== T || $ !== I) throw new Error(`Uniform variable ${_} mismatch: expect type ${T} with size ${I}, got type ${v} with size ${$} in program "${g.programInfo.name}".`);
                    }
                }
                if (Z("info", ()=>`[ProgramManager] run "${t.name}" (key=${y}) with ${h[0]}x${h[1]}x${h[2]}`), this.queryType !== "none" || this.sessionStatus === "capturing") {
                    let _ = {
                        kernelId: this.currentKernelId,
                        programName: g.programInfo.name,
                        inputTensorViews: n,
                        outputTensorViews: p
                    };
                    this.pendingKernels.push(_), this.sessionStatus === "capturing" && this.capturedPendingKernels.get(this.currentSessionId).push(_);
                }
                return this.programManager.run(g, a, f, h, m), he(t.name), p;
            }
            upload(t, n) {
                this.gpuDataManager.upload(t, n);
            }
            memcpy(t, n) {
                this.gpuDataManager.memcpy(t, n);
            }
            async download(t, n) {
                await this.gpuDataManager.download(t, n);
            }
            alloc(t) {
                return this.gpuDataManager.create(t).id;
            }
            free(t) {
                return this.gpuDataManager.release(t);
            }
            createKernel(t, n, r, o) {
                let i = _u.get(t);
                if (!i) throw new Error(`kernel not implemented: ${t}`);
                let s = {
                    kernelType: t,
                    kernelName: o,
                    kernelEntry: i[0],
                    attributes: [
                        i[1],
                        r
                    ]
                };
                this.kernels.set(n, s);
            }
            releaseKernel(t) {
                let n = this.kernelPersistentData.get(t);
                if (n) {
                    for (let r of n)this.gpuDataManager.release(r.id);
                    this.kernelPersistentData.delete(t);
                }
                this.kernelCustomData.delete(t), this.kernels.delete(t);
            }
            computeKernel(t, n, r) {
                let o = this.kernels.get(t);
                if (!o) throw new Error(`kernel not created: ${t}`);
                let i = o.kernelType, s = o.kernelName, a = o.kernelEntry, u = o.attributes;
                if (this.currentKernelId !== null) throw new Error(`kernel "[${i}] ${s}" is not allowed to be called recursively`);
                this.currentKernelId = t, u[0] && (u[1] = u[0](u[1]), u[0] = void 0), Z("info", ()=>`[WebGPU] Start to run kernel "[${i}] ${s}"...`);
                let d = this.env.debug;
                this.temporaryData = [];
                try {
                    return d && this.device.pushErrorScope("validation"), a(n, u[1]), 0;
                } catch (l) {
                    return r.push(Promise.resolve(`[WebGPU] Kernel "[${i}] ${s}" failed. ${l}`)), 1;
                } finally{
                    d && r.push(this.device.popErrorScope().then((l)=>l ? `GPU validation error for kernel "[${i}] ${s}": ${l.message}` : null));
                    for (let l of this.temporaryData)this.gpuDataManager.release(l.id);
                    this.temporaryData = [], this.currentKernelId = null;
                }
            }
            registerBuffer(t, n, r, o) {
                let i = this.sessionExternalDataMapping.get(t);
                i || (i = new Map, this.sessionExternalDataMapping.set(t, i));
                let s = i.get(n), a = this.gpuDataManager.registerExternalBuffer(r, o, s);
                return i.set(n, [
                    a,
                    r
                ]), a;
            }
            unregisterBuffers(t) {
                let n = this.sessionExternalDataMapping.get(t);
                n && (n.forEach((r)=>this.gpuDataManager.unregisterExternalBuffer(r[0])), this.sessionExternalDataMapping.delete(t));
            }
            getBuffer(t) {
                let n = this.gpuDataManager.get(t);
                if (!n) throw new Error(`no GPU data for buffer: ${t}`);
                return n.buffer;
            }
            createDownloader(t, n, r) {
                return async ()=>{
                    let o = await Gn(this, t, n);
                    return qt(o.buffer, r);
                };
            }
            writeTimestamp(t) {
                this.queryType === "inside-passes" && this.computePassEncoder.writeTimestamp(this.querySet, t);
            }
            setQueryType() {
                this.queryType = "none", (this.env.webgpu.profiling?.mode === "default" || (typeof this.env.trace > "u" ? this.env.wasm.trace : this.env.trace)) && (this.device.features.has("chromium-experimental-timestamp-query-inside-passes") ? this.queryType = "inside-passes" : this.device.features.has("timestamp-query") && (this.queryType = "at-passes"), this.queryType !== "none" && typeof this.querySet > "u" && (this.querySet = this.device.createQuerySet({
                    type: "timestamp",
                    count: this.maxDispatchNumber * 2
                }), this.queryResolveBuffer = this.device.createBuffer({
                    size: this.maxDispatchNumber * 16,
                    usage: GPUBufferUsage.COPY_SRC | GPUBufferUsage.QUERY_RESOLVE
                })));
            }
            captureBegin() {
                Z("info", "captureBegin"), this.capturedCommandList.get(this.currentSessionId) || this.capturedCommandList.set(this.currentSessionId, []), this.capturedPendingKernels.get(this.currentSessionId) || this.capturedPendingKernels.set(this.currentSessionId, []), this.flush(), this.sessionStatus = "capturing";
            }
            captureEnd() {
                Z("info", "captureEnd"), this.flush(), this.sessionStatus = "default";
            }
            replay() {
                Z("info", "replay"), this.sessionStatus = "replaying";
                let t = this.capturedCommandList.get(this.currentSessionId), n = this.capturedPendingKernels.get(this.currentSessionId), r = t.length;
                this.pendingKernels = [];
                for(let o = 0; o < r; o++){
                    let i = this.getComputePassEncoder(), s = t[o];
                    this.writeTimestamp(this.pendingDispatchNumber * 2), i.setPipeline(s.computePipeline), i.setBindGroup(0, s.bindGroup), i.dispatchWorkgroups(...s.dispatchGroup), this.writeTimestamp(this.pendingDispatchNumber * 2 + 1), this.pendingDispatchNumber++, this.queryType !== "none" && this.pendingKernels.push(n[o]), (this.pendingDispatchNumber >= this.maxDispatchNumber || this.queryType === "at-passes") && this.endComputePass(), this.pendingDispatchNumber >= this.maxDispatchNumber && this.flush();
                }
                this.flush(), this.sessionStatus = "default";
            }
            onCreateSession() {
                this.gpuDataManager.onCreateSession();
            }
            onReleaseSession(t) {
                this.unregisterBuffers(t), this.capturedCommandList.has(t) && this.capturedCommandList.delete(t), this.capturedPendingKernels.has(t) && this.capturedPendingKernels.delete(t), this.gpuDataManager.onReleaseSession(t);
            }
            onRunStart(t) {
                this.currentSessionId = t, this.setQueryType();
            }
        };
    });
    var Su = {};
    rt(Su, {
        init: ()=>pp
    });
    var $t, mr, pp, Tu = k(()=>{
        "use strict";
        L();
        ke();
        F();
        _o();
        $t = class e1 {
            constructor(t, n, r, o){
                this.module = t;
                this.dataType = n;
                this.data = r;
                this.dims = o;
            }
            getFloat32Array() {
                if (this.dataType !== 1) throw new Error("Invalid data type");
                let t = x.size(this.dims);
                return t === 0 ? new Float32Array : new Float32Array(this.module.HEAP8.buffer, this.data, t);
            }
            getBigInt64Array() {
                if (this.dataType !== 7) throw new Error("Invalid data type");
                let t = x.size(this.dims);
                return t === 0 ? new BigInt64Array : new BigInt64Array(this.module.HEAP8.buffer, this.data, t);
            }
            getInt32Array() {
                if (this.dataType !== 6) throw new Error("Invalid data type");
                let t = x.size(this.dims);
                return t === 0 ? new Int32Array : new Int32Array(this.module.HEAP8.buffer, this.data, t);
            }
            getUint16Array() {
                if (this.dataType !== 10 && this.dataType !== 4) throw new Error("Invalid data type");
                let t = x.size(this.dims);
                return t === 0 ? new Uint16Array : new Uint16Array(this.module.HEAP8.buffer, this.data, t);
            }
            reshape(t) {
                if (x.size(t) !== x.size(this.dims)) throw new Error("Invalid new shape");
                return new e1(this.module, this.dataType, this.data, t);
            }
        }, mr = class {
            constructor(t, n, r){
                this.module = t;
                this.backend = n;
                this.customDataOffset = 0;
                this.customDataSize = 0;
                this.adapterInfo = n.adapterInfo;
                let o = t.PTR_SIZE, i = r / t.PTR_SIZE, s = o === 4 ? "i32" : "i64";
                this.opKernelContext = Number(t.getValue(o * i++, s));
                let a = Number(t.getValue(o * i++, s));
                this.outputCount = Number(t.getValue(o * i++, s)), this.customDataOffset = Number(t.getValue(o * i++, "*")), this.customDataSize = Number(t.getValue(o * i++, s));
                let u = [];
                for(let d = 0; d < a; d++){
                    let l = Number(t.getValue(o * i++, s)), c = Number(t.getValue(o * i++, "*")), p = Number(t.getValue(o * i++, s)), f = [];
                    for(let m = 0; m < p; m++)f.push(Number(t.getValue(o * i++, s)));
                    u.push(new $t(t, l, c, f));
                }
                this.inputs = u;
            }
            get kernelCustomData() {
                return this.backend.currentKernelCustomData;
            }
            get customDataBuffer() {
                return this.module.HEAPU8.subarray(this.customDataOffset, this.customDataOffset + this.customDataSize);
            }
            compute(t, n) {
                let r = n?.inputs?.map((a)=>typeof a == "number" ? this.inputs[a] : a) ?? this.inputs, o = n?.outputs ?? [], i = (a, u, d)=>new $t(this.module, u, this.output(a, d), d), s = (a, u)=>{
                    let d = qe(a, u);
                    if (!d) throw new Error(`Unsupported data type: ${a}`);
                    let l = d > 0 ? this.backend.gpuDataManager.create(d).id : 0;
                    return new $t(this.module, a, l, u);
                };
                return this.backend.run(t, r, o, i, s, this.outputCount);
            }
            output(t, n) {
                let r = this.module.stackSave();
                try {
                    let o = this.module.PTR_SIZE, i = o === 4 ? "i32" : "i64", s = this.module.stackAlloc((1 + n.length) * o);
                    this.module.setValue(s, n.length, i);
                    for(let a = 0; a < n.length; a++)this.module.setValue(s + o * (a + 1), n[a], i);
                    return this.module._JsepOutput(this.opKernelContext, t, s);
                } catch (o) {
                    throw new Error(`Failed to generate kernel's output[${t}] with dims [${n}]. If you are running with pre-allocated output, please make sure the output type/dims are correct. Error: ${o}`);
                } finally{
                    this.module.stackRestore(r);
                }
            }
        }, pp = async (e1, t, n, r)=>{
            let o = t.jsepInit;
            if (!o) throw new Error("Failed to initialize JSEP. The WebAssembly module is not built with JSEP support.");
            if (e1 === "webgpu") {
                let i = (xu(), lt(vu)).WebGpuBackend, s = new i;
                await s.initialize(n, r), o("webgpu", [
                    s,
                    (a)=>s.alloc(Number(a)),
                    (a)=>s.free(a),
                    (a, u, d, l = !1)=>{
                        if (l) Z("verbose", ()=>`[WebGPU] jsepCopyGpuToGpu: src=${Number(a)}, dst=${Number(u)}, size=${Number(d)}`), s.memcpy(Number(a), Number(u));
                        else {
                            Z("verbose", ()=>`[WebGPU] jsepCopyCpuToGpu: dataOffset=${Number(a)}, gpuDataId=${Number(u)}, size=${Number(d)}`);
                            let c = t.HEAPU8.subarray(Number(a >>> 0), Number(a >>> 0) + Number(d));
                            s.upload(Number(u), c);
                        }
                    },
                    async (a, u, d)=>{
                        Z("verbose", ()=>`[WebGPU] jsepCopyGpuToCpu: gpuDataId=${a}, dataOffset=${u}, size=${d}`), await s.download(Number(a), ()=>t.HEAPU8.subarray(Number(u) >>> 0, Number(u + d) >>> 0));
                    },
                    (a, u, d)=>s.createKernel(a, Number(u), d, t.UTF8ToString(t._JsepGetNodeName(Number(u)))),
                    (a)=>s.releaseKernel(a),
                    (a, u, d, l)=>{
                        Z("verbose", ()=>`[WebGPU] jsepRun: sessionHandle=${d}, kernel=${a}, contextDataOffset=${u}`);
                        let c = new mr(t, s, Number(u));
                        return s.computeKernel(Number(a), c, l);
                    },
                    ()=>s.captureBegin(),
                    ()=>s.captureEnd(),
                    ()=>s.replay()
                ]);
            } else {
                let i = new Zt(n);
                o("webnn", [
                    i,
                    ()=>i.reserveTensorId(),
                    (s)=>i.releaseTensorId(s),
                    async (s, a, u, d, l)=>i.ensureTensor(s, a, u, d, l),
                    (s, a)=>{
                        i.uploadTensor(s, a);
                    },
                    async (s, a)=>i.downloadTensor(s, a),
                    (s, a)=>i.registerMLContext(s, a),
                    !!n.trace
                ]);
            }
        };
    });
    var mp, kt, Pt, tt, fp, Iu, mt, zt, Bt, Cu, Dt, Ot, Mt, En = k(()=>{
        "use strict";
        _e();
        io();
        ao();
        L();
        We();
        Vt();
        Dn();
        mp = (e1, t)=>{
            ne()._OrtInit(e1, t) !== 0 && Y("Can't initialize onnxruntime.");
        }, kt = async (e1)=>{
            mp(e1.wasm.numThreads, ht(e1.logLevel));
        }, Pt = async (e1, t)=>{
            ne().asyncInit?.();
            let n = e1.webgpu.adapter;
            if (t === "webgpu") {
                if (typeof navigator > "u" || !navigator.gpu) throw new Error("WebGPU is not supported in current environment");
                if (n) {
                    if (typeof n.limits != "object" || typeof n.features != "object" || typeof n.requestDevice != "function") throw new Error("Invalid GPU adapter set in `env.webgpu.adapter`. It must be a GPUAdapter object.");
                } else {
                    let r = e1.webgpu.powerPreference;
                    if (r !== void 0 && r !== "low-power" && r !== "high-performance") throw new Error(`Invalid powerPreference setting: "${r}"`);
                    let o = e1.webgpu.forceFallbackAdapter;
                    if (o !== void 0 && typeof o != "boolean") throw new Error(`Invalid forceFallbackAdapter setting: "${o}"`);
                    if (n = await navigator.gpu.requestAdapter({
                        powerPreference: r,
                        forceFallbackAdapter: o
                    }), !n) throw new Error('Failed to get GPU adapter. You may need to enable flag "--enable-unsafe-webgpu" if you are using Chrome.');
                }
            }
            if (t === "webnn" && (typeof navigator > "u" || !navigator.ml)) throw new Error("WebNN is not supported in current environment");
            {
                let r = (Tu(), lt(Su)).init;
                t === "webgpu" && await r("webgpu", ne(), e1, n), t === "webnn" && await r("webnn", ne(), e1);
            }
        }, tt = new Map, fp = (e1)=>{
            let t = ne(), n = t.stackSave();
            try {
                let r = t.PTR_SIZE, o = t.stackAlloc(2 * r);
                t._OrtGetInputOutputCount(e1, o, o + r) !== 0 && Y("Can't get session input/output count.");
                let s = r === 4 ? "i32" : "i64";
                return [
                    Number(t.getValue(o, s)),
                    Number(t.getValue(o + r, s))
                ];
            } finally{
                t.stackRestore(n);
            }
        }, Iu = (e1, t)=>{
            let n = ne(), r = n.stackSave(), o = 0;
            try {
                let i = n.PTR_SIZE, s = n.stackAlloc(2 * i);
                n._OrtGetInputOutputMetadata(e1, t, s, s + i) !== 0 && Y("Can't get session input/output metadata.");
                let u = Number(n.getValue(s, "*"));
                o = Number(n.getValue(s + i, "*"));
                let d = n.HEAP32[o / 4];
                if (d === 0) return [
                    u,
                    0
                ];
                let l = n.HEAPU32[o / 4 + 1], c = [];
                for(let p = 0; p < l; p++){
                    let f = Number(n.getValue(o + 8 + p * i, "*"));
                    c.push(f !== 0 ? n.UTF8ToString(f) : Number(n.getValue(o + 8 + (p + l) * i, "*")));
                }
                return [
                    u,
                    d,
                    c
                ];
            } finally{
                n.stackRestore(r), o !== 0 && n._OrtFree(o);
            }
        }, mt = (e1)=>{
            let t = ne(), n = t._malloc(e1.byteLength);
            if (n === 0) throw new Error(`Can't create a session. failed to allocate a buffer of size ${e1.byteLength}.`);
            return t.HEAPU8.set(e1, n), [
                n,
                e1.byteLength
            ];
        }, zt = async (e1, t)=>{
            let n, r, o = ne();
            Array.isArray(e1) ? [n, r] = e1 : e1.buffer === o.HEAPU8.buffer ? [n, r] = [
                e1.byteOffset,
                e1.byteLength
            ] : [n, r] = mt(e1);
            let i = 0, s = 0, a = 0, u = [], d = [], l = [];
            try {
                if ([s, u] = await so(t), t?.externalData && o.mountExternalData) {
                    let w = [];
                    for (let v of t.externalData){
                        let $ = typeof v == "string" ? v : v.path;
                        w.push(gt(typeof v == "string" ? v : v.data).then((T)=>{
                            o.mountExternalData($, T);
                        }));
                    }
                    await Promise.all(w);
                }
                for (let w of t?.executionProviders ?? [])if ((typeof w == "string" ? w : w.name) === "webnn") {
                    if (o.shouldTransferToMLTensor = !1, typeof w != "string") {
                        let $ = w, T = $?.context, I = $?.gpuDevice, A = $?.deviceType, z = $?.powerPreference;
                        T ? o.currentContext = T : I ? o.currentContext = await o.webnnCreateMLContext(I) : o.currentContext = await o.webnnCreateMLContext({
                            deviceType: A,
                            powerPreference: z
                        });
                    } else o.currentContext = await o.webnnCreateMLContext();
                    break;
                }
                i = await o._OrtCreateSession(n, r, s), o.webgpuOnCreateSession?.(i), i === 0 && Y("Can't create a session."), o.jsepOnCreateSession?.(), o.currentContext && (o.webnnRegisterMLContext(i, o.currentContext), o.currentContext = void 0, o.shouldTransferToMLTensor = !0);
                let [c, p] = fp(i), f = !!t?.enableGraphCapture, m = [], h = [], b = [], y = [], g = [];
                for(let w = 0; w < c; w++){
                    let [v, $, T] = Iu(i, w);
                    v === 0 && Y("Can't get an input name."), d.push(v);
                    let I = o.UTF8ToString(v);
                    m.push(I), b.push($ === 0 ? {
                        name: I,
                        isTensor: !1
                    } : {
                        name: I,
                        isTensor: !0,
                        type: Ee($),
                        shape: T
                    });
                }
                for(let w = 0; w < p; w++){
                    let [v, $, T] = Iu(i, w + c);
                    v === 0 && Y("Can't get an output name."), l.push(v);
                    let I = o.UTF8ToString(v);
                    h.push(I), y.push($ === 0 ? {
                        name: I,
                        isTensor: !1
                    } : {
                        name: I,
                        isTensor: !0,
                        type: Ee($),
                        shape: T
                    });
                    {
                        if (f && t?.preferredOutputLocation === void 0) {
                            g.push("gpu-buffer");
                            continue;
                        }
                        let A = typeof t?.preferredOutputLocation == "string" ? t.preferredOutputLocation : t?.preferredOutputLocation?.[I] ?? "cpu", z = o.webnnIsGraphOutput;
                        if (A === "cpu" && z && z(i, I)) {
                            g.push("ml-tensor-cpu-output");
                            continue;
                        }
                        if (A !== "cpu" && A !== "cpu-pinned" && A !== "gpu-buffer" && A !== "ml-tensor") throw new Error(`Not supported preferred output location: ${A}.`);
                        if (f && A !== "gpu-buffer") throw new Error(`Not supported preferred output location: ${A}. Only 'gpu-buffer' location is supported when enableGraphCapture is true.`);
                        g.push(A);
                    }
                }
                let _ = null;
                return g.some((w)=>w === "gpu-buffer" || w === "ml-tensor" || w === "ml-tensor-cpu-output") && (a = o._OrtCreateBinding(i), a === 0 && Y("Can't create IO binding."), _ = {
                    handle: a,
                    outputPreferredLocations: g,
                    outputPreferredLocationsEncoded: g.map((w)=>w === "ml-tensor-cpu-output" ? "ml-tensor" : w).map((w)=>Bn(w))
                }), tt.set(i, [
                    i,
                    d,
                    l,
                    _,
                    f,
                    !1
                ]), [
                    i,
                    m,
                    h,
                    b,
                    y
                ];
            } catch (c) {
                throw d.forEach((p)=>o._OrtFree(p)), l.forEach((p)=>o._OrtFree(p)), a !== 0 && o._OrtReleaseBinding(a) !== 0 && Y("Can't release IO binding."), i !== 0 && o._OrtReleaseSession(i) !== 0 && Y("Can't release session."), c;
            } finally{
                o._free(n), s !== 0 && o._OrtReleaseSessionOptions(s) !== 0 && Y("Can't release session options."), u.forEach((c)=>o._free(c)), o.unmountExternalData?.();
            }
        }, Bt = (e1)=>{
            let t = ne(), n = tt.get(e1);
            if (!n) throw new Error(`cannot release session. invalid session id: ${e1}`);
            let [r, o, i, s, a] = n;
            s && (a && t._OrtClearBoundOutputs(s.handle) !== 0 && Y("Can't clear bound outputs."), t._OrtReleaseBinding(s.handle) !== 0 && Y("Can't release IO binding.")), t.jsepOnReleaseSession?.(e1), t.webnnOnReleaseSession?.(e1), t.webgpuOnReleaseSession?.(e1), o.forEach((u)=>t._OrtFree(u)), i.forEach((u)=>t._OrtFree(u)), t._OrtReleaseSession(r) !== 0 && Y("Can't release session."), tt.delete(e1);
        }, Cu = async (e1, t, n, r, o, i, s = !1)=>{
            if (!e1) {
                t.push(0);
                return;
            }
            let a = ne(), u = a.PTR_SIZE, d = e1[0], l = e1[1], c = e1[3], p = c, f, m;
            if (d === "string" && (c === "gpu-buffer" || c === "ml-tensor")) throw new Error("String tensor is not supported on GPU.");
            if (s && c !== "gpu-buffer") throw new Error(`External buffer must be provided for input/output index ${i} when enableGraphCapture is true.`);
            if (c === "gpu-buffer") {
                let y = e1[2].gpuBuffer;
                m = qe(He(d), l);
                {
                    let g = a.jsepRegisterBuffer;
                    if (!g) throw new Error('Tensor location "gpu-buffer" is not supported without using WebGPU.');
                    f = g(r, i, y, m);
                }
            } else if (c === "ml-tensor") {
                let y = e1[2].mlTensor;
                m = qe(He(d), l);
                let g = a.webnnRegisterMLTensor;
                if (!g) throw new Error('Tensor location "ml-tensor" is not supported without using WebNN.');
                f = g(r, y, He(d), l);
            } else {
                let y = e1[2];
                if (Array.isArray(y)) {
                    m = u * y.length, f = a._malloc(m), n.push(f);
                    for(let g = 0; g < y.length; g++){
                        if (typeof y[g] != "string") throw new TypeError(`tensor data at index ${g} is not a string`);
                        a.setValue(f + g * u, $e(y[g], n), "*");
                    }
                } else {
                    let g = a.webnnIsGraphInput, _ = a.webnnIsGraphOutput;
                    if (d !== "string" && g && _) {
                        let w = a.UTF8ToString(o);
                        if (g(r, w) || _(r, w)) {
                            let v = He(d);
                            m = qe(v, l), p = "ml-tensor";
                            let $ = a.webnnCreateTemporaryTensor, T = a.webnnUploadTensor;
                            if (!$ || !T) throw new Error('Tensor location "ml-tensor" is not supported without using WebNN.');
                            let I = await $(r, v, l);
                            T(I, new Uint8Array(y.buffer, y.byteOffset, y.byteLength)), f = I;
                        } else m = y.byteLength, f = a._malloc(m), n.push(f), a.HEAPU8.set(new Uint8Array(y.buffer, y.byteOffset, m), f);
                    } else m = y.byteLength, f = a._malloc(m), n.push(f), a.HEAPU8.set(new Uint8Array(y.buffer, y.byteOffset, m), f);
                }
            }
            let h = a.stackSave(), b = a.stackAlloc(4 * l.length);
            try {
                l.forEach((g, _)=>a.setValue(b + _ * u, g, u === 4 ? "i32" : "i64"));
                let y = a._OrtCreateTensor(He(d), f, m, b, l.length, Bn(p));
                y === 0 && Y(`Can't create tensor for input/output. session=${r}, index=${i}.`), t.push(y);
            } finally{
                a.stackRestore(h);
            }
        }, Dt = async (e1, t, n, r, o, i)=>{
            let s = ne(), a = s.PTR_SIZE, u = tt.get(e1);
            if (!u) throw new Error(`cannot run inference. invalid session id: ${e1}`);
            let d = u[0], l = u[1], c = u[2], p = u[3], f = u[4], m = u[5], h = t.length, b = r.length, y = 0, g = [], _ = [], w = [], v = [], $ = [], T = s.stackSave(), I = s.stackAlloc(h * a), A = s.stackAlloc(h * a), z = s.stackAlloc(b * a), R = s.stackAlloc(b * a);
            try {
                [y, g] = oo(i), Ue("wasm prepareInputOutputTensor");
                for(let O = 0; O < h; O++)await Cu(n[O], _, v, e1, l[t[O]], t[O], f);
                for(let O = 0; O < b; O++)await Cu(o[O], w, v, e1, c[r[O]], h + r[O], f);
                Re("wasm prepareInputOutputTensor");
                for(let O = 0; O < h; O++)s.setValue(I + O * a, _[O], "*"), s.setValue(A + O * a, l[t[O]], "*");
                for(let O = 0; O < b; O++)s.setValue(z + O * a, w[O], "*"), s.setValue(R + O * a, c[r[O]], "*");
                if (p && !m) {
                    let { handle: O, outputPreferredLocations: M, outputPreferredLocationsEncoded: V } = p;
                    if (l.length !== h) throw new Error(`input count from feeds (${h}) is expected to be always equal to model's input count (${l.length}).`);
                    Ue("wasm bindInputsOutputs");
                    for(let W = 0; W < h; W++){
                        let H = t[W];
                        await s._OrtBindInput(O, l[H], _[W]) !== 0 && Y(`Can't bind input[${W}] for session=${e1}.`);
                    }
                    for(let W = 0; W < b; W++){
                        let H = r[W];
                        o[W]?.[3] ? ($.push(w[W]), s._OrtBindOutput(O, c[H], w[W], 0) !== 0 && Y(`Can't bind pre-allocated output[${W}] for session=${e1}.`)) : s._OrtBindOutput(O, c[H], 0, V[H]) !== 0 && Y(`Can't bind output[${W}] to ${M[W]} for session=${e1}.`);
                    }
                    Re("wasm bindInputsOutputs"), tt.set(e1, [
                        d,
                        l,
                        c,
                        p,
                        f,
                        !0
                    ]);
                }
                s.jsepOnRunStart?.(d), s.webnnOnRunStart?.(d);
                let D;
                p ? D = await s._OrtRunWithBinding(d, p.handle, b, z, y) : D = await s._OrtRun(d, A, I, h, R, b, z, y), D !== 0 && Y("failed to call OrtRun().");
                let U = [], Q = [];
                Ue("wasm ProcessOutputTensor");
                for(let O = 0; O < b; O++){
                    let M = Number(s.getValue(z + O * a, "*"));
                    if (M === w[O] || $.includes(w[O])) {
                        U.push(o[O]), M !== w[O] && s._OrtReleaseTensor(M) !== 0 && Y("Can't release tensor.");
                        continue;
                    }
                    let V = s.stackSave(), W = s.stackAlloc(4 * a), H = !1, X, oe = 0;
                    try {
                        s._OrtGetTensorData(M, W, W + a, W + 2 * a, W + 3 * a) !== 0 && Y(`Can't access output tensor data on index ${O}.`);
                        let q = a === 4 ? "i32" : "i64", E = Number(s.getValue(W, q));
                        oe = s.getValue(W + a, "*");
                        let N = s.getValue(W + a * 2, "*"), se = Number(s.getValue(W + a * 3, q)), ve = [];
                        for(let me = 0; me < se; me++)ve.push(Number(s.getValue(N + me * a, q)));
                        s._OrtFree(N) !== 0 && Y("Can't free memory for tensor dims.");
                        let ge = ve.reduce((me, ae)=>me * ae, 1);
                        X = Ee(E);
                        let je = p?.outputPreferredLocations[r[O]];
                        if (X === "string") {
                            if (je === "gpu-buffer" || je === "ml-tensor") throw new Error("String tensor is not supported on GPU.");
                            let me = [];
                            for(let ae = 0; ae < ge; ae++){
                                let Le = s.getValue(oe + ae * a, "*"), xt = s.getValue(oe + (ae + 1) * a, "*"), yr = ae === ge - 1 ? void 0 : xt - Le;
                                me.push(s.UTF8ToString(Le, yr));
                            }
                            U.push([
                                X,
                                ve,
                                me,
                                "cpu"
                            ]);
                        } else if (je === "gpu-buffer" && ge > 0) {
                            let me = s.jsepGetBuffer;
                            if (!me) throw new Error('preferredLocation "gpu-buffer" is not supported without using WebGPU.');
                            let ae = me(oe), Le = qe(E, ge);
                            if (Le === void 0 || !Lt(X)) throw new Error(`Unsupported data type: ${X}`);
                            H = !0, U.push([
                                X,
                                ve,
                                {
                                    gpuBuffer: ae,
                                    download: s.jsepCreateDownloader(ae, Le, X),
                                    dispose: ()=>{
                                        s._OrtReleaseTensor(M) !== 0 && Y("Can't release tensor.");
                                    }
                                },
                                "gpu-buffer"
                            ]);
                        } else if (je === "ml-tensor" && ge > 0) {
                            let me = s.webnnEnsureTensor, ae = s.webnnIsGraphInputOutputTypeSupported;
                            if (!me || !ae) throw new Error('preferredLocation "ml-tensor" is not supported without using WebNN.');
                            if (qe(E, ge) === void 0 || !Gt(X)) throw new Error(`Unsupported data type: ${X}`);
                            if (!ae(e1, X, !1)) throw new Error(`preferredLocation "ml-tensor" for ${X} output is not supported by current WebNN Context.`);
                            let xt = await me(e1, oe, E, ve, !1);
                            H = !0, U.push([
                                X,
                                ve,
                                {
                                    mlTensor: xt,
                                    download: s.webnnCreateMLTensorDownloader(oe, X),
                                    dispose: ()=>{
                                        s.webnnReleaseTensorId(oe), s._OrtReleaseTensor(M);
                                    }
                                },
                                "ml-tensor"
                            ]);
                        } else if (je === "ml-tensor-cpu-output" && ge > 0) {
                            let me = s.webnnCreateMLTensorDownloader(oe, X)(), ae = U.length;
                            H = !0, Q.push((async ()=>{
                                let Le = [
                                    ae,
                                    await me
                                ];
                                return s.webnnReleaseTensorId(oe), s._OrtReleaseTensor(M), Le;
                            })()), U.push([
                                X,
                                ve,
                                [],
                                "cpu"
                            ]);
                        } else {
                            let me = ot(X), ae = new me(ge);
                            new Uint8Array(ae.buffer, ae.byteOffset, ae.byteLength).set(s.HEAPU8.subarray(oe, oe + ae.byteLength)), U.push([
                                X,
                                ve,
                                ae,
                                "cpu"
                            ]);
                        }
                    } finally{
                        s.stackRestore(V), X === "string" && oe && s._free(oe), H || s._OrtReleaseTensor(M);
                    }
                }
                p && !f && (s._OrtClearBoundOutputs(p.handle) !== 0 && Y("Can't clear bound outputs."), tt.set(e1, [
                    d,
                    l,
                    c,
                    p,
                    f,
                    !1
                ]));
                for (let [O, M] of (await Promise.all(Q)))U[O][2] = M;
                return Re("wasm ProcessOutputTensor"), U;
            } finally{
                s.webnnOnRunEnd?.(d), s.stackRestore(T), _.forEach((D)=>s._OrtReleaseTensor(D)), w.forEach((D)=>s._OrtReleaseTensor(D)), v.forEach((D)=>s._free(D)), y !== 0 && s._OrtReleaseRunOptions(y), g.forEach((D)=>s._free(D));
            }
        }, Ot = (e1)=>{
            let t = ne(), n = tt.get(e1);
            if (!n) throw new Error("invalid session id");
            let r = n[0], o = t._OrtEndProfiling(r);
            o === 0 && Y("Can't get an profile file name."), t._OrtFree(o);
        }, Mt = (e1)=>{
            let t = [];
            for (let n of e1){
                let r = n[2];
                !Array.isArray(r) && "buffer" in r && t.push(r.buffer);
            }
            return t;
        };
    });
    var nt, Se, vt, yn, bn, gn, fr, hr, ut, dt, gp, Au, Eu, ku, Pu, zu, Bu, Du, gr = k(()=>{
        "use strict";
        _e();
        En();
        We();
        At();
        nt = ()=>!!te.wasm.proxy && typeof document < "u", vt = !1, yn = !1, bn = !1, hr = new Map, ut = (e1, t)=>{
            let n = hr.get(e1);
            n ? n.push(t) : hr.set(e1, [
                t
            ]);
        }, dt = ()=>{
            if (vt || !yn || bn || !Se) throw new Error("worker not ready");
        }, gp = (e1)=>{
            switch(e1.data.type){
                case "init-wasm":
                    vt = !1, e1.data.err ? (bn = !0, fr[1](e1.data.err)) : (yn = !0, fr[0]()), gn && (URL.revokeObjectURL(gn), gn = void 0);
                    break;
                case "init-ep":
                case "copy-from":
                case "create":
                case "release":
                case "run":
                case "end-profiling":
                    {
                        let t = hr.get(e1.data.type);
                        e1.data.err ? t.shift()[1](e1.data.err) : t.shift()[0](e1.data.out);
                        break;
                    }
                default:
            }
        }, Au = async ()=>{
            if (!yn) {
                if (vt) throw new Error("multiple calls to 'initWasm()' detected.");
                if (bn) throw new Error("previous call to 'initWasm()' failed.");
                if (vt = !0, nt()) return new Promise((e1, t)=>{
                    Se?.terminate(), to().then(([n, r])=>{
                        try {
                            Se = r, Se.onerror = (i)=>t(i), Se.onmessage = gp, fr = [
                                e1,
                                t
                            ];
                            let o = {
                                type: "init-wasm",
                                in: te
                            };
                            if (!o.in.wasm.wasmPaths && n) {
                                let i = Ut();
                                i && (o.in.wasm.wasmPaths = i);
                            }
                            Se.postMessage(o), gn = n;
                        } catch (o) {
                            t(o);
                        }
                    }, t);
                });
                try {
                    await Et(te.wasm), await kt(te), yn = !0;
                } catch (e1) {
                    throw bn = !0, e1;
                } finally{
                    vt = !1;
                }
            }
        }, Eu = async (e1)=>{
            if (nt()) return dt(), new Promise((t, n)=>{
                ut("init-ep", [
                    t,
                    n
                ]);
                let r = {
                    type: "init-ep",
                    in: {
                        epName: e1,
                        env: te
                    }
                };
                Se.postMessage(r);
            });
            await Pt(te, e1);
        }, ku = async (e1)=>nt() ? (dt(), new Promise((t, n)=>{
                ut("copy-from", [
                    t,
                    n
                ]);
                let r = {
                    type: "copy-from",
                    in: {
                        buffer: e1
                    }
                };
                Se.postMessage(r, [
                    e1.buffer
                ]);
            })) : mt(e1), Pu = async (e1, t)=>{
            if (nt()) {
                if (t?.preferredOutputLocation) throw new Error('session option "preferredOutputLocation" is not supported for proxy.');
                return dt(), new Promise((n, r)=>{
                    ut("create", [
                        n,
                        r
                    ]);
                    let o = {
                        type: "create",
                        in: {
                            model: e1,
                            options: {
                                ...t
                            }
                        }
                    }, i = [];
                    e1 instanceof Uint8Array && i.push(e1.buffer), Se.postMessage(o, i);
                });
            } else return zt(e1, t);
        }, zu = async (e1)=>{
            if (nt()) return dt(), new Promise((t, n)=>{
                ut("release", [
                    t,
                    n
                ]);
                let r = {
                    type: "release",
                    in: e1
                };
                Se.postMessage(r);
            });
            Bt(e1);
        }, Bu = async (e1, t, n, r, o, i)=>{
            if (nt()) {
                if (n.some((s)=>s[3] !== "cpu")) throw new Error("input tensor on GPU is not supported for proxy.");
                if (o.some((s)=>s)) throw new Error("pre-allocated output tensor is not supported for proxy.");
                return dt(), new Promise((s, a)=>{
                    ut("run", [
                        s,
                        a
                    ]);
                    let u = n, d = {
                        type: "run",
                        in: {
                            sessionId: e1,
                            inputIndices: t,
                            inputs: u,
                            outputIndices: r,
                            options: i
                        }
                    };
                    Se.postMessage(d, Mt(u));
                });
            } else return Dt(e1, t, n, r, o, i);
        }, Du = async (e1)=>{
            if (nt()) return dt(), new Promise((t, n)=>{
                ut("end-profiling", [
                    t,
                    n
                ]);
                let r = {
                    type: "end-profiling",
                    in: e1
                };
                Se.postMessage(r);
            });
            Ot(e1);
        };
    });
    var Ou, yp, _n, Mu = k(()=>{
        "use strict";
        _e();
        gr();
        L();
        Ct();
        Dn();
        Ou = (e1, t)=>{
            switch(e1.location){
                case "cpu":
                    return [
                        e1.type,
                        e1.dims,
                        e1.data,
                        "cpu"
                    ];
                case "gpu-buffer":
                    return [
                        e1.type,
                        e1.dims,
                        {
                            gpuBuffer: e1.gpuBuffer
                        },
                        "gpu-buffer"
                    ];
                case "ml-tensor":
                    return [
                        e1.type,
                        e1.dims,
                        {
                            mlTensor: e1.mlTensor
                        },
                        "ml-tensor"
                    ];
                default:
                    throw new Error(`invalid data location: ${e1.location} for ${t()}`);
            }
        }, yp = (e1)=>{
            switch(e1[3]){
                case "cpu":
                    return new xe(e1[0], e1[2], e1[1]);
                case "gpu-buffer":
                    {
                        let t = e1[0];
                        if (!Lt(t)) throw new Error(`not supported data type: ${t} for deserializing GPU tensor`);
                        let { gpuBuffer: n, download: r, dispose: o } = e1[2];
                        return xe.fromGpuBuffer(n, {
                            dataType: t,
                            dims: e1[1],
                            download: r,
                            dispose: o
                        });
                    }
                case "ml-tensor":
                    {
                        let t = e1[0];
                        if (!Gt(t)) throw new Error(`not supported data type: ${t} for deserializing MLTensor tensor`);
                        let { mlTensor: n, download: r, dispose: o } = e1[2];
                        return xe.fromMLTensor(n, {
                            dataType: t,
                            dims: e1[1],
                            download: r,
                            dispose: o
                        });
                    }
                default:
                    throw new Error(`invalid data location: ${e1[3]}`);
            }
        }, _n = class {
            async fetchModelAndCopyToWasmMemory(t) {
                return ku(await gt(t));
            }
            async loadModel(t, n) {
                ye();
                let r;
                typeof t == "string" ? r = await this.fetchModelAndCopyToWasmMemory(t) : r = t, [this.sessionId, this.inputNames, this.outputNames, this.inputMetadata, this.outputMetadata] = await Pu(r, n), he();
            }
            async dispose() {
                return zu(this.sessionId);
            }
            async run(t, n, r) {
                ye();
                let o = [], i = [];
                Object.entries(t).forEach((p)=>{
                    let f = p[0], m = p[1], h = this.inputNames.indexOf(f);
                    if (h === -1) throw new Error(`invalid input '${f}'`);
                    o.push(m), i.push(h);
                });
                let s = [], a = [];
                Object.entries(n).forEach((p)=>{
                    let f = p[0], m = p[1], h = this.outputNames.indexOf(f);
                    if (h === -1) throw new Error(`invalid output '${f}'`);
                    s.push(m), a.push(h);
                });
                let u = o.map((p, f)=>Ou(p, ()=>`input "${this.inputNames[i[f]]}"`)), d = s.map((p, f)=>p ? Ou(p, ()=>`output "${this.outputNames[a[f]]}"`) : null), l = await Bu(this.sessionId, i, u, a, d, r), c = {};
                for(let p = 0; p < l.length; p++)c[this.outputNames[a[p]]] = s[p] ?? yp(l[p]);
                return he(), c;
            }
            startProfiling() {}
            endProfiling() {
                Du(this.sessionId);
            }
        };
    });
    var Ru = {};
    rt(Ru, {
        OnnxruntimeWebAssemblyBackend: ()=>wn,
        initializeFlags: ()=>Uu,
        wasmBackend: ()=>bp
    });
    var Uu, wn, bp, Vu = k(()=>{
        "use strict";
        _e();
        gr();
        Mu();
        Uu = ()=>{
            (typeof te.wasm.initTimeout != "number" || te.wasm.initTimeout < 0) && (te.wasm.initTimeout = 0);
            let e1 = te.wasm.simd;
            if (typeof e1 != "boolean" && e1 !== void 0 && e1 !== "fixed" && e1 !== "relaxed" && (console.warn(`Property "env.wasm.simd" is set to unknown value "${e1}". Reset it to \`false\` and ignore SIMD feature checking.`), te.wasm.simd = !1), typeof te.wasm.proxy != "boolean" && (te.wasm.proxy = !1), typeof te.wasm.trace != "boolean" && (te.wasm.trace = !1), typeof te.wasm.numThreads != "number" || !Number.isInteger(te.wasm.numThreads) || te.wasm.numThreads <= 0) {
                if (typeof self < "u" && !self.crossOriginIsolated) te.wasm.numThreads = 1;
                else {
                    let t = typeof navigator > "u" ? vn("node:os").cpus().length : navigator.hardwareConcurrency;
                    te.wasm.numThreads = Math.min(4, Math.ceil((t || 1) / 2));
                }
            }
        }, wn = class {
            async init(t) {
                Uu(), await Au(), await Eu(t);
            }
            async createInferenceSessionHandler(t, n) {
                let r = new _n;
                return await r.loadModel(t, n), r;
            }
        }, bp = new wn;
    });
    var wp = {};
    rt(wp, {
        InferenceSession: ()=>Lr,
        TRACE: ()=>pt,
        TRACE_EVENT_BEGIN: ()=>Ue,
        TRACE_EVENT_END: ()=>Re,
        TRACE_FUNC_BEGIN: ()=>ye,
        TRACE_FUNC_END: ()=>he,
        Tensor: ()=>xe,
        default: ()=>_p,
        env: ()=>te,
        registerBackend: ()=>Ge
    });
    _e();
    _e();
    _e();
    var Kr = "1.24.3";
    var _p = An;
    {
        let e1 = (Vu(), lt(Ru)).wasmBackend;
        Ge("webgpu", e1, 5), Ge("webnn", e1, 5), Ge("cpu", e1, 10), Ge("wasm", e1, 10);
    }
    Object.defineProperty(te.versions, "web", {
        value: Kr,
        enumerable: !0
    });
    return lt(wp);
})();
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ module.exports = $4d680ef17f3ad71b$var$ort;

});

parcelRegister("4xkBA", function(module, exports) {

$parcel$export(module.exports, "BasePaddleOcrService", () => $34da3a4360b59d74$export$8001f19699de37a5);
$parcel$export(module.exports, "MODEL_BASE_URL", () => $34da3a4360b59d74$export$5b37f5748f4c6b2b);
$parcel$export(module.exports, "DICT_BASE_URL", () => $34da3a4360b59d74$export$3f190b30f9e15e2b);

var $kjyEk = parcelRequire("kjyEk");

var $kKDv9 = parcelRequire("kKDv9");

var $8bTxv = parcelRequire("8bTxv");

var $kdcgg = parcelRequire("kdcgg");
class $34da3a4360b59d74$export$8001f19699de37a5 {
    options = (0, $kKDv9.DEFAULT_PADDLE_OPTIONS);
    detectionSession = null;
    recognitionSession = null;
    detector = null;
    recognitor = null;
    platform;
    constructor(platform, options){
        this.platform = platform;
        this.options = (0, $8bTxv.deepMerge)({}, (0, $kKDv9.DEFAULT_PADDLE_OPTIONS), options);
        this.options.session = this.options.session || (0, $kKDv9.DEFAULT_PADDLE_OPTIONS).session;
    }
    log(message) {
        if (this.options.debugging?.verbose) console.log(`[PaddleOcrService:Base] ${message}`);
    }
    async recognize(image, options) {
        if (!this.detector || !this.recognitor) await this.initSessions();
        try {
            let imageBuffer;
            let canvas;
            if (typeof image === "string") {
                if (!image.startsWith("http") && !image.startsWith("/")) throw new Error("Invalid image string format. Must be an HTTP URL, an absolute path, ArrayBuffer, or Canvas");
                imageBuffer = await this.platform.loadResource(image, image);
                canvas = await (0, $kjyEk.CanvasProcessor).prepareCanvas(imageBuffer);
            } else if (image instanceof ArrayBuffer) {
                imageBuffer = image;
                canvas = await (0, $kjyEk.CanvasProcessor).prepareCanvas(imageBuffer);
            } else {
                canvas = image;
                if (typeof image.toBuffer === "function") {
                    let buffer = image.toBuffer("image/png");
                    imageBuffer = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
                } else {
                    let ctx = image.getContext("2d", {
                        willReadFrequently: true
                    });
                    let imageData = ctx.getImageData(0, 0, image.width, image.height);
                    let data = imageData.data;
                    imageBuffer = data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength);
                }
            }
            let cacheKey = (0, $kdcgg.ImageCache).generateKey(imageBuffer);
            if (!options?.noCache && !options?.dictionary) {
                let cacheResult = (0, $kdcgg.globalImageCache).get(cacheKey);
                if (cacheResult) {
                    this.log("Using cached OCR result");
                    if (options?.flatten) return {
                        text: cacheResult.text,
                        results: cacheResult.lines ? cacheResult.lines.flat() : cacheResult.results,
                        confidence: cacheResult.confidence
                    };
                    return cacheResult;
                }
            }
            let boxes = [];
            boxes = await this.detector.run(canvas);
            if (boxes.length === 0) return options?.flatten ? {
                text: "",
                results: [],
                confidence: 0
            } : {
                text: "",
                lines: [],
                confidence: 0
            };
            let dict = this.options.recognition.charactersDictionary;
            if (options?.dictionary) {
                let dictionaryContent = "";
                if (typeof options.dictionary === "string") {
                    let dictBuffer = await this.platform.loadResource(options.dictionary, options.dictionary);
                    dictionaryContent = new TextDecoder("utf-8").decode(dictBuffer);
                } else dictionaryContent = new TextDecoder("utf-8").decode(options.dictionary);
                dict = dictionaryContent.split(`
`).map((line)=>line.trim()).filter((line)=>line.length > 0);
            }
            let results = await this.recognitor.run(canvas, boxes, dict);
            let groupedResult = this.groupResultsByLine(results);
            let finalResult = options?.flatten ? this.flattenResults(results) : groupedResult;
            if (!options?.noCache && !options?.dictionary) (0, $kdcgg.globalImageCache).set(cacheKey, finalResult);
            return finalResult;
        } catch (e) {
            console.error("recognize: error", e.message, e.stack);
            throw e;
        }
    }
    flattenResults(results) {
        if (results.length === 0) return {
            text: "",
            results: [],
            confidence: 0
        };
        let text = results.map((r)=>r.text).join(" ");
        let avgConfidence = results.reduce((sum, r)=>sum + r.confidence, 0) / results.length;
        return {
            text: text,
            results: results,
            confidence: avgConfidence
        };
    }
    groupResultsByLine(results) {
        if (results.length === 0) return {
            text: "",
            lines: [],
            confidence: 0
        };
        let lines = [];
        let currentLine = [];
        let currentY = results[0].box.y;
        let avgHeight = results[0].box.height;
        for (let result of results){
            const { box: box } = result;
            if (Math.abs(box.y - currentY) < avgHeight / 2) {
                currentLine.push(result);
                avgHeight = (avgHeight * (currentLine.length - 1) + box.height) / currentLine.length;
            } else {
                currentLine.sort((a, b)=>a.box.x - b.box.x);
                lines.push(currentLine);
                currentLine = [
                    result
                ];
                currentY = box.y;
                avgHeight = box.height;
            }
        }
        if (currentLine.length > 0) {
            currentLine.sort((a, b)=>a.box.x - b.box.x);
            lines.push(currentLine);
        }
        let fullText = lines.map((line)=>line.map((r)=>r.text).join(" ")).join(`
`);
        let totalConfidence = lines.reduce((sum, line)=>sum + line.reduce((s, r)=>s + r.confidence, 0), 0);
        let totalItems = lines.reduce((sum, line)=>sum + line.length, 0);
        return {
            text: fullText,
            lines: lines,
            confidence: totalItems > 0 ? totalConfidence / totalItems : 0
        };
    }
}
let $34da3a4360b59d74$export$5b37f5748f4c6b2b = "https://media.githubusercontent.com/media/PT-Perkasa-Pilar-Utama/ppu-paddle-ocr-models/main";
let $34da3a4360b59d74$export$3f190b30f9e15e2b = "https://raw.githubusercontent.com/PT-Perkasa-Pilar-Utama/ppu-paddle-ocr-models/main";

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("kKDv9", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DEBUGGING_OPTIONS", () => $f1b6beb2b7a029bd$export$3de985952e13165);
$parcel$export(module.exports, "DEFAULT_DETECTION_OPTIONS", () => $f1b6beb2b7a029bd$export$f9fe4ae4c2b29d59);
$parcel$export(module.exports, "DEFAULT_RECOGNITION_OPTIONS", () => $f1b6beb2b7a029bd$export$52530f40bd8925d8);
$parcel$export(module.exports, "DEFAULT_PADDLE_OPTIONS", () => $f1b6beb2b7a029bd$export$6d3b3b5aba5a9e48);
let $f1b6beb2b7a029bd$export$3de985952e13165 = {
    verbose: false,
    debug: false,
    debugFolder: "out"
};
let $f1b6beb2b7a029bd$export$f9fe4ae4c2b29d59 = {
    mean: [
        0.485,
        0.456,
        0.406
    ],
    stdDeviation: [
        0.229,
        0.224,
        0.225
    ],
    maxSideLength: 640,
    minimumAreaThreshold: 25,
    paddingVertical: 0.4,
    paddingHorizontal: 0.6
};
let $f1b6beb2b7a029bd$export$52530f40bd8925d8 = {
    imageHeight: 48,
    charactersDictionary: []
};
let $f1b6beb2b7a029bd$export$e42c0eea0131727a = {
    executionProviders: [
        "cpu"
    ],
    graphOptimizationLevel: "all",
    enableCpuMemArena: true,
    enableMemPattern: true,
    executionMode: "sequential",
    interOpNumThreads: 0,
    intraOpNumThreads: 0
};
let $f1b6beb2b7a029bd$export$7308d59ed6a411c1 = "opencv";
let $f1b6beb2b7a029bd$export$90ae640e7dff5175 = {
    engine: $f1b6beb2b7a029bd$export$7308d59ed6a411c1
};
let $f1b6beb2b7a029bd$export$6d3b3b5aba5a9e48 = {
    model: {},
    detection: $f1b6beb2b7a029bd$export$f9fe4ae4c2b29d59,
    recognition: $f1b6beb2b7a029bd$export$52530f40bd8925d8,
    debugging: $f1b6beb2b7a029bd$export$3de985952e13165,
    session: $f1b6beb2b7a029bd$export$e42c0eea0131727a,
    processing: $f1b6beb2b7a029bd$export$90ae640e7dff5175
};

});

parcelRegister("8bTxv", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $5f6a6ec3b34ec548$export$6969335ea1e4e77c);
function $5f6a6ec3b34ec548$export$6969335ea1e4e77c(target, ...sources) {
    if (!sources.length) return target;
    let source = sources.shift();
    if ($5f6a6ec3b34ec548$export$a6cdc56e425d0d0a(target) && $5f6a6ec3b34ec548$export$a6cdc56e425d0d0a(source)) {
        for(let key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
            let sourceValue = source[key];
            let targetValue = target[key];
            if ($5f6a6ec3b34ec548$export$a6cdc56e425d0d0a(sourceValue)) {
                if (!targetValue || !$5f6a6ec3b34ec548$export$a6cdc56e425d0d0a(targetValue)) target[key] = {};
                $5f6a6ec3b34ec548$export$6969335ea1e4e77c(target[key], sourceValue);
            } else if (sourceValue !== undefined) target[key] = sourceValue;
        }
    }
    return $5f6a6ec3b34ec548$export$6969335ea1e4e77c(target, ...sources);
}
function $5f6a6ec3b34ec548$export$a6cdc56e425d0d0a(item) {
    return item !== null && typeof item === "object" && !Array.isArray(item) && !(item instanceof Date) && !(item instanceof RegExp) && !(item instanceof ArrayBuffer) && !ArrayBuffer.isView(item);
}

});

parcelRegister("kdcgg", function(module, exports) {

$parcel$export(module.exports, "ImageCache", () => $eb6e8865a2ef7db6$export$51adf995cb4f5799);
$parcel$export(module.exports, "globalImageCache", () => $eb6e8865a2ef7db6$export$bc24eb77de80fe15);
class $eb6e8865a2ef7db6$export$51adf995cb4f5799 {
    cache = new Map;
    maxSize;
    constructor(maxSize = 10){
        this.maxSize = maxSize;
    }
    get(key) {
        let value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
            return value;
        }
        return;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            let firstKey = this.cache.keys().next().value;
            if (firstKey !== undefined) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    static generateKey(imageBuffer) {
        let view = new Uint8Array(imageBuffer);
        let len = Math.min(view.length, 1024);
        let hash = 0;
        for(let i = 0; i < len; i++){
            hash = (hash << 5) - hash + view[i];
            hash = hash & hash;
        }
        return `${hash}_${view.length}`;
    }
}
let $eb6e8865a2ef7db6$export$bc24eb77de80fe15 = new $eb6e8865a2ef7db6$export$51adf995cb4f5799;

});


parcelRegister("hw71J", function(module, exports) {

$parcel$export(module.exports, "DetectionService", () => $cc0ae03b9ab43fec$export$d895910aaf713a6f);

var $lc2gH = parcelRequire("lc2gH");

var $lf5OP = parcelRequire("lf5OP");
class $cc0ae03b9ab43fec$export$d895910aaf713a6f extends (0, $lc2gH.BaseDetectionService) {
    constructor(session, options = {}, debugging = {}){
        super(new (0, $lf5OP.WebPlatformProvider), session, options, debugging, "canvas-native");
    }
}

});
parcelRegister("lc2gH", function(module, exports) {

$parcel$export(module.exports, "BaseDetectionService", () => $f6dc7a6514abde02$export$b72da2be9d962ff4);

var $kjyEk = parcelRequire("kjyEk");

var $kKDv9 = parcelRequire("kKDv9");
class $f6dc7a6514abde02$export$b72da2be9d962ff4 {
    options;
    debugging;
    session;
    platform;
    engine;
    static NUM_CHANNELS = 3;
    lastDetectionCanvas = null;
    constructor(platform, session, options = {}, debugging = {}, engine = "opencv"){
        this.platform = platform;
        this.session = session;
        this.options = {
            ...(0, $kKDv9.DEFAULT_DETECTION_OPTIONS),
            ...options
        };
        this.debugging = {
            ...(0, $kKDv9.DEFAULT_DEBUGGING_OPTIONS),
            ...debugging
        };
        if (engine === "opencv" && !this.platform.imageProcessor) this.engine = "canvas-native";
        else this.engine = engine;
    }
    log(message) {
        if (this.debugging.verbose) console.log(`[DetectionService] ${message}`);
    }
    async run(image) {
        this.log("Starting text detection process");
        try {
            let canvasToProcess = this.platform.isCanvas(image) ? image : this.engine === "opencv" && this.platform.imageProcessor ? await this.platform.imageProcessor.prepareCanvas(image) : await (0, $kjyEk.CanvasProcessor).prepareCanvas(image);
            let input = await this.preprocessDetection(canvasToProcess);
            let detection = await this.runInference(input.tensor, input.width, input.height);
            if (!detection) {
                console.error("Text detection failed (output tensor is null)");
                return [];
            }
            let detectedBoxes = this.postprocessDetection(detection, input);
            if (this.debugging.debug && this.debugging.debugFolder) {
                await this.debugDetectionCanvas(this.lastDetectionCanvas, input.width, input.height);
                await this.debugDetectedBoxes(canvasToProcess, detectedBoxes);
            }
            this.log(`Detected ${detectedBoxes.length} text boxes in image`);
            return detectedBoxes;
        } catch (error) {
            console.error("Error during text detection:", error instanceof Error ? error.message : String(error));
            return [];
        }
    }
    async preprocessDetection(canvas) {
        const { width: originalWidth, height: originalHeight } = canvas;
        const { width: resizeW, height: resizeH, ratio: resizeRatio } = this.calculateResizeDimensions(originalWidth, originalHeight);
        let resizedCanvas;
        if (this.engine === "opencv" && this.platform.imageProcessor) {
            let processor = new this.platform.imageProcessor.ImageProcessor(canvas);
            try {
                resizedCanvas = processor.resize({
                    width: resizeW,
                    height: resizeH
                }).toCanvas();
            } finally{
                processor.destroy();
            }
        } else resizedCanvas = new (0, $kjyEk.CanvasProcessor)(canvas).resize({
            width: resizeW,
            height: resizeH
        }).toCanvas();
        let width = Math.ceil(resizeW / 32) * 32;
        let height = Math.ceil(resizeH / 32) * 32;
        let paddedCanvas = this.createPaddedCanvas(resizedCanvas, resizeW, resizeH, width, height);
        let tensor = this.imageToTensor(paddedCanvas, width, height);
        this.log(`Detection preprocessed: original(${originalWidth}x${originalHeight}), ` + `model_input(${width}x${height}), resize_ratio: ${resizeRatio.toFixed(4)}, engine: ${this.engine}`);
        return {
            tensor: tensor,
            width: width,
            height: height,
            resizeRatio: resizeRatio,
            originalWidth: originalWidth,
            originalHeight: originalHeight
        };
    }
    calculateResizeDimensions(originalWidth, originalHeight) {
        let MAX_SIDE_LEN = this.options.maxSideLength;
        let resizeW = originalWidth;
        let resizeH = originalHeight;
        let ratio = 1;
        if (Math.max(resizeH, resizeW) > MAX_SIDE_LEN) {
            ratio = MAX_SIDE_LEN / (resizeH > resizeW ? resizeH : resizeW);
            resizeW = Math.round(resizeW * ratio);
            resizeH = Math.round(resizeH * ratio);
        }
        return {
            width: resizeW,
            height: resizeH,
            ratio: ratio
        };
    }
    createPaddedCanvas(resizedCanvas, resizeW, resizeH, targetWidth, targetHeight) {
        let paddedCanvas = this.platform.createCanvas(targetWidth, targetHeight);
        let paddedCtx = paddedCanvas.getContext("2d");
        paddedCtx.drawImage(resizedCanvas, 0, 0, resizeW, resizeH);
        return paddedCanvas;
    }
    imageToTensor(canvas, width, height) {
        let ctx = canvas.getContext("2d");
        let imageData = ctx.getImageData(0, 0, width, height);
        let rgbaData = imageData.data;
        let tensor = new Float32Array($f6dc7a6514abde02$export$b72da2be9d962ff4.NUM_CHANNELS * height * width);
        const { mean: mean, stdDeviation: stdDeviation } = this.options;
        for(let h = 0; h < height; h++)for(let w = 0; w < width; w++){
            let rgbaIdx = (h * width + w) * 4;
            let tensorBaseIdx = h * width + w;
            for(let c = 0; c < $f6dc7a6514abde02$export$b72da2be9d962ff4.NUM_CHANNELS; c++){
                let pixelValue = rgbaData[rgbaIdx + c] / 255;
                let normalizedValue = (pixelValue - mean[c]) / stdDeviation[c];
                tensor[c * height * width + tensorBaseIdx] = normalizedValue;
            }
        }
        return tensor;
    }
    async runInference(tensor, width, height) {
        let inputTensor;
        try {
            this.log("Running detection inference...");
            inputTensor = new this.platform.ort.Tensor("float32", tensor, [
                1,
                3,
                height,
                width
            ]);
            let feeds = {
                x: inputTensor
            };
            let results = await this.session.run(feeds);
            let outputTensor = results[this.session.outputNames[0] || "sigmoid_0.tmp_0"];
            this.log("Detection inference complete!");
            if (!outputTensor) {
                console.error(`Output tensor ${this.session.outputNames[0]} not found in detection results`);
                return null;
            }
            return outputTensor.data;
        } catch (error) {
            console.error("Error during model inference:", error instanceof Error ? error.message : String(error));
            throw error;
        } finally{
            inputTensor?.dispose();
        }
    }
    tensorToCanvas(tensor, width, height) {
        let canvas = this.platform.createCanvas(width, height);
        let ctx = canvas.getContext("2d");
        let imageData = ctx.createImageData(width, height);
        let data = imageData.data;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            let mapIndex = y * width + x;
            let probability = tensor[mapIndex] || 0;
            let grayValue = Math.round(probability * 255);
            let pixelIdx = (y * width + x) * 4;
            data[pixelIdx] = grayValue;
            data[pixelIdx + 1] = grayValue;
            data[pixelIdx + 2] = grayValue;
            data[pixelIdx + 3] = 255;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    }
    postprocessDetection(detection, input, minBoxAreaOnPadded = this.options.minimumAreaThreshold || 20, paddingVertical = this.options.paddingVertical || 0.4, paddingHorizontal = this.options.paddingHorizontal || 0.6) {
        this.log("Post-processing detection results...");
        const { width: width, height: height, resizeRatio: resizeRatio, originalWidth: originalWidth, originalHeight: originalHeight } = input;
        let canvas = this.tensorToCanvas(detection, width, height);
        this.lastDetectionCanvas = canvas;
        if (this.engine === "opencv" && this.platform.imageProcessor) return this.postprocessWithOpenCV(canvas, width, height, resizeRatio, originalWidth, originalHeight, minBoxAreaOnPadded, paddingVertical, paddingHorizontal);
        return this.postprocessWithCanvasNative(canvas, resizeRatio, originalWidth, originalHeight, minBoxAreaOnPadded, paddingVertical, paddingHorizontal);
    }
    postprocessWithOpenCV(canvas, width, height, resizeRatio, originalWidth, originalHeight, minBoxAreaOnPadded, paddingVertical, paddingHorizontal) {
        let ip = this.platform.imageProcessor;
        let processor = new ip.ImageProcessor(canvas);
        try {
            processor.grayscale().convert({
                rtype: ip.cv.CV_8UC1
            });
            let contours = new ip.Contours(processor.toMat(), {
                mode: ip.cv.RETR_LIST,
                method: ip.cv.CHAIN_APPROX_SIMPLE
            });
            let boxes = this.extractBoxesFromContours(contours, width, height, resizeRatio, originalWidth, originalHeight, minBoxAreaOnPadded, paddingVertical, paddingHorizontal);
            contours.destroy();
            this.log(`Found ${boxes.length} potential text boxes (opencv)`);
            return boxes;
        } finally{
            processor.destroy();
        }
    }
    extractBoxesFromContours(contours, width, height, resizeRatio, originalWidth, originalHeight, minBoxArea, paddingVertical, paddingHorizontal) {
        let boxes = [];
        contours.iterate((contour)=>{
            let rect = contours.getRect(contour);
            if (rect.width * rect.height <= minBoxArea) return;
            let paddedRect = this.applyPaddingToRect(rect, width, height, paddingVertical, paddingHorizontal);
            let finalBox = this.convertToOriginalCoordinates(paddedRect, resizeRatio, originalWidth, originalHeight);
            if (finalBox.width > 5 && finalBox.height > 5) boxes.push(finalBox);
        });
        return boxes;
    }
    postprocessWithCanvasNative(canvas, resizeRatio, originalWidth, originalHeight, minBoxAreaOnPadded, paddingVertical, paddingHorizontal) {
        let processor = new (0, $kjyEk.CanvasProcessor)(canvas).grayscale().threshold({
            thresh: 127
        });
        let regions = processor.findRegions({
            foreground: "light",
            minArea: minBoxAreaOnPadded,
            thresh: 0,
            padding: {
                vertical: paddingVertical,
                horizontal: paddingHorizontal
            },
            scale: 1 / resizeRatio
        });
        let boxes = this.extractBoxesFromRegions(regions, originalWidth, originalHeight);
        this.log(`Found ${boxes.length} potential text boxes (canvas-native)`);
        return boxes;
    }
    extractBoxesFromRegions(regions, originalWidth, originalHeight) {
        let boxes = [];
        for (let region of regions){
            const { bbox: bbox } = region;
            let box = {
                x: Math.max(0, bbox.x0),
                y: Math.max(0, bbox.y0),
                width: bbox.x1 - bbox.x0,
                height: bbox.y1 - bbox.y0
            };
            if (box.x + box.width > originalWidth) box.width = originalWidth - box.x;
            if (box.y + box.height > originalHeight) box.height = originalHeight - box.y;
            if (box.width > 5 && box.height > 5) boxes.push(box);
        }
        return boxes;
    }
    applyPaddingToRect(rect, maxWidth, maxHeight, paddingVertical, paddingHorizontal) {
        let verticalPadding = Math.round(rect.height * paddingVertical);
        let horizontalPadding = Math.round(rect.height * paddingHorizontal);
        let x = rect.x - horizontalPadding;
        let y = rect.y - verticalPadding;
        let width = rect.width + 2 * horizontalPadding;
        let height = rect.height + 2 * verticalPadding;
        x = Math.max(0, x);
        y = Math.max(0, y);
        let rightEdge = Math.min(maxWidth, rect.x + rect.width + horizontalPadding);
        let bottomEdge = Math.min(maxHeight, rect.y + rect.height + verticalPadding);
        width = rightEdge - x;
        height = bottomEdge - y;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    convertToOriginalCoordinates(rect, resizeRatio, originalWidth, originalHeight) {
        let scaledX = rect.x / resizeRatio;
        let scaledY = rect.y / resizeRatio;
        let scaledWidth = rect.width / resizeRatio;
        let scaledHeight = rect.height / resizeRatio;
        let x = Math.max(0, Math.round(scaledX));
        let y = Math.max(0, Math.round(scaledY));
        let width = Math.min(originalWidth - x, Math.round(scaledWidth));
        let height = Math.min(originalHeight - y, Math.round(scaledHeight));
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    async debugDetectionCanvas(canvas, width, height) {
        let dir = this.debugging.debugFolder;
        await this.platform.saveDebugImage(canvas, "detection-debug", dir);
        this.log(`Probability map visualized and saved to: ${dir}`);
    }
    async debugDetectedBoxes(image, boxes) {
        let canvas = this.platform.isCanvas(image) ? image : await (0, $kjyEk.CanvasProcessor).prepareCanvas(image);
        let ctx = canvas.getContext("2d");
        for (let box of boxes){
            const { x: x, y: y, width: width, height: height } = box;
            (0, $kjyEk.CanvasToolkit).getInstance().drawLine({
                ctx: ctx,
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
        let dir = this.debugging.debugFolder;
        await this.platform.saveDebugImage(canvas, "boxes-debug", dir);
        this.log(`Boxes visualized and saved to: ${dir}`);
    }
}

});

parcelRegister("lf5OP", function(module, exports) {

$parcel$export(module.exports, "WebPlatformProvider", () => $f76f833146cf21fc$export$c94d3932f754402b);

var $6E22k = parcelRequire("6E22k");
class $f76f833146cf21fc$export$c94d3932f754402b {
    pathSeparator = "/";
    ort = $6E22k;
    createCanvas(_width, _height) {
        let canvas = document.createElement("canvas");
        canvas.width = _width;
        canvas.height = _height;
        canvas.getContext("2d", {
            willReadFrequently: true
        });
        return canvas;
    }
    isCanvas(image) {
        return !!(image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && image instanceof OffscreenCanvas || image && typeof image.getContext === "function");
    }
    async loadResource(source, defaultUrl) {
        if (source instanceof ArrayBuffer) return source;
        let sourceToLoad = typeof source === "string" ? source : defaultUrl;
        let response = await fetch(sourceToLoad);
        if (!response.ok) throw new Error(`Failed to fetch resource from ${sourceToLoad}`);
        return response.arrayBuffer();
    }
    async saveDebugImage(_canvas, _filename, _outputDir) {
        return Promise.resolve();
    }
}
if (typeof window !== "undefined" && !$6E22k.env.wasm.wasmPaths) $6E22k.env.wasm.wasmPaths = "https://cdn.jsdelivr.net/npm/onnxruntime-web@1.24.2/dist/";

});


parcelRegister("cYueb", function(module, exports) {

$parcel$export(module.exports, "RecognitionService", () => $972289406540a50b$export$94bb2b6b0148cc2b);

var $3UHmo = parcelRequire("3UHmo");

var $lf5OP = parcelRequire("lf5OP");
class $972289406540a50b$export$94bb2b6b0148cc2b extends (0, $3UHmo.BaseRecognitionService) {
    constructor(session, options = {}, debugging = {}){
        super(new (0, $lf5OP.WebPlatformProvider), session, options, debugging, "canvas-native");
    }
}

});
parcelRegister("3UHmo", function(module, exports) {

$parcel$export(module.exports, "BaseRecognitionService", () => $2d983c7ca4cb3663$export$749f9763854c38d4);

var $kjyEk = parcelRequire("kjyEk");

var $kKDv9 = parcelRequire("kKDv9");
class $2d983c7ca4cb3663$export$749f9763854c38d4 {
    options;
    debugging;
    session;
    platform;
    engine;
    static BLANK_INDEX = 0;
    static UNK_TOKEN = "<unk>";
    static MIN_CROP_WIDTH = 8;
    constructor(platform, session, options = {}, debugging = {}, engine = "opencv"){
        this.platform = platform;
        this.session = session;
        this.options = {
            ...(0, $kKDv9.DEFAULT_RECOGNITION_OPTIONS),
            ...options
        };
        this.debugging = {
            ...(0, $kKDv9.DEFAULT_DEBUGGING_OPTIONS),
            ...debugging
        };
        if (engine === "opencv" && !this.platform.imageProcessor) this.engine = "canvas-native";
        else this.engine = engine;
    }
    log(message) {
        if (this.debugging.verbose) console.log(`[RecognitionService] ${message}`);
    }
    async run(image, detection, charactersDictionary) {
        this.log("Starting text recognition process");
        try {
            let sourceCanvasForCrop = this.platform.isCanvas(image) ? image : this.engine === "opencv" && this.platform.imageProcessor ? await this.platform.imageProcessor.prepareCanvas(image) : await (0, $kjyEk.CanvasProcessor).prepareCanvas(image);
            let validBoxes = this.filterValidBoxes(detection);
            let results = await this.processBoxesInParallel(sourceCanvasForCrop, validBoxes, charactersDictionary);
            return this.sortResultsByReadingOrder(results);
        } catch (error) {
            console.error("Error during text recognition:", error instanceof Error ? error.message : String(error));
            return [];
        }
    }
    filterValidBoxes(boxes) {
        return boxes.map((box, index)=>({
                box: box,
                index: index
            })).filter(({ box: box, index: index })=>this.isValidBox(box, index));
    }
    async processBoxesInParallel(sourceCanvas, boxData, charactersDictionary) {
        let cropsDebugPath = this.debugging.debugFolder ? `${this.debugging.debugFolder}${this.platform.pathSeparator}crops` : "";
        if (this.debugging.debug && cropsDebugPath) {
            let toolkit = (0, $kjyEk.CanvasToolkit).getInstance();
            if ("clearOutput" in toolkit && typeof toolkit.clearOutput === "function") toolkit.clearOutput(cropsDebugPath);
        }
        let results = [];
        for (const { box: box, index: index } of boxData){
            let result = await this.processBox(sourceCanvas, box, index, boxData.length, cropsDebugPath, charactersDictionary);
            if (result !== null) results.push(result);
        }
        return results;
    }
    async processBox(sourceCanvas, box, index, totalBoxes, debugPath, charactersDictionary) {
        let start = Date.now();
        try {
            let cropCanvas = this.cropRegion(sourceCanvas, box);
            const { text: recognizedText, confidence: confidence } = await this.recognizeText(cropCanvas, charactersDictionary);
            if (this.debugging.debug && debugPath) {
                await this.saveDebugCrop(cropCanvas, index, debugPath);
                this.logProcessingDetails(box, index, totalBoxes, recognizedText, start);
            }
            return {
                text: recognizedText,
                box: box,
                confidence: confidence
            };
        } catch (e) {
            let err = e instanceof Error ? e : new Error(String(e));
            console.error(`Error processing box ${index + 1}: ${err.message}`, err.stack);
            return null;
        }
    }
    sortResultsByReadingOrder(results) {
        return [
            ...results
        ].sort((a, b)=>{
            let boxA = a.box;
            let boxB = b.box;
            if (Math.abs(boxA.y - boxB.y) < (boxA.height + boxB.height) / 4) return boxA.x - boxB.x;
            return boxA.y - boxB.y;
        });
    }
    isValidBox(box, index) {
        if (box.width <= 0 || box.height <= 0) {
            console.warn(`Skipping invalid box ${index + 1}: w=${box.width}, h=${box.height}`);
            return false;
        }
        return true;
    }
    cropRegion(sourceCanvas, box) {
        return (0, $kjyEk.CanvasToolkit).getInstance().crop({
            bbox: {
                x0: box.x,
                y0: box.y,
                x1: box.x + box.width,
                y1: box.y + box.height
            },
            canvas: sourceCanvas
        });
    }
    async saveDebugCrop(cropCanvas, index, outputPath) {
        await this.platform.saveDebugImage(cropCanvas, `crop_${String(index).padStart(3, "0")}.png`, outputPath);
    }
    logProcessingDetails(box, index, totalBoxes, text, startTime) {
        let processingTime = Date.now() - startTime;
        this.log(`Box ${index + 1}/${totalBoxes}: [x:${box.x}, y:${box.y}, w:${box.width}, h:${box.height}]` + `
	 \u{2192} "${text}" (processed in ${processingTime}ms)
`);
    }
    async recognizeText(cropCanvas, charactersDictionary) {
        const { imageTensor: imageTensor, tensorWidth: tensorWidth, tensorHeight: tensorHeight } = await this.preprocessImage(cropCanvas);
        let inputTensor;
        try {
            inputTensor = new this.platform.ort.Tensor("float32", imageTensor, [
                1,
                3,
                tensorHeight,
                tensorWidth
            ]);
            let results = await this.runInference(inputTensor);
            return this.decodeResults(results, charactersDictionary);
        } finally{
            inputTensor?.dispose();
        }
    }
    async preprocessImage(cropCanvas) {
        let targetHeight = this.options.imageHeight;
        let originalWidth = cropCanvas.width;
        let originalHeight = cropCanvas.height;
        if (originalHeight === 0 || originalWidth === 0) throw new Error(`Crop dimensions are zero: ${originalWidth}x${originalHeight}`);
        let aspectRatio = originalWidth / originalHeight;
        let resizedWidth = Math.max($2d983c7ca4cb3663$export$749f9763854c38d4.MIN_CROP_WIDTH, Math.round(targetHeight * aspectRatio));
        if (this.engine === "opencv" && this.platform.imageProcessor) {
            let imgProcessor = new this.platform.imageProcessor.ImageProcessor(cropCanvas);
            try {
                imgProcessor.resize({
                    width: resizedWidth,
                    height: targetHeight
                });
                let imageTensor = this.createImageTensorFromCanvas(imgProcessor.toCanvas(), resizedWidth, targetHeight);
                return {
                    imageTensor: imageTensor,
                    tensorWidth: resizedWidth,
                    tensorHeight: targetHeight
                };
            } finally{
                imgProcessor.destroy();
            }
        } else {
            let processor = new (0, $kjyEk.CanvasProcessor)(cropCanvas).resize({
                width: resizedWidth,
                height: targetHeight
            });
            let imageTensor = this.createImageTensor(processor, resizedWidth, targetHeight);
            return {
                imageTensor: imageTensor,
                tensorWidth: resizedWidth,
                tensorHeight: targetHeight
            };
        }
    }
    createImageTensor(processor, width, height) {
        let canvas = processor.toCanvas();
        return this.createImageTensorFromCanvas(canvas, width, height);
    }
    createImageTensorFromCanvas(canvas, width, height) {
        let ctx = canvas.getContext("2d");
        let imageData = ctx.getImageData(0, 0, width, height);
        let pixelData = imageData.data;
        let numChannels = 3;
        let imageTensor = new Float32Array(numChannels * height * width);
        for(let h = 0; h < height; h++)for(let w = 0; w < width; w++){
            let pixelIndex = (h * width + w) * 4;
            let grayValue = pixelData[pixelIndex];
            let normalizedValue = (grayValue / 255 - 0.5) / 0.5;
            for(let c = 0; c < numChannels; c++){
                let tensorIndex = c * height * width + h * width + w;
                imageTensor[tensorIndex] = normalizedValue;
            }
        }
        return imageTensor;
    }
    async runInference(inputTensor) {
        let feeds = {
            x: inputTensor
        };
        let results = await this.session.run(feeds);
        let outputNodeName = Object.keys(results)[0];
        let outputTensor = results[outputNodeName];
        if (!outputTensor) throw new Error(`Recognition output tensor '${outputNodeName}' not found. Available keys: ${Object.keys(results)}`);
        return outputTensor;
    }
    decodeResults(outputTensor, charactersDictionary) {
        let outputData = outputTensor.data;
        let outputShape = outputTensor.dims;
        let sequenceLength = outputShape[1];
        let numClasses = outputShape[2];
        let dict = charactersDictionary || this.options.charactersDictionary;
        if (numClasses !== dict.length) console.warn(`Warning: Model output classes (${numClasses}) does not match dictionary length (${dict.length})`);
        return this.ctcGreedyDecode(outputData, sequenceLength, numClasses, dict);
    }
    ctcGreedyDecode(logits, sequenceLength, numClasses, charDict) {
        let decodedText = "";
        let lastCharIndex = -1;
        let charConfidences = [];
        for(let t = 0; t < sequenceLength; t++){
            const { value: maxProb, index: predictedClassIndex } = this.findMaxProbabilityClass(logits, t, numClasses);
            if (predictedClassIndex === $2d983c7ca4cb3663$export$749f9763854c38d4.BLANK_INDEX || predictedClassIndex === lastCharIndex) {
                lastCharIndex = predictedClassIndex;
                continue;
            }
            if (this.isValidDictionaryIndex(predictedClassIndex, charDict)) this.appendCharacterToText(predictedClassIndex, charDict, (char)=>{
                decodedText += char;
                charConfidences.push(maxProb);
            });
            else console.warn(`Decoded index ${predictedClassIndex} out of bounds for charDict (length ${charDict.length}) at t=${t}`);
            lastCharIndex = predictedClassIndex;
        }
        let confidence = charConfidences.length > 0 ? charConfidences.reduce((a, b)=>a + b, 0) / charConfidences.length : 0;
        return {
            text: decodedText,
            confidence: confidence
        };
    }
    appendCharacterToText(index, charDict, appendFn) {
        let char = charDict[index];
        if (index === charDict.length - 1) {
            if (char === $2d983c7ca4cb3663$export$749f9763854c38d4.UNK_TOKEN) return;
            else {
                appendFn(" ");
                return;
            }
        }
        appendFn(char);
    }
    findMaxProbabilityClass(logits, timestep, numClasses) {
        let maxProb = -1 / 0;
        let maxIndex = 0;
        for(let c = 0; c < numClasses; c++){
            let prob = logits[timestep * numClasses + c];
            if (prob > maxProb) {
                maxProb = prob;
                maxIndex = c;
            }
        }
        return {
            value: maxProb,
            index: maxIndex
        };
    }
    isValidDictionaryIndex(index, charDict) {
        return index >= 0 && index < charDict.length;
    }
}

});





parcelRegister("jk6ss", function(module, exports) {

$parcel$export(module.exports, "render", () => $e114e5051685354d$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $e114e5051685354d$var$_hoisted_1 = {
    class: "fullscreen-scanner"
};
const $e114e5051685354d$var$_hoisted_2 = {
    ref: "videoEl",
    autoplay: "",
    playsinline: "",
    muted: "",
    class: "layer-video"
};
const $e114e5051685354d$var$_hoisted_3 = {
    key: 0,
    class: "text-overlay-layer"
};
const $e114e5051685354d$var$_hoisted_4 = {
    key: 1,
    class: "status-overlay"
};
const $e114e5051685354d$var$_hoisted_5 = {
    key: 2,
    class: "controls"
};
const $e114e5051685354d$var$_hoisted_6 = [
    "disabled"
];
const $e114e5051685354d$var$_hoisted_7 = {
    key: 3
};
function $e114e5051685354d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e114e5051685354d$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("button", {
            class: "icon-btn top-left",
            onClick: _cache[0] || (_cache[0] = ($event)=>!$setup.photoTaken ? _ctx.$emit('close') : $setup.retake())
        }, [
            (0, $TusQn.createElementVNode)("i", {
                class: (0, $8POXm.normalizeClass)([
                    "fas",
                    $setup.photoTaken ? 'fa-rotate-right' : 'fa-arrow-left'
                ])
            }, null, 2)
        ]),
        (0, $TusQn.createElementVNode)("video", $e114e5051685354d$var$_hoisted_2, null, 512),
        (0, $TusQn.createElementVNode)("canvas", {
            ref: "canvasEl",
            class: (0, $8POXm.normalizeClass)([
                "layer-canvas",
                {
                    visible: $setup.photoTaken
                }
            ])
        }, null, 2),
        $setup.photoTaken && $setup.results.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e114e5051685354d$var$_hoisted_3, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.results, (item, index)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: index,
                    class: "text-box",
                    style: (0, $8POXm.normalizeStyle)($setup.calculateBoxStyle(item.bbox))
                }, (0, $8POXm.toDisplayString)(item.text), 5);
            }), 128))
        ])) : (0, $TusQn.createCommentVNode)("", true),
        !$setup.isModelReady || $setup.isScanning ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e114e5051685354d$var$_hoisted_4, [
            (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($setup.isScanning ? 'Skenujem...' : "Na\u010D\xedtavam OCR model..."), 1)
        ])) : (0, $TusQn.createCommentVNode)("", true),
        !$setup.photoTaken ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e114e5051685354d$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("button", {
                class: "snap-btn",
                onClick: $setup.scanText,
                disabled: $setup.isScanning || !$setup.isModelReady
            }, [
                ..._cache[1] || (_cache[1] = [
                    (0, $TusQn.createElementVNode)("i", {
                        class: "far fa-circle-dot"
                    }, null, -1)
                ])
            ], 8, $e114e5051685354d$var$_hoisted_6)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e114e5051685354d$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("button", {
                class: "icon-btn bottom-left",
                onClick: $setup.save
            }, [
                ..._cache[2] || (_cache[2] = [
                    (0, $TusQn.createElementVNode)("i", {
                        class: "fas fa-download"
                    }, null, -1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "icon-btn bottom-right",
                onClick: $setup.confirmText
            }, [
                ..._cache[3] || (_cache[3] = [
                    (0, $TusQn.createElementVNode)("i", {
                        class: "fas fa-check"
                    }, null, -1)
                ])
            ])
        ]))
    ]);
}

});

parcelRegister("4yR1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3523794ad0c07687$export$2e2bcd8739ae039);
let $3523794ad0c07687$var$NOOP = ()=>{};
var $3523794ad0c07687$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iRsSD", function(module, exports) {
module.exports = import("fHVg7").then(()=>parcelRequire('dOivU'));

});


parcelRegister("jqaWU", function(module, exports) {

$parcel$export(module.exports, "render", () => $e238f04f6ccfdf4c$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $e238f04f6ccfdf4c$var$_hoisted_1 = {
    class: "section"
};
const $e238f04f6ccfdf4c$var$_hoisted_2 = {
    class: "container",
    style: {
        "max-width": "860px"
    }
};
const $e238f04f6ccfdf4c$var$_hoisted_3 = {
    class: "rows"
};
const $e238f04f6ccfdf4c$var$_hoisted_4 = {
    class: "row"
};
const $e238f04f6ccfdf4c$var$_hoisted_5 = {
    class: "textarea-container"
};
const $e238f04f6ccfdf4c$var$_hoisted_6 = [
    "readOnly"
];
const $e238f04f6ccfdf4c$var$_hoisted_7 = [
    "title"
];
const $e238f04f6ccfdf4c$var$_hoisted_8 = {
    class: "row"
};
const $e238f04f6ccfdf4c$var$_hoisted_9 = [
    "readOnly"
];
const $e238f04f6ccfdf4c$var$_hoisted_10 = {
    key: 0,
    class: "notification is-info is-light mt-3"
};
const $e238f04f6ccfdf4c$var$_hoisted_11 = {
    class: "has-text-centered"
};
function $e238f04f6ccfdf4c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        $setup.showScanner ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["ScannerWindow"], {
            key: 0,
            onClose: _cache[0] || (_cache[0] = ($event)=>$setup.showScanner = false),
            onUseText: $setup.handleScannedText
        })) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("section", $e238f04f6ccfdf4c$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $e238f04f6ccfdf4c$var$_hoisted_2, [
                _cache[9] || (_cache[9] = (0, $TusQn.createElementVNode)("h1", {
                    class: "title is-size-2"
                }, "Prekladanie", -1)),
                (0, $TusQn.createElementVNode)("div", $e238f04f6ccfdf4c$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $e238f04f6ccfdf4c$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                "control is-large",
                                {
                                    'is-loading': $setup.isRusynLoading
                                }
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("div", $e238f04f6ccfdf4c$var$_hoisted_5, [
                                (0, $TusQn.createElementVNode)("textarea", {
                                    ref: "rusyn_text",
                                    onInput: _cache[1] || (_cache[1] = ($event)=>$setup.onInput('rusyn')),
                                    class: (0, $8POXm.normalizeClass)([
                                        "textarea is-large",
                                        {
                                            'is-danger': $setup.isRusynError
                                        }
                                    ]),
                                    placeholder: "Text v rus\xedn\u010Dine",
                                    readOnly: $setup.rusynIsDisabled,
                                    rows: "6"
                                }, null, 42, $e238f04f6ccfdf4c$var$_hoisted_6),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "toggle-button script-toggle-button",
                                    title: $setup.rusynType === 'cyr' ? 'Cyrilica' : 'Latinka',
                                    onClick: $setup.toggleRusynScript
                                }, (0, $8POXm.toDisplayString)($setup.rusynType === 'cyr' ? "\u0414" : 'D'), 9, $e238f04f6ccfdf4c$var$_hoisted_7),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "toggle-button record-toggle-button icon",
                                        $setup.isRecording ? 'red-background' : ''
                                    ]),
                                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.toggleRecording('rusyn'))
                                }, [
                                    (0, $TusQn.createElementVNode)("i", {
                                        class: (0, $8POXm.normalizeClass)([
                                            $setup.isRecording ? 'fa-circle-stop' : 'fa-microphone',
                                            "fas"
                                        ])
                                    }, null, 2)
                                ], 2),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "toggle-button camera-toggle-button icon",
                                    onClick: _cache[3] || (_cache[3] = ($event)=>$setup.openScanner('rusyn'))
                                }, [
                                    ..._cache[7] || (_cache[7] = [
                                        (0, $TusQn.createElementVNode)("i", {
                                            class: "fas fa-camera"
                                        }, null, -1)
                                    ])
                                ])
                            ])
                        ], 2)
                    ]),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "button mr-5 mt-3 mb-3 has-text-weight-extrabold",
                        style: {
                            "text-decoration": "none"
                        },
                        onClick: $setup.translate
                    }, "\u296E"),
                    (0, $TusQn.createElementVNode)("div", $e238f04f6ccfdf4c$var$_hoisted_8, [
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)([
                                "control is-large",
                                {
                                    'is-loading': $setup.isSlovakLoading
                                }
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("textarea", {
                                ref: "slovak_text",
                                onInput: _cache[4] || (_cache[4] = ($event)=>$setup.onInput('slovak')),
                                class: (0, $8POXm.normalizeClass)([
                                    "textarea is-large",
                                    {
                                        'is-danger': $setup.isSlovakError
                                    }
                                ]),
                                placeholder: "Text v sloven\u010Dine",
                                readOnly: $setup.slovakIsDisabled,
                                rows: "6"
                            }, null, 42, $e238f04f6ccfdf4c$var$_hoisted_9),
                            (0, $TusQn.createElementVNode)("button", {
                                class: (0, $8POXm.normalizeClass)([
                                    "toggle-button record-toggle-button icon",
                                    $setup.isRecording2 ? 'red-background' : ''
                                ]),
                                onClick: _cache[5] || (_cache[5] = ($event)=>$setup.toggleRecording('slovak'))
                            }, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: (0, $8POXm.normalizeClass)([
                                        $setup.isRecording2 ? 'fa-circle-stop' : 'fa-microphone',
                                        "fas"
                                    ])
                                }, null, 2)
                            ], 2),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "toggle-button camera-toggle-button icon",
                                onClick: _cache[6] || (_cache[6] = ($event)=>$setup.openScanner('slovak'))
                            }, [
                                ..._cache[8] || (_cache[8] = [
                                    (0, $TusQn.createElementVNode)("i", {
                                        class: "fas fa-camera"
                                    }, null, -1)
                                ])
                            ])
                        ], 2)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    class: "button mr-5 mt-3 mb-3",
                    onClick: $setup.translate
                }, "Prelo\u017E"),
                $setup.whisperStatus ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e238f04f6ccfdf4c$var$_hoisted_10, [
                    (0, $TusQn.createElementVNode)("p", $e238f04f6ccfdf4c$var$_hoisted_11, (0, $8POXm.toDisplayString)($setup.whisperStatus), 1)
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ])
    ], 64);
}

});

parcelRegister("hriFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb237028d379bfe6$export$2e2bcd8739ae039);
let $cb237028d379bfe6$var$NOOP = ()=>{};
var $cb237028d379bfe6$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("f5Rdr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $afd09a340cd2d56e$export$2e2bcd8739ae039);

var $afd09a340cd2d56e$export$2e2bcd8739ae039 = {
    __name: 'Info',
    setup (__props, { expose: __expose }) {
        __expose();
        const icon = new URL((parcelRequire("9ZY69"))).href;
        const __returned__ = {
            icon: icon
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("7Kzo9", function(module, exports) {

$parcel$export(module.exports, "render", () => $5a4847b44eba0a55$export$b3890eb0ae9dca99);
parcelRequire("dk7qG");
var $TusQn = parcelRequire("TusQn");
const $5a4847b44eba0a55$var$_hoisted_1 = {
    class: "section is-flex is-flex-direction-column is-align-items-center"
};
const $5a4847b44eba0a55$var$_hoisted_2 = {
    class: "section columns is-vcentered is-variable is-8"
};
const $5a4847b44eba0a55$var$_hoisted_3 = {
    class: "column is-full-mobile is-half-tablet has-text-centered"
};
const $5a4847b44eba0a55$var$_hoisted_4 = [
    "src"
];
function $5a4847b44eba0a55$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", $5a4847b44eba0a55$var$_hoisted_1, [
        _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("h1", {
            class: "title center is-size-2"
        }, "Rus\xednsky preklada\u010D", -1)),
        (0, $TusQn.createElementVNode)("section", $5a4847b44eba0a55$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("figure", $5a4847b44eba0a55$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("img", {
                    src: $setup.icon,
                    alt: "Logo Rus\xednsk\xe9ho preklada\u010Da",
                    style: {
                        "max-width": "100%",
                        "height": "auto"
                    }
                }, null, 8, $5a4847b44eba0a55$var$_hoisted_4)
            ]),
            _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("div", {
                class: "column is-full-mobile is-half-tablet"
            }, [
                (0, $TusQn.createElementVNode)("p", {
                    class: "is-size-4"
                }, [
                    (0, $TusQn.createTextVNode)(" Tento projekt vznikol ku v\xfdro\u010Diu 30. v\xfdro\u010Dia kodifik\xe1cie Rus\xednsk\xe9ho jazyka, "),
                    (0, $TusQn.createElementVNode)("br"),
                    (0, $TusQn.createTextVNode)(" aby sa zachoval a neupadol do zabudnutia, "),
                    (0, $TusQn.createElementVNode)("br"),
                    (0, $TusQn.createTextVNode)(" aby nezmizol z verejn\xe9ho povedomia, "),
                    (0, $TusQn.createElementVNode)("br"),
                    (0, $TusQn.createTextVNode)(" a aby zostal s\xfa\u010Das\u0165ou na\u0161ej kult\xfarnej identity. ")
                ])
            ], -1))
        ])
    ]);
}

});

parcelRegister("jY0OP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e894418809ad1795$export$2e2bcd8739ae039);
let $e894418809ad1795$var$NOOP = ()=>{};
var $e894418809ad1795$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("dk7qG");
var $eeJ70 = parcelRequire("eeJ70");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-67a34e';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;





var $73mM4 = parcelRequire("73mM4");
let $97a0afae55047eb6$var$script;




let $97a0afae55047eb6$var$initialize = ()=>{
    $97a0afae55047eb6$var$script = (parcelRequire("1EVTs"));
    if ($97a0afae55047eb6$var$script.__esModule) $97a0afae55047eb6$var$script = $97a0afae55047eb6$var$script.default;
    $97a0afae55047eb6$var$script.render = (parcelRequire("7BmyY")).render;
    $97a0afae55047eb6$var$script.__cssModules = {};
    (parcelRequire("95Qlr")).default($97a0afae55047eb6$var$script);
    $97a0afae55047eb6$var$script.__scopeId = 'data-v-b00993';
    $97a0afae55047eb6$var$script.__file = "Domov.vue";
};
$97a0afae55047eb6$var$initialize();
var $97a0afae55047eb6$export$2e2bcd8739ae039 = $97a0afae55047eb6$var$script;


let $9d0a02c143f37448$var$script;




let $9d0a02c143f37448$var$initialize = ()=>{
    $9d0a02c143f37448$var$script = (parcelRequire("hG6XS"));
    if ($9d0a02c143f37448$var$script.__esModule) $9d0a02c143f37448$var$script = $9d0a02c143f37448$var$script.default;
    $9d0a02c143f37448$var$script.render = (parcelRequire("jqaWU")).render;
    $9d0a02c143f37448$var$script.__cssModules = {};
    (parcelRequire("hriFp")).default($9d0a02c143f37448$var$script);
    $9d0a02c143f37448$var$script.__scopeId = 'data-v-64924e';
    $9d0a02c143f37448$var$script.__file = "Preklad.vue";
};
$9d0a02c143f37448$var$initialize();
var $9d0a02c143f37448$export$2e2bcd8739ae039 = $9d0a02c143f37448$var$script;


let $bcce71c2d414c829$var$script;



let $bcce71c2d414c829$var$initialize = ()=>{
    $bcce71c2d414c829$var$script = (parcelRequire("f5Rdr"));
    if ($bcce71c2d414c829$var$script.__esModule) $bcce71c2d414c829$var$script = $bcce71c2d414c829$var$script.default;
    $bcce71c2d414c829$var$script.render = (parcelRequire("7Kzo9")).render;
    (parcelRequire("jY0OP")).default($bcce71c2d414c829$var$script);
    $bcce71c2d414c829$var$script.__scopeId = 'data-v-5bbc46';
    $bcce71c2d414c829$var$script.__file = "Info.vue";
};
$bcce71c2d414c829$var$initialize();
var $bcce71c2d414c829$export$2e2bcd8739ae039 = $bcce71c2d414c829$var$script;


const $fc7674a67a1dded1$var$routes = [
    {
        path: '/',
        component: (0, $97a0afae55047eb6$export$2e2bcd8739ae039)
    },
    {
        path: '/preklad',
        component: (0, $9d0a02c143f37448$export$2e2bcd8739ae039)
    },
    {
        path: '/info',
        component: (0, $bcce71c2d414c829$export$2e2bcd8739ae039)
    }
];
var $fc7674a67a1dded1$export$2e2bcd8739ae039 = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHistory)(),
    routes: $fc7674a67a1dded1$var$routes
});


// Mount app
(0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039)).use((0, $fc7674a67a1dded1$export$2e2bcd8739ae039)).mount('#app');
var $05ec8ec55c98c4e2$exports = {};
$05ec8ec55c98c4e2$exports = import.meta.resolve("hlxEP");


// Register service worker
if ('serviceWorker' in navigator) navigator.serviceWorker.register($05ec8ec55c98c4e2$exports);


//# sourceMappingURL=app.aac8be92.js.map
